import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const DialogNoticeKeysFragmentDoc = gql`
    fragment DialogNoticeKeys on PendingNotices {
  id
  publishSidebarExplanation
  copilotAiWriterExplanation
  copilotContactCleanerExplanation
}
    `;
export const GuideBannerKeysFragmentDoc = gql`
    fragment GuideBannerKeys on GuideBannerNotices {
  analyzeOverviewPage
  audienceBuilderPage
  contactListPage
  pressreleasePage
}
    `;
export const CopilotFeaturesFragmentDoc = gql`
    fragment CopilotFeatures on PressroomFeatures {
  id
  coPilotAiWriter: managed(feature: coPilotAiWriter) {
    id
    enabled
  }
  coPilotContactCleaner: managed(feature: coPilotContactCleaner) {
    id
    enabled
  }
  coPilotPublishSidebar: managed(feature: coPilotPublishSidebar) {
    id
    enabled
  }
  coPilotRecommendedJournalists: managed(feature: coPilotRecommendedJournalists) {
    id
    enabled
  }
  coPilotPrImpactMail: managed(feature: coPilotPrImpactMail) {
    id
    enabled
  }
}
    `;
export const MediaPickerImageFragmentDoc = gql`
    fragment MediaPickerImage on Image {
  id
  header
  status
  scheduledFor
  publishedAt: publishedAt2
  altText
  containedInPressroom: pressroom {
    id
    name
  }
  usageCount
  thumbnail: image {
    id
    resourceImageId
    cloudinaryId
    url(transformation: IMAGE_BANK_THUMBNAIL)
    previewUrl: url(transformation: MATERIAL_HEADER_PREVIEW)
    altText
    croppedUrl: url
    downloadUrl
  }
}
    `;
export const ModalMediaFragmentDoc = gql`
    fragment ModalMedia on Material {
  id
  header
  status
  scheduledFor
  publishedAt: publishedAt2
  containedInPressroom: pressroom {
    id
    name
  }
  ...MediaPickerImage
  ... on Document {
    preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
    resourceDocument {
      id
      downloadUrl
    }
  }
  ... on Video {
    resourceVideo {
      id
      processed
      downloadUrl
    }
    thumbnailUrl
  }
}
    `;
export const ModalStoryMaterialFragmentDoc = gql`
    fragment ModalStoryMaterial on Material {
  id
  header
  status
  scheduledFor
  publishedAt: publishedAt2
  thumbnail: image(options: {transformation: THUMBNAIL_SMALL}) {
    id
    cloudinaryId
    url
    altText
  }
}
    `;
export const MaterialDataFragmentDoc = gql`
    fragment MaterialData on Material {
  id
  header
  publishedAt2
  scheduledFor
  updatedAt
  publicUrl
  status
}
    `;
export const StoryMaterialQuotationListQuotationsFragmentDoc = gql`
    fragment StoryMaterialQuotationListQuotations on Quotation {
  articleId
  articlePublishedBy2 {
    name
    contact {
      id
      fullName
      avatarUrl
    }
  }
  articlePublishedAt
  articleSource
  articleTitle
  articleUrl
  favatarUrl
  id
  longestCommonSubsequence
  reach
}
    `;
export const StoryMaterialQuotationConnectionFragmentDoc = gql`
    fragment StoryMaterialQuotationConnection on QuotationConnection {
  nodes {
    ...StoryMaterialQuotationListQuotations
  }
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
}
    `;
export const StoryMaterialQuotationSettingsFragmentDoc = gql`
    fragment StoryMaterialQuotationSettings on QuotationSettings {
  id
  sortingType
}
    `;
export const QuotationSettingsSortingOrderOptionFragmentDoc = gql`
    fragment QuotationSettingsSortingOrderOption on QuotationSettingsSortingTypeOption {
  id
  label
  value
}
    `;
export const TopStoriesFragmentDoc = gql`
    fragment TopStories on MaterialWithViewsConnection {
  pageInfo {
    hasNextPage
    endCursor
  }
  totalCount
  nodes {
    material {
      header
      id
      publishedAt2
    }
    views
  }
}
    `;
export const QuotationFragmentDoc = gql`
    fragment Quotation on Quotation {
  id
  articlePublishedAt
  articleSource
  articleTitle
  articleUrl
  favatarUrl
  longestCommonSubsequence
  reach
}
    `;
export const QuotationConnectionFragmentDoc = gql`
    fragment QuotationConnection on QuotationConnection {
  nodes {
    id
    ...Quotation
  }
  totalCount
  pageInfo {
    hasNextPage
    endCursor
  }
}
    `;
export const ChannelConnectionMetaFragmentDoc = gql`
    fragment ChannelConnectionMeta on Channel {
  id
  ... on YoutubeChannel {
    account {
      id
      name
    }
  }
  ... on TwitterChannel {
    user {
      id
      username
    }
  }
  ... on LinkedinChannel {
    selectedCompany {
      id
      name
    }
  }
  ... on FacebookChannel {
    selectedPage {
      id
      name
    }
  }
}
    `;
export const ChannelBaseFragmentDoc = gql`
    fragment ChannelBase on Channel {
  id
  name
  publishByDefault
  ... on PartnerChannel {
    icon
    metaDescription
    metaName
    metaKey
    screenshots
  }
  ...ChannelConnectionMeta
}
    `;
export const AudienceBuilderBannerKeysFragmentDoc = gql`
    fragment AudienceBuilderBannerKeys on AudienceBuilderBannerNotices {
  newAudienceBuilderOldCustomer
  newAudienceBuilderNewCustomer
}
    `;
export const MergedDataFragmentDoc = gql`
    fragment MergedData on AudienceBuilderContact {
  email
  importedAtLeastOnce
}
    `;
export const ContactsFragmentFragmentDoc = gql`
    fragment ContactsFragment on AudienceBuilderContact {
  id
  avatarUrl
  avatarOriginalSize: avatarUrl(size: original)
  city
  company
  country
  email
  firstName
  importedAtLeastOnce
  jobTitle
  lastName
  phoneNumber
  potentialAudience
  facebookUrls
  linkedinUrls
  twitterUrls
  lists {
    id
  }
  twitterFeeds {
    latestTweets(first: 1) {
      nodes {
        id
      }
    }
  }
}
    `;
export const ManageContactLists_ContactListFragmentDoc = gql`
    fragment ManageContactLists_ContactList on NetworkContactList {
  id
  name
  selectedStats(
    networkContactIds: $networkContactIds
    search: $search
    filter: $filter
    networkContactListId: $filterFromNetworkContactListId
  ) {
    id
    removable
    addable
  }
}
    `;
export const ManageContactLists_PressroomFragmentDoc = gql`
    fragment ManageContactLists_Pressroom on Pressroom {
  id
  networkContactListSearch(sort: name, first: 2000, search: $listSearch) {
    nodes {
      id
      ...ManageContactLists_ContactList
    }
  }
}
    `;
export const MndReachNewContactItemFragmentDoc = gql`
    fragment MndReachNewContactItem on MndReachItemInterface {
  id
  reach
  name
  email
  ... on MndReachJournalist {
    imgUrl
    outletNames
    mainOutlet {
      id
      name
    }
  }
  ... on MndReachOutlet {
    thumbnail
  }
}
    `;
export const NetworkContactFragmentDoc = gql`
    fragment NetworkContact on NetworkContact {
  id
  firstName
  lastName
  email
  unsubscribed
  hasMediaHits
  optedOut
  unreachable
  follower
  avatarUrl
  stats {
    id
    received
    openRate
    clickRate
  }
  importedVia
}
    `;
export const ContactLimitsFragmentDoc = gql`
    fragment ContactLimits on ContactLimits {
  imported
  max
  unlimited
}
    `;
export const UserBaseInfoFragmentDoc = gql`
    fragment UserBaseInfo on User {
  id
  name
  email
  phone
}
    `;
export const GeneralEmailSettingsFragmentDoc = gql`
    fragment GeneralEmailSettings on EmailSettingsGeneral {
  email
  ... on EasyCustomEmailSettings {
    pending
  }
  ... on AuthenticatedDomainEmailSettings {
    pending
    dnsRecords {
      id
      data
      host
      recordType
    }
  }
}
    `;
export const NotLivePressroomFragmentDoc = gql`
    fragment NotLivePressroom on Pressroom {
  id
  live
  newsroomUrl
  dashboard {
    id
  }
  source {
    id
    trusted
    trial
  }
}
    `;
export const OnboardingStepFragmentDoc = gql`
    fragment OnboardingStep on OnboardingUser {
  id
  step
  text
  completed
}
    `;
export const MediaRelationsArticleFragmentDoc = gql`
    fragment MediaRelationsArticle on MndReachArticle {
  id
  headline
  publishedAt
  outlet {
    id
    name
    thumbnail
  }
  groupedArticles {
    id
    headline
    publishedAt
    outlet {
      id
      name
      thumbnail
    }
  }
}
    `;
export const OutletItemFragmentDoc = gql`
    fragment OutletItem on MndReachItemInterface {
  id
  email
  reach
  contentScore
  imported
  name
  ... on MndReachOutlet {
    thumbnail
  }
}
    `;
export const MediaRelationsMaterialFragmentDoc = gql`
    fragment MediaRelationsMaterial on Material {
  id
  header
  status
  publishedAt2
  __typename
}
    `;
export const JournalistItemFragmentDoc = gql`
    fragment JournalistItem on MndReachItemInterface {
  id
  email
  reach
  imported
  name
  ... on MndReachJournalist {
    relevance
    imgUrl
    outletNames
    mainOutlet {
      id
      name
    }
  }
  ... on MndReachOutlet {
    thumbnail
  }
}
    `;
export const CountryAndRegionsFragmentDoc = gql`
    fragment CountryAndRegions on MonitorCountryAndRegions {
  id
  countryCode
  countryName
  regions {
    id
    region
  }
}
    `;
export const MonitorAlertRecipientFragmentDoc = gql`
    fragment MonitorAlertRecipient on Recipient {
  id
  email
  phoneNumber
  jobTitle
}
    `;
export const MonitorScheduledAlertFragmentDoc = gql`
    fragment MonitorScheduledAlert on ScheduledAlert {
  id
  imagePlacement
  daysOfWeek
  timesOfDay
}
    `;
export const MonitorRealTimeAlertFragmentDoc = gql`
    fragment MonitorRealTimeAlert on RealTimeAlert {
  id
}
    `;
export const MonitorSummaryAlertFragmentDoc = gql`
    fragment MonitorSummaryAlert on SummaryAlert {
  id
  frequency
  timeOfDay
  buildReport
}
    `;
export const MonitorAlertFragmentDoc = gql`
    fragment MonitorAlert on MonitorAlert {
  id
  name
  locale
  searchProfileIds
  searchProfiles {
    id
    name
    countries
    languages
    mediaTypes: mediaTypes2 {
      id
    }
  }
  mediaTypes
  excludedSourceGroups
  includedSourceGroups
  languages
  sentiments
  focusLevels
  relevanceLevels
  minReach
  maxReach
  minAdValue
  maxAdValue
  socialMediaHandlesExcluded {
    source
    handle
  }
  countriesAndRegions {
    ...CountryAndRegions
  }
  monitorAlertRecipients {
    ...MonitorAlertRecipient
  }
  monitorScheduledAlert {
    ...MonitorScheduledAlert
  }
  monitorRealTimeAlert {
    ...MonitorRealTimeAlert
  }
  monitorSummaryAlerts {
    ...MonitorSummaryAlert
  }
}
    `;
export const MonitorCrisisAlertFragmentDoc = gql`
    fragment MonitorCrisisAlert on MonitorCrisisAlert {
  id
  name
  locale
  countries
  languages
  pressroomId
  notificationWindow
  searchProfileIds
  monitorAlertRecipients {
    id
    email
    jobTitle
    phoneNumber
  }
}
    `;
export const ClipboardDataFragmentDoc = gql`
    fragment ClipboardData on MonitorClipboard {
  id
  title
  hits {
    id
    articleId
  }
}
    `;
export const CountriesByRegionGroupsFragmentDoc = gql`
    fragment CountriesByRegionGroups on ProfileCountryByRegionGroup {
  id
  label
  countries {
    id
    label
  }
}
    `;
export const MonitorSearchProfileFragmentDoc = gql`
    fragment MonitorSearchProfile on MonitorProfile {
  id
  group {
    id
    name
  }
  name
  mediaTypes2 {
    id
    name
  }
  languages
  countries
  readOnly
  rssFeed
  socialMediaSources
  sourceGroupsExcluded {
    id
    name
  }
  socialMediaHandlesExcluded {
    source
    handle
  }
  features {
    brandAiFilter {
      enabled
      name
      summary
      brandUrl
    }
  }
  searches {
    field
    operation
    caseSensitive
    tokens
    includes {
      index
      field
      caseSensitive
      operation
      tokens
    }
    excludes {
      index
      field
      caseSensitive
      operation
      tokens
    }
  }
  simpleSearchProfile {
    id
    brandUrl
  }
}
    `;
export const BooleanSearchProfileDataFragmentDoc = gql`
    fragment BooleanSearchProfileData on MonitorBooleanSearchProfile {
  id
  search
  name
  lastModifiedAt
  rssFeed
  languages
  countries
  socialMediaSources
  sourceGroupsExcluded {
    id
    name
  }
  socialMediaHandlesExcluded {
    source
    handle
  }
  group {
    id
    displayName
  }
  mediaTypes2 {
    id
    name
  }
}
    `;
export const TestSearchHitFragmentDoc = gql`
    fragment TestSearchHit on MonitorTestSearchHit {
  id
  articleId
  title
  hitLine
  link
  thumbnailUrl
  publishedAt
  sourceName
  audioUrl
  audioHitlines {
    id
    startPos
    endPos
    hitline
  }
  mediaType2: mediaType {
    id
    name
  }
}
    `;
export const GroupDataFragmentDoc = gql`
    fragment GroupData on MonitorProfileGroup {
  id
  isRoot
  displayName
  isEditable
  isDeletable
  isDeprecated
  profiles {
    id
    name
    lastModifiedAt
    rssFeed
    countries
    languages
    mediaTypes: mediaTypes2 {
      id
      name
    }
    selectedMediaTypes {
      id
      name
    }
    simpleSearchProfile {
      id
    }
    ... on MonitorProfile {
      readOnly
    }
  }
}
    `;
export const AiNewsroomSettingsFragmentDoc = gql`
    fragment AiNewsroomSettings on NewsroomSettings {
  id
  tagline(aiGenerate: true)
  companyDescription(aiGenerate: true)
}
    `;
export const PressContactFragmentDoc = gql`
    fragment PressContact on Pressroom {
  id
  contactPeopleList(perPage: 1) {
    id
    contactPeople2 {
      id
      name
      title
      email
      phone
      imageUrl
      image {
        id
        url(transformation: CONTACT_PERSON)
      }
      publiclyVisible
      showAsPressroomContact
    }
  }
}
    `;
export const CompanyDescriptionFragmentDoc = gql`
    fragment CompanyDescription on NewsroomSettings {
  id
  tagline
  companyDescription
}
    `;
export const CompanyInfoFragmentDoc = gql`
    fragment CompanyInfo on NewsroomSettings {
  id
  companyName(externalPrefill: true)
  street(externalPrefill: true)
  postalCode(externalPrefill: true)
  city(externalPrefill: true)
  country(externalPrefill: true)
}
    `;
export const BrandingFragmentDoc = gql`
    fragment Branding on NewsroomStyle {
  primaryBrandColor
  secondaryBrandColor
  logotype {
    id
    cloudinaryId
    url
  }
  favicon {
    id
    url(transformation: THUMBNAIL_SMALL, cropped: false)
  }
}
    `;
export const PressroomGoLiveFragmentDoc = gql`
    fragment PressroomGoLive on Pressroom {
  id
  ...PressContact
  newsroomSettings {
    id
    ...CompanyDescription
    ...CompanyInfo
    newsroomStyle {
      ...Branding
    }
  }
  source {
    id
    trusted
  }
}
    `;
export const PendingSourceFragmentDoc = gql`
    fragment PendingSource on PendingSource {
  id
  brandName
  brandUrl
  logoUrl
  pendingBrand
  pendingCompetitors
  competitors {
    id
    brandName
    brandUrl
    logoUrl
  }
}
    `;
export const PitchToFragmentFragmentDoc = gql`
    fragment PitchToFragment on PitchTo {
  ... on MndReachJournalist {
    id
    name
    email
    mainOutlet {
      name
    }
  }
  ... on NetworkContact {
    id
    contactEmail: email
    fullName
    unsubscribed
  }
}
    `;
export const PitchArticleFragmentDoc = gql`
    fragment PitchArticle on MndReachArticle {
  id
  headline
  publishedAt
  outlet {
    id
    name
  }
}
    `;
export const ContactPersonListDataFragmentDoc = gql`
    fragment ContactPersonListData on ContactPerson2 {
  id
  name
  scheduledPublishAt
  scheduledUnpublishAt
  showAsPressroomContact
  publiclyVisible
  visibleSince
  image {
    id
    url(transformation: CONTACT_PERSON)
  }
  imageUrl
}
    `;
export const DistributionChannelsFragmentDoc = gql`
    fragment DistributionChannels on Channel {
  id
  name
  channelName
  url
  publishableMaterialTypes
  addedToMaterial(id: $materialId, type: $type)
  valid
  ... on PartnerChannel {
    icon
  }
  ... on SocialChannel {
    customMessageForMaterial(id: $materialId, type: $type)
  }
}
    `;
export const RelatedStoryFragmentDoc = gql`
    fragment RelatedStory on Material {
  id
  header
  status
  publishedAt2
  scheduledFor
  image {
    id
    cloudinaryId
    url(transformation: IMAGE_BANK_THUMBNAIL)
    altText
  }
}
    `;
export const RelatedMediaFragmentDoc = gql`
    fragment RelatedMedia on Material {
  id
  header
  status
  publishedAt2
  scheduledFor
  containedInPressroom: pressroom {
    id
    name
  }
  ... on Image {
    image {
      id
      cloudinaryId
      url(transformation: IMAGE_BANK_THUMBNAIL)
      altText
      downloadUrl
    }
    usageCount
  }
  ... on Document {
    preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
    resourceDocument {
      id
      downloadUrl
    }
  }
  ... on Video {
    resourceVideo {
      id
      processed
      downloadUrl
    }
    thumbnailUrl
  }
}
    `;
export const ContactPersonFragmentFragmentDoc = gql`
    fragment ContactPersonFragment on ContactPerson2 {
  id
  visibleSince
  name
  imageUrl
  showAsPressroomContact
  scheduledPublishAt
  scheduledUnpublishAt
}
    `;
export const ImageEditFragmentDoc = gql`
    fragment ImageEdit on Image {
  id
  header
  status
  summary
  altText
  scheduledFor
  publishedAt: publishedAt2
  photographer
  copyright
  license {
    id
  }
  tags
  usageCount
  image {
    id
    cropping {
      x
      y
      height
      width
    }
    uncroppedUrl: url(cropped: false)
    croppedUrl: url
    dimensions
    originalDimensions {
      x
      y
    }
    size
  }
}
    `;
export const ImageUsageFragmentDoc = gql`
    fragment ImageUsage on ImageUsage {
  id
  item {
    __typename
    ... on Material {
      id
      header
      pressroom {
        id
        name
        siteCode
      }
      image {
        id
        url(transformation: THUMBNAIL_SMALL)
      }
      scheduledFor
      publishedAt2
      status
    }
    ... on Document {
      id
      thumbnail(transformation: THUMBNAIL_SMALL)
    }
    ... on Video {
      id
      thumbnailUrl
    }
    ... on ContactPerson2 {
      id
      publiclyVisible
      imageUrl
      nullableName: name
      pressroom {
        id
        name
        siteCode
      }
    }
    ... on Tag {
      id
      name
      image {
        id
        url(transformation: THUMBNAIL_SMALL)
      }
      pressroom {
        id
        name
        siteCode
      }
    }
    ... on ReportInterface {
      id
      title
      createdAt
      coverImage {
        id
        url(transformation: THUMBNAIL_SMALL)
      }
      pressroom {
        id
        name
        siteCode
      }
    }
  }
}
    `;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Image {
  id
  header
}
    `;
export const SendExclusiveFragmentDoc = gql`
    fragment SendExclusive on SendExclusive {
  id
  contactIds
  contactListIds
  message
  scheduledAt
  sender
  subject
}
    `;
export const SimpleSearchProfileFragmentDoc = gql`
    fragment SimpleSearchProfile on SimpleSearchProfile {
  id
  brandName
  brandUrl
  identifyCompetitors
  languageIso
  logoUrl
  searchProfileId
  status
  competitorsStatus
  brandSummary
  isOwnBrand
  main
  includes
  excludes
  socialMediaHandlesExcluded {
    source
    handle
  }
  mediaTypes {
    id
    name
  }
  countries
  languages
}
    `;
export const PreliminaryResultsFragmentDoc = gql`
    fragment PreliminaryResults on SimpleSearchProfilePreliminaryResult {
  stats {
    month
    hitsPerMediaType {
      mediaType
      count
    }
    total
    totalOnSource
    tooBroad
  }
  articles {
    id
    headline
    link
    publishedAt
  }
}
    `;
export const SimpleSearchProfileWithPreliminaryResultsFragmentDoc = gql`
    fragment SimpleSearchProfileWithPreliminaryResults on SimpleSearchProfile {
  id
  ...SimpleSearchProfile
  preliminaryResults {
    ...PreliminaryResults
  }
}
    `;
export const MeFragmentDoc = gql`
    fragment Me on Me {
  id
  viewAsAdmin
}
    `;
export const ReportMetaFragmentDoc = gql`
    fragment ReportMeta on ReportInterface {
  id
  pressroom {
    id
  }
  title
  description
  version
  coverImage {
    id
    url(transformation: LIMIT_1000)
  }
  logotype {
    id
    url(transformation: LIMIT_1000)
  }
  logotypeWidth
  textLogotype
  textLogotypeColor
  textLogotypeFontSize
  textLogotypeLetterSpacing
  typeOfLogo
  companyName
  brandColor
  locale
  visibleMetrics
  prValueSetting {
    cpc
    cpm
    twitterCpm
    facebookCpm
    instagramCpm
    currency
    differentFromDefault
    pricingModel
  }
  defaultPrValueSettings {
    platform
    price
    currency
    pricingModel
  }
  importJobs {
    id
    totalCount
    finishedCount
    state
    section {
      id
      title
    }
  }
  fallbackCoverSrc
  ... on BrandReport {
    brand
    compareToPreviousYear
    mediaTypes
    state2
    fromDate
    timespan
    toDate
    searchProfiles {
      id
      name
    }
    competitorSearchProfiles: competitorSearchProfiles2 {
      ids
      name
    }
  }
  createdBy
  createdAt
}
    `;
export const ReportMetricsSectionFragmentDoc = gql`
    fragment ReportMetricsSection on ReportMetricsSection {
  id
  title
  description
  coverages
  estimatedArticleReach
  estimatedSocialMediaReach
  engagement
  prValue
  prValueCurrency
  sentiment {
    hidden
    positive
    neutral
    negative
    average
  }
}
    `;
export const ReportFeaturedSectionFragmentDoc = gql`
    fragment ReportFeaturedSection on ReportFeaturedSection {
  id
  title
  description
  quotationsList {
    id
    iconUrl
    imageUrl
    publishedAt
    source
    title
    url
    featured
    hidden
    description
    reach
    engagement
    prValue
    prValueCurrency
    sentiment
    embed
    audioUrl
    audioHitlines {
      id
      startPos
      endPos
      hitline
    }
    ... on ReportQuotation {
      quote
      loadingDescription
      material {
        id
        header
        url
        type
      }
    }
  }
}
    `;
export const ReportQuotationFragmentDoc = gql`
    fragment ReportQuotation on ReportCoverageInterface {
  id
  sortIndex
  iconUrl
  imageUrl
  publishedAt
  source
  title
  url
  featured
  hidden
  description
  reach
  engagement
  prValue
  prValueCurrency
  sentiment
  embed
  audioUrl
  audioHitlines {
    id
    startPos
    endPos
    hitline
  }
  ... on ReportQuotation {
    quote
    loadingDescription
    material {
      id
      header
      url
      type
    }
  }
}
    `;
export const ReportQuotationGridSectionFragmentDoc = gql`
    fragment ReportQuotationGridSection on ReportQuotationGridSection {
  id
  title
  description
  quotations(first: $first, skipHidden: $skipHidden) {
    totalCount
    edges {
      cursor
      node {
        id
        ...ReportQuotation
      }
    }
  }
}
    `;
export const ReportQuotationFullWidthSectionFragmentDoc = gql`
    fragment ReportQuotationFullWidthSection on ReportQuotationFullWidthSection {
  id
  title
  description
  quotations(first: $first, skipHidden: $skipHidden) {
    totalCount
    edges {
      cursor
      node {
        id
        ...ReportQuotation
      }
    }
  }
}
    `;
export const ReportCoveragesFragmentDoc = gql`
    fragment ReportCoverages on ReportInterface {
  id
  sections2 {
    id
    title
    description
    ... on ReportMetricsSection {
      ...ReportMetricsSection
    }
    ... on ReportFeaturedSection {
      ...ReportFeaturedSection
    }
    ... on ReportQuotationGridSection {
      ...ReportQuotationGridSection
    }
    ... on ReportQuotationFullWidthSection {
      ...ReportQuotationFullWidthSection
    }
  }
}
    `;
export const ReportFragmentDoc = gql`
    fragment Report on ReportInterface {
  id
  ...ReportMeta
  ...ReportCoverages
}
    `;
export const ReportCoveragePollingConnectionDataFragmentDoc = gql`
    fragment ReportCoveragePollingConnectionData on ReportCoverageInterfaceConnection {
  totalCount
  edges {
    cursor
    node {
      id
      ...ReportQuotation
    }
  }
}
    `;
export const BetaFeaturesFragmentDoc = gql`
    fragment BetaFeatures on PressroomFeatures {
  id
}
    `;
export const CustomTitlesCardFragmentDoc = gql`
    fragment CustomTitlesCard on CustomTitles {
  enabled
  latestNews
  newsArchive
  mediaLibrary
  events
  contact
}
    `;
export const FontFragmentFragmentDoc = gql`
    fragment FontFragment on Font {
  id
  family
  weights {
    id
    name
    value
  }
}
    `;
export const BoilerplateFragmentFragmentDoc = gql`
    fragment BoilerplateFragment on NewsroomBoilerplate {
  id
  name
  content
  default
}
    `;
export const CrudBoilerplateFragmentFragmentDoc = gql`
    fragment CRUDBoilerplateFragment on Pressroom {
  id
  newsroomSettings {
    id
    boilerplates {
      id
      ...BoilerplateFragment
    }
  }
}
    `;
export const NewsroomStyleFragmentFragmentDoc = gql`
    fragment NewsroomStyleFragment on NewsroomStyle {
  logotype {
    id
    cloudinaryId
  }
  favicon {
    id
    cloudinaryId
  }
  mediaLayout
  primaryBrandColor
  secondaryBrandColor
  version
}
    `;
export const NewsroomSettingsFragmentFragmentDoc = gql`
    fragment NewsroomSettingsFragment on NewsroomSettings {
  id
  companyName
  tagline
  companyDescription
  boilerplates {
    id
    ...BoilerplateFragment
  }
  shortcut
  locale
  street
  postalCode
  city
  country
  gaProfileId
  noindexMaterials
  downloadMaterialsEnabled
  shareFacebookEnabled
  shareLinkedinEnabled
  shareXEnabled
  license {
    id
  }
  newsroomStyle {
    ...NewsroomStyleFragment
  }
  links {
    id
    linkText
    url
  }
  subjects2 {
    id
    name
    fullName
  }
  regions2 {
    id
    name
    fullName
  }
}
    `;
export const FontFamilyFragmentFragmentDoc = gql`
    fragment FontFamilyFragment on Font {
  id
  family
  currentWeight {
    id
    value
  }
  currentWeightAlternative {
    id
    value
  }
}
    `;
export const StyleFragmentFragmentDoc = gql`
    fragment StyleFragment on HostedNewsroomStyle {
  backgroundColor
  customFooter
  footerCss
  footerHtml
  customHeader
  headerCss
  headerHtml
  includeFooter
  includeLogotype
  headlineFont {
    id
    ...FontFamilyFragment
  }
  paragraphFont {
    id
    ...FontFamilyFragment
  }
  miscellaneousFont {
    id
    ...FontFamilyFragment
  }
}
    `;
export const StoryWidgetTagFragmentDoc = gql`
    fragment StoryWidgetTag on Tag {
  id
  name
  highlighted
}
    `;
export const StoryWidgetFragmentDoc = gql`
    fragment StoryWidget on StoryWidget {
  id
  heading
  layout
  style
  availableStyles
  openInNewTab
  types
  css
  iframeUrl
  width
  height
  tags {
    id
    ...StoryWidgetTag
  }
}
    `;
export const TagManagementMaterialFragmentDoc = gql`
    fragment TagManagementMaterial on Material {
  id
  header
}
    `;
export const TagManagementTagFragmentDoc = gql`
    fragment TagManagementTag on Tag {
  id
  name
  highlighted
  image {
    id
    url
    altText
  }
  materialCount
}
    `;
export const TagManagementPressroomFragmentDoc = gql`
    fragment TagManagementPressroom on Pressroom {
  id
  tags2(perPage: $perPage, page: $page, query: $query, sortOrder: $sortOrder) {
    id
    totalCount
    hits {
      id
      ...TagManagementTag
    }
  }
}
    `;
export const BookingModalNoticesFragmentDoc = gql`
    fragment BookingModalNotices on PendingNotices {
  id
  planUpsell
  trialDemo
}
    `;
export const PressReleasePreviewFragmentDoc = gql`
    fragment PressReleasePreview on Pressrelease {
  id
  publishedAt2
  scheduledFor
  header
  body
  image {
    id
    url
    altText
  }
  subjects {
    id
    name
  }
  regions {
    id
    name
  }
}
    `;
export const FeatureInfoFragmentDoc = gql`
    fragment featureInfo on FeatureInfo {
  id
  enabled
  previousTrial
  trial {
    __typename
  }
}
    `;
export const NotificationsDataFragmentDoc = gql`
    fragment NotificationsData on User {
  id
  sources {
    id
    name
    currentUserGetsFollowerNotifications
    pressrooms {
      id
      siteCode
    }
  }
}
    `;
export const UserSettingsDetailsFragmentDoc = gql`
    fragment UserSettingsDetails on User {
  id
  emailVerified
  enabled2fa
  enforce2fa
  timeZone: timeZone2
  locale: locale2
  username
  title
  name
  email
  phone
}
    `;
export const TopReferrersFragmentDoc = gql`
    fragment TopReferrers on TopReferrersConnection {
  nodes {
    name
    views
    icon
  }
  pageInfo {
    hasNextPage
    endCursor
  }
  totalCount
}
    `;
export const MaterialReportFragmentDoc = gql`
    fragment MaterialReport on MaterialReport {
  id
  materialId
  title
  publishedAt2
  createdAt
  updatedAt
  publicUrl
  status
  topMaterialReferrers(first: $first) {
    ...TopReferrers
  }
  insightsStats {
    todaysHits
    totalHits
    totalReach
    quotations {
      articlePublishedAt
      articleSource
      articleTitle
      articleUrl
      id
      reach
    }
  }
  viewsOverTime {
    date
    web
    email
    alert
  }
  socialMediaActions {
    count
    name
  }
  socialMediaSources {
    count
    name
  }
  devices {
    desktopPercentage
    smartphonePercentage
    tabletPercentage
  }
  totalViews
  contactListsCount
  subjectsCount
  recipients {
    id
    totalClicked
    totalDelivered
    totalOpened
    totalUniqueOpened
    totalUniqueOpenedPercentage
    contactsTotalClicked
    contactsTotalOpened
    contactsTotalUniqueOpened
    contactsTotalUniqueOpenedPercentage
    contactsTotalDelivered
    subscribersTotalClicked
    subscribersTotalOpened
    subscribersTotalUniqueOpened
    subscribersTotalUniqueOpenedPercentage
    subscribersTotalDelivered
    followersTotalClicked
    followersTotalOpened
    followersTotalUniqueOpened
    followersTotalUniqueOpenedPercentage
    followersTotalDelivered
  }
}
    `;
export const ReportCoverageInterfaceConnectionFragmentDoc = gql`
    fragment ReportCoverageInterfaceConnection on ReportCoverageInterfaceConnection {
  totalCount
  edges {
    cursor
    node {
      id
      sortIndex
      iconUrl
      imageUrl
      publishedAt
      source
      title
      url
      featured
      hidden
      description
      reach
      engagement
      prValue
      prValueCurrency
      sentiment
      embed
      audioUrl
      audioHitlines {
        id
        startPos
        endPos
        hitline
      }
      ... on ReportQuotation {
        quote
        loadingDescription
        material {
          id
          header
          url
          type
        }
      }
    }
  }
}
    `;
export const DisplayReportQuotationGridSectionFragmentDoc = gql`
    fragment DisplayReportQuotationGridSection on ReportQuotationGridSection {
  title
  description
  quotations(first: $first, after: $after, skipHidden: $skipHidden) {
    ...ReportCoverageInterfaceConnection
  }
}
    `;
export const DisplayReportQuotationFullWidthSectionFragmentDoc = gql`
    fragment DisplayReportQuotationFullWidthSection on ReportQuotationFullWidthSection {
  title
  description
  quotations(first: $first, after: $after, skipHidden: $skipHidden) {
    ...ReportCoverageInterfaceConnection
  }
}
    `;
export const ReportInsightFragmentDoc = gql`
    fragment ReportInsight on ReportInsight {
  id
  insight
}
    `;
export const ReportSlideshowFragmentDoc = gql`
    fragment ReportSlideshow on ReportInterface {
  id
  title
  description
  coverImage {
    id
    url(transformation: LIMIT_1000)
  }
  logotype {
    id
    url(transformation: LIMIT_1000)
  }
  logotypeWidth
  typeOfLogo
  textLogotype
  textLogotypeColor
  textLogotypeFontSize
  textLogotypeLetterSpacing
  brandColor
  locale
  visibleMetrics
  ...ReportCoverages
  fallbackCoverSrc
  ... on BrandReport {
    brand
    compareToPreviousYear
    mediaTypes
    state2
    fromDate
    timespan
    toDate
  }
}
    `;
export const Report2MetaFragmentDoc = gql`
    fragment Report2Meta on ReportInterface {
  id
  title
}
    `;
export const Report2PrValueSettingFragmentDoc = gql`
    fragment Report2PrValueSetting on ReportPrValueSetting {
  currency
  cpc
  cpm
  twitterCpm
  facebookCpm
  instagramCpm
  differentFromDefault
  pricingModel
}
    `;
export const BrandReportStaticDataFragmentDoc = gql`
    fragment BrandReportStaticData on BrandReport {
  id
  pressroom {
    id
  }
  brand
  compareToPreviousYear
  mediaTypes
  fromDate
  toDate
  timespan
  searchProfiles {
    id
    name
  }
  competitorSearchProfiles: competitorSearchProfiles2 {
    ids
    name
  }
  excludedSourceGroups {
    id
    name
  }
}
    `;
export const Report2SectionFragmentDoc = gql`
    fragment Report2Section on ReportAllSectionsInterface {
  id
  title
  description
  state
}
    `;
export const Report2MenuSectionFragmentDoc = gql`
    fragment Report2MenuSection on ReportMenuSection {
  id
  sections {
    id
    title
  }
}
    `;
export const Report2SummaryCoverFragmentDoc = gql`
    fragment Report2SummaryCover on ReportSummaryCover {
  id
  title
  state
}
    `;
export const Report2SummaryKeyMetricsFragmentDoc = gql`
    fragment Report2SummaryKeyMetrics on ReportSummaryKeyMetrics {
  id
  title
  state
  trialMentionsDisclaimer
  prValue
  prValuePreviousYear
  prValueCurrency
  estimatedReach
  estimatedReachPreviousYear
  mentions
  mentionsPreviousYear
  netSentimentScore
  shareOfVoice
  shareOfVoicePreviousYear
  visibleMetrics
  ...Report2Section
}
    `;
export const Report2SectionInsightsFragmentDoc = gql`
    fragment Report2SectionInsights on ReportSectionInsights {
  id
  title
  state
  insights2 {
    id
    insight
    insightType
  }
}
    `;
export const Report2SummarySectionFragmentDoc = gql`
    fragment Report2SummarySection on ReportSummarySection {
  id
  title
  state
  subSections {
    ...Report2SummaryCover
    ...Report2SummaryKeyMetrics
    ...Report2SectionInsights
  }
}
    `;
export const Report2VisibilityOverviewFragmentDoc = gql`
    fragment Report2VisibilityOverview on ReportVisibilityOverview {
  id
  title
  state
  showArticleData
  showAudioVideoData
  showSocialMediaData
  summary {
    articleReachCurrentYear
    audioVideoReachCurrentYear
    socialMediaReachCurrentYear
    showAudioVideoDataCurrentYearUncompleteNotice
    showSocialMediaDataCurrentYearUncompleteNotice
    totalReachCurrentYear
    articleReachPreviousYear
    audioVideoReachPreviousYear
    socialMediaReachPreviousYear
    showAudioVideoDataPreviousYearUncompleteNotice
    showSocialMediaDataPreviousYearUncompleteNotice
    totalReachPreviousYear
    articleReachTrend
    audioVideoReachTrend
    socialMediaReachTrend
    totalReachTrend
    articleMentionsCurrentYear
    audioVideoMentionsCurrentYear
    socialMediaMentionsCurrentYear
    totalMentionsCurrentYear
    articleMentionsPreviousYear
    audioVideoMentionsPreviousYear
    socialMediaMentionsPreviousYear
    totalMentionsPreviousYear
    articleMentionsTrend
    audioVideoMentionsTrend
    socialMediaMentionsTrend
    totalMentionsTrend
  }
}
    `;
export const Report2VisibilityMentionsOverTimeFragmentDoc = gql`
    fragment Report2VisibilityMentionsOverTime on ReportVisibilityMentionsOverTime {
  id
  title
  state
  groupBy
  mentionsOverTime {
    startAt
    endAt
    startAtPreviousYear
    endAtPreviousYear
    week
    month
    mentions
    mentionsPreviousYear
  }
  insights2 {
    id
    title
    insight
    insightType
  }
}
    `;
export const Report2VisibilityReachOverTimeFragmentDoc = gql`
    fragment Report2VisibilityReachOverTime on ReportVisibilityReachOverTime {
  id
  title
  groupBy
  state
  reach {
    startAt
    endAt
    startAtPreviousYear
    endAtPreviousYear
    week
    month
    reach
    reachPreviousYear
  }
  insights2 {
    id
    title
    insight
    insightType
  }
}
    `;
export const ReportQuotation2FragmentDoc = gql`
    fragment ReportQuotation2 on ReportCoverageInterface {
  id
  sortIndex
  iconUrl
  iconUrlNoFallback
  imageUrl
  publishedAt
  source
  title
  url
  featured
  hidden
  description
  reach
  engagement
  prValue
  prValueCurrency
  sentiment
  embed
  audioUrl
  audioHitlines {
    id
    startPos
    endPos
    hitline
  }
}
    `;
export const Report2VisibilityHighlightsFragmentDoc = gql`
    fragment Report2VisibilityHighlights on ReportVisibilityHighlights {
  id
  title
  state
  activeImportJob {
    id
    state
    leftToProcess
  }
  quotations {
    totalCount
    edges {
      cursor
      node {
        id
        ...ReportQuotation2
      }
    }
  }
}
    `;
export const Report2VisibilitySectionFragmentDoc = gql`
    fragment Report2VisibilitySection on ReportVisibilitySection {
  id
  title
  state
  subSections {
    ...Report2VisibilityOverview
    ...Report2SectionInsights
    ...Report2VisibilityMentionsOverTime
    ...Report2VisibilityReachOverTime
    ...Report2VisibilityHighlights
  }
}
    `;
export const Report2VisibilityBenchmarkShareOfVoiceFragmentDoc = gql`
    fragment Report2VisibilityBenchmarkShareOfVoice on ReportVisibilityBenchmarkShareOfVoice {
  id
  title
  state
  reportMetrics {
    brandName
    mentions
    hitIds
    share
    trendPercentage
  }
  competitorMetrics {
    searchProfileId
    brandName
    mentions
    hitIds
    share
    trendPercentage
  }
  insights2 {
    id
    title
    insight
    insightType
  }
}
    `;
export const Report2VisibilityBenchmarkShareOfVoiceOverTimeFragmentDoc = gql`
    fragment Report2VisibilityBenchmarkShareOfVoiceOverTime on ReportVisibilityBenchmarkShareOfVoiceOverTime {
  id
  title
  state
  groupBy
  metrics {
    startAt
    endAt
    month
    week
    mentions
    name
    searchProfileIds
  }
  insights2 {
    id
    title
    insight
    insightType
  }
}
    `;
export const Report2VisibilityBenchmarkSectionFragmentDoc = gql`
    fragment Report2VisibilityBenchmarkSection on ReportVisibilityBenchmarkSection {
  id
  title
  state
  subSections {
    ...Report2VisibilityBenchmarkShareOfVoice
    ...Report2VisibilityBenchmarkShareOfVoiceOverTime
    ...Report2SectionInsights
  }
}
    `;
export const Report2PerceptionSentimentOverviewFragmentDoc = gql`
    fragment Report2PerceptionSentimentOverview on ReportPerceptionSentimentOverview {
  id
  title
  state
  perceptionSentimentMetrics: metrics {
    positiveSentimentPercent
    negativeSentimentPercent
    neutralSentimentPercent
    netSentimentScore
  }
}
    `;
export const Report2PerceptionSentimentOverTimeFragmentDoc = gql`
    fragment Report2PerceptionSentimentOverTime on ReportPerceptionSentimentOverTime {
  id
  title
  state
  groupBy
  sentimentAnalysis {
    startAt
    endAt
    week
    month
    positive
    negative
  }
  insights2 {
    id
    title
    insight
    insightType
  }
}
    `;
export const Report2PerceptionSectionFragmentDoc = gql`
    fragment Report2PerceptionSection on ReportPerceptionSection {
  id
  title
  state
  subSections {
    ...Report2PerceptionSentimentOverview
    ...Report2SectionInsights
    ...Report2PerceptionSentimentOverTime
  }
}
    `;
export const Report2PerceptionBenchmarkSentimentOverviewFragmentDoc = gql`
    fragment Report2PerceptionBenchmarkSentimentOverview on ReportPerceptionBenchmarkSentimentOverview {
  id
  title
  state
  metrics {
    brand
    searchProfileIds
    sentiment {
      positiveSentimentPercent
      negativeSentimentPercent
      neutralSentimentPercent
    }
  }
  insights2 {
    id
    title
    insight
    insightType
  }
}
    `;
export const Report2PerceptionBenchmarkSectionFragmentDoc = gql`
    fragment Report2PerceptionBenchmarkSection on ReportPerceptionBenchmarkSection {
  id
  title
  state
  subSections {
    ...Report2PerceptionBenchmarkSentimentOverview
    ...Report2SectionInsights
  }
}
    `;
export const BrandReportFragmentDoc = gql`
    fragment BrandReport on BrandReport {
  id
  pressroom {
    id
    timeZone
  }
  title
  description
  campaign
  companyName
  brandColor
  visibleMetrics
  version
  locale
  prValueSetting @include(if: $includePrValueSetting) {
    ...Report2PrValueSetting
  }
  coverImage {
    id
    url(transformation: LIMIT_1000)
  }
  logotype {
    id
    url(transformation: LIMIT_1000)
  }
  totalHits
  fromDate
  toDate
  state2
  ...BrandReportStaticData
  sections2 {
    id
    ...Report2Section
    ... on ReportMenuSection {
      id
      ...Report2MenuSection
    }
    ... on ReportSummarySection {
      id
      ...Report2SummarySection
    }
    ... on ReportVisibilitySection {
      id
      ...Report2VisibilitySection
    }
    ... on ReportVisibilityBenchmarkSection {
      id
      ...Report2VisibilityBenchmarkSection
    }
    ... on ReportPerceptionSection {
      id
      ...Report2PerceptionSection
    }
    ... on ReportPerceptionBenchmarkSection {
      id
      ...Report2PerceptionBenchmarkSection
    }
  }
}
    `;
export const HitDataFragmentDoc = gql`
    fragment HitData on MonitorHit {
  id
  author
  articleId
  mediaType2 {
    id
    name
  }
  publishedAt
  title
  hitLine
  link
  reach
  thumbnailUrl
  sourceName
  sourceVerification
  sentiment
  clipboards {
    id
  }
  audioUrl
  audioHitlines {
    id
    startPos
    endPos
    hitline
  }
  brandAiFilter(language: $language) {
    brandSentiment
    brandSentimentDesc
    analysis
    relevanceLevel
    relevancePoints
  }
}
    `;
export const HitDataWithDuplicatesFragmentDoc = gql`
    fragment HitDataWithDuplicates on MonitorHit {
  id
  ...HitData
  duplicates {
    id
    ...HitData
  }
}
    `;
export const DialogNoticesDocument = gql`
    query dialogNotices($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      ...DialogNoticeKeys
    }
  }
}
    ${DialogNoticeKeysFragmentDoc}`;

/**
 * __useDialogNoticesQuery__
 *
 * To run a query within a React component, call `useDialogNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialogNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDialogNoticesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDialogNoticesQuery(baseOptions: Apollo.QueryHookOptions<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables> & ({ variables: Types.DialogNoticesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables>(DialogNoticesDocument, options);
      }
export function useDialogNoticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables>(DialogNoticesDocument, options);
        }
export function useDialogNoticesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables>(DialogNoticesDocument, options);
        }
export type DialogNoticesQueryHookResult = ReturnType<typeof useDialogNoticesQuery>;
export type DialogNoticesLazyQueryHookResult = ReturnType<typeof useDialogNoticesLazyQuery>;
export type DialogNoticesSuspenseQueryHookResult = ReturnType<typeof useDialogNoticesSuspenseQuery>;
export type DialogNoticesQueryResult = Apollo.QueryResult<Types.DialogNoticesQuery, Types.DialogNoticesQueryVariables>;
export const SeenDialogNoticeDocument = gql`
    mutation seenDialogNotice($pressroomId: ID!, $notice: Notice!) {
  noticeConfirm(input: {notice: $notice, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      ...DialogNoticeKeys
    }
  }
}
    ${DialogNoticeKeysFragmentDoc}`;
export type SeenDialogNoticeMutationFn = Apollo.MutationFunction<Types.SeenDialogNoticeMutation, Types.SeenDialogNoticeMutationVariables>;

/**
 * __useSeenDialogNoticeMutation__
 *
 * To run a mutation, you first call `useSeenDialogNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenDialogNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenDialogNoticeMutation, { data, loading, error }] = useSeenDialogNoticeMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      notice: // value for 'notice'
 *   },
 * });
 */
export function useSeenDialogNoticeMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenDialogNoticeMutation, Types.SeenDialogNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenDialogNoticeMutation, Types.SeenDialogNoticeMutationVariables>(SeenDialogNoticeDocument, options);
      }
export type SeenDialogNoticeMutationHookResult = ReturnType<typeof useSeenDialogNoticeMutation>;
export type SeenDialogNoticeMutationResult = Apollo.MutationResult<Types.SeenDialogNoticeMutation>;
export type SeenDialogNoticeMutationOptions = Apollo.BaseMutationOptions<Types.SeenDialogNoticeMutation, Types.SeenDialogNoticeMutationVariables>;
export const GetEmailCreditsDocument = gql`
    query GetEmailCredits($sourceId: ID!, $pressroomId: ID!, $contactIds: [ID!], $contactListIds: [ID!], $followersAreFree: Boolean) {
  source(id: $sourceId) {
    id
    currency
    payingCustomer
    currentPlan
  }
  pressroom(id: $pressroomId) {
    id
    emailCredits {
      id
      total
      used
      usedFor(
        contactIds: $contactIds
        contactListIds: $contactListIds
        followersAreFree: $followersAreFree
      )
    }
  }
}
    `;

/**
 * __useGetEmailCreditsQuery__
 *
 * To run a query within a React component, call `useGetEmailCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailCreditsQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      pressroomId: // value for 'pressroomId'
 *      contactIds: // value for 'contactIds'
 *      contactListIds: // value for 'contactListIds'
 *      followersAreFree: // value for 'followersAreFree'
 *   },
 * });
 */
export function useGetEmailCreditsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables> & ({ variables: Types.GetEmailCreditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables>(GetEmailCreditsDocument, options);
      }
export function useGetEmailCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables>(GetEmailCreditsDocument, options);
        }
export function useGetEmailCreditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables>(GetEmailCreditsDocument, options);
        }
export type GetEmailCreditsQueryHookResult = ReturnType<typeof useGetEmailCreditsQuery>;
export type GetEmailCreditsLazyQueryHookResult = ReturnType<typeof useGetEmailCreditsLazyQuery>;
export type GetEmailCreditsSuspenseQueryHookResult = ReturnType<typeof useGetEmailCreditsSuspenseQuery>;
export type GetEmailCreditsQueryResult = Apollo.QueryResult<Types.GetEmailCreditsQuery, Types.GetEmailCreditsQueryVariables>;
export const GetShowGuideBannersDocument = gql`
    query getShowGuideBanners($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      guideBanner {
        ...GuideBannerKeys
      }
    }
  }
}
    ${GuideBannerKeysFragmentDoc}`;

/**
 * __useGetShowGuideBannersQuery__
 *
 * To run a query within a React component, call `useGetShowGuideBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowGuideBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowGuideBannersQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetShowGuideBannersQuery(baseOptions: Apollo.QueryHookOptions<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables> & ({ variables: Types.GetShowGuideBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables>(GetShowGuideBannersDocument, options);
      }
export function useGetShowGuideBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables>(GetShowGuideBannersDocument, options);
        }
export function useGetShowGuideBannersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables>(GetShowGuideBannersDocument, options);
        }
export type GetShowGuideBannersQueryHookResult = ReturnType<typeof useGetShowGuideBannersQuery>;
export type GetShowGuideBannersLazyQueryHookResult = ReturnType<typeof useGetShowGuideBannersLazyQuery>;
export type GetShowGuideBannersSuspenseQueryHookResult = ReturnType<typeof useGetShowGuideBannersSuspenseQuery>;
export type GetShowGuideBannersQueryResult = Apollo.QueryResult<Types.GetShowGuideBannersQuery, Types.GetShowGuideBannersQueryVariables>;
export const SeenGuideBannerDocument = gql`
    mutation seenGuideBanner($pressroomId: ID!, $notice: Notice!) {
  noticeConfirm(input: {notice: $notice, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      guideBanner {
        ...GuideBannerKeys
      }
    }
  }
}
    ${GuideBannerKeysFragmentDoc}`;
export type SeenGuideBannerMutationFn = Apollo.MutationFunction<Types.SeenGuideBannerMutation, Types.SeenGuideBannerMutationVariables>;

/**
 * __useSeenGuideBannerMutation__
 *
 * To run a mutation, you first call `useSeenGuideBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenGuideBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenGuideBannerMutation, { data, loading, error }] = useSeenGuideBannerMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      notice: // value for 'notice'
 *   },
 * });
 */
export function useSeenGuideBannerMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenGuideBannerMutation, Types.SeenGuideBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenGuideBannerMutation, Types.SeenGuideBannerMutationVariables>(SeenGuideBannerDocument, options);
      }
export type SeenGuideBannerMutationHookResult = ReturnType<typeof useSeenGuideBannerMutation>;
export type SeenGuideBannerMutationResult = Apollo.MutationResult<Types.SeenGuideBannerMutation>;
export type SeenGuideBannerMutationOptions = Apollo.BaseMutationOptions<Types.SeenGuideBannerMutation, Types.SeenGuideBannerMutationVariables>;
export const PurchaseCommercialProductDocument = gql`
    mutation purchaseCommercialProduct($pressroomId: ID!, $products: [CommercialProductPurchaseProduct!]!) {
  commercialProductPurchase(
    input: {pressroomId: $pressroomId, products: $products}
  ) {
    pressroom {
      id
    }
    error {
      message
    }
  }
}
    `;
export type PurchaseCommercialProductMutationFn = Apollo.MutationFunction<Types.PurchaseCommercialProductMutation, Types.PurchaseCommercialProductMutationVariables>;

/**
 * __usePurchaseCommercialProductMutation__
 *
 * To run a mutation, you first call `usePurchaseCommercialProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseCommercialProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseCommercialProductMutation, { data, loading, error }] = usePurchaseCommercialProductMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      products: // value for 'products'
 *   },
 * });
 */
export function usePurchaseCommercialProductMutation(baseOptions?: Apollo.MutationHookOptions<Types.PurchaseCommercialProductMutation, Types.PurchaseCommercialProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PurchaseCommercialProductMutation, Types.PurchaseCommercialProductMutationVariables>(PurchaseCommercialProductDocument, options);
      }
export type PurchaseCommercialProductMutationHookResult = ReturnType<typeof usePurchaseCommercialProductMutation>;
export type PurchaseCommercialProductMutationResult = Apollo.MutationResult<Types.PurchaseCommercialProductMutation>;
export type PurchaseCommercialProductMutationOptions = Apollo.BaseMutationOptions<Types.PurchaseCommercialProductMutation, Types.PurchaseCommercialProductMutationVariables>;
export const PurchaseModalDocument = gql`
    query PurchaseModal($sourceId: ID!) {
  source(id: $sourceId) {
    id
    currency
  }
}
    `;

/**
 * __usePurchaseModalQuery__
 *
 * To run a query within a React component, call `usePurchaseModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseModalQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function usePurchaseModalQuery(baseOptions: Apollo.QueryHookOptions<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables> & ({ variables: Types.PurchaseModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables>(PurchaseModalDocument, options);
      }
export function usePurchaseModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables>(PurchaseModalDocument, options);
        }
export function usePurchaseModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables>(PurchaseModalDocument, options);
        }
export type PurchaseModalQueryHookResult = ReturnType<typeof usePurchaseModalQuery>;
export type PurchaseModalLazyQueryHookResult = ReturnType<typeof usePurchaseModalLazyQuery>;
export type PurchaseModalSuspenseQueryHookResult = ReturnType<typeof usePurchaseModalSuspenseQuery>;
export type PurchaseModalQueryResult = Apollo.QueryResult<Types.PurchaseModalQuery, Types.PurchaseModalQueryVariables>;
export const GetTrackingInitialDataDocument = gql`
    query GetTrackingInitialData($pressroomId: ID!, $skipPressroom: Boolean!, $sourceId: ID!, $skipSource: Boolean!) {
  me {
    id
    user {
      id
      name
      username
      email
      type
      locale: locale2
    }
  }
  source(id: $sourceId) @skip(if: $skipSource) {
    id
    currentPlan
    customerId
    trial
    accountInfo {
      buyerPersona
      companySize
      tier
    }
    origin
  }
  pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
    id
    live
    features {
      id
      ...BetaFeatures
      ...CopilotFeatures
      duplicateMaterial: managed(feature: duplicateMaterial) {
        id
        enabled
      }
      cloneStoryMaterial
    }
  }
}
    ${BetaFeaturesFragmentDoc}
${CopilotFeaturesFragmentDoc}`;

/**
 * __useGetTrackingInitialDataQuery__
 *
 * To run a query within a React component, call `useGetTrackingInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackingInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackingInitialDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      skipPressroom: // value for 'skipPressroom'
 *      sourceId: // value for 'sourceId'
 *      skipSource: // value for 'skipSource'
 *   },
 * });
 */
export function useGetTrackingInitialDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables> & ({ variables: Types.GetTrackingInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables>(GetTrackingInitialDataDocument, options);
      }
export function useGetTrackingInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables>(GetTrackingInitialDataDocument, options);
        }
export function useGetTrackingInitialDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables>(GetTrackingInitialDataDocument, options);
        }
export type GetTrackingInitialDataQueryHookResult = ReturnType<typeof useGetTrackingInitialDataQuery>;
export type GetTrackingInitialDataLazyQueryHookResult = ReturnType<typeof useGetTrackingInitialDataLazyQuery>;
export type GetTrackingInitialDataSuspenseQueryHookResult = ReturnType<typeof useGetTrackingInitialDataSuspenseQuery>;
export type GetTrackingInitialDataQueryResult = Apollo.QueryResult<Types.GetTrackingInitialDataQuery, Types.GetTrackingInitialDataQueryVariables>;
export const GetPressroomListDocument = gql`
    query GetPressroomList($sourceId: ID!) {
  source(id: $sourceId) {
    id
    trusted
    pressrooms {
      id
      name
      siteCode
    }
  }
}
    `;

/**
 * __useGetPressroomListQuery__
 *
 * To run a query within a React component, call `useGetPressroomListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressroomListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressroomListQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetPressroomListQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables> & ({ variables: Types.GetPressroomListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables>(GetPressroomListDocument, options);
      }
export function useGetPressroomListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables>(GetPressroomListDocument, options);
        }
export function useGetPressroomListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables>(GetPressroomListDocument, options);
        }
export type GetPressroomListQueryHookResult = ReturnType<typeof useGetPressroomListQuery>;
export type GetPressroomListLazyQueryHookResult = ReturnType<typeof useGetPressroomListLazyQuery>;
export type GetPressroomListSuspenseQueryHookResult = ReturnType<typeof useGetPressroomListSuspenseQuery>;
export type GetPressroomListQueryResult = Apollo.QueryResult<Types.GetPressroomListQuery, Types.GetPressroomListQueryVariables>;
export const GetContactPeopleDocument = gql`
    query GetContactPeople($pressroomId: ID!, $page: Int!, $filter: String) {
  pressroom(id: $pressroomId) {
    id
    contactPeopleList(page: $page, query: $filter, perPage: 11) {
      id
      totalPages
      currentPage
      totalCount
      totalUnscheduledActivePinnedCount
      contactPeople: contactPeople2 {
        id
        name
        visibleSince
        imageUrl
        showAsPressroomContact
        scheduledPublishAt
        scheduledUnpublishAt
      }
    }
  }
}
    `;

/**
 * __useGetContactPeopleQuery__
 *
 * To run a query within a React component, call `useGetContactPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPeopleQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetContactPeopleQuery(baseOptions: Apollo.QueryHookOptions<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables> & ({ variables: Types.GetContactPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables>(GetContactPeopleDocument, options);
      }
export function useGetContactPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables>(GetContactPeopleDocument, options);
        }
export function useGetContactPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables>(GetContactPeopleDocument, options);
        }
export type GetContactPeopleQueryHookResult = ReturnType<typeof useGetContactPeopleQuery>;
export type GetContactPeopleLazyQueryHookResult = ReturnType<typeof useGetContactPeopleLazyQuery>;
export type GetContactPeopleSuspenseQueryHookResult = ReturnType<typeof useGetContactPeopleSuspenseQuery>;
export type GetContactPeopleQueryResult = Apollo.QueryResult<Types.GetContactPeopleQuery, Types.GetContactPeopleQueryVariables>;
export const ConnectPersonToMaterialDocument = gql`
    mutation ConnectPersonToMaterial($materialId: ID!, $materialType: MaterialType!, $contactPersonId: ID!) {
  contactPersonConnect(
    input: {materialId: $materialId, materialType: $materialType, contactPersonId: $contactPersonId}
  ) {
    error {
      message
    }
    material {
      id
      ... on StoryMaterial {
        contactPeople: contactPeople2 {
          id
        }
      }
      ... on Event {
        contactPeople: contactPeople2 {
          id
        }
      }
      ... on Video {
        contactPeople: contactPeople2 {
          id
        }
      }
      ... on Document {
        contactPeople: contactPeople2 {
          id
        }
      }
    }
  }
}
    `;
export type ConnectPersonToMaterialMutationFn = Apollo.MutationFunction<Types.ConnectPersonToMaterialMutation, Types.ConnectPersonToMaterialMutationVariables>;

/**
 * __useConnectPersonToMaterialMutation__
 *
 * To run a mutation, you first call `useConnectPersonToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPersonToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPersonToMaterialMutation, { data, loading, error }] = useConnectPersonToMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      contactPersonId: // value for 'contactPersonId'
 *   },
 * });
 */
export function useConnectPersonToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConnectPersonToMaterialMutation, Types.ConnectPersonToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConnectPersonToMaterialMutation, Types.ConnectPersonToMaterialMutationVariables>(ConnectPersonToMaterialDocument, options);
      }
export type ConnectPersonToMaterialMutationHookResult = ReturnType<typeof useConnectPersonToMaterialMutation>;
export type ConnectPersonToMaterialMutationResult = Apollo.MutationResult<Types.ConnectPersonToMaterialMutation>;
export type ConnectPersonToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.ConnectPersonToMaterialMutation, Types.ConnectPersonToMaterialMutationVariables>;
export const DisconnectPersonToMaterialDocument = gql`
    mutation DisconnectPersonToMaterial($materialId: ID!, $materialType: MaterialType!, $contactPersonId: ID!) {
  contactPersonDisconnect(
    input: {materialId: $materialId, materialType: $materialType, contactPersonId: $contactPersonId}
  ) {
    error {
      message
    }
    material {
      id
      ... on StoryMaterial {
        contactPeople: contactPeople2 {
          id
        }
      }
      ... on Event {
        contactPeople: contactPeople2 {
          id
        }
      }
      ... on Video {
        contactPeople: contactPeople2 {
          id
        }
      }
      ... on Document {
        contactPeople: contactPeople2 {
          id
        }
      }
    }
  }
}
    `;
export type DisconnectPersonToMaterialMutationFn = Apollo.MutationFunction<Types.DisconnectPersonToMaterialMutation, Types.DisconnectPersonToMaterialMutationVariables>;

/**
 * __useDisconnectPersonToMaterialMutation__
 *
 * To run a mutation, you first call `useDisconnectPersonToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectPersonToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectPersonToMaterialMutation, { data, loading, error }] = useDisconnectPersonToMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      contactPersonId: // value for 'contactPersonId'
 *   },
 * });
 */
export function useDisconnectPersonToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisconnectPersonToMaterialMutation, Types.DisconnectPersonToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisconnectPersonToMaterialMutation, Types.DisconnectPersonToMaterialMutationVariables>(DisconnectPersonToMaterialDocument, options);
      }
export type DisconnectPersonToMaterialMutationHookResult = ReturnType<typeof useDisconnectPersonToMaterialMutation>;
export type DisconnectPersonToMaterialMutationResult = Apollo.MutationResult<Types.DisconnectPersonToMaterialMutation>;
export type DisconnectPersonToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.DisconnectPersonToMaterialMutation, Types.DisconnectPersonToMaterialMutationVariables>;
export const MediaPickerDocument = gql`
    query MediaPicker($pressroomId: ID!, $type: MaterialType!, $after: String, $query: String, $status: MaterialStatusFilter, $sort: MaterialListSort, $exclude: [Int!], $first: Int!, $imageStatus: ImageStatusFilter, $imageSort: ImageSort, $isImageQuery: Boolean!) {
  pressroom(id: $pressroomId) {
    id
    materialList: materialList2(
      first: $first
      types: [$type]
      query: $query
      status: $status
      sort: $sort
      after: $after
      exclude: $exclude
    ) @skip(if: $isImageQuery) {
      currentPage
      totalPages
      materials: nodes {
        id
        ...ModalMedia
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    images(
      first: $first
      status2: $imageStatus
      query: $query
      after: $after
      sortBy: $imageSort
    ) @include(if: $isImageQuery) {
      currentPage
      totalPages
      materials: nodes {
        id
        ...MediaPickerImage
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;

/**
 * __useMediaPickerQuery__
 *
 * To run a query within a React component, call `useMediaPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaPickerQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      type: // value for 'type'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      exclude: // value for 'exclude'
 *      first: // value for 'first'
 *      imageStatus: // value for 'imageStatus'
 *      imageSort: // value for 'imageSort'
 *      isImageQuery: // value for 'isImageQuery'
 *   },
 * });
 */
export function useMediaPickerQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaPickerQuery, Types.MediaPickerQueryVariables> & ({ variables: Types.MediaPickerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaPickerQuery, Types.MediaPickerQueryVariables>(MediaPickerDocument, options);
      }
export function useMediaPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaPickerQuery, Types.MediaPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaPickerQuery, Types.MediaPickerQueryVariables>(MediaPickerDocument, options);
        }
export function useMediaPickerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaPickerQuery, Types.MediaPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaPickerQuery, Types.MediaPickerQueryVariables>(MediaPickerDocument, options);
        }
export type MediaPickerQueryHookResult = ReturnType<typeof useMediaPickerQuery>;
export type MediaPickerLazyQueryHookResult = ReturnType<typeof useMediaPickerLazyQuery>;
export type MediaPickerSuspenseQueryHookResult = ReturnType<typeof useMediaPickerSuspenseQuery>;
export type MediaPickerQueryResult = Apollo.QueryResult<Types.MediaPickerQuery, Types.MediaPickerQueryVariables>;
export const StoryMaterialPickerDocument = gql`
    query StoryMaterialPicker($pressroomId: ID!, $query: String, $page: Int = 1, $type: MaterialType!, $exclude: [Int!]) {
  pressroom(id: $pressroomId) {
    id
    materialList(type: $type, page: $page, query: $query, exclude: $exclude) {
      currentPage
      totalPages
      materials {
        id
        ...ModalStoryMaterial
      }
    }
  }
}
    ${ModalStoryMaterialFragmentDoc}`;

/**
 * __useStoryMaterialPickerQuery__
 *
 * To run a query within a React component, call `useStoryMaterialPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryMaterialPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryMaterialPickerQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      type: // value for 'type'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useStoryMaterialPickerQuery(baseOptions: Apollo.QueryHookOptions<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables> & ({ variables: Types.StoryMaterialPickerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables>(StoryMaterialPickerDocument, options);
      }
export function useStoryMaterialPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables>(StoryMaterialPickerDocument, options);
        }
export function useStoryMaterialPickerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables>(StoryMaterialPickerDocument, options);
        }
export type StoryMaterialPickerQueryHookResult = ReturnType<typeof useStoryMaterialPickerQuery>;
export type StoryMaterialPickerLazyQueryHookResult = ReturnType<typeof useStoryMaterialPickerLazyQuery>;
export type StoryMaterialPickerSuspenseQueryHookResult = ReturnType<typeof useStoryMaterialPickerSuspenseQuery>;
export type StoryMaterialPickerQueryResult = Apollo.QueryResult<Types.StoryMaterialPickerQuery, Types.StoryMaterialPickerQueryVariables>;
export const NoticesDocument = gql`
    query Notices($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
    }
  }
}
    `;

/**
 * __useNoticesQuery__
 *
 * To run a query within a React component, call `useNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoticesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useNoticesQuery(baseOptions: Apollo.QueryHookOptions<Types.NoticesQuery, Types.NoticesQueryVariables> & ({ variables: Types.NoticesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NoticesQuery, Types.NoticesQueryVariables>(NoticesDocument, options);
      }
export function useNoticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NoticesQuery, Types.NoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NoticesQuery, Types.NoticesQueryVariables>(NoticesDocument, options);
        }
export function useNoticesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NoticesQuery, Types.NoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NoticesQuery, Types.NoticesQueryVariables>(NoticesDocument, options);
        }
export type NoticesQueryHookResult = ReturnType<typeof useNoticesQuery>;
export type NoticesLazyQueryHookResult = ReturnType<typeof useNoticesLazyQuery>;
export type NoticesSuspenseQueryHookResult = ReturnType<typeof useNoticesSuspenseQuery>;
export type NoticesQueryResult = Apollo.QueryResult<Types.NoticesQuery, Types.NoticesQueryVariables>;
export const OutdatedClientDocument = gql`
    query OutdatedClient {
  outdatedClient
}
    `;

/**
 * __useOutdatedClientQuery__
 *
 * To run a query within a React component, call `useOutdatedClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutdatedClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutdatedClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutdatedClientQuery(baseOptions?: Apollo.QueryHookOptions<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>(OutdatedClientDocument, options);
      }
export function useOutdatedClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>(OutdatedClientDocument, options);
        }
export function useOutdatedClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>(OutdatedClientDocument, options);
        }
export type OutdatedClientQueryHookResult = ReturnType<typeof useOutdatedClientQuery>;
export type OutdatedClientLazyQueryHookResult = ReturnType<typeof useOutdatedClientLazyQuery>;
export type OutdatedClientSuspenseQueryHookResult = ReturnType<typeof useOutdatedClientSuspenseQuery>;
export type OutdatedClientQueryResult = Apollo.QueryResult<Types.OutdatedClientQuery, Types.OutdatedClientQueryVariables>;
export const SyncCloudinaryDocumentDocument = gql`
    mutation SyncCloudinaryDocument($pressroomId: ID!, $documentId: ID, $cloudinaryId: ID!, $cloudinaryVersion: Int!, $cloudinaryFormat: String!, $cloudinaryBytes: Int!, $fileName: String!) {
  documentSyncCloudinaryUpload(
    input: {pressroomId: $pressroomId, cloudinaryId: $cloudinaryId, cloudinaryVersion: $cloudinaryVersion, documentId: $documentId, cloudinaryFormat: $cloudinaryFormat, cloudinaryBytes: $cloudinaryBytes, fileName: $fileName}
  ) {
    error {
      message
    }
    document {
      id
      header
      resourceDocument {
        id
        cloudinaryId
        name
      }
    }
  }
}
    `;
export type SyncCloudinaryDocumentMutationFn = Apollo.MutationFunction<Types.SyncCloudinaryDocumentMutation, Types.SyncCloudinaryDocumentMutationVariables>;

/**
 * __useSyncCloudinaryDocumentMutation__
 *
 * To run a mutation, you first call `useSyncCloudinaryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCloudinaryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCloudinaryDocumentMutation, { data, loading, error }] = useSyncCloudinaryDocumentMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      documentId: // value for 'documentId'
 *      cloudinaryId: // value for 'cloudinaryId'
 *      cloudinaryVersion: // value for 'cloudinaryVersion'
 *      cloudinaryFormat: // value for 'cloudinaryFormat'
 *      cloudinaryBytes: // value for 'cloudinaryBytes'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useSyncCloudinaryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncCloudinaryDocumentMutation, Types.SyncCloudinaryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncCloudinaryDocumentMutation, Types.SyncCloudinaryDocumentMutationVariables>(SyncCloudinaryDocumentDocument, options);
      }
export type SyncCloudinaryDocumentMutationHookResult = ReturnType<typeof useSyncCloudinaryDocumentMutation>;
export type SyncCloudinaryDocumentMutationResult = Apollo.MutationResult<Types.SyncCloudinaryDocumentMutation>;
export type SyncCloudinaryDocumentMutationOptions = Apollo.BaseMutationOptions<Types.SyncCloudinaryDocumentMutation, Types.SyncCloudinaryDocumentMutationVariables>;
export const SyncCloudinaryImageDocument = gql`
    mutation SyncCloudinaryImage($pressroomId: ID!, $cloudinaryId: ID!, $cloudinaryFormat: String, $cloudinaryVersion: Int!, $cloudinaryBytes: Int, $cloudinaryWidth: Int, $cloudinaryHeight: Int, $fileName: String, $displayTransformation: CloudinaryTransformations) {
  imageSyncCloudinaryUpload(
    input: {pressroomId: $pressroomId, cloudinaryId: $cloudinaryId, cloudinaryVersion: $cloudinaryVersion, cloudinaryFormat: $cloudinaryFormat, cloudinaryBytes: $cloudinaryBytes, cloudinaryWidth: $cloudinaryWidth, cloudinaryHeight: $cloudinaryHeight, fileName: $fileName}
  ) {
    error {
      message
    }
    image {
      id
      cloudinaryId
      resourceImageId
      url(transformation: $displayTransformation)
      croppedUrl: url
      coverImageGravity {
        x
        y
      }
    }
  }
}
    `;
export type SyncCloudinaryImageMutationFn = Apollo.MutationFunction<Types.SyncCloudinaryImageMutation, Types.SyncCloudinaryImageMutationVariables>;

/**
 * __useSyncCloudinaryImageMutation__
 *
 * To run a mutation, you first call `useSyncCloudinaryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCloudinaryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCloudinaryImageMutation, { data, loading, error }] = useSyncCloudinaryImageMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      cloudinaryId: // value for 'cloudinaryId'
 *      cloudinaryFormat: // value for 'cloudinaryFormat'
 *      cloudinaryVersion: // value for 'cloudinaryVersion'
 *      cloudinaryBytes: // value for 'cloudinaryBytes'
 *      cloudinaryWidth: // value for 'cloudinaryWidth'
 *      cloudinaryHeight: // value for 'cloudinaryHeight'
 *      fileName: // value for 'fileName'
 *      displayTransformation: // value for 'displayTransformation'
 *   },
 * });
 */
export function useSyncCloudinaryImageMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncCloudinaryImageMutation, Types.SyncCloudinaryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncCloudinaryImageMutation, Types.SyncCloudinaryImageMutationVariables>(SyncCloudinaryImageDocument, options);
      }
export type SyncCloudinaryImageMutationHookResult = ReturnType<typeof useSyncCloudinaryImageMutation>;
export type SyncCloudinaryImageMutationResult = Apollo.MutationResult<Types.SyncCloudinaryImageMutation>;
export type SyncCloudinaryImageMutationOptions = Apollo.BaseMutationOptions<Types.SyncCloudinaryImageMutation, Types.SyncCloudinaryImageMutationVariables>;
export const GetDistributionSummaryDataDocument = gql`
    query GetDistributionSummaryData($id: ID!, $type: MaterialType!) {
  material(id: $id, type: $type) {
    id
    scheduledFor
    publishedAt2
    backdatingThresholdDays
  }
}
    `;

/**
 * __useGetDistributionSummaryDataQuery__
 *
 * To run a query within a React component, call `useGetDistributionSummaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionSummaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionSummaryDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDistributionSummaryDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables> & ({ variables: Types.GetDistributionSummaryDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables>(GetDistributionSummaryDataDocument, options);
      }
export function useGetDistributionSummaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables>(GetDistributionSummaryDataDocument, options);
        }
export function useGetDistributionSummaryDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables>(GetDistributionSummaryDataDocument, options);
        }
export type GetDistributionSummaryDataQueryHookResult = ReturnType<typeof useGetDistributionSummaryDataQuery>;
export type GetDistributionSummaryDataLazyQueryHookResult = ReturnType<typeof useGetDistributionSummaryDataLazyQuery>;
export type GetDistributionSummaryDataSuspenseQueryHookResult = ReturnType<typeof useGetDistributionSummaryDataSuspenseQuery>;
export type GetDistributionSummaryDataQueryResult = Apollo.QueryResult<Types.GetDistributionSummaryDataQuery, Types.GetDistributionSummaryDataQueryVariables>;
export const IsPressroomLiveDocument = gql`
    query isPressroomLive($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    live
  }
}
    `;

/**
 * __useIsPressroomLiveQuery__
 *
 * To run a query within a React component, call `useIsPressroomLiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPressroomLiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPressroomLiveQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useIsPressroomLiveQuery(baseOptions: Apollo.QueryHookOptions<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables> & ({ variables: Types.IsPressroomLiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables>(IsPressroomLiveDocument, options);
      }
export function useIsPressroomLiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables>(IsPressroomLiveDocument, options);
        }
export function useIsPressroomLiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables>(IsPressroomLiveDocument, options);
        }
export type IsPressroomLiveQueryHookResult = ReturnType<typeof useIsPressroomLiveQuery>;
export type IsPressroomLiveLazyQueryHookResult = ReturnType<typeof useIsPressroomLiveLazyQuery>;
export type IsPressroomLiveSuspenseQueryHookResult = ReturnType<typeof useIsPressroomLiveSuspenseQuery>;
export type IsPressroomLiveQueryResult = Apollo.QueryResult<Types.IsPressroomLiveQuery, Types.IsPressroomLiveQueryVariables>;
export const ApiTokenDocument = gql`
    query ApiToken($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    mndOpenaiWrapperToken
  }
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: Apollo.QueryHookOptions<Types.ApiTokenQuery, Types.ApiTokenQueryVariables> & ({ variables: Types.ApiTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ApiTokenQuery, Types.ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ApiTokenQuery, Types.ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ApiTokenQuery, Types.ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export function useApiTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ApiTokenQuery, Types.ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ApiTokenQuery, Types.ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenSuspenseQueryHookResult = ReturnType<typeof useApiTokenSuspenseQuery>;
export type ApiTokenQueryResult = Apollo.QueryResult<Types.ApiTokenQuery, Types.ApiTokenQueryVariables>;
export const ReportQuotationStatsDocument = gql`
    query ReportQuotationStats($id: ID!) {
  report: report2(id: $id) {
    id
    sections2 {
      id
      ... on ReportQuotationFullWidthSection {
        quotations {
          edges {
            node {
              id
              reach
              engagement
              url
              prValue
              prValueCurrency
            }
          }
        }
      }
      ... on ReportQuotationGridSection {
        quotations {
          edges {
            node {
              id
              reach
              engagement
              url
              prValue
              prValueCurrency
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReportQuotationStatsQuery__
 *
 * To run a query within a React component, call `useReportQuotationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuotationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuotationStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuotationStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables> & ({ variables: Types.ReportQuotationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables>(ReportQuotationStatsDocument, options);
      }
export function useReportQuotationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables>(ReportQuotationStatsDocument, options);
        }
export function useReportQuotationStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables>(ReportQuotationStatsDocument, options);
        }
export type ReportQuotationStatsQueryHookResult = ReturnType<typeof useReportQuotationStatsQuery>;
export type ReportQuotationStatsLazyQueryHookResult = ReturnType<typeof useReportQuotationStatsLazyQuery>;
export type ReportQuotationStatsSuspenseQueryHookResult = ReturnType<typeof useReportQuotationStatsSuspenseQuery>;
export type ReportQuotationStatsQueryResult = Apollo.QueryResult<Types.ReportQuotationStatsQuery, Types.ReportQuotationStatsQueryVariables>;
export const UnscheduleMaterialDocument = gql`
    mutation UnscheduleMaterial($input: MaterialUnscheduleInput!) {
  materialUnschedule(input: $input) {
    error {
      __typename
    }
    materials {
      id
      status
      scheduledFor
    }
    pressroom {
      id
    }
  }
}
    `;
export type UnscheduleMaterialMutationFn = Apollo.MutationFunction<Types.UnscheduleMaterialMutation, Types.UnscheduleMaterialMutationVariables>;

/**
 * __useUnscheduleMaterialMutation__
 *
 * To run a mutation, you first call `useUnscheduleMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleMaterialMutation, { data, loading, error }] = useUnscheduleMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnscheduleMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.UnscheduleMaterialMutation, Types.UnscheduleMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnscheduleMaterialMutation, Types.UnscheduleMaterialMutationVariables>(UnscheduleMaterialDocument, options);
      }
export type UnscheduleMaterialMutationHookResult = ReturnType<typeof useUnscheduleMaterialMutation>;
export type UnscheduleMaterialMutationResult = Apollo.MutationResult<Types.UnscheduleMaterialMutation>;
export type UnscheduleMaterialMutationOptions = Apollo.BaseMutationOptions<Types.UnscheduleMaterialMutation, Types.UnscheduleMaterialMutationVariables>;
export const NpsDocument = gql`
    query Nps {
  me {
    id
    user {
      id
      showNps
    }
  }
}
    `;

/**
 * __useNpsQuery__
 *
 * To run a query within a React component, call `useNpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNpsQuery(baseOptions?: Apollo.QueryHookOptions<Types.NpsQuery, Types.NpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NpsQuery, Types.NpsQueryVariables>(NpsDocument, options);
      }
export function useNpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NpsQuery, Types.NpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NpsQuery, Types.NpsQueryVariables>(NpsDocument, options);
        }
export function useNpsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NpsQuery, Types.NpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NpsQuery, Types.NpsQueryVariables>(NpsDocument, options);
        }
export type NpsQueryHookResult = ReturnType<typeof useNpsQuery>;
export type NpsLazyQueryHookResult = ReturnType<typeof useNpsLazyQuery>;
export type NpsSuspenseQueryHookResult = ReturnType<typeof useNpsSuspenseQuery>;
export type NpsQueryResult = Apollo.QueryResult<Types.NpsQuery, Types.NpsQueryVariables>;
export const NpsAnswerDocument = gql`
    mutation npsAnswer($pressroomId: ID!, $score: Int!, $freetext: String) {
  npsAnswer(
    input: {pressroomId: $pressroomId, score: $score, freetext: $freetext}
  ) {
    error {
      message
    }
    user {
      id
      showNps
    }
  }
}
    `;
export type NpsAnswerMutationFn = Apollo.MutationFunction<Types.NpsAnswerMutation, Types.NpsAnswerMutationVariables>;

/**
 * __useNpsAnswerMutation__
 *
 * To run a mutation, you first call `useNpsAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsAnswerMutation, { data, loading, error }] = useNpsAnswerMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      score: // value for 'score'
 *      freetext: // value for 'freetext'
 *   },
 * });
 */
export function useNpsAnswerMutation(baseOptions?: Apollo.MutationHookOptions<Types.NpsAnswerMutation, Types.NpsAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NpsAnswerMutation, Types.NpsAnswerMutationVariables>(NpsAnswerDocument, options);
      }
export type NpsAnswerMutationHookResult = ReturnType<typeof useNpsAnswerMutation>;
export type NpsAnswerMutationResult = Apollo.MutationResult<Types.NpsAnswerMutation>;
export type NpsAnswerMutationOptions = Apollo.BaseMutationOptions<Types.NpsAnswerMutation, Types.NpsAnswerMutationVariables>;
export const GetAccessesDocument = gql`
    query GetAccesses($sourceId: ID!) {
  source(id: $sourceId) {
    id
    name
    users {
      id
      email
      name
      title
      username
      accountOwner(sourceId: $sourceId)
      enabled2fa
    }
    features {
      id
      removeUser
      promoteToAccountOwner
    }
    invitations {
      id
      email
      invitedAt
    }
  }
}
    `;

/**
 * __useGetAccessesQuery__
 *
 * To run a query within a React component, call `useGetAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessesQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetAccessesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAccessesQuery, Types.GetAccessesQueryVariables> & ({ variables: Types.GetAccessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAccessesQuery, Types.GetAccessesQueryVariables>(GetAccessesDocument, options);
      }
export function useGetAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAccessesQuery, Types.GetAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAccessesQuery, Types.GetAccessesQueryVariables>(GetAccessesDocument, options);
        }
export function useGetAccessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAccessesQuery, Types.GetAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAccessesQuery, Types.GetAccessesQueryVariables>(GetAccessesDocument, options);
        }
export type GetAccessesQueryHookResult = ReturnType<typeof useGetAccessesQuery>;
export type GetAccessesLazyQueryHookResult = ReturnType<typeof useGetAccessesLazyQuery>;
export type GetAccessesSuspenseQueryHookResult = ReturnType<typeof useGetAccessesSuspenseQuery>;
export type GetAccessesQueryResult = Apollo.QueryResult<Types.GetAccessesQuery, Types.GetAccessesQueryVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($email: String!, $sourceId: ID!) {
  userInvitationCreate(input: {email: $email, sourceId: $sourceId}) {
    error {
      message
      ... on UserInvitationCreateValidationError {
        email
      }
      __typename
    }
    source {
      id
      invitations {
        id
        email
        invitedAt
      }
    }
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<Types.InviteUserMutation, Types.InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.InviteUserMutation, Types.InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InviteUserMutation, Types.InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<Types.InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<Types.InviteUserMutation, Types.InviteUserMutationVariables>;
export const UninviteUserDocument = gql`
    mutation UninviteUser($id: ID!, $sourceId: ID!) {
  userInvitationDelete(input: {id: $id, sourceId: $sourceId}) {
    error {
      message
      __typename
    }
    source {
      id
      invitations {
        id
        email
        invitedAt
      }
    }
  }
}
    `;
export type UninviteUserMutationFn = Apollo.MutationFunction<Types.UninviteUserMutation, Types.UninviteUserMutationVariables>;

/**
 * __useUninviteUserMutation__
 *
 * To run a mutation, you first call `useUninviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUninviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uninviteUserMutation, { data, loading, error }] = useUninviteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useUninviteUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UninviteUserMutation, Types.UninviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UninviteUserMutation, Types.UninviteUserMutationVariables>(UninviteUserDocument, options);
      }
export type UninviteUserMutationHookResult = ReturnType<typeof useUninviteUserMutation>;
export type UninviteUserMutationResult = Apollo.MutationResult<Types.UninviteUserMutation>;
export type UninviteUserMutationOptions = Apollo.BaseMutationOptions<Types.UninviteUserMutation, Types.UninviteUserMutationVariables>;
export const RemoveUserAccessDocument = gql`
    mutation RemoveUserAccess($userId: ID!, $sourceId: ID!) {
  userAccessDelete(input: {userId: $userId, sourceId: $sourceId}) {
    error {
      message
    }
    source {
      id
      features {
        id
        removeUser
      }
      users {
        id
      }
    }
  }
}
    `;
export type RemoveUserAccessMutationFn = Apollo.MutationFunction<Types.RemoveUserAccessMutation, Types.RemoveUserAccessMutationVariables>;

/**
 * __useRemoveUserAccessMutation__
 *
 * To run a mutation, you first call `useRemoveUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserAccessMutation, { data, loading, error }] = useRemoveUserAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useRemoveUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveUserAccessMutation, Types.RemoveUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveUserAccessMutation, Types.RemoveUserAccessMutationVariables>(RemoveUserAccessDocument, options);
      }
export type RemoveUserAccessMutationHookResult = ReturnType<typeof useRemoveUserAccessMutation>;
export type RemoveUserAccessMutationResult = Apollo.MutationResult<Types.RemoveUserAccessMutation>;
export type RemoveUserAccessMutationOptions = Apollo.BaseMutationOptions<Types.RemoveUserAccessMutation, Types.RemoveUserAccessMutationVariables>;
export const PromoteToOwnerDocument = gql`
    mutation PromoteToOwner($userId: ID!, $sourceId: ID!) {
  userPromoteToOwner(input: {userId: $userId, sourceId: $sourceId}) {
    sourceFeatures {
      id
      promoteToAccountOwner
      removeUser
    }
    updatedUsers {
      id
      accountOwner(sourceId: $sourceId)
    }
    error {
      message
    }
  }
}
    `;
export type PromoteToOwnerMutationFn = Apollo.MutationFunction<Types.PromoteToOwnerMutation, Types.PromoteToOwnerMutationVariables>;

/**
 * __usePromoteToOwnerMutation__
 *
 * To run a mutation, you first call `usePromoteToOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteToOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteToOwnerMutation, { data, loading, error }] = usePromoteToOwnerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function usePromoteToOwnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.PromoteToOwnerMutation, Types.PromoteToOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PromoteToOwnerMutation, Types.PromoteToOwnerMutationVariables>(PromoteToOwnerDocument, options);
      }
export type PromoteToOwnerMutationHookResult = ReturnType<typeof usePromoteToOwnerMutation>;
export type PromoteToOwnerMutationResult = Apollo.MutationResult<Types.PromoteToOwnerMutation>;
export type PromoteToOwnerMutationOptions = Apollo.BaseMutationOptions<Types.PromoteToOwnerMutation, Types.PromoteToOwnerMutationVariables>;
export const ToggleOtpDocument = gql`
    mutation toggleOTP($input: SourceToggle2faInput!) {
  sourceToggle2fa(input: $input) {
    source {
      id
      otpEnforced
    }
    user {
      id
      enforce2fa
    }
    error {
      message
    }
  }
}
    `;
export type ToggleOtpMutationFn = Apollo.MutationFunction<Types.ToggleOtpMutation, Types.ToggleOtpMutationVariables>;

/**
 * __useToggleOtpMutation__
 *
 * To run a mutation, you first call `useToggleOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleOtpMutation, { data, loading, error }] = useToggleOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleOtpMutation(baseOptions?: Apollo.MutationHookOptions<Types.ToggleOtpMutation, Types.ToggleOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ToggleOtpMutation, Types.ToggleOtpMutationVariables>(ToggleOtpDocument, options);
      }
export type ToggleOtpMutationHookResult = ReturnType<typeof useToggleOtpMutation>;
export type ToggleOtpMutationResult = Apollo.MutationResult<Types.ToggleOtpMutation>;
export type ToggleOtpMutationOptions = Apollo.BaseMutationOptions<Types.ToggleOtpMutation, Types.ToggleOtpMutationVariables>;
export const SecurityPageDocument = gql`
    query SecurityPage($sourceId: ID!) {
  me {
    id
    user {
      id
      enforce2fa
    }
  }
  source(id: $sourceId) {
    id
    otpEnforced
    features {
      id
      securityPage
    }
  }
}
    `;

/**
 * __useSecurityPageQuery__
 *
 * To run a query within a React component, call `useSecurityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecurityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecurityPageQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useSecurityPageQuery(baseOptions: Apollo.QueryHookOptions<Types.SecurityPageQuery, Types.SecurityPageQueryVariables> & ({ variables: Types.SecurityPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SecurityPageQuery, Types.SecurityPageQueryVariables>(SecurityPageDocument, options);
      }
export function useSecurityPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SecurityPageQuery, Types.SecurityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SecurityPageQuery, Types.SecurityPageQueryVariables>(SecurityPageDocument, options);
        }
export function useSecurityPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SecurityPageQuery, Types.SecurityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SecurityPageQuery, Types.SecurityPageQueryVariables>(SecurityPageDocument, options);
        }
export type SecurityPageQueryHookResult = ReturnType<typeof useSecurityPageQuery>;
export type SecurityPageLazyQueryHookResult = ReturnType<typeof useSecurityPageLazyQuery>;
export type SecurityPageSuspenseQueryHookResult = ReturnType<typeof useSecurityPageSuspenseQuery>;
export type SecurityPageQueryResult = Apollo.QueryResult<Types.SecurityPageQuery, Types.SecurityPageQueryVariables>;
export const CheckPlanUpsellNoticeDocument = gql`
    query CheckPlanUpsellNotice($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      planUpsell
    }
  }
}
    `;

/**
 * __useCheckPlanUpsellNoticeQuery__
 *
 * To run a query within a React component, call `useCheckPlanUpsellNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPlanUpsellNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPlanUpsellNoticeQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useCheckPlanUpsellNoticeQuery(baseOptions: Apollo.QueryHookOptions<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables> & ({ variables: Types.CheckPlanUpsellNoticeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables>(CheckPlanUpsellNoticeDocument, options);
      }
export function useCheckPlanUpsellNoticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables>(CheckPlanUpsellNoticeDocument, options);
        }
export function useCheckPlanUpsellNoticeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables>(CheckPlanUpsellNoticeDocument, options);
        }
export type CheckPlanUpsellNoticeQueryHookResult = ReturnType<typeof useCheckPlanUpsellNoticeQuery>;
export type CheckPlanUpsellNoticeLazyQueryHookResult = ReturnType<typeof useCheckPlanUpsellNoticeLazyQuery>;
export type CheckPlanUpsellNoticeSuspenseQueryHookResult = ReturnType<typeof useCheckPlanUpsellNoticeSuspenseQuery>;
export type CheckPlanUpsellNoticeQueryResult = Apollo.QueryResult<Types.CheckPlanUpsellNoticeQuery, Types.CheckPlanUpsellNoticeQueryVariables>;
export const MembershipPageDocument = gql`
    query MembershipPage($sourceId: ID!) {
  me {
    id
    user {
      id
      locale: locale2
      ...UserBaseInfo
    }
  }
  source(id: $sourceId) {
    id
    trial
    currentPlan
    accountInfo {
      billingInfo {
        street
        postalCode
        city
        country
        email
      }
      csmAgent {
        email
        name
      }
      owner {
        email
        name
      }
    }
    orders {
      id
      name
      productCode
      startAt
      endAt
      cancellationAt
      paymentMethod
      trial
      orderId
      quantity
    }
    availablePlans {
      id
      isActive
      title
      kicker
      confirmButtonKey
      features {
        textKey
        textArgs
      }
    }
    payingCustomer
    pendingCancelation
    features {
      id
      monitor: managed(feature: monitor) {
        id
        enabled
      }
    }
  }
}
    ${UserBaseInfoFragmentDoc}`;

/**
 * __useMembershipPageQuery__
 *
 * To run a query within a React component, call `useMembershipPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipPageQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useMembershipPageQuery(baseOptions: Apollo.QueryHookOptions<Types.MembershipPageQuery, Types.MembershipPageQueryVariables> & ({ variables: Types.MembershipPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MembershipPageQuery, Types.MembershipPageQueryVariables>(MembershipPageDocument, options);
      }
export function useMembershipPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MembershipPageQuery, Types.MembershipPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MembershipPageQuery, Types.MembershipPageQueryVariables>(MembershipPageDocument, options);
        }
export function useMembershipPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MembershipPageQuery, Types.MembershipPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MembershipPageQuery, Types.MembershipPageQueryVariables>(MembershipPageDocument, options);
        }
export type MembershipPageQueryHookResult = ReturnType<typeof useMembershipPageQuery>;
export type MembershipPageLazyQueryHookResult = ReturnType<typeof useMembershipPageLazyQuery>;
export type MembershipPageSuspenseQueryHookResult = ReturnType<typeof useMembershipPageSuspenseQuery>;
export type MembershipPageQueryResult = Apollo.QueryResult<Types.MembershipPageQuery, Types.MembershipPageQueryVariables>;
export const CancelSubscriptionDataDocument = gql`
    query CancelSubscriptionData($sourceId: ID!) {
  source(id: $sourceId) {
    id
    name
    orders {
      id
      name
      productCode
      startAt
      endAt
      cancellationAt
      paymentMethod
      trial
      orderId
      quantity
    }
  }
  me {
    id
    user {
      id
      name
      phone
      email
    }
  }
}
    `;

/**
 * __useCancelSubscriptionDataQuery__
 *
 * To run a query within a React component, call `useCancelSubscriptionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelSubscriptionDataQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useCancelSubscriptionDataQuery(baseOptions: Apollo.QueryHookOptions<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables> & ({ variables: Types.CancelSubscriptionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables>(CancelSubscriptionDataDocument, options);
      }
export function useCancelSubscriptionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables>(CancelSubscriptionDataDocument, options);
        }
export function useCancelSubscriptionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables>(CancelSubscriptionDataDocument, options);
        }
export type CancelSubscriptionDataQueryHookResult = ReturnType<typeof useCancelSubscriptionDataQuery>;
export type CancelSubscriptionDataLazyQueryHookResult = ReturnType<typeof useCancelSubscriptionDataLazyQuery>;
export type CancelSubscriptionDataSuspenseQueryHookResult = ReturnType<typeof useCancelSubscriptionDataSuspenseQuery>;
export type CancelSubscriptionDataQueryResult = Apollo.QueryResult<Types.CancelSubscriptionDataQuery, Types.CancelSubscriptionDataQueryVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($pressroomId: ID!, $reason: PaymentSubscriptionCancelReason, $cancellationInfo: PaymentSubscriptionCancelCancellationInfo!) {
  paymentSubscriptionCancel(
    input: {pressroomId: $pressroomId, reason: $reason, cancellationInfo: $cancellationInfo}
  ) {
    source {
      id
      pendingCancelation
    }
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      reason: // value for 'reason'
 *      cancellationInfo: // value for 'cancellationInfo'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<Types.CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>;
export const EmailReachUsersDocument = gql`
    query EmailReachUsers($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!, $first: Int!, $after: String, $sort: MaterialRecipientsSort) {
  materialReport(
    pressroomId: $pressroomId
    materialId: $materialId
    materialType: $materialType
  ) {
    id
    containsUniqueOpenedStats
    recipients {
      id
      followers(first: $first, after: $after, sort: $sort) {
        nodes {
          ... on User {
            id
            name
            email
            materialEmailStats(materialId: $materialId, materialType: $materialType) {
              clicked
              opened
              uniqueOpened
            }
          }
          ... on UserUnknown {
            id
            email
            clicked
            opened
            uniqueOpened
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      followersTotalClicked
      followersTotalUniqueOpened
      followersTotalOpened
    }
  }
}
    `;

/**
 * __useEmailReachUsersQuery__
 *
 * To run a query within a React component, call `useEmailReachUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailReachUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailReachUsersQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEmailReachUsersQuery(baseOptions: Apollo.QueryHookOptions<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables> & ({ variables: Types.EmailReachUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables>(EmailReachUsersDocument, options);
      }
export function useEmailReachUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables>(EmailReachUsersDocument, options);
        }
export function useEmailReachUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables>(EmailReachUsersDocument, options);
        }
export type EmailReachUsersQueryHookResult = ReturnType<typeof useEmailReachUsersQuery>;
export type EmailReachUsersLazyQueryHookResult = ReturnType<typeof useEmailReachUsersLazyQuery>;
export type EmailReachUsersSuspenseQueryHookResult = ReturnType<typeof useEmailReachUsersSuspenseQuery>;
export type EmailReachUsersQueryResult = Apollo.QueryResult<Types.EmailReachUsersQuery, Types.EmailReachUsersQueryVariables>;
export const EmailReachSubscribersDocument = gql`
    query EmailReachSubscribers($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!, $first: Int!, $after: String, $sort: RecipientDomainOrUnknownSort) {
  materialReport(
    pressroomId: $pressroomId
    materialId: $materialId
    materialType: $materialType
  ) {
    id
    recipients {
      id
      subscribers(first: $first, after: $after, sort: $sort) {
        nodes {
          ... on RecipientDomain {
            id
            domain
            clicked
            delivered
            opened
          }
          ... on RecipientDomainUnknown {
            id
            name
            clicked
            delivered
            opened
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      subscribersTotalClicked
      subscribersTotalOpened
      subscribersTotalDelivered
    }
  }
}
    `;

/**
 * __useEmailReachSubscribersQuery__
 *
 * To run a query within a React component, call `useEmailReachSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailReachSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailReachSubscribersQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEmailReachSubscribersQuery(baseOptions: Apollo.QueryHookOptions<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables> & ({ variables: Types.EmailReachSubscribersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables>(EmailReachSubscribersDocument, options);
      }
export function useEmailReachSubscribersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables>(EmailReachSubscribersDocument, options);
        }
export function useEmailReachSubscribersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables>(EmailReachSubscribersDocument, options);
        }
export type EmailReachSubscribersQueryHookResult = ReturnType<typeof useEmailReachSubscribersQuery>;
export type EmailReachSubscribersLazyQueryHookResult = ReturnType<typeof useEmailReachSubscribersLazyQuery>;
export type EmailReachSubscribersSuspenseQueryHookResult = ReturnType<typeof useEmailReachSubscribersSuspenseQuery>;
export type EmailReachSubscribersQueryResult = Apollo.QueryResult<Types.EmailReachSubscribersQuery, Types.EmailReachSubscribersQueryVariables>;
export const EmailReachContactsDocument = gql`
    query EmailReachContacts($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!, $sendExclusiveOnly: Boolean, $first: Int!, $after: String, $sort: MaterialRecipientsSort, $filter: MaterialRecipientsFilter, $exclude: MaterialRecipientsFilter, $excludeIfMndReach: MaterialRecipientsFilter) {
  materialReport(
    pressroomId: $pressroomId
    materialId: $materialId
    materialType: $materialType
  ) {
    id
    containsUniqueOpenedStats
    recipients {
      id
      contacts(
        first: $first
        after: $after
        sort: $sort
        sendExclusiveOnly: $sendExclusiveOnly
        filter: $filter
        exclude: $exclude
        excludeIfMndReach: $excludeIfMndReach
      ) {
        nodes {
          ... on NetworkContact {
            id
            fullName
            email
            materialEmailStats(materialId: $materialId, materialType: $materialType) {
              clicked
              opened
              uniqueOpened
              sendExclusive
            }
          }
          ... on NetworkContactUnknown {
            id
            email
            clicked
            opened
            uniqueOpened
            sendExclusive
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      contactsTotalClicked
      contactsTotalOpened
      contactsTotalUniqueOpened
    }
  }
  pressroom(id: $pressroomId) {
    id
    features {
      id
      mndReach
      audienceBuilder: managed(feature: audienceBuilder) {
        id
        endAt
      }
    }
  }
}
    `;

/**
 * __useEmailReachContactsQuery__
 *
 * To run a query within a React component, call `useEmailReachContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailReachContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailReachContactsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      sendExclusiveOnly: // value for 'sendExclusiveOnly'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      exclude: // value for 'exclude'
 *      excludeIfMndReach: // value for 'excludeIfMndReach'
 *   },
 * });
 */
export function useEmailReachContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables> & ({ variables: Types.EmailReachContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables>(EmailReachContactsDocument, options);
      }
export function useEmailReachContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables>(EmailReachContactsDocument, options);
        }
export function useEmailReachContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables>(EmailReachContactsDocument, options);
        }
export type EmailReachContactsQueryHookResult = ReturnType<typeof useEmailReachContactsQuery>;
export type EmailReachContactsLazyQueryHookResult = ReturnType<typeof useEmailReachContactsLazyQuery>;
export type EmailReachContactsSuspenseQueryHookResult = ReturnType<typeof useEmailReachContactsSuspenseQuery>;
export type EmailReachContactsQueryResult = Apollo.QueryResult<Types.EmailReachContactsQuery, Types.EmailReachContactsQueryVariables>;
export const DecommissionedEmailReachContactsDocument = gql`
    query DecommissionedEmailReachContacts($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!) {
  materialReport(
    pressroomId: $pressroomId
    materialId: $materialId
    materialType: $materialType
  ) {
    id
    recipients {
      id
      contacts(first: 10, filter: AudienceBuilderImport) {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useDecommissionedEmailReachContactsQuery__
 *
 * To run a query within a React component, call `useDecommissionedEmailReachContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecommissionedEmailReachContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecommissionedEmailReachContactsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useDecommissionedEmailReachContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables> & ({ variables: Types.DecommissionedEmailReachContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables>(DecommissionedEmailReachContactsDocument, options);
      }
export function useDecommissionedEmailReachContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables>(DecommissionedEmailReachContactsDocument, options);
        }
export function useDecommissionedEmailReachContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables>(DecommissionedEmailReachContactsDocument, options);
        }
export type DecommissionedEmailReachContactsQueryHookResult = ReturnType<typeof useDecommissionedEmailReachContactsQuery>;
export type DecommissionedEmailReachContactsLazyQueryHookResult = ReturnType<typeof useDecommissionedEmailReachContactsLazyQuery>;
export type DecommissionedEmailReachContactsSuspenseQueryHookResult = ReturnType<typeof useDecommissionedEmailReachContactsSuspenseQuery>;
export type DecommissionedEmailReachContactsQueryResult = Apollo.QueryResult<Types.DecommissionedEmailReachContactsQuery, Types.DecommissionedEmailReachContactsQueryVariables>;
export const PrefillQuotationDataDocument = gql`
    query PrefillQuotationData($url: String!) {
  extractMetadataFromUrl(url: $url) {
    title
    publishedAt
    description
    source
  }
}
    `;

/**
 * __usePrefillQuotationDataQuery__
 *
 * To run a query within a React component, call `usePrefillQuotationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrefillQuotationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrefillQuotationDataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function usePrefillQuotationDataQuery(baseOptions: Apollo.QueryHookOptions<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables> & ({ variables: Types.PrefillQuotationDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables>(PrefillQuotationDataDocument, options);
      }
export function usePrefillQuotationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables>(PrefillQuotationDataDocument, options);
        }
export function usePrefillQuotationDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables>(PrefillQuotationDataDocument, options);
        }
export type PrefillQuotationDataQueryHookResult = ReturnType<typeof usePrefillQuotationDataQuery>;
export type PrefillQuotationDataLazyQueryHookResult = ReturnType<typeof usePrefillQuotationDataLazyQuery>;
export type PrefillQuotationDataSuspenseQueryHookResult = ReturnType<typeof usePrefillQuotationDataSuspenseQuery>;
export type PrefillQuotationDataQueryResult = Apollo.QueryResult<Types.PrefillQuotationDataQuery, Types.PrefillQuotationDataQueryVariables>;
export const CreateManualQuotationDocument = gql`
    mutation CreateManualQuotation($input: PrImpactCreateHitInput!, $first: Int) {
  prImpactCreateHit(input: $input) {
    error {
      message
      ... on PrImpactCreateHitValidationError {
        url
        source
        description
      }
    }
    quotation {
      id
    }
    materialReport {
      id
      ...MaterialReport
    }
  }
}
    ${MaterialReportFragmentDoc}
${TopReferrersFragmentDoc}`;
export type CreateManualQuotationMutationFn = Apollo.MutationFunction<Types.CreateManualQuotationMutation, Types.CreateManualQuotationMutationVariables>;

/**
 * __useCreateManualQuotationMutation__
 *
 * To run a mutation, you first call `useCreateManualQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualQuotationMutation, { data, loading, error }] = useCreateManualQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCreateManualQuotationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateManualQuotationMutation, Types.CreateManualQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateManualQuotationMutation, Types.CreateManualQuotationMutationVariables>(CreateManualQuotationDocument, options);
      }
export type CreateManualQuotationMutationHookResult = ReturnType<typeof useCreateManualQuotationMutation>;
export type CreateManualQuotationMutationResult = Apollo.MutationResult<Types.CreateManualQuotationMutation>;
export type CreateManualQuotationMutationOptions = Apollo.BaseMutationOptions<Types.CreateManualQuotationMutation, Types.CreateManualQuotationMutationVariables>;
export const RemoveQuotationMutationDocument = gql`
    mutation RemoveQuotationMutation($quotationId: ID!, $first: Int) {
  quotationDelete(input: {quotationId: $quotationId}) {
    error {
      message
    }
    deletedId
    materialReport {
      id
      ...MaterialReport
    }
  }
}
    ${MaterialReportFragmentDoc}
${TopReferrersFragmentDoc}`;
export type RemoveQuotationMutationMutationFn = Apollo.MutationFunction<Types.RemoveQuotationMutationMutation, Types.RemoveQuotationMutationMutationVariables>;

/**
 * __useRemoveQuotationMutationMutation__
 *
 * To run a mutation, you first call `useRemoveQuotationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuotationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuotationMutationMutation, { data, loading, error }] = useRemoveQuotationMutationMutation({
 *   variables: {
 *      quotationId: // value for 'quotationId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRemoveQuotationMutationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveQuotationMutationMutation, Types.RemoveQuotationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveQuotationMutationMutation, Types.RemoveQuotationMutationMutationVariables>(RemoveQuotationMutationDocument, options);
      }
export type RemoveQuotationMutationMutationHookResult = ReturnType<typeof useRemoveQuotationMutationMutation>;
export type RemoveQuotationMutationMutationResult = Apollo.MutationResult<Types.RemoveQuotationMutationMutation>;
export type RemoveQuotationMutationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveQuotationMutationMutation, Types.RemoveQuotationMutationMutationVariables>;
export const GetMaterialDataDocument = gql`
    query GetMaterialData($id: ID!, $type: MaterialType!) {
  material(id: $id, type: $type) {
    id
    ...MaterialData
  }
}
    ${MaterialDataFragmentDoc}`;

/**
 * __useGetMaterialDataQuery__
 *
 * To run a query within a React component, call `useGetMaterialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMaterialDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables> & ({ variables: Types.GetMaterialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables>(GetMaterialDataDocument, options);
      }
export function useGetMaterialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables>(GetMaterialDataDocument, options);
        }
export function useGetMaterialDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables>(GetMaterialDataDocument, options);
        }
export type GetMaterialDataQueryHookResult = ReturnType<typeof useGetMaterialDataQuery>;
export type GetMaterialDataLazyQueryHookResult = ReturnType<typeof useGetMaterialDataLazyQuery>;
export type GetMaterialDataSuspenseQueryHookResult = ReturnType<typeof useGetMaterialDataSuspenseQuery>;
export type GetMaterialDataQueryResult = Apollo.QueryResult<Types.GetMaterialDataQuery, Types.GetMaterialDataQueryVariables>;
export const GetMaterialQuotationsDocument = gql`
    query GetMaterialQuotations($id: ID!, $type: MaterialType!, $after: String) {
  material(id: $id, type: $type) {
    id
    ... on StoryMaterial {
      quotations3(after: $after) {
        ...StoryMaterialQuotationConnection
      }
    }
  }
}
    ${StoryMaterialQuotationConnectionFragmentDoc}
${StoryMaterialQuotationListQuotationsFragmentDoc}`;

/**
 * __useGetMaterialQuotationsQuery__
 *
 * To run a query within a React component, call `useGetMaterialQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialQuotationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMaterialQuotationsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables> & ({ variables: Types.GetMaterialQuotationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables>(GetMaterialQuotationsDocument, options);
      }
export function useGetMaterialQuotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables>(GetMaterialQuotationsDocument, options);
        }
export function useGetMaterialQuotationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables>(GetMaterialQuotationsDocument, options);
        }
export type GetMaterialQuotationsQueryHookResult = ReturnType<typeof useGetMaterialQuotationsQuery>;
export type GetMaterialQuotationsLazyQueryHookResult = ReturnType<typeof useGetMaterialQuotationsLazyQuery>;
export type GetMaterialQuotationsSuspenseQueryHookResult = ReturnType<typeof useGetMaterialQuotationsSuspenseQuery>;
export type GetMaterialQuotationsQueryResult = Apollo.QueryResult<Types.GetMaterialQuotationsQuery, Types.GetMaterialQuotationsQueryVariables>;
export const GetMaterialQuotationsSettingsDocument = gql`
    query GetMaterialQuotationsSettings($id: ID!, $type: MaterialType!) {
  material(id: $id, type: $type) {
    id
    ... on StoryMaterial {
      quotationSettings {
        id
        ...StoryMaterialQuotationSettings
      }
    }
  }
  quotationSettingsSortingTypeOptions {
    id
    ...QuotationSettingsSortingOrderOption
  }
}
    ${StoryMaterialQuotationSettingsFragmentDoc}
${QuotationSettingsSortingOrderOptionFragmentDoc}`;

/**
 * __useGetMaterialQuotationsSettingsQuery__
 *
 * To run a query within a React component, call `useGetMaterialQuotationsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialQuotationsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialQuotationsSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMaterialQuotationsSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables> & ({ variables: Types.GetMaterialQuotationsSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables>(GetMaterialQuotationsSettingsDocument, options);
      }
export function useGetMaterialQuotationsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables>(GetMaterialQuotationsSettingsDocument, options);
        }
export function useGetMaterialQuotationsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables>(GetMaterialQuotationsSettingsDocument, options);
        }
export type GetMaterialQuotationsSettingsQueryHookResult = ReturnType<typeof useGetMaterialQuotationsSettingsQuery>;
export type GetMaterialQuotationsSettingsLazyQueryHookResult = ReturnType<typeof useGetMaterialQuotationsSettingsLazyQuery>;
export type GetMaterialQuotationsSettingsSuspenseQueryHookResult = ReturnType<typeof useGetMaterialQuotationsSettingsSuspenseQuery>;
export type GetMaterialQuotationsSettingsQueryResult = Apollo.QueryResult<Types.GetMaterialQuotationsSettingsQuery, Types.GetMaterialQuotationsSettingsQueryVariables>;
export const CreateOrUpdateQuotationSettingsDocument = gql`
    mutation CreateOrUpdateQuotationSettings($materialId: ID!, $materialType: MaterialType!, $settings: SettingsFieldsInput!) {
  createOrUpdateQuotationSettings(
    input: {materialId: $materialId, type: $materialType, settings: $settings}
  ) {
    error {
      message
    }
    material {
      id
      quotationSettings {
        id
        ...StoryMaterialQuotationSettings
      }
      ... on StoryMaterial {
        quotations3 {
          ...StoryMaterialQuotationConnection
        }
      }
    }
  }
}
    ${StoryMaterialQuotationSettingsFragmentDoc}
${StoryMaterialQuotationConnectionFragmentDoc}
${StoryMaterialQuotationListQuotationsFragmentDoc}`;
export type CreateOrUpdateQuotationSettingsMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateQuotationSettingsMutation, Types.CreateOrUpdateQuotationSettingsMutationVariables>;

/**
 * __useCreateOrUpdateQuotationSettingsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateQuotationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateQuotationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateQuotationSettingsMutation, { data, loading, error }] = useCreateOrUpdateQuotationSettingsMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useCreateOrUpdateQuotationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateQuotationSettingsMutation, Types.CreateOrUpdateQuotationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateQuotationSettingsMutation, Types.CreateOrUpdateQuotationSettingsMutationVariables>(CreateOrUpdateQuotationSettingsDocument, options);
      }
export type CreateOrUpdateQuotationSettingsMutationHookResult = ReturnType<typeof useCreateOrUpdateQuotationSettingsMutation>;
export type CreateOrUpdateQuotationSettingsMutationResult = Apollo.MutationResult<Types.CreateOrUpdateQuotationSettingsMutation>;
export type CreateOrUpdateQuotationSettingsMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateQuotationSettingsMutation, Types.CreateOrUpdateQuotationSettingsMutationVariables>;
export const MaterialReportDocument = gql`
    query MaterialReport($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!, $first: Int) {
  me {
    id
    user {
      id
      email
    }
  }
  pressroom(id: $pressroomId) {
    id
    features {
      id
      prImpact: managed(feature: prImpact) {
        id
        enabled
      }
      prImpactLimited: managed(feature: prImpactLimited) {
        id
        enabled
      }
      analyze: managed(feature: analyze) {
        id
        enabled
      }
    }
  }
  material(id: $materialId, type: $materialType) {
    id
    reportToken
  }
  materialReport(
    pressroomId: $pressroomId
    materialId: $materialId
    materialType: $materialType
  ) {
    id
    ...MaterialReport
  }
}
    ${MaterialReportFragmentDoc}
${TopReferrersFragmentDoc}`;

/**
 * __useMaterialReportQuery__
 *
 * To run a query within a React component, call `useMaterialReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialReportQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMaterialReportQuery(baseOptions: Apollo.QueryHookOptions<Types.MaterialReportQuery, Types.MaterialReportQueryVariables> & ({ variables: Types.MaterialReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MaterialReportQuery, Types.MaterialReportQueryVariables>(MaterialReportDocument, options);
      }
export function useMaterialReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MaterialReportQuery, Types.MaterialReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MaterialReportQuery, Types.MaterialReportQueryVariables>(MaterialReportDocument, options);
        }
export function useMaterialReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MaterialReportQuery, Types.MaterialReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MaterialReportQuery, Types.MaterialReportQueryVariables>(MaterialReportDocument, options);
        }
export type MaterialReportQueryHookResult = ReturnType<typeof useMaterialReportQuery>;
export type MaterialReportLazyQueryHookResult = ReturnType<typeof useMaterialReportLazyQuery>;
export type MaterialReportSuspenseQueryHookResult = ReturnType<typeof useMaterialReportSuspenseQuery>;
export type MaterialReportQueryResult = Apollo.QueryResult<Types.MaterialReportQuery, Types.MaterialReportQueryVariables>;
export const AnalyzeMaterialsDocument = gql`
    query AnalyzeMaterials($pressroomId: ID!, $types: [MaterialType!]!, $status: MaterialStatusFilter, $perPage: Int!, $time: DateTimeRangeInput, $sort: MaterialListSort, $after: String) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      analyzeBenchmarking
    }
    materialList2(
      types: $types
      status: $status
      sort: $sort
      after: $after
      first: $perPage
      time: $time
    ) {
      totalPages
      currentPage
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        header
        newsroomViews
        publishedAt2
        scheduledFor
        updatedAt
        status
        image(options: {transformation: THUMBNAIL_SMALL}) {
          id
          url
          altText
        }
        ... on Video {
          thumbnailUrl
        }
        ... on Document {
          preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyzeMaterialsQuery__
 *
 * To run a query within a React component, call `useAnalyzeMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyzeMaterialsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      types: // value for 'types'
 *      status: // value for 'status'
 *      perPage: // value for 'perPage'
 *      time: // value for 'time'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAnalyzeMaterialsQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables> & ({ variables: Types.AnalyzeMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables>(AnalyzeMaterialsDocument, options);
      }
export function useAnalyzeMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables>(AnalyzeMaterialsDocument, options);
        }
export function useAnalyzeMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables>(AnalyzeMaterialsDocument, options);
        }
export type AnalyzeMaterialsQueryHookResult = ReturnType<typeof useAnalyzeMaterialsQuery>;
export type AnalyzeMaterialsLazyQueryHookResult = ReturnType<typeof useAnalyzeMaterialsLazyQuery>;
export type AnalyzeMaterialsSuspenseQueryHookResult = ReturnType<typeof useAnalyzeMaterialsSuspenseQuery>;
export type AnalyzeMaterialsQueryResult = Apollo.QueryResult<Types.AnalyzeMaterialsQuery, Types.AnalyzeMaterialsQueryVariables>;
export const AnalyzeNewsroomDocument = gql`
    query AnalyzeNewsroom($pressroomId: ID!, $time: DateTimeRangeInput!, $limit: Int, $after: String) {
  me {
    id
    user {
      id
      email
    }
  }
  pressroom(id: $pressroomId) {
    id
    reportToken
    name
    pendingNotices {
      id
      analyzeBenchmarking
    }
  }
  newsroomReport(pressroomId: $pressroomId) {
    id
    devices(time: $time) {
      desktopPercentage
      smartphonePercentage
      tabletPercentage
    }
    error {
      message
    }
    pageViewsPerSession(time: $time)
    timeSpentOnNewsroom(time: $time)
    viewsOverTimeSum(time: $time) {
      web
    }
    viewsOverTime(time: $time, maxLength: 9999) {
      web
      email
      alert
      ... on NewsroomViewsOverTimeDate {
        name: date
      }
    }
    topStories(time: $time, limit: $limit, first: 10, after: $after) {
      ...TopStories
    }
    topReferrers(first: 5, time: $time, after: null) {
      nodes {
        name
        views
        icon
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${TopStoriesFragmentDoc}`;

/**
 * __useAnalyzeNewsroomQuery__
 *
 * To run a query within a React component, call `useAnalyzeNewsroomQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeNewsroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyzeNewsroomQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      time: // value for 'time'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAnalyzeNewsroomQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables> & ({ variables: Types.AnalyzeNewsroomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables>(AnalyzeNewsroomDocument, options);
      }
export function useAnalyzeNewsroomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables>(AnalyzeNewsroomDocument, options);
        }
export function useAnalyzeNewsroomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables>(AnalyzeNewsroomDocument, options);
        }
export type AnalyzeNewsroomQueryHookResult = ReturnType<typeof useAnalyzeNewsroomQuery>;
export type AnalyzeNewsroomLazyQueryHookResult = ReturnType<typeof useAnalyzeNewsroomLazyQuery>;
export type AnalyzeNewsroomSuspenseQueryHookResult = ReturnType<typeof useAnalyzeNewsroomSuspenseQuery>;
export type AnalyzeNewsroomQueryResult = Apollo.QueryResult<Types.AnalyzeNewsroomQuery, Types.AnalyzeNewsroomQueryVariables>;
export const AnalyzeOverviewDocument = gql`
    query AnalyzeOverview($pressroomId: ID!, $time: DateTimeRangeInput!, $compareToTimeRange: DateTimeRangeInput!, $first: Int!, $after: String, $sort: MaterialListSort) {
  newsroomReport(pressroomId: $pressroomId) {
    id
    viewsOverTime(time: $time, maxLength: 40) {
      web
      publications
      mediaHits
      ... on NewsroomViewsOverTimeDate {
        date: date2
      }
      ... on NewsroomViewsOverTimeInterval {
        startAt
        endAt
      }
    }
    viewsOverTimeSum(time: $time) {
      web
      mediaHits
      publications
    }
    compareToSum: viewsOverTimeSum(time: $compareToTimeRange) {
      web
      mediaHits
      publications
    }
  }
  pressroom(id: $pressroomId) {
    id
    showUpsellForMediaCoverage
    pendingNotices {
      id
      analyzeBenchmarking
    }
    materialList2(
      types: [Pressrelease, News, BlogPost]
      status: published
      sort: $sort
      time: $time
      first: $first
      after: $after
    ) {
      nodes {
        id
        header
        publishedAt2
        publicUrl
        emailsSent
        emailsUniqueOpened
        emailsUniqueOpenedPercentage
        newsroomViews
        quotationsCount
        image(options: {transformation: THUMBNAIL_SMALL}) {
          id
          url
          altText
        }
        ... on Video {
          thumbnailUrl
        }
        ... on Document {
          preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    quotations2(time: $time, first: $first) {
      ...QuotationConnection
    }
    features {
      id
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      prImpact: managed(feature: prImpact) {
        id
        enabled
      }
      prImpactLimited: managed(feature: prImpactLimited) {
        id
        enabled
      }
    }
  }
}
    ${QuotationConnectionFragmentDoc}
${QuotationFragmentDoc}`;

/**
 * __useAnalyzeOverviewQuery__
 *
 * To run a query within a React component, call `useAnalyzeOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyzeOverviewQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      time: // value for 'time'
 *      compareToTimeRange: // value for 'compareToTimeRange'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyzeOverviewQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables> & ({ variables: Types.AnalyzeOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables>(AnalyzeOverviewDocument, options);
      }
export function useAnalyzeOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables>(AnalyzeOverviewDocument, options);
        }
export function useAnalyzeOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables>(AnalyzeOverviewDocument, options);
        }
export type AnalyzeOverviewQueryHookResult = ReturnType<typeof useAnalyzeOverviewQuery>;
export type AnalyzeOverviewLazyQueryHookResult = ReturnType<typeof useAnalyzeOverviewLazyQuery>;
export type AnalyzeOverviewSuspenseQueryHookResult = ReturnType<typeof useAnalyzeOverviewSuspenseQuery>;
export type AnalyzeOverviewQueryResult = Apollo.QueryResult<Types.AnalyzeOverviewQuery, Types.AnalyzeOverviewQueryVariables>;
export const LoadMoreQuotationsDocument = gql`
    query LoadMoreQuotations($pressroomId: ID!, $time: DateTimeRangeInput!, $first: Int!, $after: String) {
  pressroom(id: $pressroomId) {
    id
    quotations2(time: $time, first: $first, after: $after) {
      ...QuotationConnection
    }
  }
}
    ${QuotationConnectionFragmentDoc}
${QuotationFragmentDoc}`;

/**
 * __useLoadMoreQuotationsQuery__
 *
 * To run a query within a React component, call `useLoadMoreQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMoreQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMoreQuotationsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      time: // value for 'time'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLoadMoreQuotationsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables> & ({ variables: Types.LoadMoreQuotationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables>(LoadMoreQuotationsDocument, options);
      }
export function useLoadMoreQuotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables>(LoadMoreQuotationsDocument, options);
        }
export function useLoadMoreQuotationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables>(LoadMoreQuotationsDocument, options);
        }
export type LoadMoreQuotationsQueryHookResult = ReturnType<typeof useLoadMoreQuotationsQuery>;
export type LoadMoreQuotationsLazyQueryHookResult = ReturnType<typeof useLoadMoreQuotationsLazyQuery>;
export type LoadMoreQuotationsSuspenseQueryHookResult = ReturnType<typeof useLoadMoreQuotationsSuspenseQuery>;
export type LoadMoreQuotationsQueryResult = Apollo.QueryResult<Types.LoadMoreQuotationsQuery, Types.LoadMoreQuotationsQueryVariables>;
export const SeenBenchmarkingNoticeDocument = gql`
    mutation SeenBenchmarkingNotice($pressroomId: ID!) {
  noticeConfirm(input: {notice: analyzeBenchmarking, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      analyzeBenchmarking
    }
  }
}
    `;
export type SeenBenchmarkingNoticeMutationFn = Apollo.MutationFunction<Types.SeenBenchmarkingNoticeMutation, Types.SeenBenchmarkingNoticeMutationVariables>;

/**
 * __useSeenBenchmarkingNoticeMutation__
 *
 * To run a mutation, you first call `useSeenBenchmarkingNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenBenchmarkingNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenBenchmarkingNoticeMutation, { data, loading, error }] = useSeenBenchmarkingNoticeMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSeenBenchmarkingNoticeMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenBenchmarkingNoticeMutation, Types.SeenBenchmarkingNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenBenchmarkingNoticeMutation, Types.SeenBenchmarkingNoticeMutationVariables>(SeenBenchmarkingNoticeDocument, options);
      }
export type SeenBenchmarkingNoticeMutationHookResult = ReturnType<typeof useSeenBenchmarkingNoticeMutation>;
export type SeenBenchmarkingNoticeMutationResult = Apollo.MutationResult<Types.SeenBenchmarkingNoticeMutation>;
export type SeenBenchmarkingNoticeMutationOptions = Apollo.BaseMutationOptions<Types.SeenBenchmarkingNoticeMutation, Types.SeenBenchmarkingNoticeMutationVariables>;
export const CreateAnalyzeDownloadDocument = gql`
    mutation createAnalyzeDownload($input: AnalyzeCreateExportInput!) {
  analyzeCreateExport(input: $input) {
    error {
      message
    }
  }
}
    `;
export type CreateAnalyzeDownloadMutationFn = Apollo.MutationFunction<Types.CreateAnalyzeDownloadMutation, Types.CreateAnalyzeDownloadMutationVariables>;

/**
 * __useCreateAnalyzeDownloadMutation__
 *
 * To run a mutation, you first call `useCreateAnalyzeDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyzeDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyzeDownloadMutation, { data, loading, error }] = useCreateAnalyzeDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnalyzeDownloadMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAnalyzeDownloadMutation, Types.CreateAnalyzeDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAnalyzeDownloadMutation, Types.CreateAnalyzeDownloadMutationVariables>(CreateAnalyzeDownloadDocument, options);
      }
export type CreateAnalyzeDownloadMutationHookResult = ReturnType<typeof useCreateAnalyzeDownloadMutation>;
export type CreateAnalyzeDownloadMutationResult = Apollo.MutationResult<Types.CreateAnalyzeDownloadMutation>;
export type CreateAnalyzeDownloadMutationOptions = Apollo.BaseMutationOptions<Types.CreateAnalyzeDownloadMutation, Types.CreateAnalyzeDownloadMutationVariables>;
export const ChannelDetailsPageDocument = gql`
    query ChannelDetailsPage($pressroomId: ID!, $channelId: ID!) {
  pressroom(id: $pressroomId) {
    id
    channel(id: $channelId) {
      id
      description
      publishableMaterialTypes
      url
      ... on PartnerChannel {
        metaDescription
        metaName
        metaKey
        screenshots
      }
      ... on SocialChannel {
        lastPublishedMaterials {
          id
          publishedAt
          createdAt
          status
          material {
            id
            header
          }
        }
      }
      ...ChannelBase
    }
  }
}
    ${ChannelBaseFragmentDoc}
${ChannelConnectionMetaFragmentDoc}`;

/**
 * __useChannelDetailsPageQuery__
 *
 * To run a query within a React component, call `useChannelDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDetailsPageQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelDetailsPageQuery(baseOptions: Apollo.QueryHookOptions<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables> & ({ variables: Types.ChannelDetailsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables>(ChannelDetailsPageDocument, options);
      }
export function useChannelDetailsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables>(ChannelDetailsPageDocument, options);
        }
export function useChannelDetailsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables>(ChannelDetailsPageDocument, options);
        }
export type ChannelDetailsPageQueryHookResult = ReturnType<typeof useChannelDetailsPageQuery>;
export type ChannelDetailsPageLazyQueryHookResult = ReturnType<typeof useChannelDetailsPageLazyQuery>;
export type ChannelDetailsPageSuspenseQueryHookResult = ReturnType<typeof useChannelDetailsPageSuspenseQuery>;
export type ChannelDetailsPageQueryResult = Apollo.QueryResult<Types.ChannelDetailsPageQuery, Types.ChannelDetailsPageQueryVariables>;
export const UpdateChannelDocument = gql`
    mutation UpdateChannel($metaKey: String, $publishByDefault: Boolean!, $channelId: ID!) {
  channelUpdate(
    input: {metaKey: $metaKey, publishByDefault: $publishByDefault, channelId: $channelId}
  ) {
    error {
      message
      ... on ChannelUpdateValidationError {
        metaKey
      }
    }
    channel {
      id
      publishByDefault
      ... on PartnerChannel {
        metaKey
      }
    }
  }
}
    `;
export type UpdateChannelMutationFn = Apollo.MutationFunction<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      metaKey: // value for 'metaKey'
 *      publishByDefault: // value for 'publishByDefault'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useUpdateChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>(UpdateChannelDocument, options);
      }
export type UpdateChannelMutationHookResult = ReturnType<typeof useUpdateChannelMutation>;
export type UpdateChannelMutationResult = Apollo.MutationResult<Types.UpdateChannelMutation>;
export type UpdateChannelMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>;
export const ReauthenticateChannelDocument = gql`
    mutation ReauthenticateChannel($channelId: ID!, $facebookPageId: ID, $linkedinCompanyId: ID) {
  channelReauthenticate(
    input: {channelId: $channelId, facebookPageId: $facebookPageId, linkedinCompanyId: $linkedinCompanyId}
  ) {
    error {
      message
    }
    channel {
      id
      ...ChannelConnectionMeta
    }
  }
}
    ${ChannelConnectionMetaFragmentDoc}`;
export type ReauthenticateChannelMutationFn = Apollo.MutationFunction<Types.ReauthenticateChannelMutation, Types.ReauthenticateChannelMutationVariables>;

/**
 * __useReauthenticateChannelMutation__
 *
 * To run a mutation, you first call `useReauthenticateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReauthenticateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reauthenticateChannelMutation, { data, loading, error }] = useReauthenticateChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      facebookPageId: // value for 'facebookPageId'
 *      linkedinCompanyId: // value for 'linkedinCompanyId'
 *   },
 * });
 */
export function useReauthenticateChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReauthenticateChannelMutation, Types.ReauthenticateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReauthenticateChannelMutation, Types.ReauthenticateChannelMutationVariables>(ReauthenticateChannelDocument, options);
      }
export type ReauthenticateChannelMutationHookResult = ReturnType<typeof useReauthenticateChannelMutation>;
export type ReauthenticateChannelMutationResult = Apollo.MutationResult<Types.ReauthenticateChannelMutation>;
export type ReauthenticateChannelMutationOptions = Apollo.BaseMutationOptions<Types.ReauthenticateChannelMutation, Types.ReauthenticateChannelMutationVariables>;
export const ChannelSettingsDataDocument = gql`
    query ChannelSettingsData($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    channels {
      id
      ...ChannelBase
    }
    source {
      id
      features {
        id
        publishSocialMediaChannels: managed(feature: publishSocialMediaChannels) {
          id
          enabled
        }
      }
    }
  }
}
    ${ChannelBaseFragmentDoc}
${ChannelConnectionMetaFragmentDoc}`;

/**
 * __useChannelSettingsDataQuery__
 *
 * To run a query within a React component, call `useChannelSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelSettingsDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useChannelSettingsDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables> & ({ variables: Types.ChannelSettingsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables>(ChannelSettingsDataDocument, options);
      }
export function useChannelSettingsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables>(ChannelSettingsDataDocument, options);
        }
export function useChannelSettingsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables>(ChannelSettingsDataDocument, options);
        }
export type ChannelSettingsDataQueryHookResult = ReturnType<typeof useChannelSettingsDataQuery>;
export type ChannelSettingsDataLazyQueryHookResult = ReturnType<typeof useChannelSettingsDataLazyQuery>;
export type ChannelSettingsDataSuspenseQueryHookResult = ReturnType<typeof useChannelSettingsDataSuspenseQuery>;
export type ChannelSettingsDataQueryResult = Apollo.QueryResult<Types.ChannelSettingsDataQuery, Types.ChannelSettingsDataQueryVariables>;
export const SetChannelDefaultStateDocument = gql`
    mutation SetChannelDefaultState($publishByDefault: Boolean!, $channelId: ID!) {
  channelUpdate(
    input: {publishByDefault: $publishByDefault, channelId: $channelId}
  ) {
    error {
      message
    }
    channel {
      id
      publishByDefault
    }
  }
}
    `;
export type SetChannelDefaultStateMutationFn = Apollo.MutationFunction<Types.SetChannelDefaultStateMutation, Types.SetChannelDefaultStateMutationVariables>;

/**
 * __useSetChannelDefaultStateMutation__
 *
 * To run a mutation, you first call `useSetChannelDefaultStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChannelDefaultStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChannelDefaultStateMutation, { data, loading, error }] = useSetChannelDefaultStateMutation({
 *   variables: {
 *      publishByDefault: // value for 'publishByDefault'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useSetChannelDefaultStateMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetChannelDefaultStateMutation, Types.SetChannelDefaultStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetChannelDefaultStateMutation, Types.SetChannelDefaultStateMutationVariables>(SetChannelDefaultStateDocument, options);
      }
export type SetChannelDefaultStateMutationHookResult = ReturnType<typeof useSetChannelDefaultStateMutation>;
export type SetChannelDefaultStateMutationResult = Apollo.MutationResult<Types.SetChannelDefaultStateMutation>;
export type SetChannelDefaultStateMutationOptions = Apollo.BaseMutationOptions<Types.SetChannelDefaultStateMutation, Types.SetChannelDefaultStateMutationVariables>;
export const ConnectChannelDocument = gql`
    mutation ConnectChannel($pressroomId: ID!, $channelType: ChannelType!, $facebookPageId: ID, $linkedinCompanyId: ID) {
  channelAdd(
    input: {pressroomId: $pressroomId, channelType: $channelType, facebookPageId: $facebookPageId, linkedinCompanyId: $linkedinCompanyId}
  ) {
    error {
      message
    }
    pressroom {
      id
      channels {
        id
        ...ChannelBase
      }
    }
  }
}
    ${ChannelBaseFragmentDoc}
${ChannelConnectionMetaFragmentDoc}`;
export type ConnectChannelMutationFn = Apollo.MutationFunction<Types.ConnectChannelMutation, Types.ConnectChannelMutationVariables>;

/**
 * __useConnectChannelMutation__
 *
 * To run a mutation, you first call `useConnectChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectChannelMutation, { data, loading, error }] = useConnectChannelMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      channelType: // value for 'channelType'
 *      facebookPageId: // value for 'facebookPageId'
 *      linkedinCompanyId: // value for 'linkedinCompanyId'
 *   },
 * });
 */
export function useConnectChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConnectChannelMutation, Types.ConnectChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConnectChannelMutation, Types.ConnectChannelMutationVariables>(ConnectChannelDocument, options);
      }
export type ConnectChannelMutationHookResult = ReturnType<typeof useConnectChannelMutation>;
export type ConnectChannelMutationResult = Apollo.MutationResult<Types.ConnectChannelMutation>;
export type ConnectChannelMutationOptions = Apollo.BaseMutationOptions<Types.ConnectChannelMutation, Types.ConnectChannelMutationVariables>;
export const DisconnectChannelDocument = gql`
    mutation DisconnectChannel($pressroomId: ID!, $channelId: ID!) {
  channelDisconnect(input: {pressroomId: $pressroomId, channelId: $channelId}) {
    error {
      message
    }
    pressroom {
      id
      channels {
        id
      }
    }
  }
}
    `;
export type DisconnectChannelMutationFn = Apollo.MutationFunction<Types.DisconnectChannelMutation, Types.DisconnectChannelMutationVariables>;

/**
 * __useDisconnectChannelMutation__
 *
 * To run a mutation, you first call `useDisconnectChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectChannelMutation, { data, loading, error }] = useDisconnectChannelMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDisconnectChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisconnectChannelMutation, Types.DisconnectChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisconnectChannelMutation, Types.DisconnectChannelMutationVariables>(DisconnectChannelDocument, options);
      }
export type DisconnectChannelMutationHookResult = ReturnType<typeof useDisconnectChannelMutation>;
export type DisconnectChannelMutationResult = Apollo.MutationResult<Types.DisconnectChannelMutation>;
export type DisconnectChannelMutationOptions = Apollo.BaseMutationOptions<Types.DisconnectChannelMutation, Types.DisconnectChannelMutationVariables>;
export const AuthenticateChannelDataDocument = gql`
    query AuthenticateChannelData {
  socialMediaSessions {
    facebook {
      pages {
        id
        name
      }
    }
    linkedin {
      companies {
        id
        name
      }
    }
    youtube {
      account {
        id
      }
    }
    twitter {
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useAuthenticateChannelDataQuery__
 *
 * To run a query within a React component, call `useAuthenticateChannelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateChannelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateChannelDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateChannelDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>(AuthenticateChannelDataDocument, options);
      }
export function useAuthenticateChannelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>(AuthenticateChannelDataDocument, options);
        }
export function useAuthenticateChannelDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>(AuthenticateChannelDataDocument, options);
        }
export type AuthenticateChannelDataQueryHookResult = ReturnType<typeof useAuthenticateChannelDataQuery>;
export type AuthenticateChannelDataLazyQueryHookResult = ReturnType<typeof useAuthenticateChannelDataLazyQuery>;
export type AuthenticateChannelDataSuspenseQueryHookResult = ReturnType<typeof useAuthenticateChannelDataSuspenseQuery>;
export type AuthenticateChannelDataQueryResult = Apollo.QueryResult<Types.AuthenticateChannelDataQuery, Types.AuthenticateChannelDataQueryVariables>;
export const SaveHomepageUrlDocument = gql`
    mutation saveHomepageUrl($pressroomId: ID!, $url: String!) {
  copilotUrlSave(input: {pressroomId: $pressroomId, url: $url}) {
    newsroomSettings {
      id
      homepageUrl
    }
    error {
      message
    }
  }
}
    `;
export type SaveHomepageUrlMutationFn = Apollo.MutationFunction<Types.SaveHomepageUrlMutation, Types.SaveHomepageUrlMutationVariables>;

/**
 * __useSaveHomepageUrlMutation__
 *
 * To run a mutation, you first call `useSaveHomepageUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHomepageUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHomepageUrlMutation, { data, loading, error }] = useSaveHomepageUrlMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSaveHomepageUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveHomepageUrlMutation, Types.SaveHomepageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveHomepageUrlMutation, Types.SaveHomepageUrlMutationVariables>(SaveHomepageUrlDocument, options);
      }
export type SaveHomepageUrlMutationHookResult = ReturnType<typeof useSaveHomepageUrlMutation>;
export type SaveHomepageUrlMutationResult = Apollo.MutationResult<Types.SaveHomepageUrlMutation>;
export type SaveHomepageUrlMutationOptions = Apollo.BaseMutationOptions<Types.SaveHomepageUrlMutation, Types.SaveHomepageUrlMutationVariables>;
export const UpdateCopilotUrlDocument = gql`
    mutation updateCopilotUrl($pressroomId: ID!, $url: String!) {
  copilotUrlUpdate(input: {pressroomId: $pressroomId, url: $url}) {
    newsroomSettings {
      id
      homepageUrl
      copilotUrlUpdateAvailable
    }
    error {
      message
    }
  }
}
    `;
export type UpdateCopilotUrlMutationFn = Apollo.MutationFunction<Types.UpdateCopilotUrlMutation, Types.UpdateCopilotUrlMutationVariables>;

/**
 * __useUpdateCopilotUrlMutation__
 *
 * To run a mutation, you first call `useUpdateCopilotUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCopilotUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCopilotUrlMutation, { data, loading, error }] = useUpdateCopilotUrlMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateCopilotUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCopilotUrlMutation, Types.UpdateCopilotUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCopilotUrlMutation, Types.UpdateCopilotUrlMutationVariables>(UpdateCopilotUrlDocument, options);
      }
export type UpdateCopilotUrlMutationHookResult = ReturnType<typeof useUpdateCopilotUrlMutation>;
export type UpdateCopilotUrlMutationResult = Apollo.MutationResult<Types.UpdateCopilotUrlMutation>;
export type UpdateCopilotUrlMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCopilotUrlMutation, Types.UpdateCopilotUrlMutationVariables>;
export const CreateCopilotUrlDocument = gql`
    mutation createCopilotUrl($pressroomId: ID!, $url: String!) {
  copilotUrlSave(input: {pressroomId: $pressroomId, url: $url}) {
    newsroomSettings {
      id
      homepageUrl
      copilotUrlUpdateAvailable
    }
    error {
      message
    }
  }
}
    `;
export type CreateCopilotUrlMutationFn = Apollo.MutationFunction<Types.CreateCopilotUrlMutation, Types.CreateCopilotUrlMutationVariables>;

/**
 * __useCreateCopilotUrlMutation__
 *
 * To run a mutation, you first call `useCreateCopilotUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCopilotUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCopilotUrlMutation, { data, loading, error }] = useCreateCopilotUrlMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateCopilotUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCopilotUrlMutation, Types.CreateCopilotUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCopilotUrlMutation, Types.CreateCopilotUrlMutationVariables>(CreateCopilotUrlDocument, options);
      }
export type CreateCopilotUrlMutationHookResult = ReturnType<typeof useCreateCopilotUrlMutation>;
export type CreateCopilotUrlMutationResult = Apollo.MutationResult<Types.CreateCopilotUrlMutation>;
export type CreateCopilotUrlMutationOptions = Apollo.BaseMutationOptions<Types.CreateCopilotUrlMutation, Types.CreateCopilotUrlMutationVariables>;
export const GetHomepageUrlDocument = gql`
    query getHomepageUrl($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    newsroomSettings {
      id
      homepageUrl
      copilotUrlUpdateAvailable
    }
  }
}
    `;

/**
 * __useGetHomepageUrlQuery__
 *
 * To run a query within a React component, call `useGetHomepageUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomepageUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomepageUrlQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetHomepageUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables> & ({ variables: Types.GetHomepageUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables>(GetHomepageUrlDocument, options);
      }
export function useGetHomepageUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables>(GetHomepageUrlDocument, options);
        }
export function useGetHomepageUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables>(GetHomepageUrlDocument, options);
        }
export type GetHomepageUrlQueryHookResult = ReturnType<typeof useGetHomepageUrlQuery>;
export type GetHomepageUrlLazyQueryHookResult = ReturnType<typeof useGetHomepageUrlLazyQuery>;
export type GetHomepageUrlSuspenseQueryHookResult = ReturnType<typeof useGetHomepageUrlSuspenseQuery>;
export type GetHomepageUrlQueryResult = Apollo.QueryResult<Types.GetHomepageUrlQuery, Types.GetHomepageUrlQueryVariables>;
export const AudienceBuilderBannerDocument = gql`
    query AudienceBuilderBanner($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      mndReach
      audienceBuilder: managed(feature: audienceBuilder) {
        id
        endAt
      }
      audienceBuilder2 {
        enabled
      }
    }
    pendingNotices {
      id
      audienceBuilderBannerNotices {
        ...AudienceBuilderBannerKeys
      }
    }
  }
}
    ${AudienceBuilderBannerKeysFragmentDoc}`;

/**
 * __useAudienceBuilderBannerQuery__
 *
 * To run a query within a React component, call `useAudienceBuilderBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceBuilderBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceBuilderBannerQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useAudienceBuilderBannerQuery(baseOptions: Apollo.QueryHookOptions<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables> & ({ variables: Types.AudienceBuilderBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables>(AudienceBuilderBannerDocument, options);
      }
export function useAudienceBuilderBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables>(AudienceBuilderBannerDocument, options);
        }
export function useAudienceBuilderBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables>(AudienceBuilderBannerDocument, options);
        }
export type AudienceBuilderBannerQueryHookResult = ReturnType<typeof useAudienceBuilderBannerQuery>;
export type AudienceBuilderBannerLazyQueryHookResult = ReturnType<typeof useAudienceBuilderBannerLazyQuery>;
export type AudienceBuilderBannerSuspenseQueryHookResult = ReturnType<typeof useAudienceBuilderBannerSuspenseQuery>;
export type AudienceBuilderBannerQueryResult = Apollo.QueryResult<Types.AudienceBuilderBannerQuery, Types.AudienceBuilderBannerQueryVariables>;
export const SeenAudienceBuilderBannerDocument = gql`
    mutation seenAudienceBuilderBanner($pressroomId: ID!, $notice: Notice!) {
  noticeConfirm(input: {notice: $notice, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      audienceBuilderBannerNotices {
        ...AudienceBuilderBannerKeys
      }
    }
  }
}
    ${AudienceBuilderBannerKeysFragmentDoc}`;
export type SeenAudienceBuilderBannerMutationFn = Apollo.MutationFunction<Types.SeenAudienceBuilderBannerMutation, Types.SeenAudienceBuilderBannerMutationVariables>;

/**
 * __useSeenAudienceBuilderBannerMutation__
 *
 * To run a mutation, you first call `useSeenAudienceBuilderBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenAudienceBuilderBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenAudienceBuilderBannerMutation, { data, loading, error }] = useSeenAudienceBuilderBannerMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      notice: // value for 'notice'
 *   },
 * });
 */
export function useSeenAudienceBuilderBannerMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenAudienceBuilderBannerMutation, Types.SeenAudienceBuilderBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenAudienceBuilderBannerMutation, Types.SeenAudienceBuilderBannerMutationVariables>(SeenAudienceBuilderBannerDocument, options);
      }
export type SeenAudienceBuilderBannerMutationHookResult = ReturnType<typeof useSeenAudienceBuilderBannerMutation>;
export type SeenAudienceBuilderBannerMutationResult = Apollo.MutationResult<Types.SeenAudienceBuilderBannerMutation>;
export type SeenAudienceBuilderBannerMutationOptions = Apollo.BaseMutationOptions<Types.SeenAudienceBuilderBannerMutation, Types.SeenAudienceBuilderBannerMutationVariables>;
export const AudienceBuilderContactInfoDocument = gql`
    query audienceBuilderContactInfo($pressroomId: ID!, $contactUuid: ID!, $first: Int) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilder {
      id
      contact(uuid: $contactUuid) {
        id
        networkContact(pressroomId: $pressroomId) {
          id
        }
        avatarUrl(size: original)
        city
        country
        company
        email
        facebookUrls
        firstName
        importedAtLeastOnce
        instagramLinks {
          userName
          url
        }
        lastName
        twitterFeeds {
          twitterFollowersCount
          latestTweets(first: $first) {
            nodes {
              id
              publishedAt
              text
            }
            pageInfo {
              hasNextPage
            }
          }
        }
        lists {
          id
          name
        }
        jobTitle
        jobRoles
        languages
        linkedinUrls
        phoneNumber
        potentialAudience
        profileSummary
        subjects
        twitterLinks {
          userName
          url
        }
        outlet {
          id
          addressLine1
          addressLine2
          city
          country
          postalCode
        }
      }
    }
  }
}
    `;

/**
 * __useAudienceBuilderContactInfoQuery__
 *
 * To run a query within a React component, call `useAudienceBuilderContactInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceBuilderContactInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceBuilderContactInfoQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      contactUuid: // value for 'contactUuid'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAudienceBuilderContactInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables> & ({ variables: Types.AudienceBuilderContactInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables>(AudienceBuilderContactInfoDocument, options);
      }
export function useAudienceBuilderContactInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables>(AudienceBuilderContactInfoDocument, options);
        }
export function useAudienceBuilderContactInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables>(AudienceBuilderContactInfoDocument, options);
        }
export type AudienceBuilderContactInfoQueryHookResult = ReturnType<typeof useAudienceBuilderContactInfoQuery>;
export type AudienceBuilderContactInfoLazyQueryHookResult = ReturnType<typeof useAudienceBuilderContactInfoLazyQuery>;
export type AudienceBuilderContactInfoSuspenseQueryHookResult = ReturnType<typeof useAudienceBuilderContactInfoSuspenseQuery>;
export type AudienceBuilderContactInfoQueryResult = Apollo.QueryResult<Types.AudienceBuilderContactInfoQuery, Types.AudienceBuilderContactInfoQueryVariables>;
export const RemoveListFromAudienceBuilderContactDocument = gql`
    mutation removeListFromAudienceBuilderContact($pressroomId: ID!, $networkContactListId: ID!, $networkContactIds: [ID!]!, $contactUuid: ID!) {
  networkContactListRemoveContact(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, networkContactIds: $networkContactIds}
  ) {
    error {
      message
    }
    networkContactList {
      id
      name
    }
    pressroom {
      id
      audienceBuilder {
        id
        contact(uuid: $contactUuid) {
          id
          lists {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type RemoveListFromAudienceBuilderContactMutationFn = Apollo.MutationFunction<Types.RemoveListFromAudienceBuilderContactMutation, Types.RemoveListFromAudienceBuilderContactMutationVariables>;

/**
 * __useRemoveListFromAudienceBuilderContactMutation__
 *
 * To run a mutation, you first call `useRemoveListFromAudienceBuilderContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveListFromAudienceBuilderContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeListFromAudienceBuilderContactMutation, { data, loading, error }] = useRemoveListFromAudienceBuilderContactMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      networkContactIds: // value for 'networkContactIds'
 *      contactUuid: // value for 'contactUuid'
 *   },
 * });
 */
export function useRemoveListFromAudienceBuilderContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveListFromAudienceBuilderContactMutation, Types.RemoveListFromAudienceBuilderContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveListFromAudienceBuilderContactMutation, Types.RemoveListFromAudienceBuilderContactMutationVariables>(RemoveListFromAudienceBuilderContactDocument, options);
      }
export type RemoveListFromAudienceBuilderContactMutationHookResult = ReturnType<typeof useRemoveListFromAudienceBuilderContactMutation>;
export type RemoveListFromAudienceBuilderContactMutationResult = Apollo.MutationResult<Types.RemoveListFromAudienceBuilderContactMutation>;
export type RemoveListFromAudienceBuilderContactMutationOptions = Apollo.BaseMutationOptions<Types.RemoveListFromAudienceBuilderContactMutation, Types.RemoveListFromAudienceBuilderContactMutationVariables>;
export const SearchContactListsModalDocument = gql`
    query searchContactListsModal($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactListSearch(sort: name, withSystemManaged: false) {
      nodes {
        id
        name
        contactsCount
      }
    }
  }
}
    `;

/**
 * __useSearchContactListsModalQuery__
 *
 * To run a query within a React component, call `useSearchContactListsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactListsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactListsModalQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSearchContactListsModalQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables> & ({ variables: Types.SearchContactListsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables>(SearchContactListsModalDocument, options);
      }
export function useSearchContactListsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables>(SearchContactListsModalDocument, options);
        }
export function useSearchContactListsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables>(SearchContactListsModalDocument, options);
        }
export type SearchContactListsModalQueryHookResult = ReturnType<typeof useSearchContactListsModalQuery>;
export type SearchContactListsModalLazyQueryHookResult = ReturnType<typeof useSearchContactListsModalLazyQuery>;
export type SearchContactListsModalSuspenseQueryHookResult = ReturnType<typeof useSearchContactListsModalSuspenseQuery>;
export type SearchContactListsModalQueryResult = Apollo.QueryResult<Types.SearchContactListsModalQuery, Types.SearchContactListsModalQueryVariables>;
export const ContactListAddListDocument = gql`
    mutation ContactListAddList($contactListId: ID!, $pressroomId: ID!, $contacts: [ContactImportAttributes!]!, $contactUuid: ID!, $skipIfNoUuid: Boolean!) {
  contactsImport(
    input: {contactListId: $contactListId, pressroomId: $pressroomId, contacts: $contacts}
  ) {
    error {
      ... on ContactListImportError {
        failed
        imported
        total
      }
      message
    }
    importedContacts {
      email
      id
      importedAtLeastOnce
    }
    contactList {
      id
      name
      size
    }
    pressroom {
      id
      audienceBuilder {
        id
        contact(uuid: $contactUuid) @skip(if: $skipIfNoUuid) {
          id
          networkContact(pressroomId: $pressroomId) {
            id
          }
          lists {
            id
          }
        }
      }
    }
  }
}
    `;
export type ContactListAddListMutationFn = Apollo.MutationFunction<Types.ContactListAddListMutation, Types.ContactListAddListMutationVariables>;

/**
 * __useContactListAddListMutation__
 *
 * To run a mutation, you first call `useContactListAddListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactListAddListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactListAddListMutation, { data, loading, error }] = useContactListAddListMutation({
 *   variables: {
 *      contactListId: // value for 'contactListId'
 *      pressroomId: // value for 'pressroomId'
 *      contacts: // value for 'contacts'
 *      contactUuid: // value for 'contactUuid'
 *      skipIfNoUuid: // value for 'skipIfNoUuid'
 *   },
 * });
 */
export function useContactListAddListMutation(baseOptions?: Apollo.MutationHookOptions<Types.ContactListAddListMutation, Types.ContactListAddListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ContactListAddListMutation, Types.ContactListAddListMutationVariables>(ContactListAddListDocument, options);
      }
export type ContactListAddListMutationHookResult = ReturnType<typeof useContactListAddListMutation>;
export type ContactListAddListMutationResult = Apollo.MutationResult<Types.ContactListAddListMutation>;
export type ContactListAddListMutationOptions = Apollo.BaseMutationOptions<Types.ContactListAddListMutation, Types.ContactListAddListMutationVariables>;
export const ContactListAddKeywordSearchQueryDocument = gql`
    mutation ContactListAddKeywordSearchQuery($contactListId: ID!, $keyword: String!, $pressroomId: ID!, $locations: [AudienceBuilderGeographyId!], $sortBy: AudienceBuilderSortField, $orderBy: AudienceBuilderSortDirection, $ignoredEmails: [String!]) {
  contactsImportByAudienceBuilderQuery(
    input: {contactListId: $contactListId, pressroomId: $pressroomId, query: {keyword: $keyword, locations: $locations, sortBy: $sortBy, orderBy: $orderBy, ignoredEmails: $ignoredEmails}}
  ) {
    error {
      message
    }
    feedback {
      message
    }
  }
}
    `;
export type ContactListAddKeywordSearchQueryMutationFn = Apollo.MutationFunction<Types.ContactListAddKeywordSearchQueryMutation, Types.ContactListAddKeywordSearchQueryMutationVariables>;

/**
 * __useContactListAddKeywordSearchQueryMutation__
 *
 * To run a mutation, you first call `useContactListAddKeywordSearchQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactListAddKeywordSearchQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactListAddKeywordSearchQueryMutation, { data, loading, error }] = useContactListAddKeywordSearchQueryMutation({
 *   variables: {
 *      contactListId: // value for 'contactListId'
 *      keyword: // value for 'keyword'
 *      pressroomId: // value for 'pressroomId'
 *      locations: // value for 'locations'
 *      sortBy: // value for 'sortBy'
 *      orderBy: // value for 'orderBy'
 *      ignoredEmails: // value for 'ignoredEmails'
 *   },
 * });
 */
export function useContactListAddKeywordSearchQueryMutation(baseOptions?: Apollo.MutationHookOptions<Types.ContactListAddKeywordSearchQueryMutation, Types.ContactListAddKeywordSearchQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ContactListAddKeywordSearchQueryMutation, Types.ContactListAddKeywordSearchQueryMutationVariables>(ContactListAddKeywordSearchQueryDocument, options);
      }
export type ContactListAddKeywordSearchQueryMutationHookResult = ReturnType<typeof useContactListAddKeywordSearchQueryMutation>;
export type ContactListAddKeywordSearchQueryMutationResult = Apollo.MutationResult<Types.ContactListAddKeywordSearchQueryMutation>;
export type ContactListAddKeywordSearchQueryMutationOptions = Apollo.BaseMutationOptions<Types.ContactListAddKeywordSearchQueryMutation, Types.ContactListAddKeywordSearchQueryMutationVariables>;
export const ContactListAddSearchQueryDocument = gql`
    mutation ContactListAddSearchQuery($contactListId: ID!, $sortBy: AudienceBuilderSortField, $orderBy: AudienceBuilderSortDirection, $locations: [AudienceBuilderGeographyId!], $coverageFocuses: [ID!], $contactNames: [String!], $jobRoles: [ID!], $languageCodes: [ID!], $mediaTypes: [ID!], $subjects: [ID!], $pressroomId: ID!, $outletUuids: [String!], $targetAudiences: [ID!], $productTypes: [ID!], $ignoredEmails: [String!]) {
  contactsImportByAudienceBuilderQuery(
    input: {contactListId: $contactListId, pressroomId: $pressroomId, query: {sortBy: $sortBy, orderBy: $orderBy, locations: $locations, coverageFocuses: $coverageFocuses, names: $contactNames, jobRoles: $jobRoles, languageCodes: $languageCodes, mediaTypes: $mediaTypes, subjects: $subjects, outletUuids: $outletUuids, targetAudiences: $targetAudiences, productTypes: $productTypes, ignoredEmails: $ignoredEmails}}
  ) {
    error {
      message
    }
    feedback {
      message
    }
  }
}
    `;
export type ContactListAddSearchQueryMutationFn = Apollo.MutationFunction<Types.ContactListAddSearchQueryMutation, Types.ContactListAddSearchQueryMutationVariables>;

/**
 * __useContactListAddSearchQueryMutation__
 *
 * To run a mutation, you first call `useContactListAddSearchQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactListAddSearchQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactListAddSearchQueryMutation, { data, loading, error }] = useContactListAddSearchQueryMutation({
 *   variables: {
 *      contactListId: // value for 'contactListId'
 *      sortBy: // value for 'sortBy'
 *      orderBy: // value for 'orderBy'
 *      locations: // value for 'locations'
 *      coverageFocuses: // value for 'coverageFocuses'
 *      contactNames: // value for 'contactNames'
 *      jobRoles: // value for 'jobRoles'
 *      languageCodes: // value for 'languageCodes'
 *      mediaTypes: // value for 'mediaTypes'
 *      subjects: // value for 'subjects'
 *      pressroomId: // value for 'pressroomId'
 *      outletUuids: // value for 'outletUuids'
 *      targetAudiences: // value for 'targetAudiences'
 *      productTypes: // value for 'productTypes'
 *      ignoredEmails: // value for 'ignoredEmails'
 *   },
 * });
 */
export function useContactListAddSearchQueryMutation(baseOptions?: Apollo.MutationHookOptions<Types.ContactListAddSearchQueryMutation, Types.ContactListAddSearchQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ContactListAddSearchQueryMutation, Types.ContactListAddSearchQueryMutationVariables>(ContactListAddSearchQueryDocument, options);
      }
export type ContactListAddSearchQueryMutationHookResult = ReturnType<typeof useContactListAddSearchQueryMutation>;
export type ContactListAddSearchQueryMutationResult = Apollo.MutationResult<Types.ContactListAddSearchQueryMutation>;
export type ContactListAddSearchQueryMutationOptions = Apollo.BaseMutationOptions<Types.ContactListAddSearchQueryMutation, Types.ContactListAddSearchQueryMutationVariables>;
export const CreateListContactsModalDocument = gql`
    mutation CreateListContactsModal($pressroomId: ID!, $name: String!) {
  contactListCreate(input: {pressroomId: $pressroomId, name: $name}) {
    error {
      message
      ... on ContactListSaveValidationError {
        name
      }
    }
    contactList {
      id
      name
      size
    }
  }
}
    `;
export type CreateListContactsModalMutationFn = Apollo.MutationFunction<Types.CreateListContactsModalMutation, Types.CreateListContactsModalMutationVariables>;

/**
 * __useCreateListContactsModalMutation__
 *
 * To run a mutation, you first call `useCreateListContactsModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListContactsModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListContactsModalMutation, { data, loading, error }] = useCreateListContactsModalMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateListContactsModalMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateListContactsModalMutation, Types.CreateListContactsModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateListContactsModalMutation, Types.CreateListContactsModalMutationVariables>(CreateListContactsModalDocument, options);
      }
export type CreateListContactsModalMutationHookResult = ReturnType<typeof useCreateListContactsModalMutation>;
export type CreateListContactsModalMutationResult = Apollo.MutationResult<Types.CreateListContactsModalMutation>;
export type CreateListContactsModalMutationOptions = Apollo.BaseMutationOptions<Types.CreateListContactsModalMutation, Types.CreateListContactsModalMutationVariables>;
export const GetListsContactsModalDocument = gql`
    query GetListsContactsModal($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactListSearch(sort: name, withSystemManaged: false) {
      nodes {
        id
        name
        contactsCount
      }
    }
  }
}
    `;

/**
 * __useGetListsContactsModalQuery__
 *
 * To run a query within a React component, call `useGetListsContactsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListsContactsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListsContactsModalQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetListsContactsModalQuery(baseOptions: Apollo.QueryHookOptions<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables> & ({ variables: Types.GetListsContactsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables>(GetListsContactsModalDocument, options);
      }
export function useGetListsContactsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables>(GetListsContactsModalDocument, options);
        }
export function useGetListsContactsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables>(GetListsContactsModalDocument, options);
        }
export type GetListsContactsModalQueryHookResult = ReturnType<typeof useGetListsContactsModalQuery>;
export type GetListsContactsModalLazyQueryHookResult = ReturnType<typeof useGetListsContactsModalLazyQuery>;
export type GetListsContactsModalSuspenseQueryHookResult = ReturnType<typeof useGetListsContactsModalSuspenseQuery>;
export type GetListsContactsModalQueryResult = Apollo.QueryResult<Types.GetListsContactsModalQuery, Types.GetListsContactsModalQueryVariables>;
export const LoadContactsKeywordsDocument = gql`
    query LoadContactsKeywords($pressroomId: ID!, $keyword: String!, $locations: [AudienceBuilderGeographyId!], $page: Int, $perPage: Int, $sortBy: AudienceBuilderSortField, $orderBy: AudienceBuilderSortDirection) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilder {
      id
      keywordSearch(
        keyword: $keyword
        locations: $locations
        page: $page
        perPage: $perPage
        sortBy: $sortBy
        orderBy: $orderBy
      ) {
        contacts {
          id
          ...ContactsFragment
        }
        totalCount
        currentPage
        error {
          message
        }
      }
    }
  }
}
    ${ContactsFragmentFragmentDoc}`;

/**
 * __useLoadContactsKeywordsQuery__
 *
 * To run a query within a React component, call `useLoadContactsKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadContactsKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadContactsKeywordsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      keyword: // value for 'keyword'
 *      locations: // value for 'locations'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortBy: // value for 'sortBy'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLoadContactsKeywordsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables> & ({ variables: Types.LoadContactsKeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables>(LoadContactsKeywordsDocument, options);
      }
export function useLoadContactsKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables>(LoadContactsKeywordsDocument, options);
        }
export function useLoadContactsKeywordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables>(LoadContactsKeywordsDocument, options);
        }
export type LoadContactsKeywordsQueryHookResult = ReturnType<typeof useLoadContactsKeywordsQuery>;
export type LoadContactsKeywordsLazyQueryHookResult = ReturnType<typeof useLoadContactsKeywordsLazyQuery>;
export type LoadContactsKeywordsSuspenseQueryHookResult = ReturnType<typeof useLoadContactsKeywordsSuspenseQuery>;
export type LoadContactsKeywordsQueryResult = Apollo.QueryResult<Types.LoadContactsKeywordsQuery, Types.LoadContactsKeywordsQueryVariables>;
export const AudienceBuilderLocationsDocument = gql`
    query AudienceBuilderLocations($pressroomId: ID!, $query: String!, $type: AudienceBuilderRegionType) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilder {
      id
      locations(query: $query, type: $type) {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAudienceBuilderLocationsQuery__
 *
 * To run a query within a React component, call `useAudienceBuilderLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceBuilderLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceBuilderLocationsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      query: // value for 'query'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAudienceBuilderLocationsQuery(baseOptions: Apollo.QueryHookOptions<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables> & ({ variables: Types.AudienceBuilderLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables>(AudienceBuilderLocationsDocument, options);
      }
export function useAudienceBuilderLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables>(AudienceBuilderLocationsDocument, options);
        }
export function useAudienceBuilderLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables>(AudienceBuilderLocationsDocument, options);
        }
export type AudienceBuilderLocationsQueryHookResult = ReturnType<typeof useAudienceBuilderLocationsQuery>;
export type AudienceBuilderLocationsLazyQueryHookResult = ReturnType<typeof useAudienceBuilderLocationsLazyQuery>;
export type AudienceBuilderLocationsSuspenseQueryHookResult = ReturnType<typeof useAudienceBuilderLocationsSuspenseQuery>;
export type AudienceBuilderLocationsQueryResult = Apollo.QueryResult<Types.AudienceBuilderLocationsQuery, Types.AudienceBuilderLocationsQueryVariables>;
export const AudienceBuilderOutletsDocument = gql`
    query AudienceBuilderOutlets($pressroomId: ID!, $query: String!, $locations: [AudienceBuilderGeographyId!]!) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilder {
      id
      outlets2(query: $query, locations: $locations) {
        uuid
        name
      }
    }
  }
}
    `;

/**
 * __useAudienceBuilderOutletsQuery__
 *
 * To run a query within a React component, call `useAudienceBuilderOutletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceBuilderOutletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceBuilderOutletsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      query: // value for 'query'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useAudienceBuilderOutletsQuery(baseOptions: Apollo.QueryHookOptions<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables> & ({ variables: Types.AudienceBuilderOutletsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables>(AudienceBuilderOutletsDocument, options);
      }
export function useAudienceBuilderOutletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables>(AudienceBuilderOutletsDocument, options);
        }
export function useAudienceBuilderOutletsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables>(AudienceBuilderOutletsDocument, options);
        }
export type AudienceBuilderOutletsQueryHookResult = ReturnType<typeof useAudienceBuilderOutletsQuery>;
export type AudienceBuilderOutletsLazyQueryHookResult = ReturnType<typeof useAudienceBuilderOutletsLazyQuery>;
export type AudienceBuilderOutletsSuspenseQueryHookResult = ReturnType<typeof useAudienceBuilderOutletsSuspenseQuery>;
export type AudienceBuilderOutletsQueryResult = Apollo.QueryResult<Types.AudienceBuilderOutletsQuery, Types.AudienceBuilderOutletsQueryVariables>;
export const SaveSearchDocument = gql`
    mutation saveSearch($input: AudienceBuilderAdvancedSearchCreateInput!) {
  audienceBuilderAdvancedSearchCreate(input: $input) {
    error {
      message
      ... on AudienceBuilderAdvancedSearchCreateValidationError {
        name
      }
    }
    pressroom {
      id
      audienceBuilderAdvancedSearches {
        id
        name
      }
    }
  }
}
    `;
export type SaveSearchMutationFn = Apollo.MutationFunction<Types.SaveSearchMutation, Types.SaveSearchMutationVariables>;

/**
 * __useSaveSearchMutation__
 *
 * To run a mutation, you first call `useSaveSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSearchMutation, { data, loading, error }] = useSaveSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSearchMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveSearchMutation, Types.SaveSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveSearchMutation, Types.SaveSearchMutationVariables>(SaveSearchDocument, options);
      }
export type SaveSearchMutationHookResult = ReturnType<typeof useSaveSearchMutation>;
export type SaveSearchMutationResult = Apollo.MutationResult<Types.SaveSearchMutation>;
export type SaveSearchMutationOptions = Apollo.BaseMutationOptions<Types.SaveSearchMutation, Types.SaveSearchMutationVariables>;
export const DeleteSavedSearchDocument = gql`
    mutation deleteSavedSearch($input: AudienceBuilderAdvancedSearchDeleteInput!) {
  audienceBuilderAdvancedSearchDelete(input: $input) {
    error {
      message
    }
    pressroom {
      id
      audienceBuilderAdvancedSearches {
        id
      }
    }
  }
}
    `;
export type DeleteSavedSearchMutationFn = Apollo.MutationFunction<Types.DeleteSavedSearchMutation, Types.DeleteSavedSearchMutationVariables>;

/**
 * __useDeleteSavedSearchMutation__
 *
 * To run a mutation, you first call `useDeleteSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedSearchMutation, { data, loading, error }] = useDeleteSavedSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSavedSearchMutation, Types.DeleteSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSavedSearchMutation, Types.DeleteSavedSearchMutationVariables>(DeleteSavedSearchDocument, options);
      }
export type DeleteSavedSearchMutationHookResult = ReturnType<typeof useDeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationResult = Apollo.MutationResult<Types.DeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSavedSearchMutation, Types.DeleteSavedSearchMutationVariables>;
export const LoadContactsSearchDocument = gql`
    query LoadContactsSearch($pressroomId: ID!, $page: Int, $perPage: Int, $locations: [AudienceBuilderGeographyId!], $sortBy: AudienceBuilderSortField, $orderBy: AudienceBuilderSortDirection, $coverageFocuses: [ID!], $jobRoles: [ID!], $languageCodes: [ID!], $mediaTypes: [ID!], $subjects: [ID!], $outletUuids: [String!], $productTypes: [ID!], $targetAudiences: [ID!], $contactNames: [String!]) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilder {
      id
      search(
        page: $page
        perPage: $perPage
        sortBy: $sortBy
        locations: $locations
        orderBy: $orderBy
        coverageFocuses: $coverageFocuses
        jobRoles: $jobRoles
        languageCodes: $languageCodes
        mediaTypes: $mediaTypes
        subjects: $subjects
        outletUuids: $outletUuids
        productTypes: $productTypes
        targetAudiences: $targetAudiences
        names: $contactNames
      ) {
        contacts {
          id
          ...ContactsFragment
        }
        totalCount
        currentPage
        error {
          message
        }
      }
    }
  }
}
    ${ContactsFragmentFragmentDoc}`;

/**
 * __useLoadContactsSearchQuery__
 *
 * To run a query within a React component, call `useLoadContactsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadContactsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadContactsSearchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      locations: // value for 'locations'
 *      sortBy: // value for 'sortBy'
 *      orderBy: // value for 'orderBy'
 *      coverageFocuses: // value for 'coverageFocuses'
 *      jobRoles: // value for 'jobRoles'
 *      languageCodes: // value for 'languageCodes'
 *      mediaTypes: // value for 'mediaTypes'
 *      subjects: // value for 'subjects'
 *      outletUuids: // value for 'outletUuids'
 *      productTypes: // value for 'productTypes'
 *      targetAudiences: // value for 'targetAudiences'
 *      contactNames: // value for 'contactNames'
 *   },
 * });
 */
export function useLoadContactsSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables> & ({ variables: Types.LoadContactsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables>(LoadContactsSearchDocument, options);
      }
export function useLoadContactsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables>(LoadContactsSearchDocument, options);
        }
export function useLoadContactsSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables>(LoadContactsSearchDocument, options);
        }
export type LoadContactsSearchQueryHookResult = ReturnType<typeof useLoadContactsSearchQuery>;
export type LoadContactsSearchLazyQueryHookResult = ReturnType<typeof useLoadContactsSearchLazyQuery>;
export type LoadContactsSearchSuspenseQueryHookResult = ReturnType<typeof useLoadContactsSearchSuspenseQuery>;
export type LoadContactsSearchQueryResult = Apollo.QueryResult<Types.LoadContactsSearchQuery, Types.LoadContactsSearchQueryVariables>;
export const LoadContactsMetadataDocument = gql`
    query LoadContactsMetadata($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilder {
      id
      jobRoles {
        id
        value
      }
      subjects {
        id
        value
      }
      subjectsGrouped {
        id
        value
        children {
          id
          value
        }
      }
      languageCodes {
        id
        value
      }
      mediaTypes {
        id
        value
      }
      coverageFocuses {
        id
        value
      }
      productTypes {
        id
        value
      }
      targetAudiences {
        id
        value
      }
    }
  }
}
    `;

/**
 * __useLoadContactsMetadataQuery__
 *
 * To run a query within a React component, call `useLoadContactsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadContactsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadContactsMetadataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useLoadContactsMetadataQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables> & ({ variables: Types.LoadContactsMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables>(LoadContactsMetadataDocument, options);
      }
export function useLoadContactsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables>(LoadContactsMetadataDocument, options);
        }
export function useLoadContactsMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables>(LoadContactsMetadataDocument, options);
        }
export type LoadContactsMetadataQueryHookResult = ReturnType<typeof useLoadContactsMetadataQuery>;
export type LoadContactsMetadataLazyQueryHookResult = ReturnType<typeof useLoadContactsMetadataLazyQuery>;
export type LoadContactsMetadataSuspenseQueryHookResult = ReturnType<typeof useLoadContactsMetadataSuspenseQuery>;
export type LoadContactsMetadataQueryResult = Apollo.QueryResult<Types.LoadContactsMetadataQuery, Types.LoadContactsMetadataQueryVariables>;
export const GetSavedSearchDocument = gql`
    query getSavedSearch($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    audienceBuilderAdvancedSearches {
      id
      name
      searchParams {
        coverageFocuses {
          id
          value
        }
        languageCodes {
          id
          value
        }
        locations {
          id
          name
        }
        mediaTypes {
          id
          value
        }
        names
        outlets {
          id
          name
        }
        productTypes {
          id
          value
        }
        subject {
          id
          value
        }
        targetAudiences {
          id
          value
        }
        jobRoles {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetSavedSearchQuery__
 *
 * To run a query within a React component, call `useGetSavedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSearchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetSavedSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables> & ({ variables: Types.GetSavedSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
      }
export function useGetSavedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
        }
export function useGetSavedSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
        }
export type GetSavedSearchQueryHookResult = ReturnType<typeof useGetSavedSearchQuery>;
export type GetSavedSearchLazyQueryHookResult = ReturnType<typeof useGetSavedSearchLazyQuery>;
export type GetSavedSearchSuspenseQueryHookResult = ReturnType<typeof useGetSavedSearchSuspenseQuery>;
export type GetSavedSearchQueryResult = Apollo.QueryResult<Types.GetSavedSearchQuery, Types.GetSavedSearchQueryVariables>;
export const LoadContactLimitsDocument = gql`
    query LoadContactLimits($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    contactLimits {
      ...ContactLimits
    }
    features {
      id
      mndReach
    }
  }
}
    ${ContactLimitsFragmentDoc}`;

/**
 * __useLoadContactLimitsQuery__
 *
 * To run a query within a React component, call `useLoadContactLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadContactLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadContactLimitsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useLoadContactLimitsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables> & ({ variables: Types.LoadContactLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables>(LoadContactLimitsDocument, options);
      }
export function useLoadContactLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables>(LoadContactLimitsDocument, options);
        }
export function useLoadContactLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables>(LoadContactLimitsDocument, options);
        }
export type LoadContactLimitsQueryHookResult = ReturnType<typeof useLoadContactLimitsQuery>;
export type LoadContactLimitsLazyQueryHookResult = ReturnType<typeof useLoadContactLimitsLazyQuery>;
export type LoadContactLimitsSuspenseQueryHookResult = ReturnType<typeof useLoadContactLimitsSuspenseQuery>;
export type LoadContactLimitsQueryResult = Apollo.QueryResult<Types.LoadContactLimitsQuery, Types.LoadContactLimitsQueryVariables>;
export const NetworkContactUpdateDocument = gql`
    mutation NetworkContactUpdate($input: NetworkContactUpdateInput!) {
  networkContactUpdate(input: $input) {
    error {
      message
      ... on NetworkContactUpdateValidationError {
        email
      }
    }
    networkContact {
      id
      firstName
      lastName
      company
      email
      phone
      mobile
      fax
      address
      postcode
      country
      city
      state
      avatarUrl
      jobTitle
      unreachable
      unsubscribed
      follower
      optedOut
      notes
      showDetails
      activity {
        id
        type
        title
        description
        timestamp
      }
    }
  }
}
    `;
export type NetworkContactUpdateMutationFn = Apollo.MutationFunction<Types.NetworkContactUpdateMutation, Types.NetworkContactUpdateMutationVariables>;

/**
 * __useNetworkContactUpdateMutation__
 *
 * To run a mutation, you first call `useNetworkContactUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactUpdateMutation, { data, loading, error }] = useNetworkContactUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNetworkContactUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactUpdateMutation, Types.NetworkContactUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactUpdateMutation, Types.NetworkContactUpdateMutationVariables>(NetworkContactUpdateDocument, options);
      }
export type NetworkContactUpdateMutationHookResult = ReturnType<typeof useNetworkContactUpdateMutation>;
export type NetworkContactUpdateMutationResult = Apollo.MutationResult<Types.NetworkContactUpdateMutation>;
export type NetworkContactUpdateMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactUpdateMutation, Types.NetworkContactUpdateMutationVariables>;
export const RemoveContactListFromContactDocument = gql`
    mutation removeContactListFromContact($pressroomId: ID!, $networkContactListId: ID!, $networkContactIds: [ID!]!, $contactId: ID!) {
  networkContactListRemoveContact(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, networkContactIds: $networkContactIds}
  ) {
    error {
      message
    }
    networkContactList {
      id
      name
    }
    pressroom {
      id
      networkContact(id: $contactId) {
        id
        networkContactLists {
          id
          name
        }
      }
    }
  }
}
    `;
export type RemoveContactListFromContactMutationFn = Apollo.MutationFunction<Types.RemoveContactListFromContactMutation, Types.RemoveContactListFromContactMutationVariables>;

/**
 * __useRemoveContactListFromContactMutation__
 *
 * To run a mutation, you first call `useRemoveContactListFromContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactListFromContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactListFromContactMutation, { data, loading, error }] = useRemoveContactListFromContactMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      networkContactIds: // value for 'networkContactIds'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useRemoveContactListFromContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveContactListFromContactMutation, Types.RemoveContactListFromContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveContactListFromContactMutation, Types.RemoveContactListFromContactMutationVariables>(RemoveContactListFromContactDocument, options);
      }
export type RemoveContactListFromContactMutationHookResult = ReturnType<typeof useRemoveContactListFromContactMutation>;
export type RemoveContactListFromContactMutationResult = Apollo.MutationResult<Types.RemoveContactListFromContactMutation>;
export type RemoveContactListFromContactMutationOptions = Apollo.BaseMutationOptions<Types.RemoveContactListFromContactMutation, Types.RemoveContactListFromContactMutationVariables>;
export const NetworkContactLinksUpdateDocument = gql`
    mutation NetworkContactLinksUpdate($contactId: ID!, $pressroomId: ID!, $links: [String!]!) {
  networkContactUpdate(
    input: {id: $contactId, pressroomId: $pressroomId, socialMediaProfiles: $links}
  ) {
    error {
      message
    }
    networkContact {
      id
      firstName
      lastName
      socialMediaProfiles
    }
  }
}
    `;
export type NetworkContactLinksUpdateMutationFn = Apollo.MutationFunction<Types.NetworkContactLinksUpdateMutation, Types.NetworkContactLinksUpdateMutationVariables>;

/**
 * __useNetworkContactLinksUpdateMutation__
 *
 * To run a mutation, you first call `useNetworkContactLinksUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactLinksUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactLinksUpdateMutation, { data, loading, error }] = useNetworkContactLinksUpdateMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      pressroomId: // value for 'pressroomId'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useNetworkContactLinksUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactLinksUpdateMutation, Types.NetworkContactLinksUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactLinksUpdateMutation, Types.NetworkContactLinksUpdateMutationVariables>(NetworkContactLinksUpdateDocument, options);
      }
export type NetworkContactLinksUpdateMutationHookResult = ReturnType<typeof useNetworkContactLinksUpdateMutation>;
export type NetworkContactLinksUpdateMutationResult = Apollo.MutationResult<Types.NetworkContactLinksUpdateMutation>;
export type NetworkContactLinksUpdateMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactLinksUpdateMutation, Types.NetworkContactLinksUpdateMutationVariables>;
export const NetworkContactDocument = gql`
    query NetworkContact($id: ID!, $pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      pitch
    }
    contactLimits {
      unlimited
    }
    networkContacts2(ids: [$id]) {
      id
      firstName
      lastName
      company
      email
      phone
      mobile
      fax
      address
      postcode
      country
      city
      state
      avatarUrl
      jobTitle
      importedVia
      importedViaRecommendedContacts
      unreachable
      unsubscribed
      follower
      optedOut
      notes
      showDetails
      editable
      hasMediaHits
      stats {
        id
        received
        openRate
        clickRate
      }
      socialMediaProfiles
      activity {
        id
        type
        title
        description
        timestamp
        quotation {
          id
          reach
          articleId
          articlePublishedAt
          articleTitle
          articleSource
          longestCommonSubsequence
          articleUrl
          favatarUrl
          material {
            id
            header
          }
        }
      }
      networkContactLists {
        id
        name
        systemManaged
      }
    }
  }
}
    `;

/**
 * __useNetworkContactQuery__
 *
 * To run a query within a React component, call `useNetworkContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useNetworkContactQuery(baseOptions: Apollo.QueryHookOptions<Types.NetworkContactQuery, Types.NetworkContactQueryVariables> & ({ variables: Types.NetworkContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NetworkContactQuery, Types.NetworkContactQueryVariables>(NetworkContactDocument, options);
      }
export function useNetworkContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NetworkContactQuery, Types.NetworkContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NetworkContactQuery, Types.NetworkContactQueryVariables>(NetworkContactDocument, options);
        }
export function useNetworkContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NetworkContactQuery, Types.NetworkContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NetworkContactQuery, Types.NetworkContactQueryVariables>(NetworkContactDocument, options);
        }
export type NetworkContactQueryHookResult = ReturnType<typeof useNetworkContactQuery>;
export type NetworkContactLazyQueryHookResult = ReturnType<typeof useNetworkContactLazyQuery>;
export type NetworkContactSuspenseQueryHookResult = ReturnType<typeof useNetworkContactSuspenseQuery>;
export type NetworkContactQueryResult = Apollo.QueryResult<Types.NetworkContactQuery, Types.NetworkContactQueryVariables>;
export const InactiveNetworkContactsDocument = gql`
    query InactiveNetworkContacts($pressroomId: ID!, $page: Int, $first: Int) {
  pressroom(id: $pressroomId) {
    id
    networkInactiveContactsList {
      contactsCount
      name
      contacts2(first: $first, page: $page) {
        nodes {
          id
          ...NetworkContact
          networkContactLists {
            id
          }
        }
        currentPage
        totalPages
        pageInfo {
          hasNextPage
        }
      }
    }
  }
}
    ${NetworkContactFragmentDoc}`;

/**
 * __useInactiveNetworkContactsQuery__
 *
 * To run a query within a React component, call `useInactiveNetworkContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactiveNetworkContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactiveNetworkContactsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      page: // value for 'page'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useInactiveNetworkContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables> & ({ variables: Types.InactiveNetworkContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables>(InactiveNetworkContactsDocument, options);
      }
export function useInactiveNetworkContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables>(InactiveNetworkContactsDocument, options);
        }
export function useInactiveNetworkContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables>(InactiveNetworkContactsDocument, options);
        }
export type InactiveNetworkContactsQueryHookResult = ReturnType<typeof useInactiveNetworkContactsQuery>;
export type InactiveNetworkContactsLazyQueryHookResult = ReturnType<typeof useInactiveNetworkContactsLazyQuery>;
export type InactiveNetworkContactsSuspenseQueryHookResult = ReturnType<typeof useInactiveNetworkContactsSuspenseQuery>;
export type InactiveNetworkContactsQueryResult = Apollo.QueryResult<Types.InactiveNetworkContactsQuery, Types.InactiveNetworkContactsQueryVariables>;
export const NetworkInactiveContactRemoveDocument = gql`
    mutation NetworkInactiveContactRemove($pressroomId: ID!, $ids: [ID!]!, $deleteAll: Boolean) {
  networkInactiveContactRemove(
    input: {pressroomId: $pressroomId, ids: $ids, deleteAll: $deleteAll}
  ) {
    error {
      message
    }
    deletedIds
  }
}
    `;
export type NetworkInactiveContactRemoveMutationFn = Apollo.MutationFunction<Types.NetworkInactiveContactRemoveMutation, Types.NetworkInactiveContactRemoveMutationVariables>;

/**
 * __useNetworkInactiveContactRemoveMutation__
 *
 * To run a mutation, you first call `useNetworkInactiveContactRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkInactiveContactRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkInactiveContactRemoveMutation, { data, loading, error }] = useNetworkInactiveContactRemoveMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      ids: // value for 'ids'
 *      deleteAll: // value for 'deleteAll'
 *   },
 * });
 */
export function useNetworkInactiveContactRemoveMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkInactiveContactRemoveMutation, Types.NetworkInactiveContactRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkInactiveContactRemoveMutation, Types.NetworkInactiveContactRemoveMutationVariables>(NetworkInactiveContactRemoveDocument, options);
      }
export type NetworkInactiveContactRemoveMutationHookResult = ReturnType<typeof useNetworkInactiveContactRemoveMutation>;
export type NetworkInactiveContactRemoveMutationResult = Apollo.MutationResult<Types.NetworkInactiveContactRemoveMutation>;
export type NetworkInactiveContactRemoveMutationOptions = Apollo.BaseMutationOptions<Types.NetworkInactiveContactRemoveMutation, Types.NetworkInactiveContactRemoveMutationVariables>;
export const InviteToFollowDocument = gql`
    mutation inviteToFollow($networkContactIds: [ID!]!, $pressroomId: ID!, $subject: String!, $message: String!) {
  networkContactInviteToFollow(
    input: {networkContactIds: $networkContactIds, pressroomId: $pressroomId, subject: $subject, message: $message}
  ) {
    error {
      message
    }
    pressroom {
      id
    }
  }
}
    `;
export type InviteToFollowMutationFn = Apollo.MutationFunction<Types.InviteToFollowMutation, Types.InviteToFollowMutationVariables>;

/**
 * __useInviteToFollowMutation__
 *
 * To run a mutation, you first call `useInviteToFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToFollowMutation, { data, loading, error }] = useInviteToFollowMutation({
 *   variables: {
 *      networkContactIds: // value for 'networkContactIds'
 *      pressroomId: // value for 'pressroomId'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useInviteToFollowMutation(baseOptions?: Apollo.MutationHookOptions<Types.InviteToFollowMutation, Types.InviteToFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InviteToFollowMutation, Types.InviteToFollowMutationVariables>(InviteToFollowDocument, options);
      }
export type InviteToFollowMutationHookResult = ReturnType<typeof useInviteToFollowMutation>;
export type InviteToFollowMutationResult = Apollo.MutationResult<Types.InviteToFollowMutation>;
export type InviteToFollowMutationOptions = Apollo.BaseMutationOptions<Types.InviteToFollowMutation, Types.InviteToFollowMutationVariables>;
export const InviteToFollowBulkDocument = gql`
    mutation inviteToFollowBulk($pressroomId: ID!, $networkContactListId: ID, $filter: NetworkContactFilter, $search: String, $subject: String!, $message: String!) {
  networkContactInviteToFollowBulk(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, filter: $filter, search: $search, subject: $subject, message: $message}
  ) {
    error {
      message
    }
    pressroom {
      id
    }
  }
}
    `;
export type InviteToFollowBulkMutationFn = Apollo.MutationFunction<Types.InviteToFollowBulkMutation, Types.InviteToFollowBulkMutationVariables>;

/**
 * __useInviteToFollowBulkMutation__
 *
 * To run a mutation, you first call `useInviteToFollowBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToFollowBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToFollowBulkMutation, { data, loading, error }] = useInviteToFollowBulkMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useInviteToFollowBulkMutation(baseOptions?: Apollo.MutationHookOptions<Types.InviteToFollowBulkMutation, Types.InviteToFollowBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InviteToFollowBulkMutation, Types.InviteToFollowBulkMutationVariables>(InviteToFollowBulkDocument, options);
      }
export type InviteToFollowBulkMutationHookResult = ReturnType<typeof useInviteToFollowBulkMutation>;
export type InviteToFollowBulkMutationResult = Apollo.MutationResult<Types.InviteToFollowBulkMutation>;
export type InviteToFollowBulkMutationOptions = Apollo.BaseMutationOptions<Types.InviteToFollowBulkMutation, Types.InviteToFollowBulkMutationVariables>;
export const ManageContactLists_NetworkContactListsDocument = gql`
    query ManageContactLists_NetworkContactLists($pressroomId: ID!, $networkContactIds: [ID!], $search: String, $filter: NetworkContactFilter, $filterFromNetworkContactListId: ID, $listSearch: String!) {
  pressroom(id: $pressroomId) {
    id
    ...ManageContactLists_Pressroom
  }
}
    ${ManageContactLists_PressroomFragmentDoc}
${ManageContactLists_ContactListFragmentDoc}`;

/**
 * __useManageContactLists_NetworkContactListsQuery__
 *
 * To run a query within a React component, call `useManageContactLists_NetworkContactListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageContactLists_NetworkContactListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageContactLists_NetworkContactListsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactIds: // value for 'networkContactIds'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      listSearch: // value for 'listSearch'
 *   },
 * });
 */
export function useManageContactLists_NetworkContactListsQuery(baseOptions: Apollo.QueryHookOptions<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables> & ({ variables: Types.ManageContactLists_NetworkContactListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables>(ManageContactLists_NetworkContactListsDocument, options);
      }
export function useManageContactLists_NetworkContactListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables>(ManageContactLists_NetworkContactListsDocument, options);
        }
export function useManageContactLists_NetworkContactListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables>(ManageContactLists_NetworkContactListsDocument, options);
        }
export type ManageContactLists_NetworkContactListsQueryHookResult = ReturnType<typeof useManageContactLists_NetworkContactListsQuery>;
export type ManageContactLists_NetworkContactListsLazyQueryHookResult = ReturnType<typeof useManageContactLists_NetworkContactListsLazyQuery>;
export type ManageContactLists_NetworkContactListsSuspenseQueryHookResult = ReturnType<typeof useManageContactLists_NetworkContactListsSuspenseQuery>;
export type ManageContactLists_NetworkContactListsQueryResult = Apollo.QueryResult<Types.ManageContactLists_NetworkContactListsQuery, Types.ManageContactLists_NetworkContactListsQueryVariables>;
export const ManageContactLists_CreateContactListDocument = gql`
    mutation ManageContactLists_CreateContactList($pressroomId: ID!, $name: String!, $filterFromNetworkContactListId: ID, $networkContactIds: [ID!], $search: String, $filter: NetworkContactFilter, $listSearch: String!) {
  networkContactListAdd(input: {pressroomId: $pressroomId, name: $name}) {
    error {
      message
      ... on NetworkContactListsAddValidationError {
        name
      }
    }
    pressroom {
      id
      ...ManageContactLists_Pressroom
    }
  }
}
    ${ManageContactLists_PressroomFragmentDoc}
${ManageContactLists_ContactListFragmentDoc}`;
export type ManageContactLists_CreateContactListMutationFn = Apollo.MutationFunction<Types.ManageContactLists_CreateContactListMutation, Types.ManageContactLists_CreateContactListMutationVariables>;

/**
 * __useManageContactLists_CreateContactListMutation__
 *
 * To run a mutation, you first call `useManageContactLists_CreateContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageContactLists_CreateContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageContactListsCreateContactListMutation, { data, loading, error }] = useManageContactLists_CreateContactListMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      networkContactIds: // value for 'networkContactIds'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      listSearch: // value for 'listSearch'
 *   },
 * });
 */
export function useManageContactLists_CreateContactListMutation(baseOptions?: Apollo.MutationHookOptions<Types.ManageContactLists_CreateContactListMutation, Types.ManageContactLists_CreateContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ManageContactLists_CreateContactListMutation, Types.ManageContactLists_CreateContactListMutationVariables>(ManageContactLists_CreateContactListDocument, options);
      }
export type ManageContactLists_CreateContactListMutationHookResult = ReturnType<typeof useManageContactLists_CreateContactListMutation>;
export type ManageContactLists_CreateContactListMutationResult = Apollo.MutationResult<Types.ManageContactLists_CreateContactListMutation>;
export type ManageContactLists_CreateContactListMutationOptions = Apollo.BaseMutationOptions<Types.ManageContactLists_CreateContactListMutation, Types.ManageContactLists_CreateContactListMutationVariables>;
export const ManageContactLists_RemoveFromListDocument = gql`
    mutation ManageContactLists_RemoveFromList($pressroomId: ID!, $networkContactListId: ID!, $filterFromNetworkContactListId: ID, $networkContactIds: [ID!]!, $search: String, $filter: NetworkContactFilter, $listSearch: String!) {
  networkContactListRemoveContact(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, networkContactIds: $networkContactIds}
  ) {
    error {
      message
    }
    removedCount
    networkContactList {
      id
      name
    }
    pressroom {
      id
      ...ManageContactLists_Pressroom
    }
  }
}
    ${ManageContactLists_PressroomFragmentDoc}
${ManageContactLists_ContactListFragmentDoc}`;
export type ManageContactLists_RemoveFromListMutationFn = Apollo.MutationFunction<Types.ManageContactLists_RemoveFromListMutation, Types.ManageContactLists_RemoveFromListMutationVariables>;

/**
 * __useManageContactLists_RemoveFromListMutation__
 *
 * To run a mutation, you first call `useManageContactLists_RemoveFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageContactLists_RemoveFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageContactListsRemoveFromListMutation, { data, loading, error }] = useManageContactLists_RemoveFromListMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      networkContactIds: // value for 'networkContactIds'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      listSearch: // value for 'listSearch'
 *   },
 * });
 */
export function useManageContactLists_RemoveFromListMutation(baseOptions?: Apollo.MutationHookOptions<Types.ManageContactLists_RemoveFromListMutation, Types.ManageContactLists_RemoveFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ManageContactLists_RemoveFromListMutation, Types.ManageContactLists_RemoveFromListMutationVariables>(ManageContactLists_RemoveFromListDocument, options);
      }
export type ManageContactLists_RemoveFromListMutationHookResult = ReturnType<typeof useManageContactLists_RemoveFromListMutation>;
export type ManageContactLists_RemoveFromListMutationResult = Apollo.MutationResult<Types.ManageContactLists_RemoveFromListMutation>;
export type ManageContactLists_RemoveFromListMutationOptions = Apollo.BaseMutationOptions<Types.ManageContactLists_RemoveFromListMutation, Types.ManageContactLists_RemoveFromListMutationVariables>;
export const ManageContactLists_RemoveFromListBulkDocument = gql`
    mutation ManageContactLists_RemoveFromListBulk($pressroomId: ID!, $networkContactListId: ID!, $filterFromNetworkContactListId: ID, $search: String, $filter: NetworkContactFilter, $networkContactIds: [ID!], $listSearch: String!) {
  networkContactListRemoveContactBulk(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, filterFromNetworkContactListId: $filterFromNetworkContactListId, search: $search, filter: $filter}
  ) {
    error {
      message
    }
    removedCount
    networkContactList {
      id
      name
    }
    pressroom {
      id
      ...ManageContactLists_Pressroom
    }
  }
}
    ${ManageContactLists_PressroomFragmentDoc}
${ManageContactLists_ContactListFragmentDoc}`;
export type ManageContactLists_RemoveFromListBulkMutationFn = Apollo.MutationFunction<Types.ManageContactLists_RemoveFromListBulkMutation, Types.ManageContactLists_RemoveFromListBulkMutationVariables>;

/**
 * __useManageContactLists_RemoveFromListBulkMutation__
 *
 * To run a mutation, you first call `useManageContactLists_RemoveFromListBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageContactLists_RemoveFromListBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageContactListsRemoveFromListBulkMutation, { data, loading, error }] = useManageContactLists_RemoveFromListBulkMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      networkContactIds: // value for 'networkContactIds'
 *      listSearch: // value for 'listSearch'
 *   },
 * });
 */
export function useManageContactLists_RemoveFromListBulkMutation(baseOptions?: Apollo.MutationHookOptions<Types.ManageContactLists_RemoveFromListBulkMutation, Types.ManageContactLists_RemoveFromListBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ManageContactLists_RemoveFromListBulkMutation, Types.ManageContactLists_RemoveFromListBulkMutationVariables>(ManageContactLists_RemoveFromListBulkDocument, options);
      }
export type ManageContactLists_RemoveFromListBulkMutationHookResult = ReturnType<typeof useManageContactLists_RemoveFromListBulkMutation>;
export type ManageContactLists_RemoveFromListBulkMutationResult = Apollo.MutationResult<Types.ManageContactLists_RemoveFromListBulkMutation>;
export type ManageContactLists_RemoveFromListBulkMutationOptions = Apollo.BaseMutationOptions<Types.ManageContactLists_RemoveFromListBulkMutation, Types.ManageContactLists_RemoveFromListBulkMutationVariables>;
export const ManageContactLists_AddToListDocument = gql`
    mutation ManageContactLists_addToList($pressroomId: ID!, $networkContactListId: ID!, $networkContactIds: [ID!]!, $filterFromNetworkContactListId: ID, $search: String, $filter: NetworkContactFilter, $listSearch: String!) {
  networkContactListAddContact(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, networkContactIds: $networkContactIds}
  ) {
    error {
      message
    }
    networkContactList {
      id
      name
    }
    pressroom {
      id
      ...ManageContactLists_Pressroom
    }
    addedCount
  }
}
    ${ManageContactLists_PressroomFragmentDoc}
${ManageContactLists_ContactListFragmentDoc}`;
export type ManageContactLists_AddToListMutationFn = Apollo.MutationFunction<Types.ManageContactLists_AddToListMutation, Types.ManageContactLists_AddToListMutationVariables>;

/**
 * __useManageContactLists_AddToListMutation__
 *
 * To run a mutation, you first call `useManageContactLists_AddToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageContactLists_AddToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageContactListsAddToListMutation, { data, loading, error }] = useManageContactLists_AddToListMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      networkContactIds: // value for 'networkContactIds'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      listSearch: // value for 'listSearch'
 *   },
 * });
 */
export function useManageContactLists_AddToListMutation(baseOptions?: Apollo.MutationHookOptions<Types.ManageContactLists_AddToListMutation, Types.ManageContactLists_AddToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ManageContactLists_AddToListMutation, Types.ManageContactLists_AddToListMutationVariables>(ManageContactLists_AddToListDocument, options);
      }
export type ManageContactLists_AddToListMutationHookResult = ReturnType<typeof useManageContactLists_AddToListMutation>;
export type ManageContactLists_AddToListMutationResult = Apollo.MutationResult<Types.ManageContactLists_AddToListMutation>;
export type ManageContactLists_AddToListMutationOptions = Apollo.BaseMutationOptions<Types.ManageContactLists_AddToListMutation, Types.ManageContactLists_AddToListMutationVariables>;
export const ManageContactLists_AddToListBulkDocument = gql`
    mutation ManageContactLists_addToListBulk($pressroomId: ID!, $networkContactListId: ID!, $filterFromNetworkContactListId: ID, $search: String, $filter: NetworkContactFilter, $networkContactIds: [ID!], $listSearch: String!) {
  networkContactListAddContactBulk(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, filterFromNetworkContactListId: $filterFromNetworkContactListId, search: $search, filter: $filter}
  ) {
    error {
      message
    }
    networkContactList {
      id
      name
    }
    pressroom {
      id
      ...ManageContactLists_Pressroom
    }
    addedCount
  }
}
    ${ManageContactLists_PressroomFragmentDoc}
${ManageContactLists_ContactListFragmentDoc}`;
export type ManageContactLists_AddToListBulkMutationFn = Apollo.MutationFunction<Types.ManageContactLists_AddToListBulkMutation, Types.ManageContactLists_AddToListBulkMutationVariables>;

/**
 * __useManageContactLists_AddToListBulkMutation__
 *
 * To run a mutation, you first call `useManageContactLists_AddToListBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageContactLists_AddToListBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageContactListsAddToListBulkMutation, { data, loading, error }] = useManageContactLists_AddToListBulkMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      networkContactIds: // value for 'networkContactIds'
 *      listSearch: // value for 'listSearch'
 *   },
 * });
 */
export function useManageContactLists_AddToListBulkMutation(baseOptions?: Apollo.MutationHookOptions<Types.ManageContactLists_AddToListBulkMutation, Types.ManageContactLists_AddToListBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ManageContactLists_AddToListBulkMutation, Types.ManageContactLists_AddToListBulkMutationVariables>(ManageContactLists_AddToListBulkDocument, options);
      }
export type ManageContactLists_AddToListBulkMutationHookResult = ReturnType<typeof useManageContactLists_AddToListBulkMutation>;
export type ManageContactLists_AddToListBulkMutationResult = Apollo.MutationResult<Types.ManageContactLists_AddToListBulkMutation>;
export type ManageContactLists_AddToListBulkMutationOptions = Apollo.BaseMutationOptions<Types.ManageContactLists_AddToListBulkMutation, Types.ManageContactLists_AddToListBulkMutationVariables>;
export const JournalistOutletEmailDocument = gql`
    query JournalistOutletEmail($pressroomId: ID!, $email: String!) {
  pressroom(id: $pressroomId) {
    id
    networkContactsNameSearch(search: $email) {
      nodes {
        id
        firstName
        lastName
        email
      }
    }
    mndReachSearch(email: $email) {
      id
      items {
        id
        ...MndReachNewContactItem
      }
    }
    mndReachOutlets(email: $email, includeUnsubscribed: false) {
      id
      items {
        id
        ...MndReachNewContactItem
      }
    }
  }
}
    ${MndReachNewContactItemFragmentDoc}`;

/**
 * __useJournalistOutletEmailQuery__
 *
 * To run a query within a React component, call `useJournalistOutletEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useJournalistOutletEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJournalistOutletEmailQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useJournalistOutletEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables> & ({ variables: Types.JournalistOutletEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables>(JournalistOutletEmailDocument, options);
      }
export function useJournalistOutletEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables>(JournalistOutletEmailDocument, options);
        }
export function useJournalistOutletEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables>(JournalistOutletEmailDocument, options);
        }
export type JournalistOutletEmailQueryHookResult = ReturnType<typeof useJournalistOutletEmailQuery>;
export type JournalistOutletEmailLazyQueryHookResult = ReturnType<typeof useJournalistOutletEmailLazyQuery>;
export type JournalistOutletEmailSuspenseQueryHookResult = ReturnType<typeof useJournalistOutletEmailSuspenseQuery>;
export type JournalistOutletEmailQueryResult = Apollo.QueryResult<Types.JournalistOutletEmailQuery, Types.JournalistOutletEmailQueryVariables>;
export const AddContactDocument = gql`
    mutation addContact($pressroomId: ID!, $firstName: String, $lastName: String, $email: String!, $networkContactListId: ID) {
  networkContactAdd(
    input: {pressroomId: $pressroomId, firstName: $firstName, lastName: $lastName, email: $email, networkContactListId: $networkContactListId}
  ) {
    error {
      message
      ... on NetworkContactAddValidationError {
        email
      }
    }
    networkContact {
      id
      firstName
      lastName
      email
    }
    user {
      id
      onboarding(pressroomId: $pressroomId) {
        id
        completed
      }
    }
  }
}
    `;
export type AddContactMutationFn = Apollo.MutationFunction<Types.AddContactMutation, Types.AddContactMutationVariables>;

/**
 * __useAddContactMutation__
 *
 * To run a mutation, you first call `useAddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactMutation, { data, loading, error }] = useAddContactMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      networkContactListId: // value for 'networkContactListId'
 *   },
 * });
 */
export function useAddContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddContactMutation, Types.AddContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddContactMutation, Types.AddContactMutationVariables>(AddContactDocument, options);
      }
export type AddContactMutationHookResult = ReturnType<typeof useAddContactMutation>;
export type AddContactMutationResult = Apollo.MutationResult<Types.AddContactMutation>;
export type AddContactMutationOptions = Apollo.BaseMutationOptions<Types.AddContactMutation, Types.AddContactMutationVariables>;
export const NetworkContactAddFromMndReachDocument = gql`
    mutation networkContactAddFromMndReach($pressroomId: ID!, $journalistIds: [ID!], $outletIds: [ID!], $contactListIds: [ID!]!) {
  contactsMediaRelationsImport(
    input: {isExportable: true, pressroomId: $pressroomId, journalistIds: $journalistIds, outletIds: $outletIds, contactListIds: $contactListIds}
  ) {
    error {
      message
    }
  }
}
    `;
export type NetworkContactAddFromMndReachMutationFn = Apollo.MutationFunction<Types.NetworkContactAddFromMndReachMutation, Types.NetworkContactAddFromMndReachMutationVariables>;

/**
 * __useNetworkContactAddFromMndReachMutation__
 *
 * To run a mutation, you first call `useNetworkContactAddFromMndReachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactAddFromMndReachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactAddFromMndReachMutation, { data, loading, error }] = useNetworkContactAddFromMndReachMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      journalistIds: // value for 'journalistIds'
 *      outletIds: // value for 'outletIds'
 *      contactListIds: // value for 'contactListIds'
 *   },
 * });
 */
export function useNetworkContactAddFromMndReachMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactAddFromMndReachMutation, Types.NetworkContactAddFromMndReachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactAddFromMndReachMutation, Types.NetworkContactAddFromMndReachMutationVariables>(NetworkContactAddFromMndReachDocument, options);
      }
export type NetworkContactAddFromMndReachMutationHookResult = ReturnType<typeof useNetworkContactAddFromMndReachMutation>;
export type NetworkContactAddFromMndReachMutationResult = Apollo.MutationResult<Types.NetworkContactAddFromMndReachMutation>;
export type NetworkContactAddFromMndReachMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactAddFromMndReachMutation, Types.NetworkContactAddFromMndReachMutationVariables>;
export const AllNetworkContactsDocument = gql`
    query AllNetworkContacts($pressroomId: ID!, $page: Int!, $perPage: Int!, $search: String, $filter: NetworkContactFilter, $exclude: NetworkContactExclude, $excludeIfMndReach: NetworkContactExclude, $sort: NetworkContactSort) {
  pressroom(id: $pressroomId) {
    id
    contactLimits {
      ...ContactLimits
    }
    networkContactsSearch(
      page: $page
      first: $perPage
      search: $search
      filter: $filter
      exclude: $exclude
      excludeIfMndReach: $excludeIfMndReach
      sort: $sort
    ) {
      totalCount
      totalPages
      nodes {
        id
        ...NetworkContact
      }
    }
    features {
      id
      mndReach
      newsroom: managed(feature: newsroom) {
        id
        enabled
      }
      audienceBuilder: managed(feature: audienceBuilder) {
        id
        endAt
      }
    }
  }
}
    ${ContactLimitsFragmentDoc}
${NetworkContactFragmentDoc}`;

/**
 * __useAllNetworkContactsQuery__
 *
 * To run a query within a React component, call `useAllNetworkContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNetworkContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNetworkContactsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      exclude: // value for 'exclude'
 *      excludeIfMndReach: // value for 'excludeIfMndReach'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAllNetworkContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables> & ({ variables: Types.AllNetworkContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables>(AllNetworkContactsDocument, options);
      }
export function useAllNetworkContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables>(AllNetworkContactsDocument, options);
        }
export function useAllNetworkContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables>(AllNetworkContactsDocument, options);
        }
export type AllNetworkContactsQueryHookResult = ReturnType<typeof useAllNetworkContactsQuery>;
export type AllNetworkContactsLazyQueryHookResult = ReturnType<typeof useAllNetworkContactsLazyQuery>;
export type AllNetworkContactsSuspenseQueryHookResult = ReturnType<typeof useAllNetworkContactsSuspenseQuery>;
export type AllNetworkContactsQueryResult = Apollo.QueryResult<Types.AllNetworkContactsQuery, Types.AllNetworkContactsQueryVariables>;
export const DecommissionedAllNetworkContactsDocument = gql`
    query DecommissionedAllNetworkContacts($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactsSearch(page: 1, first: 10, filter: AudienceBuilderImport) {
      totalCount
    }
  }
}
    `;

/**
 * __useDecommissionedAllNetworkContactsQuery__
 *
 * To run a query within a React component, call `useDecommissionedAllNetworkContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecommissionedAllNetworkContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecommissionedAllNetworkContactsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDecommissionedAllNetworkContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables> & ({ variables: Types.DecommissionedAllNetworkContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables>(DecommissionedAllNetworkContactsDocument, options);
      }
export function useDecommissionedAllNetworkContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables>(DecommissionedAllNetworkContactsDocument, options);
        }
export function useDecommissionedAllNetworkContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables>(DecommissionedAllNetworkContactsDocument, options);
        }
export type DecommissionedAllNetworkContactsQueryHookResult = ReturnType<typeof useDecommissionedAllNetworkContactsQuery>;
export type DecommissionedAllNetworkContactsLazyQueryHookResult = ReturnType<typeof useDecommissionedAllNetworkContactsLazyQuery>;
export type DecommissionedAllNetworkContactsSuspenseQueryHookResult = ReturnType<typeof useDecommissionedAllNetworkContactsSuspenseQuery>;
export type DecommissionedAllNetworkContactsQueryResult = Apollo.QueryResult<Types.DecommissionedAllNetworkContactsQuery, Types.DecommissionedAllNetworkContactsQueryVariables>;
export const NetworkContactListListingDocument = gql`
    query NetworkContactListListing($pressroomId: ID!, $id: ID!, $page: Int!, $perPage: Int!, $search: String, $filter: NetworkContactFilter, $exclude: NetworkContactExclude, $excludeIfMndReach: NetworkContactExclude, $sort: NetworkContactSort) {
  pressroom(id: $pressroomId) {
    id
    contactLimits {
      ...ContactLimits
    }
    networkContactLists(ids: [$id]) {
      id
      name
      systemManaged
      description
      networkContacts(
        page: $page
        first: $perPage
        search: $search
        filter: $filter
        exclude: $exclude
        excludeIfMndReach: $excludeIfMndReach
        sort: $sort
      ) {
        totalCount
        totalPages
        nodes {
          id
          ...NetworkContact
        }
      }
    }
    features {
      id
      mndReach
      newsroom: managed(feature: newsroom) {
        id
        enabled
      }
      audienceBuilder: managed(feature: audienceBuilder) {
        id
        endAt
      }
    }
  }
}
    ${ContactLimitsFragmentDoc}
${NetworkContactFragmentDoc}`;

/**
 * __useNetworkContactListListingQuery__
 *
 * To run a query within a React component, call `useNetworkContactListListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactListListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkContactListListingQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      exclude: // value for 'exclude'
 *      excludeIfMndReach: // value for 'excludeIfMndReach'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useNetworkContactListListingQuery(baseOptions: Apollo.QueryHookOptions<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables> & ({ variables: Types.NetworkContactListListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables>(NetworkContactListListingDocument, options);
      }
export function useNetworkContactListListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables>(NetworkContactListListingDocument, options);
        }
export function useNetworkContactListListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables>(NetworkContactListListingDocument, options);
        }
export type NetworkContactListListingQueryHookResult = ReturnType<typeof useNetworkContactListListingQuery>;
export type NetworkContactListListingLazyQueryHookResult = ReturnType<typeof useNetworkContactListListingLazyQuery>;
export type NetworkContactListListingSuspenseQueryHookResult = ReturnType<typeof useNetworkContactListListingSuspenseQuery>;
export type NetworkContactListListingQueryResult = Apollo.QueryResult<Types.NetworkContactListListingQuery, Types.NetworkContactListListingQueryVariables>;
export const DecommissionedNetworkContactListListingDocument = gql`
    query DecommissionedNetworkContactListListing($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactLists(ids: [$id]) {
      id
      networkContacts(page: 1, first: 10, filter: AudienceBuilderImport) {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useDecommissionedNetworkContactListListingQuery__
 *
 * To run a query within a React component, call `useDecommissionedNetworkContactListListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecommissionedNetworkContactListListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecommissionedNetworkContactListListingQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDecommissionedNetworkContactListListingQuery(baseOptions: Apollo.QueryHookOptions<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables> & ({ variables: Types.DecommissionedNetworkContactListListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables>(DecommissionedNetworkContactListListingDocument, options);
      }
export function useDecommissionedNetworkContactListListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables>(DecommissionedNetworkContactListListingDocument, options);
        }
export function useDecommissionedNetworkContactListListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables>(DecommissionedNetworkContactListListingDocument, options);
        }
export type DecommissionedNetworkContactListListingQueryHookResult = ReturnType<typeof useDecommissionedNetworkContactListListingQuery>;
export type DecommissionedNetworkContactListListingLazyQueryHookResult = ReturnType<typeof useDecommissionedNetworkContactListListingLazyQuery>;
export type DecommissionedNetworkContactListListingSuspenseQueryHookResult = ReturnType<typeof useDecommissionedNetworkContactListListingSuspenseQuery>;
export type DecommissionedNetworkContactListListingQueryResult = Apollo.QueryResult<Types.DecommissionedNetworkContactListListingQuery, Types.DecommissionedNetworkContactListListingQueryVariables>;
export const RemoveNetworkContactsDocument = gql`
    mutation removeNetworkContacts($ids: [ID!]!, $pressroomId: ID!) {
  networkContactRemove(input: {ids: $ids, pressroomId: $pressroomId}) {
    error {
      message
    }
    deletedIds
    pressroom {
      id
    }
  }
}
    `;
export type RemoveNetworkContactsMutationFn = Apollo.MutationFunction<Types.RemoveNetworkContactsMutation, Types.RemoveNetworkContactsMutationVariables>;

/**
 * __useRemoveNetworkContactsMutation__
 *
 * To run a mutation, you first call `useRemoveNetworkContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNetworkContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNetworkContactsMutation, { data, loading, error }] = useRemoveNetworkContactsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useRemoveNetworkContactsMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveNetworkContactsMutation, Types.RemoveNetworkContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveNetworkContactsMutation, Types.RemoveNetworkContactsMutationVariables>(RemoveNetworkContactsDocument, options);
      }
export type RemoveNetworkContactsMutationHookResult = ReturnType<typeof useRemoveNetworkContactsMutation>;
export type RemoveNetworkContactsMutationResult = Apollo.MutationResult<Types.RemoveNetworkContactsMutation>;
export type RemoveNetworkContactsMutationOptions = Apollo.BaseMutationOptions<Types.RemoveNetworkContactsMutation, Types.RemoveNetworkContactsMutationVariables>;
export const RemoveNetworkContactsBulkDocument = gql`
    mutation removeNetworkContactsBulk($pressroomId: ID!, $networkContactListId: ID, $search: String, $filter: NetworkContactFilter) {
  networkContactRemoveBulk(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, search: $search, filter: $filter}
  ) {
    error {
      message
    }
    deletedIds
    pressroom {
      id
    }
  }
}
    `;
export type RemoveNetworkContactsBulkMutationFn = Apollo.MutationFunction<Types.RemoveNetworkContactsBulkMutation, Types.RemoveNetworkContactsBulkMutationVariables>;

/**
 * __useRemoveNetworkContactsBulkMutation__
 *
 * To run a mutation, you first call `useRemoveNetworkContactsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNetworkContactsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNetworkContactsBulkMutation, { data, loading, error }] = useRemoveNetworkContactsBulkMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRemoveNetworkContactsBulkMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveNetworkContactsBulkMutation, Types.RemoveNetworkContactsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveNetworkContactsBulkMutation, Types.RemoveNetworkContactsBulkMutationVariables>(RemoveNetworkContactsBulkDocument, options);
      }
export type RemoveNetworkContactsBulkMutationHookResult = ReturnType<typeof useRemoveNetworkContactsBulkMutation>;
export type RemoveNetworkContactsBulkMutationResult = Apollo.MutationResult<Types.RemoveNetworkContactsBulkMutation>;
export type RemoveNetworkContactsBulkMutationOptions = Apollo.BaseMutationOptions<Types.RemoveNetworkContactsBulkMutation, Types.RemoveNetworkContactsBulkMutationVariables>;
export const RemoveFromListDocument = gql`
    mutation removeFromList($pressroomId: ID!, $networkContactListId: ID!, $networkContactIds: [ID!]!) {
  networkContactListRemoveContact(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, networkContactIds: $networkContactIds}
  ) {
    error {
      message
    }
    removedCount
    networkContactList {
      id
      name
    }
  }
}
    `;
export type RemoveFromListMutationFn = Apollo.MutationFunction<Types.RemoveFromListMutation, Types.RemoveFromListMutationVariables>;

/**
 * __useRemoveFromListMutation__
 *
 * To run a mutation, you first call `useRemoveFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromListMutation, { data, loading, error }] = useRemoveFromListMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      networkContactIds: // value for 'networkContactIds'
 *   },
 * });
 */
export function useRemoveFromListMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveFromListMutation, Types.RemoveFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveFromListMutation, Types.RemoveFromListMutationVariables>(RemoveFromListDocument, options);
      }
export type RemoveFromListMutationHookResult = ReturnType<typeof useRemoveFromListMutation>;
export type RemoveFromListMutationResult = Apollo.MutationResult<Types.RemoveFromListMutation>;
export type RemoveFromListMutationOptions = Apollo.BaseMutationOptions<Types.RemoveFromListMutation, Types.RemoveFromListMutationVariables>;
export const RemoveFromListBulkDocument = gql`
    mutation removeFromListBulk($pressroomId: ID!, $networkContactListId: ID!, $filterFromNetworkContactListId: ID, $search: String, $filter: NetworkContactFilter) {
  networkContactListRemoveContactBulk(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, filterFromNetworkContactListId: $filterFromNetworkContactListId, search: $search, filter: $filter}
  ) {
    error {
      message
    }
    removedCount
    networkContactList {
      id
      name
    }
  }
}
    `;
export type RemoveFromListBulkMutationFn = Apollo.MutationFunction<Types.RemoveFromListBulkMutation, Types.RemoveFromListBulkMutationVariables>;

/**
 * __useRemoveFromListBulkMutation__
 *
 * To run a mutation, you first call `useRemoveFromListBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromListBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromListBulkMutation, { data, loading, error }] = useRemoveFromListBulkMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      filterFromNetworkContactListId: // value for 'filterFromNetworkContactListId'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRemoveFromListBulkMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveFromListBulkMutation, Types.RemoveFromListBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveFromListBulkMutation, Types.RemoveFromListBulkMutationVariables>(RemoveFromListBulkDocument, options);
      }
export type RemoveFromListBulkMutationHookResult = ReturnType<typeof useRemoveFromListBulkMutation>;
export type RemoveFromListBulkMutationResult = Apollo.MutationResult<Types.RemoveFromListBulkMutation>;
export type RemoveFromListBulkMutationOptions = Apollo.BaseMutationOptions<Types.RemoveFromListBulkMutation, Types.RemoveFromListBulkMutationVariables>;
export const NetworkContactListRemoveDocument = gql`
    mutation NetworkContactListRemove($pressroomId: ID!, $networkContactListId: ID!) {
  networkContactListRemove(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId}
  ) {
    error {
      message
    }
    networkContactList {
      id
      name
    }
  }
}
    `;
export type NetworkContactListRemoveMutationFn = Apollo.MutationFunction<Types.NetworkContactListRemoveMutation, Types.NetworkContactListRemoveMutationVariables>;

/**
 * __useNetworkContactListRemoveMutation__
 *
 * To run a mutation, you first call `useNetworkContactListRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactListRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactListRemoveMutation, { data, loading, error }] = useNetworkContactListRemoveMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *   },
 * });
 */
export function useNetworkContactListRemoveMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactListRemoveMutation, Types.NetworkContactListRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactListRemoveMutation, Types.NetworkContactListRemoveMutationVariables>(NetworkContactListRemoveDocument, options);
      }
export type NetworkContactListRemoveMutationHookResult = ReturnType<typeof useNetworkContactListRemoveMutation>;
export type NetworkContactListRemoveMutationResult = Apollo.MutationResult<Types.NetworkContactListRemoveMutation>;
export type NetworkContactListRemoveMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactListRemoveMutation, Types.NetworkContactListRemoveMutationVariables>;
export const NetworkContactListExportDocument = gql`
    mutation NetworkContactListExport($pressroomId: ID!, $fileFormat: NetworkContactExportFileFormat!, $networkContactListId: ID!) {
  networkContactExport(
    input: {pressroomId: $pressroomId, fileFormat: $fileFormat, networkContactListId: $networkContactListId}
  ) {
    exportedFileFormat
    error {
      message
    }
  }
}
    `;
export type NetworkContactListExportMutationFn = Apollo.MutationFunction<Types.NetworkContactListExportMutation, Types.NetworkContactListExportMutationVariables>;

/**
 * __useNetworkContactListExportMutation__
 *
 * To run a mutation, you first call `useNetworkContactListExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactListExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactListExportMutation, { data, loading, error }] = useNetworkContactListExportMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      fileFormat: // value for 'fileFormat'
 *      networkContactListId: // value for 'networkContactListId'
 *   },
 * });
 */
export function useNetworkContactListExportMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactListExportMutation, Types.NetworkContactListExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactListExportMutation, Types.NetworkContactListExportMutationVariables>(NetworkContactListExportDocument, options);
      }
export type NetworkContactListExportMutationHookResult = ReturnType<typeof useNetworkContactListExportMutation>;
export type NetworkContactListExportMutationResult = Apollo.MutationResult<Types.NetworkContactListExportMutation>;
export type NetworkContactListExportMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactListExportMutation, Types.NetworkContactListExportMutationVariables>;
export const AllContactsCountDocument = gql`
    query AllContactsCount($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactsSearch {
      totalCount
    }
    networkInactiveContactsList {
      contactsCount
    }
    features {
      id
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      coPilotContactCleaner: managed(feature: coPilotContactCleaner) {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useAllContactsCountQuery__
 *
 * To run a query within a React component, call `useAllContactsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContactsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContactsCountQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useAllContactsCountQuery(baseOptions: Apollo.QueryHookOptions<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables> & ({ variables: Types.AllContactsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables>(AllContactsCountDocument, options);
      }
export function useAllContactsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables>(AllContactsCountDocument, options);
        }
export function useAllContactsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables>(AllContactsCountDocument, options);
        }
export type AllContactsCountQueryHookResult = ReturnType<typeof useAllContactsCountQuery>;
export type AllContactsCountLazyQueryHookResult = ReturnType<typeof useAllContactsCountLazyQuery>;
export type AllContactsCountSuspenseQueryHookResult = ReturnType<typeof useAllContactsCountSuspenseQuery>;
export type AllContactsCountQueryResult = Apollo.QueryResult<Types.AllContactsCountQuery, Types.AllContactsCountQueryVariables>;
export const NetworkContactListDocument = gql`
    query NetworkContactList($pressroomId: ID!, $search: String!, $sort: NetworkContactListSort!, $page: Int!, $perPage: Int!) {
  pressroom(id: $pressroomId) {
    id
    contactLimits {
      ...ContactLimits
    }
    networkContactListSearch(
      search: $search
      sort: $sort
      page: $page
      first: $perPage
      withSystemManaged: true
    ) {
      totalPages
      currentPage
      nodes {
        id
        name
        contactsCount
        systemManaged
        stats {
          id
          received
          openRate
          clickRate
          engagementRate
        }
      }
    }
  }
}
    ${ContactLimitsFragmentDoc}`;

/**
 * __useNetworkContactListQuery__
 *
 * To run a query within a React component, call `useNetworkContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkContactListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNetworkContactListQuery(baseOptions: Apollo.QueryHookOptions<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables> & ({ variables: Types.NetworkContactListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables>(NetworkContactListDocument, options);
      }
export function useNetworkContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables>(NetworkContactListDocument, options);
        }
export function useNetworkContactListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables>(NetworkContactListDocument, options);
        }
export type NetworkContactListQueryHookResult = ReturnType<typeof useNetworkContactListQuery>;
export type NetworkContactListLazyQueryHookResult = ReturnType<typeof useNetworkContactListLazyQuery>;
export type NetworkContactListSuspenseQueryHookResult = ReturnType<typeof useNetworkContactListSuspenseQuery>;
export type NetworkContactListQueryResult = Apollo.QueryResult<Types.NetworkContactListQuery, Types.NetworkContactListQueryVariables>;
export const AllContactsExportDocument = gql`
    mutation AllContactsExport($pressroomId: ID!, $fileFormat: NetworkContactExportFileFormat!) {
  networkContactExport(
    input: {pressroomId: $pressroomId, fileFormat: $fileFormat}
  ) {
    exportedFileFormat
    error {
      message
    }
  }
}
    `;
export type AllContactsExportMutationFn = Apollo.MutationFunction<Types.AllContactsExportMutation, Types.AllContactsExportMutationVariables>;

/**
 * __useAllContactsExportMutation__
 *
 * To run a mutation, you first call `useAllContactsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllContactsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allContactsExportMutation, { data, loading, error }] = useAllContactsExportMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      fileFormat: // value for 'fileFormat'
 *   },
 * });
 */
export function useAllContactsExportMutation(baseOptions?: Apollo.MutationHookOptions<Types.AllContactsExportMutation, Types.AllContactsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AllContactsExportMutation, Types.AllContactsExportMutationVariables>(AllContactsExportDocument, options);
      }
export type AllContactsExportMutationHookResult = ReturnType<typeof useAllContactsExportMutation>;
export type AllContactsExportMutationResult = Apollo.MutationResult<Types.AllContactsExportMutation>;
export type AllContactsExportMutationOptions = Apollo.BaseMutationOptions<Types.AllContactsExportMutation, Types.AllContactsExportMutationVariables>;
export const NetworkContactListUpdateDocument = gql`
    mutation NetworkContactListUpdate($pressroomId: ID!, $networkContactListId: ID!, $name: String!) {
  networkContactListUpdate(
    input: {pressroomId: $pressroomId, networkContactListId: $networkContactListId, name: $name}
  ) {
    error {
      message
      ... on NetworkContactListsUpdateValidationError {
        name
      }
    }
    networkContactList {
      id
      name
    }
  }
}
    `;
export type NetworkContactListUpdateMutationFn = Apollo.MutationFunction<Types.NetworkContactListUpdateMutation, Types.NetworkContactListUpdateMutationVariables>;

/**
 * __useNetworkContactListUpdateMutation__
 *
 * To run a mutation, you first call `useNetworkContactListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactListUpdateMutation, { data, loading, error }] = useNetworkContactListUpdateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      networkContactListId: // value for 'networkContactListId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useNetworkContactListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactListUpdateMutation, Types.NetworkContactListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactListUpdateMutation, Types.NetworkContactListUpdateMutationVariables>(NetworkContactListUpdateDocument, options);
      }
export type NetworkContactListUpdateMutationHookResult = ReturnType<typeof useNetworkContactListUpdateMutation>;
export type NetworkContactListUpdateMutationResult = Apollo.MutationResult<Types.NetworkContactListUpdateMutation>;
export type NetworkContactListUpdateMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactListUpdateMutation, Types.NetworkContactListUpdateMutationVariables>;
export const NetworkContactListAddDocument = gql`
    mutation NetworkContactListAdd($pressroomId: ID!, $name: String!) {
  networkContactListAdd(input: {pressroomId: $pressroomId, name: $name}) {
    error {
      message
      ... on NetworkContactListsAddValidationError {
        name
      }
    }
    networkContactList {
      id
      name
    }
  }
}
    `;
export type NetworkContactListAddMutationFn = Apollo.MutationFunction<Types.NetworkContactListAddMutation, Types.NetworkContactListAddMutationVariables>;

/**
 * __useNetworkContactListAddMutation__
 *
 * To run a mutation, you first call `useNetworkContactListAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactListAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkContactListAddMutation, { data, loading, error }] = useNetworkContactListAddMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useNetworkContactListAddMutation(baseOptions?: Apollo.MutationHookOptions<Types.NetworkContactListAddMutation, Types.NetworkContactListAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.NetworkContactListAddMutation, Types.NetworkContactListAddMutationVariables>(NetworkContactListAddDocument, options);
      }
export type NetworkContactListAddMutationHookResult = ReturnType<typeof useNetworkContactListAddMutation>;
export type NetworkContactListAddMutationResult = Apollo.MutationResult<Types.NetworkContactListAddMutation>;
export type NetworkContactListAddMutationOptions = Apollo.BaseMutationOptions<Types.NetworkContactListAddMutation, Types.NetworkContactListAddMutationVariables>;
export const ImportContactsFromFilePageDocument = gql`
    query ImportContactsFromFilePage($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactListSearch(sort: name, withSystemManaged: false) {
      nodes {
        id
        name
        contactsCount
      }
    }
  }
}
    `;

/**
 * __useImportContactsFromFilePageQuery__
 *
 * To run a query within a React component, call `useImportContactsFromFilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportContactsFromFilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportContactsFromFilePageQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useImportContactsFromFilePageQuery(baseOptions: Apollo.QueryHookOptions<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables> & ({ variables: Types.ImportContactsFromFilePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables>(ImportContactsFromFilePageDocument, options);
      }
export function useImportContactsFromFilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables>(ImportContactsFromFilePageDocument, options);
        }
export function useImportContactsFromFilePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables>(ImportContactsFromFilePageDocument, options);
        }
export type ImportContactsFromFilePageQueryHookResult = ReturnType<typeof useImportContactsFromFilePageQuery>;
export type ImportContactsFromFilePageLazyQueryHookResult = ReturnType<typeof useImportContactsFromFilePageLazyQuery>;
export type ImportContactsFromFilePageSuspenseQueryHookResult = ReturnType<typeof useImportContactsFromFilePageSuspenseQuery>;
export type ImportContactsFromFilePageQueryResult = Apollo.QueryResult<Types.ImportContactsFromFilePageQuery, Types.ImportContactsFromFilePageQueryVariables>;
export const ImportContactsFromFileDocument = gql`
    mutation ImportContactsFromFile($input: ContactsImportFileInput!) {
  contactsImportFile(input: $input) {
    error {
      __typename
      message
    }
  }
}
    `;
export type ImportContactsFromFileMutationFn = Apollo.MutationFunction<Types.ImportContactsFromFileMutation, Types.ImportContactsFromFileMutationVariables>;

/**
 * __useImportContactsFromFileMutation__
 *
 * To run a mutation, you first call `useImportContactsFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportContactsFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importContactsFromFileMutation, { data, loading, error }] = useImportContactsFromFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportContactsFromFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportContactsFromFileMutation, Types.ImportContactsFromFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportContactsFromFileMutation, Types.ImportContactsFromFileMutationVariables>(ImportContactsFromFileDocument, options);
      }
export type ImportContactsFromFileMutationHookResult = ReturnType<typeof useImportContactsFromFileMutation>;
export type ImportContactsFromFileMutationResult = Apollo.MutationResult<Types.ImportContactsFromFileMutation>;
export type ImportContactsFromFileMutationOptions = Apollo.BaseMutationOptions<Types.ImportContactsFromFileMutation, Types.ImportContactsFromFileMutationVariables>;
export const ImportContactsFromPastePageDocument = gql`
    query ImportContactsFromPastePage($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    networkContactListSearch(sort: name, withSystemManaged: false) {
      nodes {
        id
        name
        contactsCount
      }
    }
  }
}
    `;

/**
 * __useImportContactsFromPastePageQuery__
 *
 * To run a query within a React component, call `useImportContactsFromPastePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportContactsFromPastePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportContactsFromPastePageQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useImportContactsFromPastePageQuery(baseOptions: Apollo.QueryHookOptions<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables> & ({ variables: Types.ImportContactsFromPastePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables>(ImportContactsFromPastePageDocument, options);
      }
export function useImportContactsFromPastePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables>(ImportContactsFromPastePageDocument, options);
        }
export function useImportContactsFromPastePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables>(ImportContactsFromPastePageDocument, options);
        }
export type ImportContactsFromPastePageQueryHookResult = ReturnType<typeof useImportContactsFromPastePageQuery>;
export type ImportContactsFromPastePageLazyQueryHookResult = ReturnType<typeof useImportContactsFromPastePageLazyQuery>;
export type ImportContactsFromPastePageSuspenseQueryHookResult = ReturnType<typeof useImportContactsFromPastePageSuspenseQuery>;
export type ImportContactsFromPastePageQueryResult = Apollo.QueryResult<Types.ImportContactsFromPastePageQuery, Types.ImportContactsFromPastePageQueryVariables>;
export const ImportContactsFromPasteDocument = gql`
    mutation ImportContactsFromPaste($pressroomId: ID!, $emails: [String!]!, $contactListIds: [ID!]!) {
  contactsImportEmailList(
    input: {pressroomId: $pressroomId, emails: $emails, contactListIds: $contactListIds}
  ) {
    error {
      __typename
      message
      ... on ContactsImportEmailListValidationError {
        emails
      }
    }
  }
}
    `;
export type ImportContactsFromPasteMutationFn = Apollo.MutationFunction<Types.ImportContactsFromPasteMutation, Types.ImportContactsFromPasteMutationVariables>;

/**
 * __useImportContactsFromPasteMutation__
 *
 * To run a mutation, you first call `useImportContactsFromPasteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportContactsFromPasteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importContactsFromPasteMutation, { data, loading, error }] = useImportContactsFromPasteMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      emails: // value for 'emails'
 *      contactListIds: // value for 'contactListIds'
 *   },
 * });
 */
export function useImportContactsFromPasteMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportContactsFromPasteMutation, Types.ImportContactsFromPasteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportContactsFromPasteMutation, Types.ImportContactsFromPasteMutationVariables>(ImportContactsFromPasteDocument, options);
      }
export type ImportContactsFromPasteMutationHookResult = ReturnType<typeof useImportContactsFromPasteMutation>;
export type ImportContactsFromPasteMutationResult = Apollo.MutationResult<Types.ImportContactsFromPasteMutation>;
export type ImportContactsFromPasteMutationOptions = Apollo.BaseMutationOptions<Types.ImportContactsFromPasteMutation, Types.ImportContactsFromPasteMutationVariables>;
export const ImportLogDocument = gql`
    query ImportLog($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    contactImports {
      id
      name
      error
      createdAt
      recordsNew
      recordsTotal
      recordsInvalid
      recordsDuplicate
      invalidOrDuplicateEmails
      hasErrors
      existingIssuesList
      importedContactLists {
        id
        name
      }
      duplicateEmailsList {
        totalCount
      }
      invalidEmailsList {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useImportLogQuery__
 *
 * To run a query within a React component, call `useImportLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportLogQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useImportLogQuery(baseOptions: Apollo.QueryHookOptions<Types.ImportLogQuery, Types.ImportLogQueryVariables> & ({ variables: Types.ImportLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImportLogQuery, Types.ImportLogQueryVariables>(ImportLogDocument, options);
      }
export function useImportLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImportLogQuery, Types.ImportLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImportLogQuery, Types.ImportLogQueryVariables>(ImportLogDocument, options);
        }
export function useImportLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ImportLogQuery, Types.ImportLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ImportLogQuery, Types.ImportLogQueryVariables>(ImportLogDocument, options);
        }
export type ImportLogQueryHookResult = ReturnType<typeof useImportLogQuery>;
export type ImportLogLazyQueryHookResult = ReturnType<typeof useImportLogLazyQuery>;
export type ImportLogSuspenseQueryHookResult = ReturnType<typeof useImportLogSuspenseQuery>;
export type ImportLogQueryResult = Apollo.QueryResult<Types.ImportLogQuery, Types.ImportLogQueryVariables>;
export const DuplicateEmailListDocument = gql`
    query DuplicateEmailList($pressroomId: ID!, $contactLogId: ID!, $first: Int, $after: String) {
  pressroom(id: $pressroomId) {
    id
    contactImport(id: $contactLogId) {
      id
      duplicateEmailsList(first: $first, after: $after) {
        nodes {
          id
          email
          duplicate
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useDuplicateEmailListQuery__
 *
 * To run a query within a React component, call `useDuplicateEmailListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEmailListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateEmailListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      contactLogId: // value for 'contactLogId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDuplicateEmailListQuery(baseOptions: Apollo.QueryHookOptions<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables> & ({ variables: Types.DuplicateEmailListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables>(DuplicateEmailListDocument, options);
      }
export function useDuplicateEmailListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables>(DuplicateEmailListDocument, options);
        }
export function useDuplicateEmailListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables>(DuplicateEmailListDocument, options);
        }
export type DuplicateEmailListQueryHookResult = ReturnType<typeof useDuplicateEmailListQuery>;
export type DuplicateEmailListLazyQueryHookResult = ReturnType<typeof useDuplicateEmailListLazyQuery>;
export type DuplicateEmailListSuspenseQueryHookResult = ReturnType<typeof useDuplicateEmailListSuspenseQuery>;
export type DuplicateEmailListQueryResult = Apollo.QueryResult<Types.DuplicateEmailListQuery, Types.DuplicateEmailListQueryVariables>;
export const InvalidEmailListDocument = gql`
    query InvalidEmailList($pressroomId: ID!, $contactLogId: ID!, $first: Int, $after: String) {
  pressroom(id: $pressroomId) {
    id
    contactImport(id: $contactLogId) {
      id
      invalidEmailsList(first: $first, after: $after) {
        nodes {
          id
          email
          duplicate
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useInvalidEmailListQuery__
 *
 * To run a query within a React component, call `useInvalidEmailListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvalidEmailListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvalidEmailListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      contactLogId: // value for 'contactLogId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInvalidEmailListQuery(baseOptions: Apollo.QueryHookOptions<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables> & ({ variables: Types.InvalidEmailListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables>(InvalidEmailListDocument, options);
      }
export function useInvalidEmailListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables>(InvalidEmailListDocument, options);
        }
export function useInvalidEmailListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables>(InvalidEmailListDocument, options);
        }
export type InvalidEmailListQueryHookResult = ReturnType<typeof useInvalidEmailListQuery>;
export type InvalidEmailListLazyQueryHookResult = ReturnType<typeof useInvalidEmailListLazyQuery>;
export type InvalidEmailListSuspenseQueryHookResult = ReturnType<typeof useInvalidEmailListSuspenseQuery>;
export type InvalidEmailListQueryResult = Apollo.QueryResult<Types.InvalidEmailListQuery, Types.InvalidEmailListQueryVariables>;
export const FailedEmailListDocument = gql`
    query FailedEmailList($pressroomId: ID!, $contactLogId: ID!, $reason: EmailListReason, $first: Int, $after: String) {
  pressroom(id: $pressroomId) {
    id
    contactImport(id: $contactLogId) {
      id
      filterFailedEmailList(reason: $reason, first: $first, after: $after) {
        nodes {
          id
          email
          reason
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
  }
}
    `;

/**
 * __useFailedEmailListQuery__
 *
 * To run a query within a React component, call `useFailedEmailListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedEmailListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedEmailListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      contactLogId: // value for 'contactLogId'
 *      reason: // value for 'reason'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFailedEmailListQuery(baseOptions: Apollo.QueryHookOptions<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables> & ({ variables: Types.FailedEmailListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables>(FailedEmailListDocument, options);
      }
export function useFailedEmailListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables>(FailedEmailListDocument, options);
        }
export function useFailedEmailListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables>(FailedEmailListDocument, options);
        }
export type FailedEmailListQueryHookResult = ReturnType<typeof useFailedEmailListQuery>;
export type FailedEmailListLazyQueryHookResult = ReturnType<typeof useFailedEmailListLazyQuery>;
export type FailedEmailListSuspenseQueryHookResult = ReturnType<typeof useFailedEmailListSuspenseQuery>;
export type FailedEmailListQueryResult = Apollo.QueryResult<Types.FailedEmailListQuery, Types.FailedEmailListQueryVariables>;
export const DashboardTopStoriesDocument = gql`
    query DashboardTopStories($pressroomId: ID!, $sort: MaterialListSort) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      prImpactLimited: managed(feature: prImpactLimited) {
        id
        enabled
      }
      analyze: managed(feature: analyze) {
        id
        enabled
      }
    }
    materialList2(
      types: [Pressrelease, News, BlogPost]
      status: published
      sort: $sort
      first: 5
    ) {
      nodes {
        __typename
        id
        header
        publishedAt2
        publicUrl
        emailsSent
        emailsOpened
        emailsUniqueOpened
        emailsUniqueOpenedPercentage
        newsroomViews
        quotationsCount
        image(options: {transformation: THUMBNAIL_SMALL}) {
          id
          url
          altText
        }
        ... on Video {
          thumbnailUrl
        }
        ... on Document {
          preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardTopStoriesQuery__
 *
 * To run a query within a React component, call `useDashboardTopStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTopStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTopStoriesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useDashboardTopStoriesQuery(baseOptions: Apollo.QueryHookOptions<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables> & ({ variables: Types.DashboardTopStoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables>(DashboardTopStoriesDocument, options);
      }
export function useDashboardTopStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables>(DashboardTopStoriesDocument, options);
        }
export function useDashboardTopStoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables>(DashboardTopStoriesDocument, options);
        }
export type DashboardTopStoriesQueryHookResult = ReturnType<typeof useDashboardTopStoriesQuery>;
export type DashboardTopStoriesLazyQueryHookResult = ReturnType<typeof useDashboardTopStoriesLazyQuery>;
export type DashboardTopStoriesSuspenseQueryHookResult = ReturnType<typeof useDashboardTopStoriesSuspenseQuery>;
export type DashboardTopStoriesQueryResult = Apollo.QueryResult<Types.DashboardTopStoriesQuery, Types.DashboardTopStoriesQueryVariables>;
export const UpdateProgressDocument = gql`
    mutation updateProgress($id: ID!, $progressPercentage: Int!) {
  videoProgressUpdate(input: {id: $id, progressPercentage: $progressPercentage}) {
    video {
      id
      progressPercentage
    }
    error {
      message
    }
  }
}
    `;
export type UpdateProgressMutationFn = Apollo.MutationFunction<Types.UpdateProgressMutation, Types.UpdateProgressMutationVariables>;

/**
 * __useUpdateProgressMutation__
 *
 * To run a mutation, you first call `useUpdateProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgressMutation, { data, loading, error }] = useUpdateProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      progressPercentage: // value for 'progressPercentage'
 *   },
 * });
 */
export function useUpdateProgressMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProgressMutation, Types.UpdateProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProgressMutation, Types.UpdateProgressMutationVariables>(UpdateProgressDocument, options);
      }
export type UpdateProgressMutationHookResult = ReturnType<typeof useUpdateProgressMutation>;
export type UpdateProgressMutationResult = Apollo.MutationResult<Types.UpdateProgressMutation>;
export type UpdateProgressMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProgressMutation, Types.UpdateProgressMutationVariables>;
export const DismissOnboardingVideoCourseDocument = gql`
    mutation dismissOnboardingVideoCourse($pressroomId: ID!) {
  noticeConfirm(input: {notice: userOnboarding, pressroomId: $pressroomId}) {
    pressroom {
      id
      dashboard {
        id
        ... on VideoCourse {
          id
        }
      }
    }
  }
}
    `;
export type DismissOnboardingVideoCourseMutationFn = Apollo.MutationFunction<Types.DismissOnboardingVideoCourseMutation, Types.DismissOnboardingVideoCourseMutationVariables>;

/**
 * __useDismissOnboardingVideoCourseMutation__
 *
 * To run a mutation, you first call `useDismissOnboardingVideoCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissOnboardingVideoCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissOnboardingVideoCourseMutation, { data, loading, error }] = useDismissOnboardingVideoCourseMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDismissOnboardingVideoCourseMutation(baseOptions?: Apollo.MutationHookOptions<Types.DismissOnboardingVideoCourseMutation, Types.DismissOnboardingVideoCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DismissOnboardingVideoCourseMutation, Types.DismissOnboardingVideoCourseMutationVariables>(DismissOnboardingVideoCourseDocument, options);
      }
export type DismissOnboardingVideoCourseMutationHookResult = ReturnType<typeof useDismissOnboardingVideoCourseMutation>;
export type DismissOnboardingVideoCourseMutationResult = Apollo.MutationResult<Types.DismissOnboardingVideoCourseMutation>;
export type DismissOnboardingVideoCourseMutationOptions = Apollo.BaseMutationOptions<Types.DismissOnboardingVideoCourseMutation, Types.DismissOnboardingVideoCourseMutationVariables>;
export const ZeroPublicationDocument = gql`
    query zeroPublication($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    publicationLimit
  }
}
    `;

/**
 * __useZeroPublicationQuery__
 *
 * To run a query within a React component, call `useZeroPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useZeroPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZeroPublicationQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useZeroPublicationQuery(baseOptions: Apollo.QueryHookOptions<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables> & ({ variables: Types.ZeroPublicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables>(ZeroPublicationDocument, options);
      }
export function useZeroPublicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables>(ZeroPublicationDocument, options);
        }
export function useZeroPublicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables>(ZeroPublicationDocument, options);
        }
export type ZeroPublicationQueryHookResult = ReturnType<typeof useZeroPublicationQuery>;
export type ZeroPublicationLazyQueryHookResult = ReturnType<typeof useZeroPublicationLazyQuery>;
export type ZeroPublicationSuspenseQueryHookResult = ReturnType<typeof useZeroPublicationSuspenseQuery>;
export type ZeroPublicationQueryResult = Apollo.QueryResult<Types.ZeroPublicationQuery, Types.ZeroPublicationQueryVariables>;
export const DismissBrandReportBannerH12024Document = gql`
    mutation dismissBrandReportBannerH12024($pressroomId: ID!) {
  noticeConfirm(
    input: {notice: brandReportBannerH12024, pressroomId: $pressroomId}
  ) {
    pressroom {
      id
      dashboard {
        id
        ... on BrandReportBannerH12024 {
          id
        }
      }
    }
  }
}
    `;
export type DismissBrandReportBannerH12024MutationFn = Apollo.MutationFunction<Types.DismissBrandReportBannerH12024Mutation, Types.DismissBrandReportBannerH12024MutationVariables>;

/**
 * __useDismissBrandReportBannerH12024Mutation__
 *
 * To run a mutation, you first call `useDismissBrandReportBannerH12024Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissBrandReportBannerH12024Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissBrandReportBannerH12024Mutation, { data, loading, error }] = useDismissBrandReportBannerH12024Mutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDismissBrandReportBannerH12024Mutation(baseOptions?: Apollo.MutationHookOptions<Types.DismissBrandReportBannerH12024Mutation, Types.DismissBrandReportBannerH12024MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DismissBrandReportBannerH12024Mutation, Types.DismissBrandReportBannerH12024MutationVariables>(DismissBrandReportBannerH12024Document, options);
      }
export type DismissBrandReportBannerH12024MutationHookResult = ReturnType<typeof useDismissBrandReportBannerH12024Mutation>;
export type DismissBrandReportBannerH12024MutationResult = Apollo.MutationResult<Types.DismissBrandReportBannerH12024Mutation>;
export type DismissBrandReportBannerH12024MutationOptions = Apollo.BaseMutationOptions<Types.DismissBrandReportBannerH12024Mutation, Types.DismissBrandReportBannerH12024MutationVariables>;
export const DashboardDataDocument = gql`
    query DashboardData($pressroomId: ID!) {
  me {
    id
    user {
      id
      showNps
      ...UserBaseInfo
    }
  }
  pressroom(id: $pressroomId) {
    id
    siteCode
    name
    newsroomUrl
    remainingPublicationCount
    features {
      id
      dashboardInsights: managed(feature: dashboardInsights) {
        id
        enabled
      }
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      analyzeLight: managed(feature: analyzeLight) {
        id
        enabled
      }
    }
    dashboard {
      id
      ... on LatestStory {
        story {
          id
          header
          image(options: {transformation: MATERIAL_HEADER_PREVIEW}) {
            altText
            id
            url
          }
          publishedAt2
          scheduledFor
          publicUrl
          status
        }
        metrics {
          id
          label
          value
        }
      }
      ... on NewsroomStatistics {
        id
        weeklyViews
        monthlyViews
        averageTime
      }
      ... on LatestMediaCoverage {
        id
        quotations {
          id
          articleTitle
          articlePublishedAt
          articleUrl
          favatarUrl
        }
      }
      ... on LatestMediaCoverageUnlocker {
        id
        quotationCount
      }
      ... on LatestFollowers {
        id
        followers {
          id
          firstName
          lastName
          email
          avatarUrl
          followerAt
        }
      }
      ... on OnboardingWizard {
        newsroomGoLiveOnly
        pressroom {
          id
          siteLocale
          ...PressroomGoLive
        }
        showReadyToGoLive
        user {
          id
          name
          email
          phone
          onboarding(pressroomId: $pressroomId) {
            id
            ...OnboardingStep
          }
        }
      }
      ... on AccountVerificationPending {
        id
        user {
          id
          name
          email
          phone
          locale2
        }
      }
      ... on VideoCourse {
        id
        dashboardEntry
        user {
          id
          name
          locale: locale2
        }
        videos {
          id
          title
          description
          thumbnail
          progressPercentage
          duration
          src
          contentType
        }
      }
      ... on BrandReportBannerH12024 {
        id
        trialActivationNeeded
      }
    }
  }
}
    ${UserBaseInfoFragmentDoc}
${PressroomGoLiveFragmentDoc}
${PressContactFragmentDoc}
${CompanyDescriptionFragmentDoc}
${CompanyInfoFragmentDoc}
${BrandingFragmentDoc}
${OnboardingStepFragmentDoc}`;

/**
 * __useDashboardDataQuery__
 *
 * To run a query within a React component, call `useDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDashboardDataQuery(baseOptions: Apollo.QueryHookOptions<Types.DashboardDataQuery, Types.DashboardDataQueryVariables> & ({ variables: Types.DashboardDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DashboardDataQuery, Types.DashboardDataQueryVariables>(DashboardDataDocument, options);
      }
export function useDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DashboardDataQuery, Types.DashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DashboardDataQuery, Types.DashboardDataQueryVariables>(DashboardDataDocument, options);
        }
export function useDashboardDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DashboardDataQuery, Types.DashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DashboardDataQuery, Types.DashboardDataQueryVariables>(DashboardDataDocument, options);
        }
export type DashboardDataQueryHookResult = ReturnType<typeof useDashboardDataQuery>;
export type DashboardDataLazyQueryHookResult = ReturnType<typeof useDashboardDataLazyQuery>;
export type DashboardDataSuspenseQueryHookResult = ReturnType<typeof useDashboardDataSuspenseQuery>;
export type DashboardDataQueryResult = Apollo.QueryResult<Types.DashboardDataQuery, Types.DashboardDataQueryVariables>;
export const GetReportsSettingsDocument = gql`
    query getReportsSettings($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      prImpact: managed(feature: prImpact) {
        id
        enabled
      }
      analyze: managed(feature: analyze) {
        id
        enabled
      }
    }
    emailReports {
      analyzeMaterialReport {
        settings {
          statsOverviewSetting
          statsOverviewEmails
        }
      }
      analyzePressroomReport {
        settings {
          statsItemDay
          statsItem2day
          statsItem3day
          statsItemWeek
          statsItem2weeks
          statsItemEmails
        }
      }
      prImpactMaterialReport {
        settings {
          prImpactEmailReceivers
          prImpactEmailSendoutActive
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportsSettingsQuery__
 *
 * To run a query within a React component, call `useGetReportsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsSettingsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetReportsSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables> & ({ variables: Types.GetReportsSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables>(GetReportsSettingsDocument, options);
      }
export function useGetReportsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables>(GetReportsSettingsDocument, options);
        }
export function useGetReportsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables>(GetReportsSettingsDocument, options);
        }
export type GetReportsSettingsQueryHookResult = ReturnType<typeof useGetReportsSettingsQuery>;
export type GetReportsSettingsLazyQueryHookResult = ReturnType<typeof useGetReportsSettingsLazyQuery>;
export type GetReportsSettingsSuspenseQueryHookResult = ReturnType<typeof useGetReportsSettingsSuspenseQuery>;
export type GetReportsSettingsQueryResult = Apollo.QueryResult<Types.GetReportsSettingsQuery, Types.GetReportsSettingsQueryVariables>;
export const UpdateReportSettingsDocument = gql`
    mutation updateReportSettings($pressroomId: ID!, $statsOverviewSetting: String, $statsOverviewEmails: [String!]!, $statsItemDay: Boolean!, $statsItem2day: Boolean!, $statsItem3day: Boolean!, $statsItemWeek: Boolean!, $statsItem2weeks: Boolean!, $statsItemEmails: [String!]!, $prImpactEmailReceivers: [String!]!, $prImpactEmailSendoutActive: Boolean!) {
  updateEmailReportsSettings(
    input: {pressroomId: $pressroomId, analyzeReportsSettings: {statsOverviewSetting: $statsOverviewSetting, statsOverviewEmails: $statsOverviewEmails, statsItemDay: $statsItemDay, statsItem2day: $statsItem2day, statsItem3day: $statsItem3day, statsItemWeek: $statsItemWeek, statsItem2weeks: $statsItem2weeks, statsItemEmails: $statsItemEmails}, prImpactReportsSettings: {prImpactEmailReceivers: $prImpactEmailReceivers, prImpactEmailSendoutActive: $prImpactEmailSendoutActive}}
  ) {
    errors
    pressroom {
      id
      emailReports {
        analyzeMaterialReport {
          settings {
            statsOverviewSetting
            statsOverviewEmails
          }
        }
        analyzePressroomReport {
          settings {
            statsItemDay
            statsItem2day
            statsItem3day
            statsItemWeek
            statsItem2weeks
            statsItemEmails
          }
        }
        prImpactMaterialReport {
          settings {
            prImpactEmailReceivers
            prImpactEmailSendoutActive
          }
        }
      }
    }
  }
}
    `;
export type UpdateReportSettingsMutationFn = Apollo.MutationFunction<Types.UpdateReportSettingsMutation, Types.UpdateReportSettingsMutationVariables>;

/**
 * __useUpdateReportSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateReportSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportSettingsMutation, { data, loading, error }] = useUpdateReportSettingsMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      statsOverviewSetting: // value for 'statsOverviewSetting'
 *      statsOverviewEmails: // value for 'statsOverviewEmails'
 *      statsItemDay: // value for 'statsItemDay'
 *      statsItem2day: // value for 'statsItem2day'
 *      statsItem3day: // value for 'statsItem3day'
 *      statsItemWeek: // value for 'statsItemWeek'
 *      statsItem2weeks: // value for 'statsItem2weeks'
 *      statsItemEmails: // value for 'statsItemEmails'
 *      prImpactEmailReceivers: // value for 'prImpactEmailReceivers'
 *      prImpactEmailSendoutActive: // value for 'prImpactEmailSendoutActive'
 *   },
 * });
 */
export function useUpdateReportSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateReportSettingsMutation, Types.UpdateReportSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateReportSettingsMutation, Types.UpdateReportSettingsMutationVariables>(UpdateReportSettingsDocument, options);
      }
export type UpdateReportSettingsMutationHookResult = ReturnType<typeof useUpdateReportSettingsMutation>;
export type UpdateReportSettingsMutationResult = Apollo.MutationResult<Types.UpdateReportSettingsMutation>;
export type UpdateReportSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateReportSettingsMutation, Types.UpdateReportSettingsMutationVariables>;
export const EmailSettingsAccessDocument = gql`
    query EmailSettingsAccess($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      customEmailDomainAndDesign: managed(feature: customEmailDomainAndDesign) {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useEmailSettingsAccessQuery__
 *
 * To run a query within a React component, call `useEmailSettingsAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailSettingsAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailSettingsAccessQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useEmailSettingsAccessQuery(baseOptions: Apollo.QueryHookOptions<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables> & ({ variables: Types.EmailSettingsAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables>(EmailSettingsAccessDocument, options);
      }
export function useEmailSettingsAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables>(EmailSettingsAccessDocument, options);
        }
export function useEmailSettingsAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables>(EmailSettingsAccessDocument, options);
        }
export type EmailSettingsAccessQueryHookResult = ReturnType<typeof useEmailSettingsAccessQuery>;
export type EmailSettingsAccessLazyQueryHookResult = ReturnType<typeof useEmailSettingsAccessLazyQuery>;
export type EmailSettingsAccessSuspenseQueryHookResult = ReturnType<typeof useEmailSettingsAccessSuspenseQuery>;
export type EmailSettingsAccessQueryResult = Apollo.QueryResult<Types.EmailSettingsAccessQuery, Types.EmailSettingsAccessQueryVariables>;
export const UpdateEmailDesignDocument = gql`
    mutation UpdateEmailDesign($pressroomId: ID!, $design: EmailSettingsDesignInput, $enabled: Boolean!) {
  emailSettingsDesignUpdate(
    input: {pressroomId: $pressroomId, design: $design, enabled: $enabled}
  ) {
    error {
      message
      ... on EmailSettingsDesignUpdateValidationError {
        headerFont
        bodyFont
        primaryBrandColor
        headerColor
        bodyColor
        linkColor
        dividerColor
      }
    }
    emailSettings {
      id
      design {
        headerFont
        bodyFont
        primaryBrandColor
        headerColor
        bodyColor
        linkColor
        dividerColor
      }
    }
  }
}
    `;
export type UpdateEmailDesignMutationFn = Apollo.MutationFunction<Types.UpdateEmailDesignMutation, Types.UpdateEmailDesignMutationVariables>;

/**
 * __useUpdateEmailDesignMutation__
 *
 * To run a mutation, you first call `useUpdateEmailDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailDesignMutation, { data, loading, error }] = useUpdateEmailDesignMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      design: // value for 'design'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateEmailDesignMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEmailDesignMutation, Types.UpdateEmailDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEmailDesignMutation, Types.UpdateEmailDesignMutationVariables>(UpdateEmailDesignDocument, options);
      }
export type UpdateEmailDesignMutationHookResult = ReturnType<typeof useUpdateEmailDesignMutation>;
export type UpdateEmailDesignMutationResult = Apollo.MutationResult<Types.UpdateEmailDesignMutation>;
export type UpdateEmailDesignMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEmailDesignMutation, Types.UpdateEmailDesignMutationVariables>;
export const EmailDesignSettingsDocument = gql`
    query EmailDesignSettings($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    emailSettings {
      id
      design {
        primaryBrandColor
        headerFont
        bodyFont
        headerColor
        bodyColor
        linkColor
        dividerColor
      }
    }
  }
}
    `;

/**
 * __useEmailDesignSettingsQuery__
 *
 * To run a query within a React component, call `useEmailDesignSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailDesignSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailDesignSettingsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useEmailDesignSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables> & ({ variables: Types.EmailDesignSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables>(EmailDesignSettingsDocument, options);
      }
export function useEmailDesignSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables>(EmailDesignSettingsDocument, options);
        }
export function useEmailDesignSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables>(EmailDesignSettingsDocument, options);
        }
export type EmailDesignSettingsQueryHookResult = ReturnType<typeof useEmailDesignSettingsQuery>;
export type EmailDesignSettingsLazyQueryHookResult = ReturnType<typeof useEmailDesignSettingsLazyQuery>;
export type EmailDesignSettingsSuspenseQueryHookResult = ReturnType<typeof useEmailDesignSettingsSuspenseQuery>;
export type EmailDesignSettingsQueryResult = Apollo.QueryResult<Types.EmailDesignSettingsQuery, Types.EmailDesignSettingsQueryVariables>;
export const GeneralEmailSettingsDocument = gql`
    query GeneralEmailSettings($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    emailSettings {
      id
      outdated
      enableAuthenticatedDomain
      general {
        ...GeneralEmailSettings
      }
    }
  }
}
    ${GeneralEmailSettingsFragmentDoc}`;

/**
 * __useGeneralEmailSettingsQuery__
 *
 * To run a query within a React component, call `useGeneralEmailSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralEmailSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralEmailSettingsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGeneralEmailSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables> & ({ variables: Types.GeneralEmailSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables>(GeneralEmailSettingsDocument, options);
      }
export function useGeneralEmailSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables>(GeneralEmailSettingsDocument, options);
        }
export function useGeneralEmailSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables>(GeneralEmailSettingsDocument, options);
        }
export type GeneralEmailSettingsQueryHookResult = ReturnType<typeof useGeneralEmailSettingsQuery>;
export type GeneralEmailSettingsLazyQueryHookResult = ReturnType<typeof useGeneralEmailSettingsLazyQuery>;
export type GeneralEmailSettingsSuspenseQueryHookResult = ReturnType<typeof useGeneralEmailSettingsSuspenseQuery>;
export type GeneralEmailSettingsQueryResult = Apollo.QueryResult<Types.GeneralEmailSettingsQuery, Types.GeneralEmailSettingsQueryVariables>;
export const UpdateGeneralEmailSettingsDocument = gql`
    mutation UpdateGeneralEmailSettings($input: EmailSettingsGeneralUpdateInput!) {
  emailSettingsGeneralUpdate(input: $input) {
    error {
      message
      ... on EmailSettingsGeneralUpdateValidationError {
        email
      }
    }
    pressroom {
      id
      replyToEmail
    }
    emailSettings {
      id
      outdated
      general {
        ...GeneralEmailSettings
      }
    }
  }
}
    ${GeneralEmailSettingsFragmentDoc}`;
export type UpdateGeneralEmailSettingsMutationFn = Apollo.MutationFunction<Types.UpdateGeneralEmailSettingsMutation, Types.UpdateGeneralEmailSettingsMutationVariables>;

/**
 * __useUpdateGeneralEmailSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateGeneralEmailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneralEmailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneralEmailSettingsMutation, { data, loading, error }] = useUpdateGeneralEmailSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGeneralEmailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateGeneralEmailSettingsMutation, Types.UpdateGeneralEmailSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateGeneralEmailSettingsMutation, Types.UpdateGeneralEmailSettingsMutationVariables>(UpdateGeneralEmailSettingsDocument, options);
      }
export type UpdateGeneralEmailSettingsMutationHookResult = ReturnType<typeof useUpdateGeneralEmailSettingsMutation>;
export type UpdateGeneralEmailSettingsMutationResult = Apollo.MutationResult<Types.UpdateGeneralEmailSettingsMutation>;
export type UpdateGeneralEmailSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateGeneralEmailSettingsMutation, Types.UpdateGeneralEmailSettingsMutationVariables>;
export const ResetGeneralEmailSettingsDocument = gql`
    mutation ResetGeneralEmailSettings($pressroomId: ID!) {
  emailSettingsGeneralReset(input: {pressroomId: $pressroomId}) {
    error {
      message
    }
    pressroom {
      id
      replyToEmail
    }
    emailSettings {
      id
      outdated
      general {
        ...GeneralEmailSettings
      }
    }
  }
}
    ${GeneralEmailSettingsFragmentDoc}`;
export type ResetGeneralEmailSettingsMutationFn = Apollo.MutationFunction<Types.ResetGeneralEmailSettingsMutation, Types.ResetGeneralEmailSettingsMutationVariables>;

/**
 * __useResetGeneralEmailSettingsMutation__
 *
 * To run a mutation, you first call `useResetGeneralEmailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGeneralEmailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGeneralEmailSettingsMutation, { data, loading, error }] = useResetGeneralEmailSettingsMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useResetGeneralEmailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResetGeneralEmailSettingsMutation, Types.ResetGeneralEmailSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResetGeneralEmailSettingsMutation, Types.ResetGeneralEmailSettingsMutationVariables>(ResetGeneralEmailSettingsDocument, options);
      }
export type ResetGeneralEmailSettingsMutationHookResult = ReturnType<typeof useResetGeneralEmailSettingsMutation>;
export type ResetGeneralEmailSettingsMutationResult = Apollo.MutationResult<Types.ResetGeneralEmailSettingsMutation>;
export type ResetGeneralEmailSettingsMutationOptions = Apollo.BaseMutationOptions<Types.ResetGeneralEmailSettingsMutation, Types.ResetGeneralEmailSettingsMutationVariables>;
export const ValidateAuthenticationDomainDocument = gql`
    mutation ValidateAuthenticationDomain($pressroomId: ID!) {
  emailSettingsValidateAuthenticatedDomain(input: {pressroomId: $pressroomId}) {
    error {
      message
      ... on EmailSettingsValidateAuthenticatedDomainInvalidError {
        validationResults {
          id
          valid
          reason
        }
      }
    }
    emailSettings {
      id
      general {
        ... on AuthenticatedDomainEmailSettings {
          pending
        }
      }
    }
  }
}
    `;
export type ValidateAuthenticationDomainMutationFn = Apollo.MutationFunction<Types.ValidateAuthenticationDomainMutation, Types.ValidateAuthenticationDomainMutationVariables>;

/**
 * __useValidateAuthenticationDomainMutation__
 *
 * To run a mutation, you first call `useValidateAuthenticationDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAuthenticationDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAuthenticationDomainMutation, { data, loading, error }] = useValidateAuthenticationDomainMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useValidateAuthenticationDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateAuthenticationDomainMutation, Types.ValidateAuthenticationDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateAuthenticationDomainMutation, Types.ValidateAuthenticationDomainMutationVariables>(ValidateAuthenticationDomainDocument, options);
      }
export type ValidateAuthenticationDomainMutationHookResult = ReturnType<typeof useValidateAuthenticationDomainMutation>;
export type ValidateAuthenticationDomainMutationResult = Apollo.MutationResult<Types.ValidateAuthenticationDomainMutation>;
export type ValidateAuthenticationDomainMutationOptions = Apollo.BaseMutationOptions<Types.ValidateAuthenticationDomainMutation, Types.ValidateAuthenticationDomainMutationVariables>;
export const ResendEmailSettingsEmailDocument = gql`
    mutation ResendEmailSettingsEmail($pressroomId: ID!) {
  emailSettingsGeneralResendEmail(input: {pressroomId: $pressroomId}) {
    error {
      message
    }
  }
}
    `;
export type ResendEmailSettingsEmailMutationFn = Apollo.MutationFunction<Types.ResendEmailSettingsEmailMutation, Types.ResendEmailSettingsEmailMutationVariables>;

/**
 * __useResendEmailSettingsEmailMutation__
 *
 * To run a mutation, you first call `useResendEmailSettingsEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailSettingsEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailSettingsEmailMutation, { data, loading, error }] = useResendEmailSettingsEmailMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useResendEmailSettingsEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendEmailSettingsEmailMutation, Types.ResendEmailSettingsEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendEmailSettingsEmailMutation, Types.ResendEmailSettingsEmailMutationVariables>(ResendEmailSettingsEmailDocument, options);
      }
export type ResendEmailSettingsEmailMutationHookResult = ReturnType<typeof useResendEmailSettingsEmailMutation>;
export type ResendEmailSettingsEmailMutationResult = Apollo.MutationResult<Types.ResendEmailSettingsEmailMutation>;
export type ResendEmailSettingsEmailMutationOptions = Apollo.BaseMutationOptions<Types.ResendEmailSettingsEmailMutation, Types.ResendEmailSettingsEmailMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation resendEmailVerification {
  userActivationEmailResend(input: {}) {
    error {
      message
    }
    success
  }
}
    `;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<Types.ResendEmailVerificationMutation, Types.ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendEmailVerificationMutation, Types.ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendEmailVerificationMutation, Types.ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<Types.ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<Types.ResendEmailVerificationMutation, Types.ResendEmailVerificationMutationVariables>;
export const ChangeEmailVerificationDocument = gql`
    mutation changeEmailVerification($email: String!) {
  userActivationEmailUpdate(input: {email: $email}) {
    error {
      message
    }
    user {
      id
      email
    }
  }
}
    `;
export type ChangeEmailVerificationMutationFn = Apollo.MutationFunction<Types.ChangeEmailVerificationMutation, Types.ChangeEmailVerificationMutationVariables>;

/**
 * __useChangeEmailVerificationMutation__
 *
 * To run a mutation, you first call `useChangeEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailVerificationMutation, { data, loading, error }] = useChangeEmailVerificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangeEmailVerificationMutation, Types.ChangeEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangeEmailVerificationMutation, Types.ChangeEmailVerificationMutationVariables>(ChangeEmailVerificationDocument, options);
      }
export type ChangeEmailVerificationMutationHookResult = ReturnType<typeof useChangeEmailVerificationMutation>;
export type ChangeEmailVerificationMutationResult = Apollo.MutationResult<Types.ChangeEmailVerificationMutation>;
export type ChangeEmailVerificationMutationOptions = Apollo.BaseMutationOptions<Types.ChangeEmailVerificationMutation, Types.ChangeEmailVerificationMutationVariables>;
export const ContextContainerDocument = gql`
    query ContextContainer($pressroomId: ID!, $skipPressroom: Boolean!) {
  me {
    id
    user {
      id
      locale2
      timeZone2
    }
  }
  pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
    id
    source {
      id
      trial
    }
  }
  environmentVariables {
    mndAssets {
      apiKey
      cdnDistribution
      postUrl
      preset
    }
  }
}
    `;

/**
 * __useContextContainerQuery__
 *
 * To run a query within a React component, call `useContextContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextContainerQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      skipPressroom: // value for 'skipPressroom'
 *   },
 * });
 */
export function useContextContainerQuery(baseOptions: Apollo.QueryHookOptions<Types.ContextContainerQuery, Types.ContextContainerQueryVariables> & ({ variables: Types.ContextContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContextContainerQuery, Types.ContextContainerQueryVariables>(ContextContainerDocument, options);
      }
export function useContextContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContextContainerQuery, Types.ContextContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContextContainerQuery, Types.ContextContainerQueryVariables>(ContextContainerDocument, options);
        }
export function useContextContainerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ContextContainerQuery, Types.ContextContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ContextContainerQuery, Types.ContextContainerQueryVariables>(ContextContainerDocument, options);
        }
export type ContextContainerQueryHookResult = ReturnType<typeof useContextContainerQuery>;
export type ContextContainerLazyQueryHookResult = ReturnType<typeof useContextContainerLazyQuery>;
export type ContextContainerSuspenseQueryHookResult = ReturnType<typeof useContextContainerSuspenseQuery>;
export type ContextContainerQueryResult = Apollo.QueryResult<Types.ContextContainerQuery, Types.ContextContainerQueryVariables>;
export const QuickNavigationDocument = gql`
    query QuickNavigation($query: String!) {
  sourceList(query: $query) {
    id
    name
    pressrooms {
      id
      siteCode
    }
  }
}
    `;

/**
 * __useQuickNavigationQuery__
 *
 * To run a query within a React component, call `useQuickNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickNavigationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useQuickNavigationQuery(baseOptions: Apollo.QueryHookOptions<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables> & ({ variables: Types.QuickNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables>(QuickNavigationDocument, options);
      }
export function useQuickNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables>(QuickNavigationDocument, options);
        }
export function useQuickNavigationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables>(QuickNavigationDocument, options);
        }
export type QuickNavigationQueryHookResult = ReturnType<typeof useQuickNavigationQuery>;
export type QuickNavigationLazyQueryHookResult = ReturnType<typeof useQuickNavigationLazyQuery>;
export type QuickNavigationSuspenseQueryHookResult = ReturnType<typeof useQuickNavigationSuspenseQuery>;
export type QuickNavigationQueryResult = Apollo.QueryResult<Types.QuickNavigationQuery, Types.QuickNavigationQueryVariables>;
export const SupportFormDocument = gql`
    query SupportForm($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    name
    siteCode
    source {
      id
      name
      currentPlan
    }
  }
}
    `;

/**
 * __useSupportFormQuery__
 *
 * To run a query within a React component, call `useSupportFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportFormQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSupportFormQuery(baseOptions: Apollo.QueryHookOptions<Types.SupportFormQuery, Types.SupportFormQueryVariables> & ({ variables: Types.SupportFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SupportFormQuery, Types.SupportFormQueryVariables>(SupportFormDocument, options);
      }
export function useSupportFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SupportFormQuery, Types.SupportFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SupportFormQuery, Types.SupportFormQueryVariables>(SupportFormDocument, options);
        }
export function useSupportFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SupportFormQuery, Types.SupportFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SupportFormQuery, Types.SupportFormQueryVariables>(SupportFormDocument, options);
        }
export type SupportFormQueryHookResult = ReturnType<typeof useSupportFormQuery>;
export type SupportFormLazyQueryHookResult = ReturnType<typeof useSupportFormLazyQuery>;
export type SupportFormSuspenseQueryHookResult = ReturnType<typeof useSupportFormSuspenseQuery>;
export type SupportFormQueryResult = Apollo.QueryResult<Types.SupportFormQuery, Types.SupportFormQueryVariables>;
export const DebugInfoDocument = gql`
    query DebugInfo($pressroomId: ID!) {
  me {
    id
    viewAsAdmin
    accessLevel(pressroomId: $pressroomId)
  }
}
    `;

/**
 * __useDebugInfoQuery__
 *
 * To run a query within a React component, call `useDebugInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugInfoQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDebugInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.DebugInfoQuery, Types.DebugInfoQueryVariables> & ({ variables: Types.DebugInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DebugInfoQuery, Types.DebugInfoQueryVariables>(DebugInfoDocument, options);
      }
export function useDebugInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DebugInfoQuery, Types.DebugInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DebugInfoQuery, Types.DebugInfoQueryVariables>(DebugInfoDocument, options);
        }
export function useDebugInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DebugInfoQuery, Types.DebugInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DebugInfoQuery, Types.DebugInfoQueryVariables>(DebugInfoDocument, options);
        }
export type DebugInfoQueryHookResult = ReturnType<typeof useDebugInfoQuery>;
export type DebugInfoLazyQueryHookResult = ReturnType<typeof useDebugInfoLazyQuery>;
export type DebugInfoSuspenseQueryHookResult = ReturnType<typeof useDebugInfoSuspenseQuery>;
export type DebugInfoQueryResult = Apollo.QueryResult<Types.DebugInfoQuery, Types.DebugInfoQueryVariables>;
export const MenuDataDocument = gql`
    query MenuData($pressroomId: ID!, $skipPressroom: Boolean!, $sourceId: ID!, $skipSource: Boolean!) {
  me {
    id
    viewAsAdmin
    user {
      id
      name
      username
      email
      isMynewsdeskAdmin
      isOnlyJournalist
      locale: locale2
      sources {
        id
      }
    }
  }
  pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
    id
    newsroomUrl
    newsroomSettingsPage
    newsroomSettings {
      id
      newsroomStyle {
        logotype {
          id
          url(transformation: LOGOTYPE_SMALL, cropped: false)
        }
        favicon {
          id
          url(transformation: LOGOTYPE_SMALL, cropped: false)
        }
      }
    }
    siteCode
    name
    monitor {
      id
      hasSearchProfiles
      hasSmartSearchProfiles
    }
    features {
      id
      monitor: managed(feature: monitor) {
        id
        enabled
      }
      mention: managed(feature: mention) {
        id
        enabled
      }
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      analyzeLight: managed(feature: analyzeLight) {
        id
        enabled
      }
      customEmailDomainAndDesign: managed(feature: customEmailDomainAndDesign) {
        id
        enabled
      }
      storyWidget: managed(feature: storyWidget) {
        id
        enabled
      }
      tagManagement: managed(feature: tagManagement) {
        id
        enabled
      }
      mndReach
      images
      eqs
      copilot
      copilotFeatures
      emailReportsPage
      pitch
      audienceBuilder2 {
        enabled
        showUpsellPage
      }
    }
  }
  source(id: $sourceId) @skip(if: $skipSource) {
    id
    trial
    pressrooms {
      id
      name
      siteCode
    }
    features {
      id
      securityPage
      userManagementPage
      brandReport: managed(feature: brandReports) {
        id
        enabled
        previousTrial
      }
      coverageReports {
        enabled
      }
    }
  }
}
    `;

/**
 * __useMenuDataQuery__
 *
 * To run a query within a React component, call `useMenuDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      skipPressroom: // value for 'skipPressroom'
 *      sourceId: // value for 'sourceId'
 *      skipSource: // value for 'skipSource'
 *   },
 * });
 */
export function useMenuDataQuery(baseOptions: Apollo.QueryHookOptions<Types.MenuDataQuery, Types.MenuDataQueryVariables> & ({ variables: Types.MenuDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MenuDataQuery, Types.MenuDataQueryVariables>(MenuDataDocument, options);
      }
export function useMenuDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MenuDataQuery, Types.MenuDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MenuDataQuery, Types.MenuDataQueryVariables>(MenuDataDocument, options);
        }
export function useMenuDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MenuDataQuery, Types.MenuDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MenuDataQuery, Types.MenuDataQueryVariables>(MenuDataDocument, options);
        }
export type MenuDataQueryHookResult = ReturnType<typeof useMenuDataQuery>;
export type MenuDataLazyQueryHookResult = ReturnType<typeof useMenuDataLazyQuery>;
export type MenuDataSuspenseQueryHookResult = ReturnType<typeof useMenuDataSuspenseQuery>;
export type MenuDataQueryResult = Apollo.QueryResult<Types.MenuDataQuery, Types.MenuDataQueryVariables>;
export const PressroomLiveDocument = gql`
    query PressroomLive($id: ID!) {
  pressroom(id: $id) {
    id
    ...NotLivePressroom
    ...PressroomGoLive
  }
  me {
    id
    user {
      id
      locale2
      ...UserBaseInfo
    }
  }
}
    ${NotLivePressroomFragmentDoc}
${PressroomGoLiveFragmentDoc}
${PressContactFragmentDoc}
${CompanyDescriptionFragmentDoc}
${CompanyInfoFragmentDoc}
${BrandingFragmentDoc}
${UserBaseInfoFragmentDoc}`;

/**
 * __usePressroomLiveQuery__
 *
 * To run a query within a React component, call `usePressroomLiveQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressroomLiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressroomLiveQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePressroomLiveQuery(baseOptions: Apollo.QueryHookOptions<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables> & ({ variables: Types.PressroomLiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables>(PressroomLiveDocument, options);
      }
export function usePressroomLiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables>(PressroomLiveDocument, options);
        }
export function usePressroomLiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables>(PressroomLiveDocument, options);
        }
export type PressroomLiveQueryHookResult = ReturnType<typeof usePressroomLiveQuery>;
export type PressroomLiveLazyQueryHookResult = ReturnType<typeof usePressroomLiveLazyQuery>;
export type PressroomLiveSuspenseQueryHookResult = ReturnType<typeof usePressroomLiveSuspenseQuery>;
export type PressroomLiveQueryResult = Apollo.QueryResult<Types.PressroomLiveQuery, Types.PressroomLiveQueryVariables>;
export const GetUserLocaleDocument = gql`
    query GetUserLocale {
  me {
    id
    user {
      id
      locale: locale2
    }
  }
}
    `;

/**
 * __useGetUserLocaleQuery__
 *
 * To run a query within a React component, call `useGetUserLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLocaleQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
      }
export function useGetUserLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
        }
export function useGetUserLocaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
        }
export type GetUserLocaleQueryHookResult = ReturnType<typeof useGetUserLocaleQuery>;
export type GetUserLocaleLazyQueryHookResult = ReturnType<typeof useGetUserLocaleLazyQuery>;
export type GetUserLocaleSuspenseQueryHookResult = ReturnType<typeof useGetUserLocaleSuspenseQuery>;
export type GetUserLocaleQueryResult = Apollo.QueryResult<Types.GetUserLocaleQuery, Types.GetUserLocaleQueryVariables>;
export const UserOnboardingStepsDocument = gql`
    query UserOnboardingSteps($pressroomId: ID!) {
  me {
    id
    user {
      id
      onboarding(pressroomId: $pressroomId) {
        id
        ...OnboardingStep
      }
    }
  }
}
    ${OnboardingStepFragmentDoc}`;

/**
 * __useUserOnboardingStepsQuery__
 *
 * To run a query within a React component, call `useUserOnboardingStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOnboardingStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOnboardingStepsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useUserOnboardingStepsQuery(baseOptions: Apollo.QueryHookOptions<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables> & ({ variables: Types.UserOnboardingStepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables>(UserOnboardingStepsDocument, options);
      }
export function useUserOnboardingStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables>(UserOnboardingStepsDocument, options);
        }
export function useUserOnboardingStepsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables>(UserOnboardingStepsDocument, options);
        }
export type UserOnboardingStepsQueryHookResult = ReturnType<typeof useUserOnboardingStepsQuery>;
export type UserOnboardingStepsLazyQueryHookResult = ReturnType<typeof useUserOnboardingStepsLazyQuery>;
export type UserOnboardingStepsSuspenseQueryHookResult = ReturnType<typeof useUserOnboardingStepsSuspenseQuery>;
export type UserOnboardingStepsQueryResult = Apollo.QueryResult<Types.UserOnboardingStepsQuery, Types.UserOnboardingStepsQueryVariables>;
export const CompleteOnboardingStepDocument = gql`
    mutation CompleteOnboardingStep($pressroomId: ID!, $step: OnboardingStep!) {
  userOnboardingCompletion(input: {step: $step, pressroomId: $pressroomId}) {
    user {
      id
      onboarding(pressroomId: $pressroomId) {
        id
        completed
      }
    }
  }
}
    `;
export type CompleteOnboardingStepMutationFn = Apollo.MutationFunction<Types.CompleteOnboardingStepMutation, Types.CompleteOnboardingStepMutationVariables>;

/**
 * __useCompleteOnboardingStepMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOnboardingStepMutation, { data, loading, error }] = useCompleteOnboardingStepMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      step: // value for 'step'
 *   },
 * });
 */
export function useCompleteOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<Types.CompleteOnboardingStepMutation, Types.CompleteOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CompleteOnboardingStepMutation, Types.CompleteOnboardingStepMutationVariables>(CompleteOnboardingStepDocument, options);
      }
export type CompleteOnboardingStepMutationHookResult = ReturnType<typeof useCompleteOnboardingStepMutation>;
export type CompleteOnboardingStepMutationResult = Apollo.MutationResult<Types.CompleteOnboardingStepMutation>;
export type CompleteOnboardingStepMutationOptions = Apollo.BaseMutationOptions<Types.CompleteOnboardingStepMutation, Types.CompleteOnboardingStepMutationVariables>;
export const AppDocument = gql`
    query App($pressroomId: ID!, $skipPressroom: Boolean!) {
  me {
    id
    viewAsAdmin
    user {
      id
      emailVerified
      enforceEmailVerification
      enforce2fa
      isMynewsdeskAdmin
      email
    }
  }
  pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
    id
    siteLocale
    siteCode
    name
    timeZone
    newsroomSettingsPage
    copilotError
    audienceBuilderMaintenance
    newsroomSettings {
      id
      companyName
      homepageUrl
      locale
      gaProfileId
      newsroomStyle {
        ...Branding
      }
    }
    features {
      id
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      analyzeLight: managed(feature: analyzeLight) {
        id
        enabled
      }
      analyzeMaterial: managed(feature: analyzeMaterial) {
        id
        enabled
      }
      monitor: managed(feature: monitor) {
        id
        enabled
        enabledWithoutAdminAccess
        previousTrial
      }
      prImpact: managed(feature: prImpact) {
        id
        enabled
      }
      coPilotContactCleaner: managed(feature: coPilotContactCleaner) {
        id
        enabled
      }
      mndReach
      emailReportsPage
      images
      audienceBuilder2 {
        enabled
        showUpsellPage
      }
      copilotFeatures
    }
    monitor {
      id
      hasSearchProfiles
      hasSmartSearchProfiles
    }
    source {
      id
      name
    }
  }
  maintenanceNotification {
    id
    notification {
      message
      showStatusPageLink
    }
  }
}
    ${BrandingFragmentDoc}`;

/**
 * __useAppQuery__
 *
 * To run a query within a React component, call `useAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      skipPressroom: // value for 'skipPressroom'
 *   },
 * });
 */
export function useAppQuery(baseOptions: Apollo.QueryHookOptions<Types.AppQuery, Types.AppQueryVariables> & ({ variables: Types.AppQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AppQuery, Types.AppQueryVariables>(AppDocument, options);
      }
export function useAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AppQuery, Types.AppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AppQuery, Types.AppQueryVariables>(AppDocument, options);
        }
export function useAppSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AppQuery, Types.AppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AppQuery, Types.AppQueryVariables>(AppDocument, options);
        }
export type AppQueryHookResult = ReturnType<typeof useAppQuery>;
export type AppLazyQueryHookResult = ReturnType<typeof useAppLazyQuery>;
export type AppSuspenseQueryHookResult = ReturnType<typeof useAppSuspenseQuery>;
export type AppQueryResult = Apollo.QueryResult<Types.AppQuery, Types.AppQueryVariables>;
export const OlarkScriptDocument = gql`
    query OlarkScript($pressroomId: ID!, $skipPressroom: Boolean!, $sourceId: ID!, $skipSource: Boolean!) {
  me {
    id
    user {
      id
      name
    }
  }
  source(id: $sourceId) @skip(if: $skipSource) {
    id
    name
  }
  pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
    id
    name
  }
}
    `;

/**
 * __useOlarkScriptQuery__
 *
 * To run a query within a React component, call `useOlarkScriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useOlarkScriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOlarkScriptQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      skipPressroom: // value for 'skipPressroom'
 *      sourceId: // value for 'sourceId'
 *      skipSource: // value for 'skipSource'
 *   },
 * });
 */
export function useOlarkScriptQuery(baseOptions: Apollo.QueryHookOptions<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables> & ({ variables: Types.OlarkScriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables>(OlarkScriptDocument, options);
      }
export function useOlarkScriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables>(OlarkScriptDocument, options);
        }
export function useOlarkScriptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables>(OlarkScriptDocument, options);
        }
export type OlarkScriptQueryHookResult = ReturnType<typeof useOlarkScriptQuery>;
export type OlarkScriptLazyQueryHookResult = ReturnType<typeof useOlarkScriptLazyQuery>;
export type OlarkScriptSuspenseQueryHookResult = ReturnType<typeof useOlarkScriptSuspenseQuery>;
export type OlarkScriptQueryResult = Apollo.QueryResult<Types.OlarkScriptQuery, Types.OlarkScriptQueryVariables>;
export const HasPitchDocument = gql`
    query HasPitch($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      pitch
    }
  }
}
    `;

/**
 * __useHasPitchQuery__
 *
 * To run a query within a React component, call `useHasPitchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasPitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasPitchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useHasPitchQuery(baseOptions: Apollo.QueryHookOptions<Types.HasPitchQuery, Types.HasPitchQueryVariables> & ({ variables: Types.HasPitchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.HasPitchQuery, Types.HasPitchQueryVariables>(HasPitchDocument, options);
      }
export function useHasPitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.HasPitchQuery, Types.HasPitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.HasPitchQuery, Types.HasPitchQueryVariables>(HasPitchDocument, options);
        }
export function useHasPitchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.HasPitchQuery, Types.HasPitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.HasPitchQuery, Types.HasPitchQueryVariables>(HasPitchDocument, options);
        }
export type HasPitchQueryHookResult = ReturnType<typeof useHasPitchQuery>;
export type HasPitchLazyQueryHookResult = ReturnType<typeof useHasPitchLazyQuery>;
export type HasPitchSuspenseQueryHookResult = ReturnType<typeof useHasPitchSuspenseQuery>;
export type HasPitchQueryResult = Apollo.QueryResult<Types.HasPitchQuery, Types.HasPitchQueryVariables>;
export const MediaRelationsContactDocument = gql`
    query MediaRelationsContact($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    mndReachContact2(id: $id) {
      id
      email
      reach
      imported
      name
      motivation
      relevance
      twitterHandle
      imgUrl
      biography
      outletNames
      languages
      jobRoles {
        id
        name
      }
      mainOutlet {
        id
        name
        twitter
        facebook
        instagram
        address
        phoneNumber
      }
      mediaHits {
        id
      }
      categories {
        categoryId
        name
      }
      relevantArticles(limit: 5, groupByHeadline: true) {
        id
        ...MediaRelationsArticle
      }
      latestArticles(limit: 20, groupByHeadline: true) {
        id
        ...MediaRelationsArticle
      }
    }
  }
}
    ${MediaRelationsArticleFragmentDoc}`;

/**
 * __useMediaRelationsContactQuery__
 *
 * To run a query within a React component, call `useMediaRelationsContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsContactQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaRelationsContactQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables> & ({ variables: Types.MediaRelationsContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables>(MediaRelationsContactDocument, options);
      }
export function useMediaRelationsContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables>(MediaRelationsContactDocument, options);
        }
export function useMediaRelationsContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables>(MediaRelationsContactDocument, options);
        }
export type MediaRelationsContactQueryHookResult = ReturnType<typeof useMediaRelationsContactQuery>;
export type MediaRelationsContactLazyQueryHookResult = ReturnType<typeof useMediaRelationsContactLazyQuery>;
export type MediaRelationsContactSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsContactSuspenseQuery>;
export type MediaRelationsContactQueryResult = Apollo.QueryResult<Types.MediaRelationsContactQuery, Types.MediaRelationsContactQueryVariables>;
export const MediaRelationsOutletDocument = gql`
    query MediaRelationsOutlet($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    mndReachOutlet(id: $id) {
      id
      email
      reach
      imported
      name
      contentScore
      thumbnail
      twitter
      facebook
      instagram
      address
      phoneNumber
      biographyEnglish
      biographyNative
      relevantArticles(limit: 5, groupByHeadline: true) {
        id
        ...MediaRelationsArticle
      }
      latestArticles(limit: 20, groupByHeadline: true) {
        id
        ...MediaRelationsArticle
      }
      categories {
        categoryId
        name
      }
    }
  }
}
    ${MediaRelationsArticleFragmentDoc}`;

/**
 * __useMediaRelationsOutletQuery__
 *
 * To run a query within a React component, call `useMediaRelationsOutletQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsOutletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsOutletQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaRelationsOutletQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables> & ({ variables: Types.MediaRelationsOutletQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables>(MediaRelationsOutletDocument, options);
      }
export function useMediaRelationsOutletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables>(MediaRelationsOutletDocument, options);
        }
export function useMediaRelationsOutletSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables>(MediaRelationsOutletDocument, options);
        }
export type MediaRelationsOutletQueryHookResult = ReturnType<typeof useMediaRelationsOutletQuery>;
export type MediaRelationsOutletLazyQueryHookResult = ReturnType<typeof useMediaRelationsOutletLazyQuery>;
export type MediaRelationsOutletSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsOutletSuspenseQuery>;
export type MediaRelationsOutletQueryResult = Apollo.QueryResult<Types.MediaRelationsOutletQuery, Types.MediaRelationsOutletQueryVariables>;
export const MediaRelationsContactListsModalDocument = gql`
    query mediaRelationsContactListsModal($pressroomId: ID!, $search: String, $skipNetworkContacts: Boolean!, $email: String) {
  pressroom(id: $pressroomId) {
    id
    networkContactListSearch(sort: latest_added, search: $search) {
      nodes {
        id
        name
        networkContacts(search: $email) @skip(if: $skipNetworkContacts) {
          nodes {
            id
            email
            importedVia
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMediaRelationsContactListsModalQuery__
 *
 * To run a query within a React component, call `useMediaRelationsContactListsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsContactListsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsContactListsModalQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      search: // value for 'search'
 *      skipNetworkContacts: // value for 'skipNetworkContacts'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useMediaRelationsContactListsModalQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables> & ({ variables: Types.MediaRelationsContactListsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables>(MediaRelationsContactListsModalDocument, options);
      }
export function useMediaRelationsContactListsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables>(MediaRelationsContactListsModalDocument, options);
        }
export function useMediaRelationsContactListsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables>(MediaRelationsContactListsModalDocument, options);
        }
export type MediaRelationsContactListsModalQueryHookResult = ReturnType<typeof useMediaRelationsContactListsModalQuery>;
export type MediaRelationsContactListsModalLazyQueryHookResult = ReturnType<typeof useMediaRelationsContactListsModalLazyQuery>;
export type MediaRelationsContactListsModalSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsContactListsModalSuspenseQuery>;
export type MediaRelationsContactListsModalQueryResult = Apollo.QueryResult<Types.MediaRelationsContactListsModalQuery, Types.MediaRelationsContactListsModalQueryVariables>;
export const MediaRelationsContactListAddDocument = gql`
    mutation MediaRelationsContactListAdd($pressroomId: ID!, $name: String!) {
  networkContactListAdd(input: {pressroomId: $pressroomId, name: $name}) {
    error {
      message
      ... on NetworkContactListsAddValidationError {
        name
      }
    }
    networkContactList {
      id
      name
    }
  }
}
    `;
export type MediaRelationsContactListAddMutationFn = Apollo.MutationFunction<Types.MediaRelationsContactListAddMutation, Types.MediaRelationsContactListAddMutationVariables>;

/**
 * __useMediaRelationsContactListAddMutation__
 *
 * To run a mutation, you first call `useMediaRelationsContactListAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsContactListAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaRelationsContactListAddMutation, { data, loading, error }] = useMediaRelationsContactListAddMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMediaRelationsContactListAddMutation(baseOptions?: Apollo.MutationHookOptions<Types.MediaRelationsContactListAddMutation, Types.MediaRelationsContactListAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MediaRelationsContactListAddMutation, Types.MediaRelationsContactListAddMutationVariables>(MediaRelationsContactListAddDocument, options);
      }
export type MediaRelationsContactListAddMutationHookResult = ReturnType<typeof useMediaRelationsContactListAddMutation>;
export type MediaRelationsContactListAddMutationResult = Apollo.MutationResult<Types.MediaRelationsContactListAddMutation>;
export type MediaRelationsContactListAddMutationOptions = Apollo.BaseMutationOptions<Types.MediaRelationsContactListAddMutation, Types.MediaRelationsContactListAddMutationVariables>;
export const MediaRelationsImportDocument = gql`
    mutation MediaRelationsImport($pressroomId: ID!, $journalistIds: [ID!], $outletIds: [ID!], $contactListIds: [ID!]!) {
  contactsMediaRelationsImport(
    input: {pressroomId: $pressroomId, journalistIds: $journalistIds, outletIds: $outletIds, contactListIds: $contactListIds}
  ) {
    error {
      message
    }
    pressroom {
      id
      contactLimits {
        ...ContactLimits
      }
      topJournalists: mndReachSearch(
        includeImported: false
        relevances: [HIGHLY_RELEVANT]
        order: RelevanceDesc
      ) {
        id
        items {
          id
          ...JournalistItem
        }
      }
    }
  }
}
    ${ContactLimitsFragmentDoc}
${JournalistItemFragmentDoc}`;
export type MediaRelationsImportMutationFn = Apollo.MutationFunction<Types.MediaRelationsImportMutation, Types.MediaRelationsImportMutationVariables>;

/**
 * __useMediaRelationsImportMutation__
 *
 * To run a mutation, you first call `useMediaRelationsImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaRelationsImportMutation, { data, loading, error }] = useMediaRelationsImportMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      journalistIds: // value for 'journalistIds'
 *      outletIds: // value for 'outletIds'
 *      contactListIds: // value for 'contactListIds'
 *   },
 * });
 */
export function useMediaRelationsImportMutation(baseOptions?: Apollo.MutationHookOptions<Types.MediaRelationsImportMutation, Types.MediaRelationsImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MediaRelationsImportMutation, Types.MediaRelationsImportMutationVariables>(MediaRelationsImportDocument, options);
      }
export type MediaRelationsImportMutationHookResult = ReturnType<typeof useMediaRelationsImportMutation>;
export type MediaRelationsImportMutationResult = Apollo.MutationResult<Types.MediaRelationsImportMutation>;
export type MediaRelationsImportMutationOptions = Apollo.BaseMutationOptions<Types.MediaRelationsImportMutation, Types.MediaRelationsImportMutationVariables>;
export const MediaRelationsSearchDocument = gql`
    query MediaRelationsSearch($pressroomId: ID!, $name: String, $outletIds: [ID!], $categoryIds: [ID!], $locationIds: [ID!], $geoTargetIds: [ID!], $industryIds: [ID!], $jobRoleIds: [ID!], $keywords: [String!], $order: MndReachSortOrder, $page: Int, $includeImported: Boolean, $onlyImported: Boolean, $materialId: ID, $materialType: MaterialType) {
  pressroom(id: $pressroomId) {
    id
    mndReachSearch(
      name: $name
      outletIds: $outletIds
      categoryIds: $categoryIds
      locationIds: $locationIds
      geoTargetIds: $geoTargetIds
      industryIds: $industryIds
      jobRoleIds: $jobRoleIds
      keywords: $keywords
      includeImported: $includeImported
      onlyImported: $onlyImported
      order: $order
      page: $page
      materialId: $materialId
      materialType: $materialType
    ) {
      id
      totalPages
      totalCount
      items {
        id
        ... on MndReachOutlet {
          thumbnail
        }
        ...JournalistItem
      }
    }
  }
}
    ${JournalistItemFragmentDoc}`;

/**
 * __useMediaRelationsSearchQuery__
 *
 * To run a query within a React component, call `useMediaRelationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsSearchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *      outletIds: // value for 'outletIds'
 *      categoryIds: // value for 'categoryIds'
 *      locationIds: // value for 'locationIds'
 *      geoTargetIds: // value for 'geoTargetIds'
 *      industryIds: // value for 'industryIds'
 *      jobRoleIds: // value for 'jobRoleIds'
 *      keywords: // value for 'keywords'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *      includeImported: // value for 'includeImported'
 *      onlyImported: // value for 'onlyImported'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useMediaRelationsSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables> & ({ variables: Types.MediaRelationsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables>(MediaRelationsSearchDocument, options);
      }
export function useMediaRelationsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables>(MediaRelationsSearchDocument, options);
        }
export function useMediaRelationsSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables>(MediaRelationsSearchDocument, options);
        }
export type MediaRelationsSearchQueryHookResult = ReturnType<typeof useMediaRelationsSearchQuery>;
export type MediaRelationsSearchLazyQueryHookResult = ReturnType<typeof useMediaRelationsSearchLazyQuery>;
export type MediaRelationsSearchSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsSearchSuspenseQuery>;
export type MediaRelationsSearchQueryResult = Apollo.QueryResult<Types.MediaRelationsSearchQuery, Types.MediaRelationsSearchQueryVariables>;
export const MediaRelationsOutletSearchDocument = gql`
    query MediaRelationsOutletSearch($pressroomId: ID!, $name: String, $categoryIds: [ID!], $industryIds: [ID!], $locationIds: [ID!], $page: Int, $order: MndReachOutletSortOrder, $onlyImported: Boolean) {
  pressroom(id: $pressroomId) {
    id
    mndReachOutlets(
      name: $name
      categoryIds: $categoryIds
      industryIds: $industryIds
      locationIds: $locationIds
      hasEmail: true
      includeUnsubscribed: false
      onlyImported: $onlyImported
      page: $page
      order: $order
      perPage: 25
    ) {
      id
      totalPages
      totalCount
      items {
        id
        ...OutletItem
      }
    }
  }
}
    ${OutletItemFragmentDoc}`;

/**
 * __useMediaRelationsOutletSearchQuery__
 *
 * To run a query within a React component, call `useMediaRelationsOutletSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsOutletSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsOutletSearchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *      categoryIds: // value for 'categoryIds'
 *      industryIds: // value for 'industryIds'
 *      locationIds: // value for 'locationIds'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *      onlyImported: // value for 'onlyImported'
 *   },
 * });
 */
export function useMediaRelationsOutletSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables> & ({ variables: Types.MediaRelationsOutletSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables>(MediaRelationsOutletSearchDocument, options);
      }
export function useMediaRelationsOutletSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables>(MediaRelationsOutletSearchDocument, options);
        }
export function useMediaRelationsOutletSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables>(MediaRelationsOutletSearchDocument, options);
        }
export type MediaRelationsOutletSearchQueryHookResult = ReturnType<typeof useMediaRelationsOutletSearchQuery>;
export type MediaRelationsOutletSearchLazyQueryHookResult = ReturnType<typeof useMediaRelationsOutletSearchLazyQuery>;
export type MediaRelationsOutletSearchSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsOutletSearchSuspenseQuery>;
export type MediaRelationsOutletSearchQueryResult = Apollo.QueryResult<Types.MediaRelationsOutletSearchQuery, Types.MediaRelationsOutletSearchQueryVariables>;
export const MediaRelationsOutletsDocument = gql`
    query MediaRelationsOutlets($pressroomId: ID!, $name: String) {
  pressroom(id: $pressroomId) {
    id
    mndReachOutlets(name: $name, includeUnsubscribed: true) {
      id
      totalPages
      totalCount
      items {
        id
        name
        ... on MndReachOutlet {
          baseUrl
        }
      }
    }
  }
}
    `;

/**
 * __useMediaRelationsOutletsQuery__
 *
 * To run a query within a React component, call `useMediaRelationsOutletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsOutletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsOutletsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMediaRelationsOutletsQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables> & ({ variables: Types.MediaRelationsOutletsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables>(MediaRelationsOutletsDocument, options);
      }
export function useMediaRelationsOutletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables>(MediaRelationsOutletsDocument, options);
        }
export function useMediaRelationsOutletsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables>(MediaRelationsOutletsDocument, options);
        }
export type MediaRelationsOutletsQueryHookResult = ReturnType<typeof useMediaRelationsOutletsQuery>;
export type MediaRelationsOutletsLazyQueryHookResult = ReturnType<typeof useMediaRelationsOutletsLazyQuery>;
export type MediaRelationsOutletsSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsOutletsSuspenseQuery>;
export type MediaRelationsOutletsQueryResult = Apollo.QueryResult<Types.MediaRelationsOutletsQuery, Types.MediaRelationsOutletsQueryVariables>;
export const MediaRelationsPageDocument = gql`
    query MediaRelationsPage($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    contactLimits {
      ...ContactLimits
    }
    journalistMndReachSuggestedCategories: mndReachSuggestedCategories(
      hasJournalists: true
      hasOutlets: false
    ) {
      categoryId
      name
    }
    outletMndReachSuggestedCategories: mndReachSuggestedCategories(
      hasJournalists: false
      hasOutlets: true
    ) {
      categoryId
      name
    }
    outletMndReachCategories: mndReachCategories(
      hasJournalists: false
      hasOutlets: true
    ) {
      categoryId
      name
      categories {
        categoryId
        name
      }
    }
    journalistMndReachCategories: mndReachCategories(
      hasJournalists: true
      hasOutlets: false
    ) {
      categoryId
      name
      categories {
        categoryId
        name
      }
    }
    mndReachLocations {
      id
      name
      parentName
    }
    mndReachGeoTargets {
      id
      name
    }
    mndReachIndustries {
      id
      name
    }
    mndReachJobRoles {
      id
      name
    }
    publishedMaterials: materialList2(
      types: [Pressrelease, BlogPost, News]
      status: published
      sort: descending_published_at
      first: 10
    ) {
      nodes {
        id
        ...MediaRelationsMaterial
      }
    }
    draftMaterials: materialList2(
      types: [Pressrelease, BlogPost, News]
      status: draft
      sort: DESCENDING_CREATED_AT
      first: 100
    ) {
      nodes {
        id
        ...MediaRelationsMaterial
      }
    }
  }
}
    ${ContactLimitsFragmentDoc}
${MediaRelationsMaterialFragmentDoc}`;

/**
 * __useMediaRelationsPageQuery__
 *
 * To run a query within a React component, call `useMediaRelationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaRelationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaRelationsPageQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useMediaRelationsPageQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables> & ({ variables: Types.MediaRelationsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables>(MediaRelationsPageDocument, options);
      }
export function useMediaRelationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables>(MediaRelationsPageDocument, options);
        }
export function useMediaRelationsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables>(MediaRelationsPageDocument, options);
        }
export type MediaRelationsPageQueryHookResult = ReturnType<typeof useMediaRelationsPageQuery>;
export type MediaRelationsPageLazyQueryHookResult = ReturnType<typeof useMediaRelationsPageLazyQuery>;
export type MediaRelationsPageSuspenseQueryHookResult = ReturnType<typeof useMediaRelationsPageSuspenseQuery>;
export type MediaRelationsPageQueryResult = Apollo.QueryResult<Types.MediaRelationsPageQuery, Types.MediaRelationsPageQueryVariables>;
export const TopJournalistsDocument = gql`
    query TopJournalists($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    topJournalists: mndReachSearch(
      includeImported: false
      relevances: [HIGHLY_RELEVANT]
      order: RelevanceDesc
    ) {
      id
      items {
        id
        ...JournalistItem
      }
    }
  }
}
    ${JournalistItemFragmentDoc}`;

/**
 * __useTopJournalistsQuery__
 *
 * To run a query within a React component, call `useTopJournalistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopJournalistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopJournalistsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTopJournalistsQuery(baseOptions: Apollo.QueryHookOptions<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables> & ({ variables: Types.TopJournalistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables>(TopJournalistsDocument, options);
      }
export function useTopJournalistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables>(TopJournalistsDocument, options);
        }
export function useTopJournalistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables>(TopJournalistsDocument, options);
        }
export type TopJournalistsQueryHookResult = ReturnType<typeof useTopJournalistsQuery>;
export type TopJournalistsLazyQueryHookResult = ReturnType<typeof useTopJournalistsLazyQuery>;
export type TopJournalistsSuspenseQueryHookResult = ReturnType<typeof useTopJournalistsSuspenseQuery>;
export type TopJournalistsQueryResult = Apollo.QueryResult<Types.TopJournalistsQuery, Types.TopJournalistsQueryVariables>;
export const MonitorSearchProfilesCreateSearchProfileButtonsModalDocument = gql`
    query MonitorSearchProfilesCreateSearchProfileButtonsModal($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      profileLimitReached
      smartSearchProfileLimitReached
      hasSmartSearchProfiles
    }
  }
}
    `;

/**
 * __useMonitorSearchProfilesCreateSearchProfileButtonsModalQuery__
 *
 * To run a query within a React component, call `useMonitorSearchProfilesCreateSearchProfileButtonsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitorSearchProfilesCreateSearchProfileButtonsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitorSearchProfilesCreateSearchProfileButtonsModalQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useMonitorSearchProfilesCreateSearchProfileButtonsModalQuery(baseOptions: Apollo.QueryHookOptions<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables> & ({ variables: Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables>(MonitorSearchProfilesCreateSearchProfileButtonsModalDocument, options);
      }
export function useMonitorSearchProfilesCreateSearchProfileButtonsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables>(MonitorSearchProfilesCreateSearchProfileButtonsModalDocument, options);
        }
export function useMonitorSearchProfilesCreateSearchProfileButtonsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables>(MonitorSearchProfilesCreateSearchProfileButtonsModalDocument, options);
        }
export type MonitorSearchProfilesCreateSearchProfileButtonsModalQueryHookResult = ReturnType<typeof useMonitorSearchProfilesCreateSearchProfileButtonsModalQuery>;
export type MonitorSearchProfilesCreateSearchProfileButtonsModalLazyQueryHookResult = ReturnType<typeof useMonitorSearchProfilesCreateSearchProfileButtonsModalLazyQuery>;
export type MonitorSearchProfilesCreateSearchProfileButtonsModalSuspenseQueryHookResult = ReturnType<typeof useMonitorSearchProfilesCreateSearchProfileButtonsModalSuspenseQuery>;
export type MonitorSearchProfilesCreateSearchProfileButtonsModalQueryResult = Apollo.QueryResult<Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQuery, Types.MonitorSearchProfilesCreateSearchProfileButtonsModalQueryVariables>;
export const LocationDataFilterDocument = gql`
    query LocationDataFilter($pressroomId: ID!, $profiles: [ID!], $sources: [MonitorMediaFilterType!], $timespan: MonitorTimespan, $timeRange: MonitorTimeRange) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      dashboard(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
      ) {
        geographicalImpact(sortBy: HITS) {
          country
          countryCode
          hits
          regions {
            hits
            region
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLocationDataFilterQuery__
 *
 * To run a query within a React component, call `useLocationDataFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDataFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDataFilterQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profiles: // value for 'profiles'
 *      sources: // value for 'sources'
 *      timespan: // value for 'timespan'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useLocationDataFilterQuery(baseOptions: Apollo.QueryHookOptions<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables> & ({ variables: Types.LocationDataFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables>(LocationDataFilterDocument, options);
      }
export function useLocationDataFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables>(LocationDataFilterDocument, options);
        }
export function useLocationDataFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables>(LocationDataFilterDocument, options);
        }
export type LocationDataFilterQueryHookResult = ReturnType<typeof useLocationDataFilterQuery>;
export type LocationDataFilterLazyQueryHookResult = ReturnType<typeof useLocationDataFilterLazyQuery>;
export type LocationDataFilterSuspenseQueryHookResult = ReturnType<typeof useLocationDataFilterSuspenseQuery>;
export type LocationDataFilterQueryResult = Apollo.QueryResult<Types.LocationDataFilterQuery, Types.LocationDataFilterQueryVariables>;
export const DashboardFilterDocument = gql`
    query DashboardFilter($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      sources {
        id
        name
      }
      profiles: searchProfiles {
        id
        lastModifiedAt
        name
      }
      groups {
        isRoot
        id
        name
        profiles {
          id
          name
          lastModifiedAt
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardFilterQuery__
 *
 * To run a query within a React component, call `useDashboardFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardFilterQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useDashboardFilterQuery(baseOptions: Apollo.QueryHookOptions<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables> & ({ variables: Types.DashboardFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables>(DashboardFilterDocument, options);
      }
export function useDashboardFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables>(DashboardFilterDocument, options);
        }
export function useDashboardFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables>(DashboardFilterDocument, options);
        }
export type DashboardFilterQueryHookResult = ReturnType<typeof useDashboardFilterQuery>;
export type DashboardFilterLazyQueryHookResult = ReturnType<typeof useDashboardFilterLazyQuery>;
export type DashboardFilterSuspenseQueryHookResult = ReturnType<typeof useDashboardFilterSuspenseQuery>;
export type DashboardFilterQueryResult = Apollo.QueryResult<Types.DashboardFilterQuery, Types.DashboardFilterQueryVariables>;
export const CreateSimpleSearchProfileDocument = gql`
    mutation CreateSimpleSearchProfile($pressroomId: ID!, $brandName: String!, $languageIso: MonitorProfileLanguage!, $brandUrl: String!, $identifyCompetitors: Boolean, $numberOfCompetitors: Int, $isOwnBrand: Boolean, $parentSimpleSearchProfileId: ID) {
  monitorSimpleSearchProfileCreate(
    input: {pressroomId: $pressroomId, brandName: $brandName, languageIso: $languageIso, brandUrl: $brandUrl, identifyCompetitors: $identifyCompetitors, numberOfCompetitors: $numberOfCompetitors, isOwnBrand: $isOwnBrand, parentSimpleSearchProfileId: $parentSimpleSearchProfileId}
  ) {
    monitor {
      id
      smartSearchProfileLimitReached
    }
    simpleSearchProfile {
      id
      ...SimpleSearchProfile
    }
    error {
      message
    }
  }
}
    ${SimpleSearchProfileFragmentDoc}`;
export type CreateSimpleSearchProfileMutationFn = Apollo.MutationFunction<Types.CreateSimpleSearchProfileMutation, Types.CreateSimpleSearchProfileMutationVariables>;

/**
 * __useCreateSimpleSearchProfileMutation__
 *
 * To run a mutation, you first call `useCreateSimpleSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSimpleSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSimpleSearchProfileMutation, { data, loading, error }] = useCreateSimpleSearchProfileMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      brandName: // value for 'brandName'
 *      languageIso: // value for 'languageIso'
 *      brandUrl: // value for 'brandUrl'
 *      identifyCompetitors: // value for 'identifyCompetitors'
 *      numberOfCompetitors: // value for 'numberOfCompetitors'
 *      isOwnBrand: // value for 'isOwnBrand'
 *      parentSimpleSearchProfileId: // value for 'parentSimpleSearchProfileId'
 *   },
 * });
 */
export function useCreateSimpleSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSimpleSearchProfileMutation, Types.CreateSimpleSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSimpleSearchProfileMutation, Types.CreateSimpleSearchProfileMutationVariables>(CreateSimpleSearchProfileDocument, options);
      }
export type CreateSimpleSearchProfileMutationHookResult = ReturnType<typeof useCreateSimpleSearchProfileMutation>;
export type CreateSimpleSearchProfileMutationResult = Apollo.MutationResult<Types.CreateSimpleSearchProfileMutation>;
export type CreateSimpleSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.CreateSimpleSearchProfileMutation, Types.CreateSimpleSearchProfileMutationVariables>;
export const SimpleSearchProfileDocument = gql`
    query SimpleSearchProfile($simpleSearchProfileId: ID!, $pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      hasSearchProfiles
      hasSmartSearchProfiles
      smartSearchProfileLimitReached
      simpleSearchProfile(id: $simpleSearchProfileId) {
        id
        ...SimpleSearchProfile
        competitors {
          id
          ...SimpleSearchProfile
        }
      }
    }
  }
}
    ${SimpleSearchProfileFragmentDoc}`;

/**
 * __useSimpleSearchProfileQuery__
 *
 * To run a query within a React component, call `useSimpleSearchProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleSearchProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleSearchProfileQuery({
 *   variables: {
 *      simpleSearchProfileId: // value for 'simpleSearchProfileId'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSimpleSearchProfileQuery(baseOptions: Apollo.QueryHookOptions<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables> & ({ variables: Types.SimpleSearchProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables>(SimpleSearchProfileDocument, options);
      }
export function useSimpleSearchProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables>(SimpleSearchProfileDocument, options);
        }
export function useSimpleSearchProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables>(SimpleSearchProfileDocument, options);
        }
export type SimpleSearchProfileQueryHookResult = ReturnType<typeof useSimpleSearchProfileQuery>;
export type SimpleSearchProfileLazyQueryHookResult = ReturnType<typeof useSimpleSearchProfileLazyQuery>;
export type SimpleSearchProfileSuspenseQueryHookResult = ReturnType<typeof useSimpleSearchProfileSuspenseQuery>;
export type SimpleSearchProfileQueryResult = Apollo.QueryResult<Types.SimpleSearchProfileQuery, Types.SimpleSearchProfileQueryVariables>;
export const SimpleSearchProfileSettingsDocument = gql`
    query SimpleSearchProfileSettings($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    newsroomSettings {
      id
      homepageUrl
      companyName
    }
    siteLocale
    siteCode
    features {
      id
      brandReport: managed(feature: brandReports) {
        id
        enabled
      }
    }
    monitor {
      id
      hasSearchProfiles
      hasSmartSearchProfiles
      smartSearchProfileLimitReached
      maxAllowedCompetitorSearchProfiles
      sources {
        id
        name
      }
      defaultCountries
      countriesByRegionGroups {
        id
        ...CountriesByRegionGroups
      }
      defaultLanguages
      allLanguages: languages {
        id
        value
        label
      }
      allCountries: countries {
        id
        value
        label
      }
    }
  }
}
    ${CountriesByRegionGroupsFragmentDoc}`;

/**
 * __useSimpleSearchProfileSettingsQuery__
 *
 * To run a query within a React component, call `useSimpleSearchProfileSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleSearchProfileSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleSearchProfileSettingsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSimpleSearchProfileSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables> & ({ variables: Types.SimpleSearchProfileSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables>(SimpleSearchProfileSettingsDocument, options);
      }
export function useSimpleSearchProfileSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables>(SimpleSearchProfileSettingsDocument, options);
        }
export function useSimpleSearchProfileSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables>(SimpleSearchProfileSettingsDocument, options);
        }
export type SimpleSearchProfileSettingsQueryHookResult = ReturnType<typeof useSimpleSearchProfileSettingsQuery>;
export type SimpleSearchProfileSettingsLazyQueryHookResult = ReturnType<typeof useSimpleSearchProfileSettingsLazyQuery>;
export type SimpleSearchProfileSettingsSuspenseQueryHookResult = ReturnType<typeof useSimpleSearchProfileSettingsSuspenseQuery>;
export type SimpleSearchProfileSettingsQueryResult = Apollo.QueryResult<Types.SimpleSearchProfileSettingsQuery, Types.SimpleSearchProfileSettingsQueryVariables>;
export const ActivateSimpleSearchProfilesDocument = gql`
    mutation ActivateSimpleSearchProfiles($pressroomId: ID!, $simpleSearchProfileIds: [ID!]!, $sourceSelection: SimpleSearchProfileSourceSelection!) {
  monitorSimpleSearchProfilesActivate(
    input: {pressroomId: $pressroomId, simpleSearchProfileIds: $simpleSearchProfileIds, sourceSelection: $sourceSelection}
  ) {
    monitor {
      id
      smartSearchProfileLimitReached
      hasSearchProfiles
      hasSmartSearchProfiles
    }
    simpleSearchProfileIds
    error {
      message
    }
  }
}
    `;
export type ActivateSimpleSearchProfilesMutationFn = Apollo.MutationFunction<Types.ActivateSimpleSearchProfilesMutation, Types.ActivateSimpleSearchProfilesMutationVariables>;

/**
 * __useActivateSimpleSearchProfilesMutation__
 *
 * To run a mutation, you first call `useActivateSimpleSearchProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSimpleSearchProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSimpleSearchProfilesMutation, { data, loading, error }] = useActivateSimpleSearchProfilesMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      simpleSearchProfileIds: // value for 'simpleSearchProfileIds'
 *      sourceSelection: // value for 'sourceSelection'
 *   },
 * });
 */
export function useActivateSimpleSearchProfilesMutation(baseOptions?: Apollo.MutationHookOptions<Types.ActivateSimpleSearchProfilesMutation, Types.ActivateSimpleSearchProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ActivateSimpleSearchProfilesMutation, Types.ActivateSimpleSearchProfilesMutationVariables>(ActivateSimpleSearchProfilesDocument, options);
      }
export type ActivateSimpleSearchProfilesMutationHookResult = ReturnType<typeof useActivateSimpleSearchProfilesMutation>;
export type ActivateSimpleSearchProfilesMutationResult = Apollo.MutationResult<Types.ActivateSimpleSearchProfilesMutation>;
export type ActivateSimpleSearchProfilesMutationOptions = Apollo.BaseMutationOptions<Types.ActivateSimpleSearchProfilesMutation, Types.ActivateSimpleSearchProfilesMutationVariables>;
export const DeleteSimpleSearchProfileDocument = gql`
    mutation DeleteSimpleSearchProfile($pressroomId: ID!, $id: ID!) {
  monitorSimpleSearchProfileDelete(input: {pressroomId: $pressroomId, id: $id}) {
    id
    searchProfileId
    error {
      message
    }
  }
}
    `;
export type DeleteSimpleSearchProfileMutationFn = Apollo.MutationFunction<Types.DeleteSimpleSearchProfileMutation, Types.DeleteSimpleSearchProfileMutationVariables>;

/**
 * __useDeleteSimpleSearchProfileMutation__
 *
 * To run a mutation, you first call `useDeleteSimpleSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSimpleSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSimpleSearchProfileMutation, { data, loading, error }] = useDeleteSimpleSearchProfileMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSimpleSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSimpleSearchProfileMutation, Types.DeleteSimpleSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSimpleSearchProfileMutation, Types.DeleteSimpleSearchProfileMutationVariables>(DeleteSimpleSearchProfileDocument, options);
      }
export type DeleteSimpleSearchProfileMutationHookResult = ReturnType<typeof useDeleteSimpleSearchProfileMutation>;
export type DeleteSimpleSearchProfileMutationResult = Apollo.MutationResult<Types.DeleteSimpleSearchProfileMutation>;
export type DeleteSimpleSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSimpleSearchProfileMutation, Types.DeleteSimpleSearchProfileMutationVariables>;
export const GetSimpleSearchProfileDataDocument = gql`
    query GetSimpleSearchProfileData($pressroomId: ID!, $profileId: ID!, $skipProfile: Boolean!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      sources {
        id
        name
      }
      languages {
        id
        label
        value
      }
      countries {
        id
        label
        value
      }
      defaultCountries
      defaultLanguages
      profile: searchProfile(id: $profileId) @skip(if: $skipProfile) {
        id
        lastModifiedAt
        simpleSearchProfile {
          id
        }
        selectedMediaTypes {
          id
          name
        }
        ...MonitorSearchProfile
      }
    }
  }
}
    ${MonitorSearchProfileFragmentDoc}`;

/**
 * __useGetSimpleSearchProfileDataQuery__
 *
 * To run a query within a React component, call `useGetSimpleSearchProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleSearchProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleSearchProfileDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profileId: // value for 'profileId'
 *      skipProfile: // value for 'skipProfile'
 *   },
 * });
 */
export function useGetSimpleSearchProfileDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables> & ({ variables: Types.GetSimpleSearchProfileDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables>(GetSimpleSearchProfileDataDocument, options);
      }
export function useGetSimpleSearchProfileDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables>(GetSimpleSearchProfileDataDocument, options);
        }
export function useGetSimpleSearchProfileDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables>(GetSimpleSearchProfileDataDocument, options);
        }
export type GetSimpleSearchProfileDataQueryHookResult = ReturnType<typeof useGetSimpleSearchProfileDataQuery>;
export type GetSimpleSearchProfileDataLazyQueryHookResult = ReturnType<typeof useGetSimpleSearchProfileDataLazyQuery>;
export type GetSimpleSearchProfileDataSuspenseQueryHookResult = ReturnType<typeof useGetSimpleSearchProfileDataSuspenseQuery>;
export type GetSimpleSearchProfileDataQueryResult = Apollo.QueryResult<Types.GetSimpleSearchProfileDataQuery, Types.GetSimpleSearchProfileDataQueryVariables>;
export const UpdateSimpleSearchProfileDocument = gql`
    mutation UpdateSimpleSearchProfile($pressroomId: ID!, $simpleSearchProfileId: ID!, $sourceSelection: SimpleSearchProfileSourceSelection, $main: [String!], $includes: [String!], $excludes: [String!], $brandSummary: String, $regenerateFromDate: DateTime, $regenerateToDate: DateTime, $includePreliminaryResults: Boolean!) {
  monitorSimpleSearchProfileUpdate(
    input: {pressroomId: $pressroomId, simpleSearchProfileId: $simpleSearchProfileId, sourceSelection: $sourceSelection, main: $main, includes: $includes, excludes: $excludes, brandSummary: $brandSummary, regenerateFromDate: $regenerateFromDate, regenerateToDate: $regenerateToDate}
  ) {
    updatedSimpleSearchProfile {
      id
      preliminaryResults @include(if: $includePreliminaryResults) {
        ...PreliminaryResults
      }
    }
    error {
      message
    }
  }
}
    ${PreliminaryResultsFragmentDoc}`;
export type UpdateSimpleSearchProfileMutationFn = Apollo.MutationFunction<Types.UpdateSimpleSearchProfileMutation, Types.UpdateSimpleSearchProfileMutationVariables>;

/**
 * __useUpdateSimpleSearchProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSimpleSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSimpleSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSimpleSearchProfileMutation, { data, loading, error }] = useUpdateSimpleSearchProfileMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      simpleSearchProfileId: // value for 'simpleSearchProfileId'
 *      sourceSelection: // value for 'sourceSelection'
 *      main: // value for 'main'
 *      includes: // value for 'includes'
 *      excludes: // value for 'excludes'
 *      brandSummary: // value for 'brandSummary'
 *      regenerateFromDate: // value for 'regenerateFromDate'
 *      regenerateToDate: // value for 'regenerateToDate'
 *      includePreliminaryResults: // value for 'includePreliminaryResults'
 *   },
 * });
 */
export function useUpdateSimpleSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSimpleSearchProfileMutation, Types.UpdateSimpleSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSimpleSearchProfileMutation, Types.UpdateSimpleSearchProfileMutationVariables>(UpdateSimpleSearchProfileDocument, options);
      }
export type UpdateSimpleSearchProfileMutationHookResult = ReturnType<typeof useUpdateSimpleSearchProfileMutation>;
export type UpdateSimpleSearchProfileMutationResult = Apollo.MutationResult<Types.UpdateSimpleSearchProfileMutation>;
export type UpdateSimpleSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSimpleSearchProfileMutation, Types.UpdateSimpleSearchProfileMutationVariables>;
export const SearchProfilesRegenerationStatusDocument = gql`
    query SearchProfilesRegenerationStatus($id: ID!, $searchProfileIds: [ID!]) {
  pressroom(id: $id) {
    id
    monitor {
      id
      searchProfilesRegenerationStatus(ids: $searchProfileIds)
    }
  }
}
    `;

/**
 * __useSearchProfilesRegenerationStatusQuery__
 *
 * To run a query within a React component, call `useSearchProfilesRegenerationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfilesRegenerationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfilesRegenerationStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *      searchProfileIds: // value for 'searchProfileIds'
 *   },
 * });
 */
export function useSearchProfilesRegenerationStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables> & ({ variables: Types.SearchProfilesRegenerationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables>(SearchProfilesRegenerationStatusDocument, options);
      }
export function useSearchProfilesRegenerationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables>(SearchProfilesRegenerationStatusDocument, options);
        }
export function useSearchProfilesRegenerationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables>(SearchProfilesRegenerationStatusDocument, options);
        }
export type SearchProfilesRegenerationStatusQueryHookResult = ReturnType<typeof useSearchProfilesRegenerationStatusQuery>;
export type SearchProfilesRegenerationStatusLazyQueryHookResult = ReturnType<typeof useSearchProfilesRegenerationStatusLazyQuery>;
export type SearchProfilesRegenerationStatusSuspenseQueryHookResult = ReturnType<typeof useSearchProfilesRegenerationStatusSuspenseQuery>;
export type SearchProfilesRegenerationStatusQueryResult = Apollo.QueryResult<Types.SearchProfilesRegenerationStatusQuery, Types.SearchProfilesRegenerationStatusQueryVariables>;
export const ListMonitorAlertsDocument = gql`
    query ListMonitorAlerts($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      alerts {
        ...MonitorAlert
      }
    }
  }
}
    ${MonitorAlertFragmentDoc}
${CountryAndRegionsFragmentDoc}
${MonitorAlertRecipientFragmentDoc}
${MonitorScheduledAlertFragmentDoc}
${MonitorRealTimeAlertFragmentDoc}
${MonitorSummaryAlertFragmentDoc}`;

/**
 * __useListMonitorAlertsQuery__
 *
 * To run a query within a React component, call `useListMonitorAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMonitorAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMonitorAlertsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useListMonitorAlertsQuery(baseOptions: Apollo.QueryHookOptions<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables> & ({ variables: Types.ListMonitorAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables>(ListMonitorAlertsDocument, options);
      }
export function useListMonitorAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables>(ListMonitorAlertsDocument, options);
        }
export function useListMonitorAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables>(ListMonitorAlertsDocument, options);
        }
export type ListMonitorAlertsQueryHookResult = ReturnType<typeof useListMonitorAlertsQuery>;
export type ListMonitorAlertsLazyQueryHookResult = ReturnType<typeof useListMonitorAlertsLazyQuery>;
export type ListMonitorAlertsSuspenseQueryHookResult = ReturnType<typeof useListMonitorAlertsSuspenseQuery>;
export type ListMonitorAlertsQueryResult = Apollo.QueryResult<Types.ListMonitorAlertsQuery, Types.ListMonitorAlertsQueryVariables>;
export const MonitorAlertCountriesAndRegionsDocument = gql`
    query MonitorAlertCountriesAndRegions($pressroomId: ID!, $sourceCountries: [MonitorProfileCountry!]!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      countriesAndRegions(sourceCountries: $sourceCountries) {
        ...CountryAndRegions
      }
    }
  }
}
    ${CountryAndRegionsFragmentDoc}`;

/**
 * __useMonitorAlertCountriesAndRegionsQuery__
 *
 * To run a query within a React component, call `useMonitorAlertCountriesAndRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitorAlertCountriesAndRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitorAlertCountriesAndRegionsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      sourceCountries: // value for 'sourceCountries'
 *   },
 * });
 */
export function useMonitorAlertCountriesAndRegionsQuery(baseOptions: Apollo.QueryHookOptions<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables> & ({ variables: Types.MonitorAlertCountriesAndRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables>(MonitorAlertCountriesAndRegionsDocument, options);
      }
export function useMonitorAlertCountriesAndRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables>(MonitorAlertCountriesAndRegionsDocument, options);
        }
export function useMonitorAlertCountriesAndRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables>(MonitorAlertCountriesAndRegionsDocument, options);
        }
export type MonitorAlertCountriesAndRegionsQueryHookResult = ReturnType<typeof useMonitorAlertCountriesAndRegionsQuery>;
export type MonitorAlertCountriesAndRegionsLazyQueryHookResult = ReturnType<typeof useMonitorAlertCountriesAndRegionsLazyQuery>;
export type MonitorAlertCountriesAndRegionsSuspenseQueryHookResult = ReturnType<typeof useMonitorAlertCountriesAndRegionsSuspenseQuery>;
export type MonitorAlertCountriesAndRegionsQueryResult = Apollo.QueryResult<Types.MonitorAlertCountriesAndRegionsQuery, Types.MonitorAlertCountriesAndRegionsQueryVariables>;
export const MonitorAlertDocument = gql`
    query MonitorAlert($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      alert(id: $id) {
        ...MonitorAlert
      }
    }
  }
}
    ${MonitorAlertFragmentDoc}
${CountryAndRegionsFragmentDoc}
${MonitorAlertRecipientFragmentDoc}
${MonitorScheduledAlertFragmentDoc}
${MonitorRealTimeAlertFragmentDoc}
${MonitorSummaryAlertFragmentDoc}`;

/**
 * __useMonitorAlertQuery__
 *
 * To run a query within a React component, call `useMonitorAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitorAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitorAlertQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMonitorAlertQuery(baseOptions: Apollo.QueryHookOptions<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables> & ({ variables: Types.MonitorAlertQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables>(MonitorAlertDocument, options);
      }
export function useMonitorAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables>(MonitorAlertDocument, options);
        }
export function useMonitorAlertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables>(MonitorAlertDocument, options);
        }
export type MonitorAlertQueryHookResult = ReturnType<typeof useMonitorAlertQuery>;
export type MonitorAlertLazyQueryHookResult = ReturnType<typeof useMonitorAlertLazyQuery>;
export type MonitorAlertSuspenseQueryHookResult = ReturnType<typeof useMonitorAlertSuspenseQuery>;
export type MonitorAlertQueryResult = Apollo.QueryResult<Types.MonitorAlertQuery, Types.MonitorAlertQueryVariables>;
export const DuplicateMonitorAlertDocument = gql`
    mutation DuplicateMonitorAlert($pressroomId: ID!, $id: ID!) {
  monitorAlertDuplicate(input: {pressroomId: $pressroomId, monitorAlertId: $id}) {
    monitorAlert {
      ...MonitorAlert
    }
    monitor {
      id
      alerts {
        ...MonitorAlert
      }
    }
    error {
      __typename
      message
    }
  }
}
    ${MonitorAlertFragmentDoc}
${CountryAndRegionsFragmentDoc}
${MonitorAlertRecipientFragmentDoc}
${MonitorScheduledAlertFragmentDoc}
${MonitorRealTimeAlertFragmentDoc}
${MonitorSummaryAlertFragmentDoc}`;
export type DuplicateMonitorAlertMutationFn = Apollo.MutationFunction<Types.DuplicateMonitorAlertMutation, Types.DuplicateMonitorAlertMutationVariables>;

/**
 * __useDuplicateMonitorAlertMutation__
 *
 * To run a mutation, you first call `useDuplicateMonitorAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMonitorAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMonitorAlertMutation, { data, loading, error }] = useDuplicateMonitorAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateMonitorAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateMonitorAlertMutation, Types.DuplicateMonitorAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateMonitorAlertMutation, Types.DuplicateMonitorAlertMutationVariables>(DuplicateMonitorAlertDocument, options);
      }
export type DuplicateMonitorAlertMutationHookResult = ReturnType<typeof useDuplicateMonitorAlertMutation>;
export type DuplicateMonitorAlertMutationResult = Apollo.MutationResult<Types.DuplicateMonitorAlertMutation>;
export type DuplicateMonitorAlertMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateMonitorAlertMutation, Types.DuplicateMonitorAlertMutationVariables>;
export const CreateMonitorAlertDocument = gql`
    mutation CreateMonitorAlert($pressroomId: ID!, $monitorAlert: MonitorAlertInput!) {
  monitorAlertCreate(
    input: {pressroomId: $pressroomId, monitorAlert: $monitorAlert}
  ) {
    monitorAlert {
      ...MonitorAlert
    }
    monitor {
      id
      alerts {
        ...MonitorAlert
      }
    }
    error {
      __typename
      message
    }
  }
}
    ${MonitorAlertFragmentDoc}
${CountryAndRegionsFragmentDoc}
${MonitorAlertRecipientFragmentDoc}
${MonitorScheduledAlertFragmentDoc}
${MonitorRealTimeAlertFragmentDoc}
${MonitorSummaryAlertFragmentDoc}`;
export type CreateMonitorAlertMutationFn = Apollo.MutationFunction<Types.CreateMonitorAlertMutation, Types.CreateMonitorAlertMutationVariables>;

/**
 * __useCreateMonitorAlertMutation__
 *
 * To run a mutation, you first call `useCreateMonitorAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitorAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitorAlertMutation, { data, loading, error }] = useCreateMonitorAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      monitorAlert: // value for 'monitorAlert'
 *   },
 * });
 */
export function useCreateMonitorAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMonitorAlertMutation, Types.CreateMonitorAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMonitorAlertMutation, Types.CreateMonitorAlertMutationVariables>(CreateMonitorAlertDocument, options);
      }
export type CreateMonitorAlertMutationHookResult = ReturnType<typeof useCreateMonitorAlertMutation>;
export type CreateMonitorAlertMutationResult = Apollo.MutationResult<Types.CreateMonitorAlertMutation>;
export type CreateMonitorAlertMutationOptions = Apollo.BaseMutationOptions<Types.CreateMonitorAlertMutation, Types.CreateMonitorAlertMutationVariables>;
export const UpdateMonitorAlertDocument = gql`
    mutation UpdateMonitorAlert($pressroomId: ID!, $id: ID!, $monitorAlert: MonitorAlertInput!) {
  monitorAlertUpdate(
    input: {pressroomId: $pressroomId, id: $id, monitorAlert: $monitorAlert}
  ) {
    monitorAlert {
      ...MonitorAlert
    }
    error {
      __typename
      message
    }
  }
}
    ${MonitorAlertFragmentDoc}
${CountryAndRegionsFragmentDoc}
${MonitorAlertRecipientFragmentDoc}
${MonitorScheduledAlertFragmentDoc}
${MonitorRealTimeAlertFragmentDoc}
${MonitorSummaryAlertFragmentDoc}`;
export type UpdateMonitorAlertMutationFn = Apollo.MutationFunction<Types.UpdateMonitorAlertMutation, Types.UpdateMonitorAlertMutationVariables>;

/**
 * __useUpdateMonitorAlertMutation__
 *
 * To run a mutation, you first call `useUpdateMonitorAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitorAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitorAlertMutation, { data, loading, error }] = useUpdateMonitorAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      monitorAlert: // value for 'monitorAlert'
 *   },
 * });
 */
export function useUpdateMonitorAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMonitorAlertMutation, Types.UpdateMonitorAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMonitorAlertMutation, Types.UpdateMonitorAlertMutationVariables>(UpdateMonitorAlertDocument, options);
      }
export type UpdateMonitorAlertMutationHookResult = ReturnType<typeof useUpdateMonitorAlertMutation>;
export type UpdateMonitorAlertMutationResult = Apollo.MutationResult<Types.UpdateMonitorAlertMutation>;
export type UpdateMonitorAlertMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMonitorAlertMutation, Types.UpdateMonitorAlertMutationVariables>;
export const DeleteMonitorAlertDocument = gql`
    mutation DeleteMonitorAlert($pressroomId: ID!, $id: ID!) {
  monitorAlertDelete(input: {pressroomId: $pressroomId, id: $id}) {
    error {
      __typename
    }
    monitor {
      id
      alerts {
        ...MonitorAlert
      }
    }
  }
}
    ${MonitorAlertFragmentDoc}
${CountryAndRegionsFragmentDoc}
${MonitorAlertRecipientFragmentDoc}
${MonitorScheduledAlertFragmentDoc}
${MonitorRealTimeAlertFragmentDoc}
${MonitorSummaryAlertFragmentDoc}`;
export type DeleteMonitorAlertMutationFn = Apollo.MutationFunction<Types.DeleteMonitorAlertMutation, Types.DeleteMonitorAlertMutationVariables>;

/**
 * __useDeleteMonitorAlertMutation__
 *
 * To run a mutation, you first call `useDeleteMonitorAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMonitorAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMonitorAlertMutation, { data, loading, error }] = useDeleteMonitorAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMonitorAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMonitorAlertMutation, Types.DeleteMonitorAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMonitorAlertMutation, Types.DeleteMonitorAlertMutationVariables>(DeleteMonitorAlertDocument, options);
      }
export type DeleteMonitorAlertMutationHookResult = ReturnType<typeof useDeleteMonitorAlertMutation>;
export type DeleteMonitorAlertMutationResult = Apollo.MutationResult<Types.DeleteMonitorAlertMutation>;
export type DeleteMonitorAlertMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMonitorAlertMutation, Types.DeleteMonitorAlertMutationVariables>;
export const CreateMonitorClipboardDocument = gql`
    mutation CreateMonitorClipboard($pressroomId: ID!, $title: String!, $comment: String, $sortedBy: ClipboardSortedByField, $hitIds: [ID!]) {
  monitorClipboardCreate(
    input: {pressroomId: $pressroomId, payload: {title: $title, comment: $comment, sortedBy: $sortedBy, hitIds: $hitIds}}
  ) {
    error {
      message
    }
    clipboard {
      id
      title
      comment
      sortedBy
      hits {
        id
        clipboards {
          id
        }
      }
    }
    monitor {
      id
      clipboards {
        id
        title
      }
    }
  }
}
    `;
export type CreateMonitorClipboardMutationFn = Apollo.MutationFunction<Types.CreateMonitorClipboardMutation, Types.CreateMonitorClipboardMutationVariables>;

/**
 * __useCreateMonitorClipboardMutation__
 *
 * To run a mutation, you first call `useCreateMonitorClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitorClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitorClipboardMutation, { data, loading, error }] = useCreateMonitorClipboardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      title: // value for 'title'
 *      comment: // value for 'comment'
 *      sortedBy: // value for 'sortedBy'
 *      hitIds: // value for 'hitIds'
 *   },
 * });
 */
export function useCreateMonitorClipboardMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMonitorClipboardMutation, Types.CreateMonitorClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMonitorClipboardMutation, Types.CreateMonitorClipboardMutationVariables>(CreateMonitorClipboardDocument, options);
      }
export type CreateMonitorClipboardMutationHookResult = ReturnType<typeof useCreateMonitorClipboardMutation>;
export type CreateMonitorClipboardMutationResult = Apollo.MutationResult<Types.CreateMonitorClipboardMutation>;
export type CreateMonitorClipboardMutationOptions = Apollo.BaseMutationOptions<Types.CreateMonitorClipboardMutation, Types.CreateMonitorClipboardMutationVariables>;
export const UpdateMonitorClipboardDocument = gql`
    mutation UpdateMonitorClipboard($pressroomId: ID!, $clipboardId: ID!, $title: String!, $comment: String, $sortedBy: ClipboardSortedByField) {
  monitorClipboardUpdate(
    input: {pressroomId: $pressroomId, clipboardId: $clipboardId, payload: {title: $title, comment: $comment, sortedBy: $sortedBy}}
  ) {
    error {
      message
    }
    clipboard {
      id
      title
      comment
      sortedBy
    }
  }
}
    `;
export type UpdateMonitorClipboardMutationFn = Apollo.MutationFunction<Types.UpdateMonitorClipboardMutation, Types.UpdateMonitorClipboardMutationVariables>;

/**
 * __useUpdateMonitorClipboardMutation__
 *
 * To run a mutation, you first call `useUpdateMonitorClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitorClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitorClipboardMutation, { data, loading, error }] = useUpdateMonitorClipboardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *      title: // value for 'title'
 *      comment: // value for 'comment'
 *      sortedBy: // value for 'sortedBy'
 *   },
 * });
 */
export function useUpdateMonitorClipboardMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMonitorClipboardMutation, Types.UpdateMonitorClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMonitorClipboardMutation, Types.UpdateMonitorClipboardMutationVariables>(UpdateMonitorClipboardDocument, options);
      }
export type UpdateMonitorClipboardMutationHookResult = ReturnType<typeof useUpdateMonitorClipboardMutation>;
export type UpdateMonitorClipboardMutationResult = Apollo.MutationResult<Types.UpdateMonitorClipboardMutation>;
export type UpdateMonitorClipboardMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMonitorClipboardMutation, Types.UpdateMonitorClipboardMutationVariables>;
export const ClipboardEditDataDocument = gql`
    query ClipboardEditData($pressroomId: ID!, $clipboardId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      clipboard(id: $clipboardId) {
        id
        title
        comment
        sortedBy
      }
    }
  }
}
    `;

/**
 * __useClipboardEditDataQuery__
 *
 * To run a query within a React component, call `useClipboardEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipboardEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipboardEditDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *   },
 * });
 */
export function useClipboardEditDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables> & ({ variables: Types.ClipboardEditDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables>(ClipboardEditDataDocument, options);
      }
export function useClipboardEditDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables>(ClipboardEditDataDocument, options);
        }
export function useClipboardEditDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables>(ClipboardEditDataDocument, options);
        }
export type ClipboardEditDataQueryHookResult = ReturnType<typeof useClipboardEditDataQuery>;
export type ClipboardEditDataLazyQueryHookResult = ReturnType<typeof useClipboardEditDataLazyQuery>;
export type ClipboardEditDataSuspenseQueryHookResult = ReturnType<typeof useClipboardEditDataSuspenseQuery>;
export type ClipboardEditDataQueryResult = Apollo.QueryResult<Types.ClipboardEditDataQuery, Types.ClipboardEditDataQueryVariables>;
export const ClipboardSortedByOptionsDocument = gql`
    query ClipboardSortedByOptions($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      clipboardSortedByOptions {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useClipboardSortedByOptionsQuery__
 *
 * To run a query within a React component, call `useClipboardSortedByOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipboardSortedByOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipboardSortedByOptionsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useClipboardSortedByOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables> & ({ variables: Types.ClipboardSortedByOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables>(ClipboardSortedByOptionsDocument, options);
      }
export function useClipboardSortedByOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables>(ClipboardSortedByOptionsDocument, options);
        }
export function useClipboardSortedByOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables>(ClipboardSortedByOptionsDocument, options);
        }
export type ClipboardSortedByOptionsQueryHookResult = ReturnType<typeof useClipboardSortedByOptionsQuery>;
export type ClipboardSortedByOptionsLazyQueryHookResult = ReturnType<typeof useClipboardSortedByOptionsLazyQuery>;
export type ClipboardSortedByOptionsSuspenseQueryHookResult = ReturnType<typeof useClipboardSortedByOptionsSuspenseQuery>;
export type ClipboardSortedByOptionsQueryResult = Apollo.QueryResult<Types.ClipboardSortedByOptionsQuery, Types.ClipboardSortedByOptionsQueryVariables>;
export const DeleteMonitorClipboardDocument = gql`
    mutation DeleteMonitorClipboard($pressroomId: ID!, $clipboardId: ID!) {
  monitorClipboardDelete(input: {pressroomId: $pressroomId, id: $clipboardId}) {
    error {
      message
    }
    monitor {
      id
      clipboards {
        id
      }
    }
    clipboardId
  }
}
    `;
export type DeleteMonitorClipboardMutationFn = Apollo.MutationFunction<Types.DeleteMonitorClipboardMutation, Types.DeleteMonitorClipboardMutationVariables>;

/**
 * __useDeleteMonitorClipboardMutation__
 *
 * To run a mutation, you first call `useDeleteMonitorClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMonitorClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMonitorClipboardMutation, { data, loading, error }] = useDeleteMonitorClipboardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *   },
 * });
 */
export function useDeleteMonitorClipboardMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMonitorClipboardMutation, Types.DeleteMonitorClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMonitorClipboardMutation, Types.DeleteMonitorClipboardMutationVariables>(DeleteMonitorClipboardDocument, options);
      }
export type DeleteMonitorClipboardMutationHookResult = ReturnType<typeof useDeleteMonitorClipboardMutation>;
export type DeleteMonitorClipboardMutationResult = Apollo.MutationResult<Types.DeleteMonitorClipboardMutation>;
export type DeleteMonitorClipboardMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMonitorClipboardMutation, Types.DeleteMonitorClipboardMutationVariables>;
export const ClipboardListDataDocument = gql`
    query ClipboardListData($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      clipboards {
        id
        title
        comment
        createdAt
        feedLink
        hitsCount
      }
    }
  }
}
    `;

/**
 * __useClipboardListDataQuery__
 *
 * To run a query within a React component, call `useClipboardListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipboardListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipboardListDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useClipboardListDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables> & ({ variables: Types.ClipboardListDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables>(ClipboardListDataDocument, options);
      }
export function useClipboardListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables>(ClipboardListDataDocument, options);
        }
export function useClipboardListDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables>(ClipboardListDataDocument, options);
        }
export type ClipboardListDataQueryHookResult = ReturnType<typeof useClipboardListDataQuery>;
export type ClipboardListDataLazyQueryHookResult = ReturnType<typeof useClipboardListDataLazyQuery>;
export type ClipboardListDataSuspenseQueryHookResult = ReturnType<typeof useClipboardListDataSuspenseQuery>;
export type ClipboardListDataQueryResult = Apollo.QueryResult<Types.ClipboardListDataQuery, Types.ClipboardListDataQueryVariables>;
export const SendEmailMonitorClipboardDocument = gql`
    mutation SendEmailMonitorClipboard($pressroomId: ID!, $clipboardId: ID!, $clipboardEmail: ClipboardEmailInput!) {
  monitorClipboardSendEmail(
    input: {pressroomId: $pressroomId, clipboardId: $clipboardId, clipboardEmail: $clipboardEmail}
  ) {
    error {
      message
    }
  }
}
    `;
export type SendEmailMonitorClipboardMutationFn = Apollo.MutationFunction<Types.SendEmailMonitorClipboardMutation, Types.SendEmailMonitorClipboardMutationVariables>;

/**
 * __useSendEmailMonitorClipboardMutation__
 *
 * To run a mutation, you first call `useSendEmailMonitorClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMonitorClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMonitorClipboardMutation, { data, loading, error }] = useSendEmailMonitorClipboardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *      clipboardEmail: // value for 'clipboardEmail'
 *   },
 * });
 */
export function useSendEmailMonitorClipboardMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendEmailMonitorClipboardMutation, Types.SendEmailMonitorClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendEmailMonitorClipboardMutation, Types.SendEmailMonitorClipboardMutationVariables>(SendEmailMonitorClipboardDocument, options);
      }
export type SendEmailMonitorClipboardMutationHookResult = ReturnType<typeof useSendEmailMonitorClipboardMutation>;
export type SendEmailMonitorClipboardMutationResult = Apollo.MutationResult<Types.SendEmailMonitorClipboardMutation>;
export type SendEmailMonitorClipboardMutationOptions = Apollo.BaseMutationOptions<Types.SendEmailMonitorClipboardMutation, Types.SendEmailMonitorClipboardMutationVariables>;
export const ShareableReportLinkFindOrCreateDocument = gql`
    mutation ShareableReportLinkFindOrCreate($pressroomId: ID!, $clipboardId: ID!) {
  monitorShareableClipboardReportLinkFindOrCreate(
    input: {pressroomId: $pressroomId, clipboardId: $clipboardId}
  ) {
    error {
      message
    }
    clipboard {
      id
      mediaCoverageReportLink {
        link
      }
    }
  }
}
    `;
export type ShareableReportLinkFindOrCreateMutationFn = Apollo.MutationFunction<Types.ShareableReportLinkFindOrCreateMutation, Types.ShareableReportLinkFindOrCreateMutationVariables>;

/**
 * __useShareableReportLinkFindOrCreateMutation__
 *
 * To run a mutation, you first call `useShareableReportLinkFindOrCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareableReportLinkFindOrCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareableReportLinkFindOrCreateMutation, { data, loading, error }] = useShareableReportLinkFindOrCreateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *   },
 * });
 */
export function useShareableReportLinkFindOrCreateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ShareableReportLinkFindOrCreateMutation, Types.ShareableReportLinkFindOrCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ShareableReportLinkFindOrCreateMutation, Types.ShareableReportLinkFindOrCreateMutationVariables>(ShareableReportLinkFindOrCreateDocument, options);
      }
export type ShareableReportLinkFindOrCreateMutationHookResult = ReturnType<typeof useShareableReportLinkFindOrCreateMutation>;
export type ShareableReportLinkFindOrCreateMutationResult = Apollo.MutationResult<Types.ShareableReportLinkFindOrCreateMutation>;
export type ShareableReportLinkFindOrCreateMutationOptions = Apollo.BaseMutationOptions<Types.ShareableReportLinkFindOrCreateMutation, Types.ShareableReportLinkFindOrCreateMutationVariables>;
export const ClipboardDataDocument = gql`
    query ClipboardData($pressroomId: ID!, $clipboardId: ID!, $language: UserLocale) {
  pressroom(id: $pressroomId) {
    id
    siteLocale
    monitor {
      id
      clipboard(id: $clipboardId) {
        id
        title
        comment
        createdAt
        feedLink
        hitsCount
        mediaCoverageReportLink {
          link
        }
        hits {
          id
          ...HitDataWithDuplicates
        }
      }
    }
  }
}
    ${HitDataWithDuplicatesFragmentDoc}
${HitDataFragmentDoc}`;

/**
 * __useClipboardDataQuery__
 *
 * To run a query within a React component, call `useClipboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipboardDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useClipboardDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables> & ({ variables: Types.ClipboardDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables>(ClipboardDataDocument, options);
      }
export function useClipboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables>(ClipboardDataDocument, options);
        }
export function useClipboardDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables>(ClipboardDataDocument, options);
        }
export type ClipboardDataQueryHookResult = ReturnType<typeof useClipboardDataQuery>;
export type ClipboardDataLazyQueryHookResult = ReturnType<typeof useClipboardDataLazyQuery>;
export type ClipboardDataSuspenseQueryHookResult = ReturnType<typeof useClipboardDataSuspenseQuery>;
export type ClipboardDataQueryResult = Apollo.QueryResult<Types.ClipboardDataQuery, Types.ClipboardDataQueryVariables>;
export const ListMonitorCrisisAlertsDocument = gql`
    query ListMonitorCrisisAlerts($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      crisisAlerts {
        ...MonitorCrisisAlert
      }
    }
  }
}
    ${MonitorCrisisAlertFragmentDoc}`;

/**
 * __useListMonitorCrisisAlertsQuery__
 *
 * To run a query within a React component, call `useListMonitorCrisisAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMonitorCrisisAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMonitorCrisisAlertsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useListMonitorCrisisAlertsQuery(baseOptions: Apollo.QueryHookOptions<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables> & ({ variables: Types.ListMonitorCrisisAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables>(ListMonitorCrisisAlertsDocument, options);
      }
export function useListMonitorCrisisAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables>(ListMonitorCrisisAlertsDocument, options);
        }
export function useListMonitorCrisisAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables>(ListMonitorCrisisAlertsDocument, options);
        }
export type ListMonitorCrisisAlertsQueryHookResult = ReturnType<typeof useListMonitorCrisisAlertsQuery>;
export type ListMonitorCrisisAlertsLazyQueryHookResult = ReturnType<typeof useListMonitorCrisisAlertsLazyQuery>;
export type ListMonitorCrisisAlertsSuspenseQueryHookResult = ReturnType<typeof useListMonitorCrisisAlertsSuspenseQuery>;
export type ListMonitorCrisisAlertsQueryResult = Apollo.QueryResult<Types.ListMonitorCrisisAlertsQuery, Types.ListMonitorCrisisAlertsQueryVariables>;
export const MonitorCrisisAlertDocument = gql`
    query MonitorCrisisAlert($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      crisisAlert(id: $id) {
        ...MonitorCrisisAlert
      }
    }
  }
}
    ${MonitorCrisisAlertFragmentDoc}`;

/**
 * __useMonitorCrisisAlertQuery__
 *
 * To run a query within a React component, call `useMonitorCrisisAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitorCrisisAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitorCrisisAlertQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMonitorCrisisAlertQuery(baseOptions: Apollo.QueryHookOptions<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables> & ({ variables: Types.MonitorCrisisAlertQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables>(MonitorCrisisAlertDocument, options);
      }
export function useMonitorCrisisAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables>(MonitorCrisisAlertDocument, options);
        }
export function useMonitorCrisisAlertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables>(MonitorCrisisAlertDocument, options);
        }
export type MonitorCrisisAlertQueryHookResult = ReturnType<typeof useMonitorCrisisAlertQuery>;
export type MonitorCrisisAlertLazyQueryHookResult = ReturnType<typeof useMonitorCrisisAlertLazyQuery>;
export type MonitorCrisisAlertSuspenseQueryHookResult = ReturnType<typeof useMonitorCrisisAlertSuspenseQuery>;
export type MonitorCrisisAlertQueryResult = Apollo.QueryResult<Types.MonitorCrisisAlertQuery, Types.MonitorCrisisAlertQueryVariables>;
export const CreateMonitorCrisisAlertDocument = gql`
    mutation CreateMonitorCrisisAlert($pressroomId: ID!, $monitorCrisisAlert: MonitorCrisisAlertInput!) {
  monitorCrisisAlertCreate(
    input: {pressroomId: $pressroomId, monitorCrisisAlert: $monitorCrisisAlert}
  ) {
    crisisAlert {
      ...MonitorCrisisAlert
    }
    monitor {
      id
      crisisAlerts {
        ...MonitorCrisisAlert
      }
    }
    error {
      message
    }
  }
}
    ${MonitorCrisisAlertFragmentDoc}`;
export type CreateMonitorCrisisAlertMutationFn = Apollo.MutationFunction<Types.CreateMonitorCrisisAlertMutation, Types.CreateMonitorCrisisAlertMutationVariables>;

/**
 * __useCreateMonitorCrisisAlertMutation__
 *
 * To run a mutation, you first call `useCreateMonitorCrisisAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitorCrisisAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitorCrisisAlertMutation, { data, loading, error }] = useCreateMonitorCrisisAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      monitorCrisisAlert: // value for 'monitorCrisisAlert'
 *   },
 * });
 */
export function useCreateMonitorCrisisAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMonitorCrisisAlertMutation, Types.CreateMonitorCrisisAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMonitorCrisisAlertMutation, Types.CreateMonitorCrisisAlertMutationVariables>(CreateMonitorCrisisAlertDocument, options);
      }
export type CreateMonitorCrisisAlertMutationHookResult = ReturnType<typeof useCreateMonitorCrisisAlertMutation>;
export type CreateMonitorCrisisAlertMutationResult = Apollo.MutationResult<Types.CreateMonitorCrisisAlertMutation>;
export type CreateMonitorCrisisAlertMutationOptions = Apollo.BaseMutationOptions<Types.CreateMonitorCrisisAlertMutation, Types.CreateMonitorCrisisAlertMutationVariables>;
export const UpdateMonitorCrisisAlertDocument = gql`
    mutation UpdateMonitorCrisisAlert($pressroomId: ID!, $monitorCrisisAlertId: ID!, $monitorCrisisAlert: MonitorCrisisAlertInput!) {
  monitorCrisisAlertUpdate(
    input: {pressroomId: $pressroomId, id: $monitorCrisisAlertId, monitorCrisisAlert: $monitorCrisisAlert}
  ) {
    crisisAlert {
      ...MonitorCrisisAlert
    }
    monitor {
      id
      crisisAlerts {
        ...MonitorCrisisAlert
      }
    }
    error {
      message
    }
  }
}
    ${MonitorCrisisAlertFragmentDoc}`;
export type UpdateMonitorCrisisAlertMutationFn = Apollo.MutationFunction<Types.UpdateMonitorCrisisAlertMutation, Types.UpdateMonitorCrisisAlertMutationVariables>;

/**
 * __useUpdateMonitorCrisisAlertMutation__
 *
 * To run a mutation, you first call `useUpdateMonitorCrisisAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitorCrisisAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitorCrisisAlertMutation, { data, loading, error }] = useUpdateMonitorCrisisAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      monitorCrisisAlertId: // value for 'monitorCrisisAlertId'
 *      monitorCrisisAlert: // value for 'monitorCrisisAlert'
 *   },
 * });
 */
export function useUpdateMonitorCrisisAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMonitorCrisisAlertMutation, Types.UpdateMonitorCrisisAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMonitorCrisisAlertMutation, Types.UpdateMonitorCrisisAlertMutationVariables>(UpdateMonitorCrisisAlertDocument, options);
      }
export type UpdateMonitorCrisisAlertMutationHookResult = ReturnType<typeof useUpdateMonitorCrisisAlertMutation>;
export type UpdateMonitorCrisisAlertMutationResult = Apollo.MutationResult<Types.UpdateMonitorCrisisAlertMutation>;
export type UpdateMonitorCrisisAlertMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMonitorCrisisAlertMutation, Types.UpdateMonitorCrisisAlertMutationVariables>;
export const DeleteMonitorCrisisAlertDocument = gql`
    mutation DeleteMonitorCrisisAlert($pressroomId: ID!, $monitorCrisisAlertId: ID!) {
  monitorCrisisAlertDelete(
    input: {pressroomId: $pressroomId, id: $monitorCrisisAlertId}
  ) {
    monitor {
      id
      crisisAlerts {
        ...MonitorCrisisAlert
      }
    }
    error {
      message
    }
  }
}
    ${MonitorCrisisAlertFragmentDoc}`;
export type DeleteMonitorCrisisAlertMutationFn = Apollo.MutationFunction<Types.DeleteMonitorCrisisAlertMutation, Types.DeleteMonitorCrisisAlertMutationVariables>;

/**
 * __useDeleteMonitorCrisisAlertMutation__
 *
 * To run a mutation, you first call `useDeleteMonitorCrisisAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMonitorCrisisAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMonitorCrisisAlertMutation, { data, loading, error }] = useDeleteMonitorCrisisAlertMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      monitorCrisisAlertId: // value for 'monitorCrisisAlertId'
 *   },
 * });
 */
export function useDeleteMonitorCrisisAlertMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMonitorCrisisAlertMutation, Types.DeleteMonitorCrisisAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMonitorCrisisAlertMutation, Types.DeleteMonitorCrisisAlertMutationVariables>(DeleteMonitorCrisisAlertDocument, options);
      }
export type DeleteMonitorCrisisAlertMutationHookResult = ReturnType<typeof useDeleteMonitorCrisisAlertMutation>;
export type DeleteMonitorCrisisAlertMutationResult = Apollo.MutationResult<Types.DeleteMonitorCrisisAlertMutation>;
export type DeleteMonitorCrisisAlertMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMonitorCrisisAlertMutation, Types.DeleteMonitorCrisisAlertMutationVariables>;
export const AddToClipboardModalDataDocument = gql`
    query AddToClipboardModalData($pressroomId: ID!, $hitIds: [ID!]!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      clipboards {
        id
        title
        hasHits(ids: $hitIds)
      }
    }
  }
}
    `;

/**
 * __useAddToClipboardModalDataQuery__
 *
 * To run a query within a React component, call `useAddToClipboardModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddToClipboardModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddToClipboardModalDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      hitIds: // value for 'hitIds'
 *   },
 * });
 */
export function useAddToClipboardModalDataQuery(baseOptions: Apollo.QueryHookOptions<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables> & ({ variables: Types.AddToClipboardModalDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables>(AddToClipboardModalDataDocument, options);
      }
export function useAddToClipboardModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables>(AddToClipboardModalDataDocument, options);
        }
export function useAddToClipboardModalDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables>(AddToClipboardModalDataDocument, options);
        }
export type AddToClipboardModalDataQueryHookResult = ReturnType<typeof useAddToClipboardModalDataQuery>;
export type AddToClipboardModalDataLazyQueryHookResult = ReturnType<typeof useAddToClipboardModalDataLazyQuery>;
export type AddToClipboardModalDataSuspenseQueryHookResult = ReturnType<typeof useAddToClipboardModalDataSuspenseQuery>;
export type AddToClipboardModalDataQueryResult = Apollo.QueryResult<Types.AddToClipboardModalDataQuery, Types.AddToClipboardModalDataQueryVariables>;
export const SaveHitChangesToClipboardsDocument = gql`
    mutation SaveHitChangesToClipboards($addInput: AddHitToClipboardInput!, $removeInput: RemoveHitFromClipboardInput!) {
  monitorClipboardAddHit(input: $addInput) {
    error {
      message
    }
    clipboards {
      id
      hitsCount
      hits {
        id
      }
    }
    hits {
      id
      clipboards {
        id
      }
    }
  }
  monitorClipboardRemoveHit(input: $removeInput) {
    error {
      message
    }
    clipboards {
      id
      hitsCount
      hits {
        id
      }
    }
    hits {
      id
      clipboards {
        id
      }
    }
  }
}
    `;
export type SaveHitChangesToClipboardsMutationFn = Apollo.MutationFunction<Types.SaveHitChangesToClipboardsMutation, Types.SaveHitChangesToClipboardsMutationVariables>;

/**
 * __useSaveHitChangesToClipboardsMutation__
 *
 * To run a mutation, you first call `useSaveHitChangesToClipboardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHitChangesToClipboardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHitChangesToClipboardsMutation, { data, loading, error }] = useSaveHitChangesToClipboardsMutation({
 *   variables: {
 *      addInput: // value for 'addInput'
 *      removeInput: // value for 'removeInput'
 *   },
 * });
 */
export function useSaveHitChangesToClipboardsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveHitChangesToClipboardsMutation, Types.SaveHitChangesToClipboardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveHitChangesToClipboardsMutation, Types.SaveHitChangesToClipboardsMutationVariables>(SaveHitChangesToClipboardsDocument, options);
      }
export type SaveHitChangesToClipboardsMutationHookResult = ReturnType<typeof useSaveHitChangesToClipboardsMutation>;
export type SaveHitChangesToClipboardsMutationResult = Apollo.MutationResult<Types.SaveHitChangesToClipboardsMutation>;
export type SaveHitChangesToClipboardsMutationOptions = Apollo.BaseMutationOptions<Types.SaveHitChangesToClipboardsMutation, Types.SaveHitChangesToClipboardsMutationVariables>;
export const MonitorProfileLanguagesDocument = gql`
    query MonitorProfileLanguages($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      searchProfiles {
        id
        languages
      }
    }
  }
}
    `;

/**
 * __useMonitorProfileLanguagesQuery__
 *
 * To run a query within a React component, call `useMonitorProfileLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitorProfileLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitorProfileLanguagesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useMonitorProfileLanguagesQuery(baseOptions: Apollo.QueryHookOptions<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables> & ({ variables: Types.MonitorProfileLanguagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables>(MonitorProfileLanguagesDocument, options);
      }
export function useMonitorProfileLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables>(MonitorProfileLanguagesDocument, options);
        }
export function useMonitorProfileLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables>(MonitorProfileLanguagesDocument, options);
        }
export type MonitorProfileLanguagesQueryHookResult = ReturnType<typeof useMonitorProfileLanguagesQuery>;
export type MonitorProfileLanguagesLazyQueryHookResult = ReturnType<typeof useMonitorProfileLanguagesLazyQuery>;
export type MonitorProfileLanguagesSuspenseQueryHookResult = ReturnType<typeof useMonitorProfileLanguagesSuspenseQuery>;
export type MonitorProfileLanguagesQueryResult = Apollo.QueryResult<Types.MonitorProfileLanguagesQuery, Types.MonitorProfileLanguagesQueryVariables>;
export const RemoveHitsFromMonitorFeedDocument = gql`
    mutation RemoveHitsFromMonitorFeed($pressroomId: ID!, $articleIds: [ID!]!, $profiles: [ID!], $sources: [MonitorMediaFilterType!], $timespan: MonitorTimespan, $timeRange: MonitorTimeRange, $after: String) {
  monitorRemoveHits(input: {pressroomId: $pressroomId, articleIds: $articleIds}) {
    error {
      message
    }
    monitor {
      id
      hitList(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
        after: $after
      ) {
        endCursor
        hits {
          id
        }
      }
    }
  }
}
    `;
export type RemoveHitsFromMonitorFeedMutationFn = Apollo.MutationFunction<Types.RemoveHitsFromMonitorFeedMutation, Types.RemoveHitsFromMonitorFeedMutationVariables>;

/**
 * __useRemoveHitsFromMonitorFeedMutation__
 *
 * To run a mutation, you first call `useRemoveHitsFromMonitorFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHitsFromMonitorFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHitsFromMonitorFeedMutation, { data, loading, error }] = useRemoveHitsFromMonitorFeedMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      articleIds: // value for 'articleIds'
 *      profiles: // value for 'profiles'
 *      sources: // value for 'sources'
 *      timespan: // value for 'timespan'
 *      timeRange: // value for 'timeRange'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRemoveHitsFromMonitorFeedMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveHitsFromMonitorFeedMutation, Types.RemoveHitsFromMonitorFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveHitsFromMonitorFeedMutation, Types.RemoveHitsFromMonitorFeedMutationVariables>(RemoveHitsFromMonitorFeedDocument, options);
      }
export type RemoveHitsFromMonitorFeedMutationHookResult = ReturnType<typeof useRemoveHitsFromMonitorFeedMutation>;
export type RemoveHitsFromMonitorFeedMutationResult = Apollo.MutationResult<Types.RemoveHitsFromMonitorFeedMutation>;
export type RemoveHitsFromMonitorFeedMutationOptions = Apollo.BaseMutationOptions<Types.RemoveHitsFromMonitorFeedMutation, Types.RemoveHitsFromMonitorFeedMutationVariables>;
export const RemoveHitFromMonitorClipboardDocument = gql`
    mutation RemoveHitFromMonitorClipboard($pressroomId: ID!, $clipboardId: ID!, $hitId: ID!) {
  monitorClipboardRemoveHit(
    input: {pressroomId: $pressroomId, clipboardId: $clipboardId, hitId: $hitId}
  ) {
    error {
      message
    }
    monitor {
      id
      clipboard(id: $clipboardId) {
        id
        hits {
          id
          articleId
          clipboards {
            id
          }
        }
      }
      clipboards {
        id
        hits {
          id
          articleId
        }
      }
    }
    hits {
      id
      clipboards {
        id
      }
    }
  }
}
    `;
export type RemoveHitFromMonitorClipboardMutationFn = Apollo.MutationFunction<Types.RemoveHitFromMonitorClipboardMutation, Types.RemoveHitFromMonitorClipboardMutationVariables>;

/**
 * __useRemoveHitFromMonitorClipboardMutation__
 *
 * To run a mutation, you first call `useRemoveHitFromMonitorClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHitFromMonitorClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHitFromMonitorClipboardMutation, { data, loading, error }] = useRemoveHitFromMonitorClipboardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *      hitId: // value for 'hitId'
 *   },
 * });
 */
export function useRemoveHitFromMonitorClipboardMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveHitFromMonitorClipboardMutation, Types.RemoveHitFromMonitorClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveHitFromMonitorClipboardMutation, Types.RemoveHitFromMonitorClipboardMutationVariables>(RemoveHitFromMonitorClipboardDocument, options);
      }
export type RemoveHitFromMonitorClipboardMutationHookResult = ReturnType<typeof useRemoveHitFromMonitorClipboardMutation>;
export type RemoveHitFromMonitorClipboardMutationResult = Apollo.MutationResult<Types.RemoveHitFromMonitorClipboardMutation>;
export type RemoveHitFromMonitorClipboardMutationOptions = Apollo.BaseMutationOptions<Types.RemoveHitFromMonitorClipboardMutation, Types.RemoveHitFromMonitorClipboardMutationVariables>;
export const AddHitToMonitorClipboardDocument = gql`
    mutation AddHitToMonitorClipboard($pressroomId: ID!, $clipboardIds: [ID!]!, $hitIds: [ID!]!) {
  monitorClipboardAddHit(
    input: {pressroomId: $pressroomId, clipboardIds: $clipboardIds, hitIds: $hitIds}
  ) {
    error {
      message
    }
    clipboards {
      id
      hits {
        id
      }
    }
  }
}
    `;
export type AddHitToMonitorClipboardMutationFn = Apollo.MutationFunction<Types.AddHitToMonitorClipboardMutation, Types.AddHitToMonitorClipboardMutationVariables>;

/**
 * __useAddHitToMonitorClipboardMutation__
 *
 * To run a mutation, you first call `useAddHitToMonitorClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHitToMonitorClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHitToMonitorClipboardMutation, { data, loading, error }] = useAddHitToMonitorClipboardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardIds: // value for 'clipboardIds'
 *      hitIds: // value for 'hitIds'
 *   },
 * });
 */
export function useAddHitToMonitorClipboardMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddHitToMonitorClipboardMutation, Types.AddHitToMonitorClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddHitToMonitorClipboardMutation, Types.AddHitToMonitorClipboardMutationVariables>(AddHitToMonitorClipboardDocument, options);
      }
export type AddHitToMonitorClipboardMutationHookResult = ReturnType<typeof useAddHitToMonitorClipboardMutation>;
export type AddHitToMonitorClipboardMutationResult = Apollo.MutationResult<Types.AddHitToMonitorClipboardMutation>;
export type AddHitToMonitorClipboardMutationOptions = Apollo.BaseMutationOptions<Types.AddHitToMonitorClipboardMutation, Types.AddHitToMonitorClipboardMutationVariables>;
export const UpdateMonitorClipboardHitsDocument = gql`
    mutation UpdateMonitorClipboardHits($pressroomId: ID!, $clipboardId: ID!, $hitIds: [ID!]!) {
  monitorClipboardHitsUpdate(
    input: {pressroomId: $pressroomId, clipboardId: $clipboardId, hitIds: $hitIds}
  ) {
    error {
      message
    }
    clipboard {
      id
      hits {
        id
        articleId
      }
    }
    monitor {
      id
      clipboards {
        id
        hits {
          id
          articleId
        }
      }
    }
  }
}
    `;
export type UpdateMonitorClipboardHitsMutationFn = Apollo.MutationFunction<Types.UpdateMonitorClipboardHitsMutation, Types.UpdateMonitorClipboardHitsMutationVariables>;

/**
 * __useUpdateMonitorClipboardHitsMutation__
 *
 * To run a mutation, you first call `useUpdateMonitorClipboardHitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitorClipboardHitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitorClipboardHitsMutation, { data, loading, error }] = useUpdateMonitorClipboardHitsMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      clipboardId: // value for 'clipboardId'
 *      hitIds: // value for 'hitIds'
 *   },
 * });
 */
export function useUpdateMonitorClipboardHitsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMonitorClipboardHitsMutation, Types.UpdateMonitorClipboardHitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMonitorClipboardHitsMutation, Types.UpdateMonitorClipboardHitsMutationVariables>(UpdateMonitorClipboardHitsDocument, options);
      }
export type UpdateMonitorClipboardHitsMutationHookResult = ReturnType<typeof useUpdateMonitorClipboardHitsMutation>;
export type UpdateMonitorClipboardHitsMutationResult = Apollo.MutationResult<Types.UpdateMonitorClipboardHitsMutation>;
export type UpdateMonitorClipboardHitsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMonitorClipboardHitsMutation, Types.UpdateMonitorClipboardHitsMutationVariables>;
export const MonitorUpdateHitDocument = gql`
    mutation MonitorUpdateHit($pressroomId: ID!, $id: ID!, $data: UpdateHit2DataInput!) {
  monitorUpdateHit2(input: {pressroomId: $pressroomId, id: $id, data: $data}) {
    error {
      message
    }
    hit {
      id
      articleId
      sentiment
    }
  }
}
    `;
export type MonitorUpdateHitMutationFn = Apollo.MutationFunction<Types.MonitorUpdateHitMutation, Types.MonitorUpdateHitMutationVariables>;

/**
 * __useMonitorUpdateHitMutation__
 *
 * To run a mutation, you first call `useMonitorUpdateHitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMonitorUpdateHitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [monitorUpdateHitMutation, { data, loading, error }] = useMonitorUpdateHitMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMonitorUpdateHitMutation(baseOptions?: Apollo.MutationHookOptions<Types.MonitorUpdateHitMutation, Types.MonitorUpdateHitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MonitorUpdateHitMutation, Types.MonitorUpdateHitMutationVariables>(MonitorUpdateHitDocument, options);
      }
export type MonitorUpdateHitMutationHookResult = ReturnType<typeof useMonitorUpdateHitMutation>;
export type MonitorUpdateHitMutationResult = Apollo.MutationResult<Types.MonitorUpdateHitMutation>;
export type MonitorUpdateHitMutationOptions = Apollo.BaseMutationOptions<Types.MonitorUpdateHitMutation, Types.MonitorUpdateHitMutationVariables>;
export const MediaFeedDataDocument = gql`
    query MediaFeedData($pressroomId: ID!, $profiles: [ID!], $sources: [MonitorMediaFilterType!], $timespan: MonitorTimespan, $timeRange: MonitorTimeRange, $after: String, $groupIdentical: Boolean, $locations: [LocationFilterInput!], $orderBy: MonitorOrderBy, $freeTextSearch: String, $sourceIds: [ID!], $sourceGroupIds: [ID!], $feature: Feature!, $language: UserLocale) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      dashboard(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
      ) {
        sourceGroups {
          id
          name
        }
      }
      hitList(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
        sourceIds: $sourceIds
        sourceGroupIds: $sourceGroupIds
        locations: $locations
        after: $after
        groupIdentical: $groupIdentical
        freetextSearch: $freeTextSearch
        orderBy: $orderBy
      ) {
        totalCount
        endCursor
        hits {
          ...HitDataWithDuplicates
        }
        error {
          __typename
        }
      }
    }
    features {
      id
      managed(feature: $feature) {
        id
        enabled
      }
    }
  }
}
    ${HitDataWithDuplicatesFragmentDoc}
${HitDataFragmentDoc}`;

/**
 * __useMediaFeedDataQuery__
 *
 * To run a query within a React component, call `useMediaFeedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaFeedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaFeedDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profiles: // value for 'profiles'
 *      sources: // value for 'sources'
 *      timespan: // value for 'timespan'
 *      timeRange: // value for 'timeRange'
 *      after: // value for 'after'
 *      groupIdentical: // value for 'groupIdentical'
 *      locations: // value for 'locations'
 *      orderBy: // value for 'orderBy'
 *      freeTextSearch: // value for 'freeTextSearch'
 *      sourceIds: // value for 'sourceIds'
 *      sourceGroupIds: // value for 'sourceGroupIds'
 *      feature: // value for 'feature'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMediaFeedDataQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables> & ({ variables: Types.MediaFeedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables>(MediaFeedDataDocument, options);
      }
export function useMediaFeedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables>(MediaFeedDataDocument, options);
        }
export function useMediaFeedDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables>(MediaFeedDataDocument, options);
        }
export type MediaFeedDataQueryHookResult = ReturnType<typeof useMediaFeedDataQuery>;
export type MediaFeedDataLazyQueryHookResult = ReturnType<typeof useMediaFeedDataLazyQuery>;
export type MediaFeedDataSuspenseQueryHookResult = ReturnType<typeof useMediaFeedDataSuspenseQuery>;
export type MediaFeedDataQueryResult = Apollo.QueryResult<Types.MediaFeedDataQuery, Types.MediaFeedDataQueryVariables>;
export const LoadClipboardsDocument = gql`
    query LoadClipboards($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      clipboards {
        id
        ...ClipboardData
      }
    }
  }
}
    ${ClipboardDataFragmentDoc}`;

/**
 * __useLoadClipboardsQuery__
 *
 * To run a query within a React component, call `useLoadClipboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadClipboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadClipboardsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useLoadClipboardsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables> & ({ variables: Types.LoadClipboardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables>(LoadClipboardsDocument, options);
      }
export function useLoadClipboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables>(LoadClipboardsDocument, options);
        }
export function useLoadClipboardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables>(LoadClipboardsDocument, options);
        }
export type LoadClipboardsQueryHookResult = ReturnType<typeof useLoadClipboardsQuery>;
export type LoadClipboardsLazyQueryHookResult = ReturnType<typeof useLoadClipboardsLazyQuery>;
export type LoadClipboardsSuspenseQueryHookResult = ReturnType<typeof useLoadClipboardsSuspenseQuery>;
export type LoadClipboardsQueryResult = Apollo.QueryResult<Types.LoadClipboardsQuery, Types.LoadClipboardsQueryVariables>;
export const PreviewFeedDocument = gql`
    query PreviewFeed($pressroomId: ID!, $searchParams: InsightsSearchInput!, $locations: [LocationFilterInput!], $language: UserLocale) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      hitList(
        searchParams: $searchParams
        locations: $locations
        groupIdentical: true
      ) {
        totalCount
        hits {
          ...HitDataWithDuplicates
        }
      }
    }
  }
}
    ${HitDataWithDuplicatesFragmentDoc}
${HitDataFragmentDoc}`;

/**
 * __usePreviewFeedQuery__
 *
 * To run a query within a React component, call `usePreviewFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewFeedQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      searchParams: // value for 'searchParams'
 *      locations: // value for 'locations'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePreviewFeedQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables> & ({ variables: Types.PreviewFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables>(PreviewFeedDocument, options);
      }
export function usePreviewFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables>(PreviewFeedDocument, options);
        }
export function usePreviewFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables>(PreviewFeedDocument, options);
        }
export type PreviewFeedQueryHookResult = ReturnType<typeof usePreviewFeedQuery>;
export type PreviewFeedLazyQueryHookResult = ReturnType<typeof usePreviewFeedLazyQuery>;
export type PreviewFeedSuspenseQueryHookResult = ReturnType<typeof usePreviewFeedSuspenseQuery>;
export type PreviewFeedQueryResult = Apollo.QueryResult<Types.PreviewFeedQuery, Types.PreviewFeedQueryVariables>;
export const MediaImpactDataDocument = gql`
    query MediaImpactData($pressroomId: ID!, $profiles: [ID!], $sources: [MonitorMediaFilterType!], $timespan: MonitorTimespan, $timeRange: MonitorTimeRange, $sortBy: GeographicalImpactSortOrder, $time: DateTimeRangeInput, $first: Int, $after: String) {
  pressroom(id: $pressroomId) {
    id
    materialList2(
      types: [Pressrelease, BlogPost, News]
      sort: descending_published_at
      status: published
      time: $time
      first: $first
      after: $after
    ) {
      __typename
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        header
        publishedAt2
        __typename
      }
    }
    monitor {
      id
      dashboard(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
      ) {
        hitsOverTime {
          profileHits {
            count
            share
            profile(pressroomId: $pressroomId) {
              id
              name
            }
          }
          timestamp: timestamp2
        }
        averageHits {
          hits
          unit
        }
        topSources {
          count
          mediaType {
            id
            name
          }
        }
        topMentioners {
          count
          id
          url
          reach
          name
          mediaType {
            id
            name
          }
        }
        totalHits
        profileDistribution {
          count
          share
          trend
          profile(pressroomId: $pressroomId) {
            id
            name
          }
        }
        geographicalImpact(sortBy: $sortBy) {
          country
          countryCode
          hits
          regions {
            hits
            region
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMediaImpactDataQuery__
 *
 * To run a query within a React component, call `useMediaImpactDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaImpactDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaImpactDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profiles: // value for 'profiles'
 *      sources: // value for 'sources'
 *      timespan: // value for 'timespan'
 *      timeRange: // value for 'timeRange'
 *      sortBy: // value for 'sortBy'
 *      time: // value for 'time'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMediaImpactDataQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables> & ({ variables: Types.MediaImpactDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables>(MediaImpactDataDocument, options);
      }
export function useMediaImpactDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables>(MediaImpactDataDocument, options);
        }
export function useMediaImpactDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables>(MediaImpactDataDocument, options);
        }
export type MediaImpactDataQueryHookResult = ReturnType<typeof useMediaImpactDataQuery>;
export type MediaImpactDataLazyQueryHookResult = ReturnType<typeof useMediaImpactDataLazyQuery>;
export type MediaImpactDataSuspenseQueryHookResult = ReturnType<typeof useMediaImpactDataSuspenseQuery>;
export type MediaImpactDataQueryResult = Apollo.QueryResult<Types.MediaImpactDataQuery, Types.MediaImpactDataQueryVariables>;
export const ReachDataDocument = gql`
    query ReachData($pressroomId: ID!, $profiles: [ID!], $sources: [MonitorMediaFilterType!], $timespan: MonitorTimespan, $timeRange: MonitorTimeRange, $sortBy: GeographicalImpactSortOrder) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      reach(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
      ) {
        total
        trend
        breakdown {
          count
          trend
          profile(pressroomId: $pressroomId) {
            id
            name
          }
        }
      }
      dashboard(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
      ) {
        geographicalImpact(sortBy: $sortBy) {
          country
          countryCode
          reach
          regions {
            reach
            region
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReachDataQuery__
 *
 * To run a query within a React component, call `useReachDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReachDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReachDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profiles: // value for 'profiles'
 *      sources: // value for 'sources'
 *      timespan: // value for 'timespan'
 *      timeRange: // value for 'timeRange'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useReachDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ReachDataQuery, Types.ReachDataQueryVariables> & ({ variables: Types.ReachDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReachDataQuery, Types.ReachDataQueryVariables>(ReachDataDocument, options);
      }
export function useReachDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReachDataQuery, Types.ReachDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReachDataQuery, Types.ReachDataQueryVariables>(ReachDataDocument, options);
        }
export function useReachDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReachDataQuery, Types.ReachDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReachDataQuery, Types.ReachDataQueryVariables>(ReachDataDocument, options);
        }
export type ReachDataQueryHookResult = ReturnType<typeof useReachDataQuery>;
export type ReachDataLazyQueryHookResult = ReturnType<typeof useReachDataLazyQuery>;
export type ReachDataSuspenseQueryHookResult = ReturnType<typeof useReachDataSuspenseQuery>;
export type ReachDataQueryResult = Apollo.QueryResult<Types.ReachDataQuery, Types.ReachDataQueryVariables>;
export const CreateMonitorSearchProfileDocument = gql`
    mutation CreateMonitorSearchProfile($input: CreateSearchProfileInput!) {
  monitorSearchProfileCreate(input: $input) {
    error {
      message
      ... on CreateSearchProfileValidationError {
        countries
        name
        booleanSearch
      }
    }
    profile2 {
      id
      name
      group {
        id
        displayName
        profiles {
          id
        }
      }
      ...BooleanSearchProfileData
    }
    monitor {
      id
      profileLimitReached
      hasSearchProfiles
      groups {
        id
        isRoot
        displayName
        profiles {
          id
          name
        }
      }
    }
  }
}
    ${BooleanSearchProfileDataFragmentDoc}`;
export type CreateMonitorSearchProfileMutationFn = Apollo.MutationFunction<Types.CreateMonitorSearchProfileMutation, Types.CreateMonitorSearchProfileMutationVariables>;

/**
 * __useCreateMonitorSearchProfileMutation__
 *
 * To run a mutation, you first call `useCreateMonitorSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitorSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitorSearchProfileMutation, { data, loading, error }] = useCreateMonitorSearchProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMonitorSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMonitorSearchProfileMutation, Types.CreateMonitorSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMonitorSearchProfileMutation, Types.CreateMonitorSearchProfileMutationVariables>(CreateMonitorSearchProfileDocument, options);
      }
export type CreateMonitorSearchProfileMutationHookResult = ReturnType<typeof useCreateMonitorSearchProfileMutation>;
export type CreateMonitorSearchProfileMutationResult = Apollo.MutationResult<Types.CreateMonitorSearchProfileMutation>;
export type CreateMonitorSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.CreateMonitorSearchProfileMutation, Types.CreateMonitorSearchProfileMutationVariables>;
export const UpdateMonitorSearchProfileDocument = gql`
    mutation UpdateMonitorSearchProfile($input: UpdateSearchProfileInput!) {
  monitorSearchProfileUpdate(input: $input) {
    error {
      message
      ... on UpdateSearchProfileValidationError {
        countries
        name
        booleanSearch
      }
    }
    profile2 {
      id
      name
      group {
        id
        displayName
      }
      ...BooleanSearchProfileData
    }
    monitor {
      id
      groups {
        id
        displayName
        profiles {
          id
        }
      }
    }
  }
}
    ${BooleanSearchProfileDataFragmentDoc}`;
export type UpdateMonitorSearchProfileMutationFn = Apollo.MutationFunction<Types.UpdateMonitorSearchProfileMutation, Types.UpdateMonitorSearchProfileMutationVariables>;

/**
 * __useUpdateMonitorSearchProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMonitorSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitorSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitorSearchProfileMutation, { data, loading, error }] = useUpdateMonitorSearchProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMonitorSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMonitorSearchProfileMutation, Types.UpdateMonitorSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMonitorSearchProfileMutation, Types.UpdateMonitorSearchProfileMutationVariables>(UpdateMonitorSearchProfileDocument, options);
      }
export type UpdateMonitorSearchProfileMutationHookResult = ReturnType<typeof useUpdateMonitorSearchProfileMutation>;
export type UpdateMonitorSearchProfileMutationResult = Apollo.MutationResult<Types.UpdateMonitorSearchProfileMutation>;
export type UpdateMonitorSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMonitorSearchProfileMutation, Types.UpdateMonitorSearchProfileMutationVariables>;
export const SearchProfilesSourceGroupFilterDocument = gql`
    query SearchProfilesSourceGroupFilter($pressroomId: ID!, $languages: [MonitorProfileLanguage!]!, $countries: [MonitorProfileCountry!]!, $name: String!, $mediaTypes: [MonitorMediaFilterType!]!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      sourceGroups2(
        countries: $countries
        languages: $languages
        name: $name
        mediaTypes: $mediaTypes
      ) {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchProfilesSourceGroupFilterQuery__
 *
 * To run a query within a React component, call `useSearchProfilesSourceGroupFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfilesSourceGroupFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfilesSourceGroupFilterQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      languages: // value for 'languages'
 *      countries: // value for 'countries'
 *      name: // value for 'name'
 *      mediaTypes: // value for 'mediaTypes'
 *   },
 * });
 */
export function useSearchProfilesSourceGroupFilterQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables> & ({ variables: Types.SearchProfilesSourceGroupFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables>(SearchProfilesSourceGroupFilterDocument, options);
      }
export function useSearchProfilesSourceGroupFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables>(SearchProfilesSourceGroupFilterDocument, options);
        }
export function useSearchProfilesSourceGroupFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables>(SearchProfilesSourceGroupFilterDocument, options);
        }
export type SearchProfilesSourceGroupFilterQueryHookResult = ReturnType<typeof useSearchProfilesSourceGroupFilterQuery>;
export type SearchProfilesSourceGroupFilterLazyQueryHookResult = ReturnType<typeof useSearchProfilesSourceGroupFilterLazyQuery>;
export type SearchProfilesSourceGroupFilterSuspenseQueryHookResult = ReturnType<typeof useSearchProfilesSourceGroupFilterSuspenseQuery>;
export type SearchProfilesSourceGroupFilterQueryResult = Apollo.QueryResult<Types.SearchProfilesSourceGroupFilterQuery, Types.SearchProfilesSourceGroupFilterQueryVariables>;
export const SearchProfileDataDocument = gql`
    query SearchProfileData($pressroomId: ID!, $profileId: ID!, $skipProfile: Boolean!) {
  me {
    id
    viewAsAdmin
  }
  pressroom(id: $pressroomId) {
    id
    features {
      id
      monitorSocialMedia
    }
    monitor {
      id
      profileLimitReached
      groups {
        id
        isRoot
        displayName
        isDeprecated
      }
      socialMediaSources {
        label
        value
      }
      profileMediaTypes2 {
        id
        name
      }
      languages {
        id
        label
        value
      }
      countries {
        id
        label
        value
      }
      defaultCountries
      defaultLanguages
      countriesByRegionGroups {
        id
        ...CountriesByRegionGroups
      }
      profile: searchProfile(id: $profileId) @skip(if: $skipProfile) {
        id
        ...MonitorSearchProfile
        ...BooleanSearchProfileData
      }
    }
  }
}
    ${CountriesByRegionGroupsFragmentDoc}
${MonitorSearchProfileFragmentDoc}
${BooleanSearchProfileDataFragmentDoc}`;

/**
 * __useSearchProfileDataQuery__
 *
 * To run a query within a React component, call `useSearchProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfileDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profileId: // value for 'profileId'
 *      skipProfile: // value for 'skipProfile'
 *   },
 * });
 */
export function useSearchProfileDataQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables> & ({ variables: Types.SearchProfileDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables>(SearchProfileDataDocument, options);
      }
export function useSearchProfileDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables>(SearchProfileDataDocument, options);
        }
export function useSearchProfileDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables>(SearchProfileDataDocument, options);
        }
export type SearchProfileDataQueryHookResult = ReturnType<typeof useSearchProfileDataQuery>;
export type SearchProfileDataLazyQueryHookResult = ReturnType<typeof useSearchProfileDataLazyQuery>;
export type SearchProfileDataSuspenseQueryHookResult = ReturnType<typeof useSearchProfileDataSuspenseQuery>;
export type SearchProfileDataQueryResult = Apollo.QueryResult<Types.SearchProfileDataQuery, Types.SearchProfileDataQueryVariables>;
export const TestSearchDocument = gql`
    query TestSearch($pressroomId: ID!, $sourceSelection: SourceSelection!, $searchSpec: SearchProfileKeywordsInput!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      testSearch: testSearch2(
        sourceSelection: $sourceSelection
        searchSpec: $searchSpec
      ) {
        valid
        tooBroad
        hits2 {
          id
          ...TestSearchHit
        }
      }
    }
  }
}
    ${TestSearchHitFragmentDoc}`;

/**
 * __useTestSearchQuery__
 *
 * To run a query within a React component, call `useTestSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestSearchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      sourceSelection: // value for 'sourceSelection'
 *      searchSpec: // value for 'searchSpec'
 *   },
 * });
 */
export function useTestSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.TestSearchQuery, Types.TestSearchQueryVariables> & ({ variables: Types.TestSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TestSearchQuery, Types.TestSearchQueryVariables>(TestSearchDocument, options);
      }
export function useTestSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TestSearchQuery, Types.TestSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TestSearchQuery, Types.TestSearchQueryVariables>(TestSearchDocument, options);
        }
export function useTestSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TestSearchQuery, Types.TestSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TestSearchQuery, Types.TestSearchQueryVariables>(TestSearchDocument, options);
        }
export type TestSearchQueryHookResult = ReturnType<typeof useTestSearchQuery>;
export type TestSearchLazyQueryHookResult = ReturnType<typeof useTestSearchLazyQuery>;
export type TestSearchSuspenseQueryHookResult = ReturnType<typeof useTestSearchSuspenseQuery>;
export type TestSearchQueryResult = Apollo.QueryResult<Types.TestSearchQuery, Types.TestSearchQueryVariables>;
export const DeleteMonitorSearchProfileGroupDocument = gql`
    mutation DeleteMonitorSearchProfileGroup($pressroomId: ID!, $profileId: ID!) {
  monitorSearchGroupDelete(input: {pressroomId: $pressroomId, id: $profileId}) {
    error {
      message
    }
    profileGroupId
    monitor {
      id
      profileLimitReached
      groups {
        id
        name
        profiles {
          id
        }
      }
    }
  }
}
    `;
export type DeleteMonitorSearchProfileGroupMutationFn = Apollo.MutationFunction<Types.DeleteMonitorSearchProfileGroupMutation, Types.DeleteMonitorSearchProfileGroupMutationVariables>;

/**
 * __useDeleteMonitorSearchProfileGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMonitorSearchProfileGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMonitorSearchProfileGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMonitorSearchProfileGroupMutation, { data, loading, error }] = useDeleteMonitorSearchProfileGroupMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useDeleteMonitorSearchProfileGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMonitorSearchProfileGroupMutation, Types.DeleteMonitorSearchProfileGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMonitorSearchProfileGroupMutation, Types.DeleteMonitorSearchProfileGroupMutationVariables>(DeleteMonitorSearchProfileGroupDocument, options);
      }
export type DeleteMonitorSearchProfileGroupMutationHookResult = ReturnType<typeof useDeleteMonitorSearchProfileGroupMutation>;
export type DeleteMonitorSearchProfileGroupMutationResult = Apollo.MutationResult<Types.DeleteMonitorSearchProfileGroupMutation>;
export type DeleteMonitorSearchProfileGroupMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMonitorSearchProfileGroupMutation, Types.DeleteMonitorSearchProfileGroupMutationVariables>;
export const DeleteMonitorSearchProfileDocument = gql`
    mutation DeleteMonitorSearchProfile($pressroomId: ID!, $profileId: ID!) {
  monitorSearchProfileDelete(input: {pressroomId: $pressroomId, id: $profileId}) {
    error {
      message
    }
    profileId
    profileType
    monitor {
      id
      profileLimitReached
      groups {
        id
        name
        profiles {
          id
        }
      }
    }
  }
}
    `;
export type DeleteMonitorSearchProfileMutationFn = Apollo.MutationFunction<Types.DeleteMonitorSearchProfileMutation, Types.DeleteMonitorSearchProfileMutationVariables>;

/**
 * __useDeleteMonitorSearchProfileMutation__
 *
 * To run a mutation, you first call `useDeleteMonitorSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMonitorSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMonitorSearchProfileMutation, { data, loading, error }] = useDeleteMonitorSearchProfileMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useDeleteMonitorSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMonitorSearchProfileMutation, Types.DeleteMonitorSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMonitorSearchProfileMutation, Types.DeleteMonitorSearchProfileMutationVariables>(DeleteMonitorSearchProfileDocument, options);
      }
export type DeleteMonitorSearchProfileMutationHookResult = ReturnType<typeof useDeleteMonitorSearchProfileMutation>;
export type DeleteMonitorSearchProfileMutationResult = Apollo.MutationResult<Types.DeleteMonitorSearchProfileMutation>;
export type DeleteMonitorSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMonitorSearchProfileMutation, Types.DeleteMonitorSearchProfileMutationVariables>;
export const CreateMonitorSearchGroupDocument = gql`
    mutation CreateMonitorSearchGroup($pressroomId: ID!, $name: String!) {
  monitorSearchGroupCreateOrUpdate(
    input: {pressroomId: $pressroomId, name: $name}
  ) {
    error {
      message
      ... on CreateOrUpdateSearchGroupValidationError {
        name
      }
    }
    group {
      id
      name
      profiles {
        id
      }
    }
    monitor {
      id
      groups {
        id
        name
        profiles {
          id
        }
      }
    }
  }
}
    `;
export type CreateMonitorSearchGroupMutationFn = Apollo.MutationFunction<Types.CreateMonitorSearchGroupMutation, Types.CreateMonitorSearchGroupMutationVariables>;

/**
 * __useCreateMonitorSearchGroupMutation__
 *
 * To run a mutation, you first call `useCreateMonitorSearchGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitorSearchGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitorSearchGroupMutation, { data, loading, error }] = useCreateMonitorSearchGroupMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateMonitorSearchGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMonitorSearchGroupMutation, Types.CreateMonitorSearchGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMonitorSearchGroupMutation, Types.CreateMonitorSearchGroupMutationVariables>(CreateMonitorSearchGroupDocument, options);
      }
export type CreateMonitorSearchGroupMutationHookResult = ReturnType<typeof useCreateMonitorSearchGroupMutation>;
export type CreateMonitorSearchGroupMutationResult = Apollo.MutationResult<Types.CreateMonitorSearchGroupMutation>;
export type CreateMonitorSearchGroupMutationOptions = Apollo.BaseMutationOptions<Types.CreateMonitorSearchGroupMutation, Types.CreateMonitorSearchGroupMutationVariables>;
export const UpdateMonitorSearchGroupDocument = gql`
    mutation UpdateMonitorSearchGroup($pressroomId: ID!, $name: String!, $id: ID!) {
  monitorSearchGroupCreateOrUpdate(
    input: {pressroomId: $pressroomId, name: $name, id: $id}
  ) {
    error {
      message
      ... on CreateOrUpdateSearchGroupValidationError {
        name
      }
    }
    monitor {
      id
      groups {
        id
        name
      }
    }
  }
}
    `;
export type UpdateMonitorSearchGroupMutationFn = Apollo.MutationFunction<Types.UpdateMonitorSearchGroupMutation, Types.UpdateMonitorSearchGroupMutationVariables>;

/**
 * __useUpdateMonitorSearchGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMonitorSearchGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitorSearchGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitorSearchGroupMutation, { data, loading, error }] = useUpdateMonitorSearchGroupMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMonitorSearchGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMonitorSearchGroupMutation, Types.UpdateMonitorSearchGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMonitorSearchGroupMutation, Types.UpdateMonitorSearchGroupMutationVariables>(UpdateMonitorSearchGroupDocument, options);
      }
export type UpdateMonitorSearchGroupMutationHookResult = ReturnType<typeof useUpdateMonitorSearchGroupMutation>;
export type UpdateMonitorSearchGroupMutationResult = Apollo.MutationResult<Types.UpdateMonitorSearchGroupMutation>;
export type UpdateMonitorSearchGroupMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMonitorSearchGroupMutation, Types.UpdateMonitorSearchGroupMutationVariables>;
export const MoveToGroupMonitorSearchProfileDocument = gql`
    mutation MoveToGroupMonitorSearchProfile($pressroomId: ID!, $groupId: ID!, $profileId: ID!) {
  monitorSearchProfileMoveToGroup(
    input: {pressroomId: $pressroomId, groupId: $groupId, profileId: $profileId}
  ) {
    error {
      message
    }
    groups {
      id
      name
      isRoot
      profiles {
        id
        name
      }
    }
  }
}
    `;
export type MoveToGroupMonitorSearchProfileMutationFn = Apollo.MutationFunction<Types.MoveToGroupMonitorSearchProfileMutation, Types.MoveToGroupMonitorSearchProfileMutationVariables>;

/**
 * __useMoveToGroupMonitorSearchProfileMutation__
 *
 * To run a mutation, you first call `useMoveToGroupMonitorSearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveToGroupMonitorSearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveToGroupMonitorSearchProfileMutation, { data, loading, error }] = useMoveToGroupMonitorSearchProfileMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      groupId: // value for 'groupId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useMoveToGroupMonitorSearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveToGroupMonitorSearchProfileMutation, Types.MoveToGroupMonitorSearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveToGroupMonitorSearchProfileMutation, Types.MoveToGroupMonitorSearchProfileMutationVariables>(MoveToGroupMonitorSearchProfileDocument, options);
      }
export type MoveToGroupMonitorSearchProfileMutationHookResult = ReturnType<typeof useMoveToGroupMonitorSearchProfileMutation>;
export type MoveToGroupMonitorSearchProfileMutationResult = Apollo.MutationResult<Types.MoveToGroupMonitorSearchProfileMutation>;
export type MoveToGroupMonitorSearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.MoveToGroupMonitorSearchProfileMutation, Types.MoveToGroupMonitorSearchProfileMutationVariables>;
export const SearchProfilesListDataDocument = gql`
    query SearchProfilesListData($pressroomId: ID!) {
  me {
    id
    viewAsAdmin
  }
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      profileLimitReached
      groups {
        id
        ...GroupData
      }
    }
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useSearchProfilesListDataQuery__
 *
 * To run a query within a React component, call `useSearchProfilesListDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfilesListDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfilesListDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSearchProfilesListDataQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables> & ({ variables: Types.SearchProfilesListDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables>(SearchProfilesListDataDocument, options);
      }
export function useSearchProfilesListDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables>(SearchProfilesListDataDocument, options);
        }
export function useSearchProfilesListDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables>(SearchProfilesListDataDocument, options);
        }
export type SearchProfilesListDataQueryHookResult = ReturnType<typeof useSearchProfilesListDataQuery>;
export type SearchProfilesListDataLazyQueryHookResult = ReturnType<typeof useSearchProfilesListDataLazyQuery>;
export type SearchProfilesListDataSuspenseQueryHookResult = ReturnType<typeof useSearchProfilesListDataSuspenseQuery>;
export type SearchProfilesListDataQueryResult = Apollo.QueryResult<Types.SearchProfilesListDataQuery, Types.SearchProfilesListDataQueryVariables>;
export const CopySearchProfileDocument = gql`
    mutation CopySearchProfile($input: CopySearchProfileInput!) {
  monitorSearchProfileCopy(input: $input) {
    searchProfile {
      id
    }
    error {
      message
      __typename
    }
  }
}
    `;
export type CopySearchProfileMutationFn = Apollo.MutationFunction<Types.CopySearchProfileMutation, Types.CopySearchProfileMutationVariables>;

/**
 * __useCopySearchProfileMutation__
 *
 * To run a mutation, you first call `useCopySearchProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopySearchProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copySearchProfileMutation, { data, loading, error }] = useCopySearchProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopySearchProfileMutation(baseOptions?: Apollo.MutationHookOptions<Types.CopySearchProfileMutation, Types.CopySearchProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CopySearchProfileMutation, Types.CopySearchProfileMutationVariables>(CopySearchProfileDocument, options);
      }
export type CopySearchProfileMutationHookResult = ReturnType<typeof useCopySearchProfileMutation>;
export type CopySearchProfileMutationResult = Apollo.MutationResult<Types.CopySearchProfileMutation>;
export type CopySearchProfileMutationOptions = Apollo.BaseMutationOptions<Types.CopySearchProfileMutation, Types.CopySearchProfileMutationVariables>;
export const AiGeneratedNewsroomSettingsDocument = gql`
    query AiGeneratedNewsroomSettings($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    newsroomSettings {
      id
      ...AiNewsroomSettings
    }
  }
}
    ${AiNewsroomSettingsFragmentDoc}`;

/**
 * __useAiGeneratedNewsroomSettingsQuery__
 *
 * To run a query within a React component, call `useAiGeneratedNewsroomSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGeneratedNewsroomSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGeneratedNewsroomSettingsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useAiGeneratedNewsroomSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables> & ({ variables: Types.AiGeneratedNewsroomSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables>(AiGeneratedNewsroomSettingsDocument, options);
      }
export function useAiGeneratedNewsroomSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables>(AiGeneratedNewsroomSettingsDocument, options);
        }
export function useAiGeneratedNewsroomSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables>(AiGeneratedNewsroomSettingsDocument, options);
        }
export type AiGeneratedNewsroomSettingsQueryHookResult = ReturnType<typeof useAiGeneratedNewsroomSettingsQuery>;
export type AiGeneratedNewsroomSettingsLazyQueryHookResult = ReturnType<typeof useAiGeneratedNewsroomSettingsLazyQuery>;
export type AiGeneratedNewsroomSettingsSuspenseQueryHookResult = ReturnType<typeof useAiGeneratedNewsroomSettingsSuspenseQuery>;
export type AiGeneratedNewsroomSettingsQueryResult = Apollo.QueryResult<Types.AiGeneratedNewsroomSettingsQuery, Types.AiGeneratedNewsroomSettingsQueryVariables>;
export const UpdateBrandingStylesDocument = gql`
    mutation updateBrandingStyles($pressroomId: ID!, $logotype: ResourceImageInput, $deleteLogotype: Boolean, $primaryBrandColor: String, $secondaryBrandColor: String) {
  newsroomSettingsUpdate(
    input: {newsroomId: $pressroomId, logotype: $logotype, deleteLogotype: $deleteLogotype, primaryBrandColor: $primaryBrandColor, secondaryBrandColor: $secondaryBrandColor}
  ) {
    error {
      message
      ... on NewsroomSettingsUpdateValidationError {
        primaryBrandColor
        secondaryBrandColor
        logotype {
          fileFormat
          name
        }
      }
    }
    newsroomSettings {
      id
      newsroomStyle {
        ...Branding
      }
    }
  }
}
    ${BrandingFragmentDoc}`;
export type UpdateBrandingStylesMutationFn = Apollo.MutationFunction<Types.UpdateBrandingStylesMutation, Types.UpdateBrandingStylesMutationVariables>;

/**
 * __useUpdateBrandingStylesMutation__
 *
 * To run a mutation, you first call `useUpdateBrandingStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandingStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandingStylesMutation, { data, loading, error }] = useUpdateBrandingStylesMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      logotype: // value for 'logotype'
 *      deleteLogotype: // value for 'deleteLogotype'
 *      primaryBrandColor: // value for 'primaryBrandColor'
 *      secondaryBrandColor: // value for 'secondaryBrandColor'
 *   },
 * });
 */
export function useUpdateBrandingStylesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBrandingStylesMutation, Types.UpdateBrandingStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBrandingStylesMutation, Types.UpdateBrandingStylesMutationVariables>(UpdateBrandingStylesDocument, options);
      }
export type UpdateBrandingStylesMutationHookResult = ReturnType<typeof useUpdateBrandingStylesMutation>;
export type UpdateBrandingStylesMutationResult = Apollo.MutationResult<Types.UpdateBrandingStylesMutation>;
export type UpdateBrandingStylesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBrandingStylesMutation, Types.UpdateBrandingStylesMutationVariables>;
export const PreviewBrandingStylesDocument = gql`
    mutation previewBrandingStyles($newsroomId: ID!, $primaryBrandColor: String, $secondaryBrandColor: String, $logotype: ResourceImageInput, $deleteLogotype: Boolean) {
  newsroomStylePreviewUpdate(
    input: {newsroomId: $newsroomId, primaryBrandColor: $primaryBrandColor, secondaryBrandColor: $secondaryBrandColor, logotype: $logotype, deleteLogotype: $deleteLogotype}
  ) {
    newsroomStyle {
      ...Branding
    }
    pressroom {
      id
      newsroomUrl
    }
  }
}
    ${BrandingFragmentDoc}`;
export type PreviewBrandingStylesMutationFn = Apollo.MutationFunction<Types.PreviewBrandingStylesMutation, Types.PreviewBrandingStylesMutationVariables>;

/**
 * __usePreviewBrandingStylesMutation__
 *
 * To run a mutation, you first call `usePreviewBrandingStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewBrandingStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewBrandingStylesMutation, { data, loading, error }] = usePreviewBrandingStylesMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      primaryBrandColor: // value for 'primaryBrandColor'
 *      secondaryBrandColor: // value for 'secondaryBrandColor'
 *      logotype: // value for 'logotype'
 *      deleteLogotype: // value for 'deleteLogotype'
 *   },
 * });
 */
export function usePreviewBrandingStylesMutation(baseOptions?: Apollo.MutationHookOptions<Types.PreviewBrandingStylesMutation, Types.PreviewBrandingStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PreviewBrandingStylesMutation, Types.PreviewBrandingStylesMutationVariables>(PreviewBrandingStylesDocument, options);
      }
export type PreviewBrandingStylesMutationHookResult = ReturnType<typeof usePreviewBrandingStylesMutation>;
export type PreviewBrandingStylesMutationResult = Apollo.MutationResult<Types.PreviewBrandingStylesMutation>;
export type PreviewBrandingStylesMutationOptions = Apollo.BaseMutationOptions<Types.PreviewBrandingStylesMutation, Types.PreviewBrandingStylesMutationVariables>;
export const UpdateCompanyDescriptionOnboardingDocument = gql`
    mutation UpdateCompanyDescriptionOnboarding($newsroomId: ID!, $tagline: String, $companyDescription: String) {
  newsroomSettingsUpdate(
    input: {newsroomId: $newsroomId, tagline: $tagline, companyDescription: $companyDescription}
  ) {
    error {
      ... on NewsroomSettingsUpdateValidationError {
        companyDescription
        tagline
      }
    }
    newsroomSettings {
      id
      ...CompanyDescription
    }
  }
}
    ${CompanyDescriptionFragmentDoc}`;
export type UpdateCompanyDescriptionOnboardingMutationFn = Apollo.MutationFunction<Types.UpdateCompanyDescriptionOnboardingMutation, Types.UpdateCompanyDescriptionOnboardingMutationVariables>;

/**
 * __useUpdateCompanyDescriptionOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDescriptionOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDescriptionOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDescriptionOnboardingMutation, { data, loading, error }] = useUpdateCompanyDescriptionOnboardingMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      tagline: // value for 'tagline'
 *      companyDescription: // value for 'companyDescription'
 *   },
 * });
 */
export function useUpdateCompanyDescriptionOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCompanyDescriptionOnboardingMutation, Types.UpdateCompanyDescriptionOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCompanyDescriptionOnboardingMutation, Types.UpdateCompanyDescriptionOnboardingMutationVariables>(UpdateCompanyDescriptionOnboardingDocument, options);
      }
export type UpdateCompanyDescriptionOnboardingMutationHookResult = ReturnType<typeof useUpdateCompanyDescriptionOnboardingMutation>;
export type UpdateCompanyDescriptionOnboardingMutationResult = Apollo.MutationResult<Types.UpdateCompanyDescriptionOnboardingMutation>;
export type UpdateCompanyDescriptionOnboardingMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCompanyDescriptionOnboardingMutation, Types.UpdateCompanyDescriptionOnboardingMutationVariables>;
export const UpdateCompanyInformationOnboardingDocument = gql`
    mutation UpdateCompanyInformationOnboarding($newsroomId: ID!, $companyName: String, $street: String, $postalCode: String, $city: String, $country: String) {
  newsroomSettingsUpdate(
    input: {newsroomId: $newsroomId, companyName: $companyName, street: $street, postalCode: $postalCode, city: $city, country: $country}
  ) {
    error {
      ... on NewsroomSettingsUpdateValidationError {
        companyName
        street
        postalCode
        city
        country
      }
    }
    newsroomSettings {
      id
      ...CompanyInfo
    }
  }
}
    ${CompanyInfoFragmentDoc}`;
export type UpdateCompanyInformationOnboardingMutationFn = Apollo.MutationFunction<Types.UpdateCompanyInformationOnboardingMutation, Types.UpdateCompanyInformationOnboardingMutationVariables>;

/**
 * __useUpdateCompanyInformationOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyInformationOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyInformationOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyInformationOnboardingMutation, { data, loading, error }] = useUpdateCompanyInformationOnboardingMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      companyName: // value for 'companyName'
 *      street: // value for 'street'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useUpdateCompanyInformationOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCompanyInformationOnboardingMutation, Types.UpdateCompanyInformationOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCompanyInformationOnboardingMutation, Types.UpdateCompanyInformationOnboardingMutationVariables>(UpdateCompanyInformationOnboardingDocument, options);
      }
export type UpdateCompanyInformationOnboardingMutationHookResult = ReturnType<typeof useUpdateCompanyInformationOnboardingMutation>;
export type UpdateCompanyInformationOnboardingMutationResult = Apollo.MutationResult<Types.UpdateCompanyInformationOnboardingMutation>;
export type UpdateCompanyInformationOnboardingMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCompanyInformationOnboardingMutation, Types.UpdateCompanyInformationOnboardingMutationVariables>;
export const SeenOnboardingWizardFromFooterDocument = gql`
    mutation seenOnboardingWizardFromFooter($pressroomId: ID!) {
  noticeConfirm(input: {notice: onboardingWizard, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      onboardingWizard
    }
    pressroom {
      id
      dashboard {
        id
        ... on AccountVerificationPending {
          id
          user {
            id
            locale2
          }
        }
      }
    }
  }
}
    `;
export type SeenOnboardingWizardFromFooterMutationFn = Apollo.MutationFunction<Types.SeenOnboardingWizardFromFooterMutation, Types.SeenOnboardingWizardFromFooterMutationVariables>;

/**
 * __useSeenOnboardingWizardFromFooterMutation__
 *
 * To run a mutation, you first call `useSeenOnboardingWizardFromFooterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenOnboardingWizardFromFooterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenOnboardingWizardFromFooterMutation, { data, loading, error }] = useSeenOnboardingWizardFromFooterMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSeenOnboardingWizardFromFooterMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenOnboardingWizardFromFooterMutation, Types.SeenOnboardingWizardFromFooterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenOnboardingWizardFromFooterMutation, Types.SeenOnboardingWizardFromFooterMutationVariables>(SeenOnboardingWizardFromFooterDocument, options);
      }
export type SeenOnboardingWizardFromFooterMutationHookResult = ReturnType<typeof useSeenOnboardingWizardFromFooterMutation>;
export type SeenOnboardingWizardFromFooterMutationResult = Apollo.MutationResult<Types.SeenOnboardingWizardFromFooterMutation>;
export type SeenOnboardingWizardFromFooterMutationOptions = Apollo.BaseMutationOptions<Types.SeenOnboardingWizardFromFooterMutation, Types.SeenOnboardingWizardFromFooterMutationVariables>;
export const SeenOnboardingWizardDocument = gql`
    mutation seenOnboardingWizard($pressroomId: ID!) {
  noticeConfirm(input: {notice: onboardingWizard, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      onboardingWizard
    }
    pressroom {
      id
      dashboard {
        id
      }
    }
  }
}
    `;
export type SeenOnboardingWizardMutationFn = Apollo.MutationFunction<Types.SeenOnboardingWizardMutation, Types.SeenOnboardingWizardMutationVariables>;

/**
 * __useSeenOnboardingWizardMutation__
 *
 * To run a mutation, you first call `useSeenOnboardingWizardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenOnboardingWizardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenOnboardingWizardMutation, { data, loading, error }] = useSeenOnboardingWizardMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSeenOnboardingWizardMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenOnboardingWizardMutation, Types.SeenOnboardingWizardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenOnboardingWizardMutation, Types.SeenOnboardingWizardMutationVariables>(SeenOnboardingWizardDocument, options);
      }
export type SeenOnboardingWizardMutationHookResult = ReturnType<typeof useSeenOnboardingWizardMutation>;
export type SeenOnboardingWizardMutationResult = Apollo.MutationResult<Types.SeenOnboardingWizardMutation>;
export type SeenOnboardingWizardMutationOptions = Apollo.BaseMutationOptions<Types.SeenOnboardingWizardMutation, Types.SeenOnboardingWizardMutationVariables>;
export const GoLiveDocument = gql`
    mutation goLive($id: ID!) {
  pressroomGoLive(input: {id: $id}) {
    pressroom {
      id
      livePublicationCount
      ...NotLivePressroom
    }
    user {
      id
      onboarding(pressroomId: $id) {
        id
        completed
      }
    }
    error {
      message
    }
  }
}
    ${NotLivePressroomFragmentDoc}`;
export type GoLiveMutationFn = Apollo.MutationFunction<Types.GoLiveMutation, Types.GoLiveMutationVariables>;

/**
 * __useGoLiveMutation__
 *
 * To run a mutation, you first call `useGoLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [goLiveMutation, { data, loading, error }] = useGoLiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoLiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.GoLiveMutation, Types.GoLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GoLiveMutation, Types.GoLiveMutationVariables>(GoLiveDocument, options);
      }
export type GoLiveMutationHookResult = ReturnType<typeof useGoLiveMutation>;
export type GoLiveMutationResult = Apollo.MutationResult<Types.GoLiveMutation>;
export type GoLiveMutationOptions = Apollo.BaseMutationOptions<Types.GoLiveMutation, Types.GoLiveMutationVariables>;
export const CreateContactPersonOnboardingDocument = gql`
    mutation createContactPersonOnboarding($pressroomId: ID!, $id: ID, $name: String!, $title: String!, $email: String!, $phone: String, $resourceImageId: ID) {
  contactPersonUpdate(
    input: {pressroomId: $pressroomId, id: $id, name: $name, title: $title, email: $email, phone: $phone, resourceImageId: $resourceImageId, showAsPressroomContact: true, publiclyVisible: true}
  ) {
    pressroom {
      id
      ...PressContact
    }
    error {
      message
      ... on ContactPersonUpdateValidationError {
        name
        email
      }
    }
  }
}
    ${PressContactFragmentDoc}`;
export type CreateContactPersonOnboardingMutationFn = Apollo.MutationFunction<Types.CreateContactPersonOnboardingMutation, Types.CreateContactPersonOnboardingMutationVariables>;

/**
 * __useCreateContactPersonOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateContactPersonOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactPersonOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactPersonOnboardingMutation, { data, loading, error }] = useCreateContactPersonOnboardingMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      title: // value for 'title'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      resourceImageId: // value for 'resourceImageId'
 *   },
 * });
 */
export function useCreateContactPersonOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateContactPersonOnboardingMutation, Types.CreateContactPersonOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateContactPersonOnboardingMutation, Types.CreateContactPersonOnboardingMutationVariables>(CreateContactPersonOnboardingDocument, options);
      }
export type CreateContactPersonOnboardingMutationHookResult = ReturnType<typeof useCreateContactPersonOnboardingMutation>;
export type CreateContactPersonOnboardingMutationResult = Apollo.MutationResult<Types.CreateContactPersonOnboardingMutation>;
export type CreateContactPersonOnboardingMutationOptions = Apollo.BaseMutationOptions<Types.CreateContactPersonOnboardingMutation, Types.CreateContactPersonOnboardingMutationVariables>;
export const PendingSourceUpdateDocument = gql`
    mutation PendingSourceUpdate($input: PendingSourceUpdateInput!) {
  pendingSourceUpdate(input: $input) {
    pendingSource {
      id
      ...PendingSource
    }
    error {
      message
      ... on PendingSourceUpdateValidationError {
        brandUrl
        brandName
        competitorBrandName
        competitorBrandUrl
      }
    }
  }
}
    ${PendingSourceFragmentDoc}`;
export type PendingSourceUpdateMutationFn = Apollo.MutationFunction<Types.PendingSourceUpdateMutation, Types.PendingSourceUpdateMutationVariables>;

/**
 * __usePendingSourceUpdateMutation__
 *
 * To run a mutation, you first call `usePendingSourceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingSourceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingSourceUpdateMutation, { data, loading, error }] = usePendingSourceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePendingSourceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.PendingSourceUpdateMutation, Types.PendingSourceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PendingSourceUpdateMutation, Types.PendingSourceUpdateMutationVariables>(PendingSourceUpdateDocument, options);
      }
export type PendingSourceUpdateMutationHookResult = ReturnType<typeof usePendingSourceUpdateMutation>;
export type PendingSourceUpdateMutationResult = Apollo.MutationResult<Types.PendingSourceUpdateMutation>;
export type PendingSourceUpdateMutationOptions = Apollo.BaseMutationOptions<Types.PendingSourceUpdateMutation, Types.PendingSourceUpdateMutationVariables>;
export const PendingSourceCreateSourceDocument = gql`
    mutation PendingSourceCreateSource($id: ID!) {
  pendingSourceCreateSource(input: {id: $id}) {
    pressroom {
      id
    }
    error {
      message
    }
  }
}
    `;
export type PendingSourceCreateSourceMutationFn = Apollo.MutationFunction<Types.PendingSourceCreateSourceMutation, Types.PendingSourceCreateSourceMutationVariables>;

/**
 * __usePendingSourceCreateSourceMutation__
 *
 * To run a mutation, you first call `usePendingSourceCreateSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingSourceCreateSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingSourceCreateSourceMutation, { data, loading, error }] = usePendingSourceCreateSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingSourceCreateSourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.PendingSourceCreateSourceMutation, Types.PendingSourceCreateSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PendingSourceCreateSourceMutation, Types.PendingSourceCreateSourceMutationVariables>(PendingSourceCreateSourceDocument, options);
      }
export type PendingSourceCreateSourceMutationHookResult = ReturnType<typeof usePendingSourceCreateSourceMutation>;
export type PendingSourceCreateSourceMutationResult = Apollo.MutationResult<Types.PendingSourceCreateSourceMutation>;
export type PendingSourceCreateSourceMutationOptions = Apollo.BaseMutationOptions<Types.PendingSourceCreateSourceMutation, Types.PendingSourceCreateSourceMutationVariables>;
export const PendingSourceDocument = gql`
    query PendingSource($id: ID!) {
  me {
    id
    pendingSource(id: $id) {
      id
      ...PendingSource
    }
  }
}
    ${PendingSourceFragmentDoc}`;

/**
 * __usePendingSourceQuery__
 *
 * To run a query within a React component, call `usePendingSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingSourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingSourceQuery(baseOptions: Apollo.QueryHookOptions<Types.PendingSourceQuery, Types.PendingSourceQueryVariables> & ({ variables: Types.PendingSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PendingSourceQuery, Types.PendingSourceQueryVariables>(PendingSourceDocument, options);
      }
export function usePendingSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PendingSourceQuery, Types.PendingSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PendingSourceQuery, Types.PendingSourceQueryVariables>(PendingSourceDocument, options);
        }
export function usePendingSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PendingSourceQuery, Types.PendingSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PendingSourceQuery, Types.PendingSourceQueryVariables>(PendingSourceDocument, options);
        }
export type PendingSourceQueryHookResult = ReturnType<typeof usePendingSourceQuery>;
export type PendingSourceLazyQueryHookResult = ReturnType<typeof usePendingSourceLazyQuery>;
export type PendingSourceSuspenseQueryHookResult = ReturnType<typeof usePendingSourceSuspenseQuery>;
export type PendingSourceQueryResult = Apollo.QueryResult<Types.PendingSourceQuery, Types.PendingSourceQueryVariables>;
export const PitchDeleteDocument = gql`
    mutation PitchDelete($input: PitchDeleteInput!) {
  pitchDelete(input: $input) {
    error {
      message
    }
    deletedId
  }
}
    `;
export type PitchDeleteMutationFn = Apollo.MutationFunction<Types.PitchDeleteMutation, Types.PitchDeleteMutationVariables>;

/**
 * __usePitchDeleteMutation__
 *
 * To run a mutation, you first call `usePitchDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePitchDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pitchDeleteMutation, { data, loading, error }] = usePitchDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePitchDeleteMutation(baseOptions?: Apollo.MutationHookOptions<Types.PitchDeleteMutation, Types.PitchDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PitchDeleteMutation, Types.PitchDeleteMutationVariables>(PitchDeleteDocument, options);
      }
export type PitchDeleteMutationHookResult = ReturnType<typeof usePitchDeleteMutation>;
export type PitchDeleteMutationResult = Apollo.MutationResult<Types.PitchDeleteMutation>;
export type PitchDeleteMutationOptions = Apollo.BaseMutationOptions<Types.PitchDeleteMutation, Types.PitchDeleteMutationVariables>;
export const PitchUpdateDocument = gql`
    mutation PitchUpdate($pressroomId: ID!, $id: ID, $body: String, $subject: String, $to: PitchToInput, $from: String, $attachment: MaterialIdTuple, $replyTo: String) {
  pitchUpdate(
    input: {pressroomId: $pressroomId, id: $id, body: $body, subject: $subject, to: $to, from: $from, attachment: $attachment, replyTo: $replyTo}
  ) {
    error {
      message
    }
    pitch {
      id
      from
      replyTo
      to {
        ...PitchToFragment
      }
      subject
      body
      previewBody
      sentAt
      sentBy
      attachment {
        id
        header
        publicUrl(allowDraft: true)
      }
    }
  }
}
    ${PitchToFragmentFragmentDoc}`;
export type PitchUpdateMutationFn = Apollo.MutationFunction<Types.PitchUpdateMutation, Types.PitchUpdateMutationVariables>;

/**
 * __usePitchUpdateMutation__
 *
 * To run a mutation, you first call `usePitchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePitchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pitchUpdateMutation, { data, loading, error }] = usePitchUpdateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      body: // value for 'body'
 *      subject: // value for 'subject'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      attachment: // value for 'attachment'
 *      replyTo: // value for 'replyTo'
 *   },
 * });
 */
export function usePitchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.PitchUpdateMutation, Types.PitchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PitchUpdateMutation, Types.PitchUpdateMutationVariables>(PitchUpdateDocument, options);
      }
export type PitchUpdateMutationHookResult = ReturnType<typeof usePitchUpdateMutation>;
export type PitchUpdateMutationResult = Apollo.MutationResult<Types.PitchUpdateMutation>;
export type PitchUpdateMutationOptions = Apollo.BaseMutationOptions<Types.PitchUpdateMutation, Types.PitchUpdateMutationVariables>;
export const PitchSendDocument = gql`
    mutation PitchSend($pitchId: ID!) {
  pitchSend(input: {pitchId: $pitchId}) {
    error {
      message
    }
    pitch {
      id
      sentAt
      sentBy
      state {
        timestamp
      }
    }
  }
}
    `;
export type PitchSendMutationFn = Apollo.MutationFunction<Types.PitchSendMutation, Types.PitchSendMutationVariables>;

/**
 * __usePitchSendMutation__
 *
 * To run a mutation, you first call `usePitchSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePitchSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pitchSendMutation, { data, loading, error }] = usePitchSendMutation({
 *   variables: {
 *      pitchId: // value for 'pitchId'
 *   },
 * });
 */
export function usePitchSendMutation(baseOptions?: Apollo.MutationHookOptions<Types.PitchSendMutation, Types.PitchSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PitchSendMutation, Types.PitchSendMutationVariables>(PitchSendDocument, options);
      }
export type PitchSendMutationHookResult = ReturnType<typeof usePitchSendMutation>;
export type PitchSendMutationResult = Apollo.MutationResult<Types.PitchSendMutation>;
export type PitchSendMutationOptions = Apollo.BaseMutationOptions<Types.PitchSendMutation, Types.PitchSendMutationVariables>;
export const PitchMetadataDocument = gql`
    query PitchMetadata($pressroomId: ID!, $contactId: ID!, $includeContact: Boolean!, $mndReachJournalistId: ID!, $includeMndReachJournalist: Boolean!, $attachmentId: ID!, $attachmentType: MaterialType!, $includeAttachment: Boolean!) {
  material(id: $attachmentId, type: $attachmentType) @include(if: $includeAttachment) {
    id
    publicUrl(allowDraft: true)
    header
  }
  pressroom(id: $pressroomId) {
    id
    name
    networkContacts2(ids: [$contactId]) @include(if: $includeContact) {
      id
      contactEmail: email
      fullName
      unsubscribed
      avatarUrl
    }
    mndReachContact2(id: $mndReachJournalistId) @include(if: $includeMndReachJournalist) {
      id
      name
      email
      imgUrl
      mainOutlet {
        name
      }
      outletNames
      motivation
      relevantArticles(limit: 1) {
        id
        ...PitchArticle
      }
      latestArticles(limit: 1) {
        id
        ...PitchArticle
      }
    }
    emailSettings {
      id
      pitchSenderOptions {
        sender
        enabled
      }
      dnsEnabled
      general {
        __typename
        ... on AuthenticatedDomainEmailSettings {
          domain
        }
      }
    }
  }
}
    ${PitchArticleFragmentDoc}`;

/**
 * __usePitchMetadataQuery__
 *
 * To run a query within a React component, call `usePitchMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchMetadataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      contactId: // value for 'contactId'
 *      includeContact: // value for 'includeContact'
 *      mndReachJournalistId: // value for 'mndReachJournalistId'
 *      includeMndReachJournalist: // value for 'includeMndReachJournalist'
 *      attachmentId: // value for 'attachmentId'
 *      attachmentType: // value for 'attachmentType'
 *      includeAttachment: // value for 'includeAttachment'
 *   },
 * });
 */
export function usePitchMetadataQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables> & ({ variables: Types.PitchMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables>(PitchMetadataDocument, options);
      }
export function usePitchMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables>(PitchMetadataDocument, options);
        }
export function usePitchMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables>(PitchMetadataDocument, options);
        }
export type PitchMetadataQueryHookResult = ReturnType<typeof usePitchMetadataQuery>;
export type PitchMetadataLazyQueryHookResult = ReturnType<typeof usePitchMetadataLazyQuery>;
export type PitchMetadataSuspenseQueryHookResult = ReturnType<typeof usePitchMetadataSuspenseQuery>;
export type PitchMetadataQueryResult = Apollo.QueryResult<Types.PitchMetadataQuery, Types.PitchMetadataQueryVariables>;
export const PitchDocument = gql`
    query Pitch($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    pitch(id: $id) {
      id
      from
      replyTo
      to {
        ...PitchToFragment
      }
      subject
      body
      previewBody
      sentAt
      sentBy
      attachment {
        id
        header
        publicUrl(allowDraft: true)
      }
    }
  }
}
    ${PitchToFragmentFragmentDoc}`;

/**
 * __usePitchQuery__
 *
 * To run a query within a React component, call `usePitchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePitchQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchQuery, Types.PitchQueryVariables> & ({ variables: Types.PitchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchQuery, Types.PitchQueryVariables>(PitchDocument, options);
      }
export function usePitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchQuery, Types.PitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchQuery, Types.PitchQueryVariables>(PitchDocument, options);
        }
export function usePitchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchQuery, Types.PitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchQuery, Types.PitchQueryVariables>(PitchDocument, options);
        }
export type PitchQueryHookResult = ReturnType<typeof usePitchQuery>;
export type PitchLazyQueryHookResult = ReturnType<typeof usePitchLazyQuery>;
export type PitchSuspenseQueryHookResult = ReturnType<typeof usePitchSuspenseQuery>;
export type PitchQueryResult = Apollo.QueryResult<Types.PitchQuery, Types.PitchQueryVariables>;
export const PitchTopJournalistsDocument = gql`
    query PitchTopJournalists($pressroomId: ID!, $relevances: [MndReachRelevance!]!, $materialId: ID, $materialType: MaterialType) {
  pressroom(id: $pressroomId) {
    id
    mndReachSearch(
      relevances: $relevances
      materialId: $materialId
      materialType: $materialType
    ) {
      id
      items {
        id
        name
        email
        ... on MndReachJournalist {
          imgUrl
          motivation
          mainOutlet {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePitchTopJournalistsQuery__
 *
 * To run a query within a React component, call `usePitchTopJournalistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchTopJournalistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchTopJournalistsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      relevances: // value for 'relevances'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function usePitchTopJournalistsQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables> & ({ variables: Types.PitchTopJournalistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables>(PitchTopJournalistsDocument, options);
      }
export function usePitchTopJournalistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables>(PitchTopJournalistsDocument, options);
        }
export function usePitchTopJournalistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables>(PitchTopJournalistsDocument, options);
        }
export type PitchTopJournalistsQueryHookResult = ReturnType<typeof usePitchTopJournalistsQuery>;
export type PitchTopJournalistsLazyQueryHookResult = ReturnType<typeof usePitchTopJournalistsLazyQuery>;
export type PitchTopJournalistsSuspenseQueryHookResult = ReturnType<typeof usePitchTopJournalistsSuspenseQuery>;
export type PitchTopJournalistsQueryResult = Apollo.QueryResult<Types.PitchTopJournalistsQuery, Types.PitchTopJournalistsQueryVariables>;
export const PitchJournalistsDocument = gql`
    query PitchJournalists($pressroomId: ID!, $searchTerm: String!, $includeNetworkContacts: Boolean!) {
  pressroom(id: $pressroomId) {
    id
    networkContactsNameSearch(search: $searchTerm, first: 3, filter: Subscribing) @include(if: $includeNetworkContacts) {
      nodes {
        id
        fullName
        contactEmail: email
        company
        avatarUrl
        unsubscribed
        importedVia
      }
    }
    mndReachSearch(name: $searchTerm) {
      id
      items {
        id
        name
        email
        ... on MndReachJournalist {
          imgUrl
          motivation
          mainOutlet {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePitchJournalistsQuery__
 *
 * To run a query within a React component, call `usePitchJournalistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchJournalistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchJournalistsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      searchTerm: // value for 'searchTerm'
 *      includeNetworkContacts: // value for 'includeNetworkContacts'
 *   },
 * });
 */
export function usePitchJournalistsQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables> & ({ variables: Types.PitchJournalistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables>(PitchJournalistsDocument, options);
      }
export function usePitchJournalistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables>(PitchJournalistsDocument, options);
        }
export function usePitchJournalistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables>(PitchJournalistsDocument, options);
        }
export type PitchJournalistsQueryHookResult = ReturnType<typeof usePitchJournalistsQuery>;
export type PitchJournalistsLazyQueryHookResult = ReturnType<typeof usePitchJournalistsLazyQuery>;
export type PitchJournalistsSuspenseQueryHookResult = ReturnType<typeof usePitchJournalistsSuspenseQuery>;
export type PitchJournalistsQueryResult = Apollo.QueryResult<Types.PitchJournalistsQuery, Types.PitchJournalistsQueryVariables>;
export const PitchMaterialLinksDocument = gql`
    query PitchMaterialLinks($pressroomId: ID!, $after: String, $type: MaterialType!) {
  pressroom(id: $pressroomId) {
    id
    materialList2(types: [$type], after: $after, first: 20) {
      nodes {
        id
        header
        thumbnail: image {
          id
          url(transformation: THUMBNAIL_SMALL)
        }
        status
        publicUrl(allowDraft: true)
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __usePitchMaterialLinksQuery__
 *
 * To run a query within a React component, call `usePitchMaterialLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchMaterialLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchMaterialLinksQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePitchMaterialLinksQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables> & ({ variables: Types.PitchMaterialLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables>(PitchMaterialLinksDocument, options);
      }
export function usePitchMaterialLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables>(PitchMaterialLinksDocument, options);
        }
export function usePitchMaterialLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables>(PitchMaterialLinksDocument, options);
        }
export type PitchMaterialLinksQueryHookResult = ReturnType<typeof usePitchMaterialLinksQuery>;
export type PitchMaterialLinksLazyQueryHookResult = ReturnType<typeof usePitchMaterialLinksLazyQuery>;
export type PitchMaterialLinksSuspenseQueryHookResult = ReturnType<typeof usePitchMaterialLinksSuspenseQuery>;
export type PitchMaterialLinksQueryResult = Apollo.QueryResult<Types.PitchMaterialLinksQuery, Types.PitchMaterialLinksQueryVariables>;
export const PitchToDocument = gql`
    query PitchTo($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    pitch(id: $id) {
      id
      to {
        ... on NetworkContact {
          id
          contactEmail: email
          fullName
          avatarUrl
          importedVia
        }
        ... on MndReachJournalist {
          id
          name
          email
          outletNames
          imgUrl
          relevantArticles(limit: 1) {
            id
            ...PitchArticle
          }
          latestArticles(limit: 1) {
            id
            ...PitchArticle
          }
        }
      }
    }
  }
}
    ${PitchArticleFragmentDoc}`;

/**
 * __usePitchToQuery__
 *
 * To run a query within a React component, call `usePitchToQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchToQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePitchToQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchToQuery, Types.PitchToQueryVariables> & ({ variables: Types.PitchToQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchToQuery, Types.PitchToQueryVariables>(PitchToDocument, options);
      }
export function usePitchToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchToQuery, Types.PitchToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchToQuery, Types.PitchToQueryVariables>(PitchToDocument, options);
        }
export function usePitchToSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchToQuery, Types.PitchToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchToQuery, Types.PitchToQueryVariables>(PitchToDocument, options);
        }
export type PitchToQueryHookResult = ReturnType<typeof usePitchToQuery>;
export type PitchToLazyQueryHookResult = ReturnType<typeof usePitchToLazyQuery>;
export type PitchToSuspenseQueryHookResult = ReturnType<typeof usePitchToSuspenseQuery>;
export type PitchToQueryResult = Apollo.QueryResult<Types.PitchToQuery, Types.PitchToQueryVariables>;
export const PitchExportToEmailDocument = gql`
    query PitchExportToEmail($pitchId: ID!, $pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pitch(id: $pitchId) {
      id
      subject
      body
      to {
        ... on MndReachJournalist {
          id
          email
        }
        ... on NetworkContact {
          id
          contactEmail: email
        }
      }
    }
  }
}
    `;

/**
 * __usePitchExportToEmailQuery__
 *
 * To run a query within a React component, call `usePitchExportToEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchExportToEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchExportToEmailQuery({
 *   variables: {
 *      pitchId: // value for 'pitchId'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function usePitchExportToEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables> & ({ variables: Types.PitchExportToEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables>(PitchExportToEmailDocument, options);
      }
export function usePitchExportToEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables>(PitchExportToEmailDocument, options);
        }
export function usePitchExportToEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables>(PitchExportToEmailDocument, options);
        }
export type PitchExportToEmailQueryHookResult = ReturnType<typeof usePitchExportToEmailQuery>;
export type PitchExportToEmailLazyQueryHookResult = ReturnType<typeof usePitchExportToEmailLazyQuery>;
export type PitchExportToEmailSuspenseQueryHookResult = ReturnType<typeof usePitchExportToEmailSuspenseQuery>;
export type PitchExportToEmailQueryResult = Apollo.QueryResult<Types.PitchExportToEmailQuery, Types.PitchExportToEmailQueryVariables>;
export const PitchesDocument = gql`
    query Pitches($pressroomId: ID!, $status: PitchStatusFilter, $query: String, $page: Int!, $perPage: Int!) {
  pressroom(id: $pressroomId) {
    id
    pitches(status: $status, query: $query, page: $page, first: $perPage) {
      totalPages
      nodes {
        id
        subject
        body
        sentAt
        updatedBy
        updatedAt
        sentBy
        to {
          ... on MndReachJournalist {
            id
            name
            email
          }
          ... on NetworkContact {
            id
            contactEmail: email
            firstName
            lastName
          }
        }
        state {
          timestamp
          ... on PitchOpenedState {
            count
          }
          ... on PitchClickedState {
            count
          }
          ... on PitchMediaHitState {
            quotation {
              id
              articleSource
              articlePublishedAt
              articleUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePitchesQuery__
 *
 * To run a query within a React component, call `usePitchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      status: // value for 'status'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePitchesQuery(baseOptions: Apollo.QueryHookOptions<Types.PitchesQuery, Types.PitchesQueryVariables> & ({ variables: Types.PitchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PitchesQuery, Types.PitchesQueryVariables>(PitchesDocument, options);
      }
export function usePitchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PitchesQuery, Types.PitchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PitchesQuery, Types.PitchesQueryVariables>(PitchesDocument, options);
        }
export function usePitchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PitchesQuery, Types.PitchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PitchesQuery, Types.PitchesQueryVariables>(PitchesDocument, options);
        }
export type PitchesQueryHookResult = ReturnType<typeof usePitchesQuery>;
export type PitchesLazyQueryHookResult = ReturnType<typeof usePitchesLazyQuery>;
export type PitchesSuspenseQueryHookResult = ReturnType<typeof usePitchesSuspenseQuery>;
export type PitchesQueryResult = Apollo.QueryResult<Types.PitchesQuery, Types.PitchesQueryVariables>;
export const SourcesDocument = gql`
    query Sources {
  me {
    id
    user {
      id
      isMynewsdeskAdmin
      sources {
        id
        name
        pressrooms {
          id
          name
          siteCode
        }
      }
    }
  }
}
    `;

/**
 * __useSourcesQuery__
 *
 * To run a query within a React component, call `useSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSourcesQuery(baseOptions?: Apollo.QueryHookOptions<Types.SourcesQuery, Types.SourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SourcesQuery, Types.SourcesQueryVariables>(SourcesDocument, options);
      }
export function useSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SourcesQuery, Types.SourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SourcesQuery, Types.SourcesQueryVariables>(SourcesDocument, options);
        }
export function useSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SourcesQuery, Types.SourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SourcesQuery, Types.SourcesQueryVariables>(SourcesDocument, options);
        }
export type SourcesQueryHookResult = ReturnType<typeof useSourcesQuery>;
export type SourcesLazyQueryHookResult = ReturnType<typeof useSourcesLazyQuery>;
export type SourcesSuspenseQueryHookResult = ReturnType<typeof useSourcesSuspenseQuery>;
export type SourcesQueryResult = Apollo.QueryResult<Types.SourcesQuery, Types.SourcesQueryVariables>;
export const SeenG2ModalDocument = gql`
    mutation seenG2Modal($pressroomId: ID!) {
  noticeConfirm(input: {notice: G2Review, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      g2Review
    }
  }
}
    `;
export type SeenG2ModalMutationFn = Apollo.MutationFunction<Types.SeenG2ModalMutation, Types.SeenG2ModalMutationVariables>;

/**
 * __useSeenG2ModalMutation__
 *
 * To run a mutation, you first call `useSeenG2ModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenG2ModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenG2ModalMutation, { data, loading, error }] = useSeenG2ModalMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSeenG2ModalMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenG2ModalMutation, Types.SeenG2ModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenG2ModalMutation, Types.SeenG2ModalMutationVariables>(SeenG2ModalDocument, options);
      }
export type SeenG2ModalMutationHookResult = ReturnType<typeof useSeenG2ModalMutation>;
export type SeenG2ModalMutationResult = Apollo.MutationResult<Types.SeenG2ModalMutation>;
export type SeenG2ModalMutationOptions = Apollo.BaseMutationOptions<Types.SeenG2ModalMutation, Types.SeenG2ModalMutationVariables>;
export const GetNewsroomUrlDocument = gql`
    query getNewsroomUrl($pressroomId: ID!, $id: ID!, $type: MaterialType!, $skipPressroom: Boolean!) {
  material(id: $id, type: $type) {
    id
    publicUrl
    validToPublish2
    ... on StoryMaterial {
      previewUrl
    }
  }
  pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
    id
    newsroomUrl
    siteCode
    name
  }
}
    `;

/**
 * __useGetNewsroomUrlQuery__
 *
 * To run a query within a React component, call `useGetNewsroomUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsroomUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsroomUrlQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      skipPressroom: // value for 'skipPressroom'
 *   },
 * });
 */
export function useGetNewsroomUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables> & ({ variables: Types.GetNewsroomUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables>(GetNewsroomUrlDocument, options);
      }
export function useGetNewsroomUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables>(GetNewsroomUrlDocument, options);
        }
export function useGetNewsroomUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables>(GetNewsroomUrlDocument, options);
        }
export type GetNewsroomUrlQueryHookResult = ReturnType<typeof useGetNewsroomUrlQuery>;
export type GetNewsroomUrlLazyQueryHookResult = ReturnType<typeof useGetNewsroomUrlLazyQuery>;
export type GetNewsroomUrlSuspenseQueryHookResult = ReturnType<typeof useGetNewsroomUrlSuspenseQuery>;
export type GetNewsroomUrlQueryResult = Apollo.QueryResult<Types.GetNewsroomUrlQuery, Types.GetNewsroomUrlQueryVariables>;
export const LoadContactPersonDocument = gql`
    query LoadContactPerson($id: ID!, $pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    contactPerson(id: $id) {
      id
      name
      publiclyVisible
      title
      email
      phone
      responsibility
      scheduledPublishAt
      scheduledUnpublishAt
      showAsPressroomContact
      links {
        url
        name
      }
      image {
        id
        cloudinaryId
        url(transformation: CONTACT_PERSON)
      }
    }
  }
}
    `;

/**
 * __useLoadContactPersonQuery__
 *
 * To run a query within a React component, call `useLoadContactPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadContactPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadContactPersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useLoadContactPersonQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables> & ({ variables: Types.LoadContactPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables>(LoadContactPersonDocument, options);
      }
export function useLoadContactPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables>(LoadContactPersonDocument, options);
        }
export function useLoadContactPersonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables>(LoadContactPersonDocument, options);
        }
export type LoadContactPersonQueryHookResult = ReturnType<typeof useLoadContactPersonQuery>;
export type LoadContactPersonLazyQueryHookResult = ReturnType<typeof useLoadContactPersonLazyQuery>;
export type LoadContactPersonSuspenseQueryHookResult = ReturnType<typeof useLoadContactPersonSuspenseQuery>;
export type LoadContactPersonQueryResult = Apollo.QueryResult<Types.LoadContactPersonQuery, Types.LoadContactPersonQueryVariables>;
export const ContactPeopleListDocument = gql`
    query ContactPeopleList($pressroomId: ID!, $filter: String, $page: Int!) {
  pressroom(id: $pressroomId) {
    id
    contactPeopleList(page: $page, query: $filter, perPage: 12) {
      id
      totalPages
      currentPage
      totalUnscheduledActiveCount
      totalUnscheduledActivePinnedCount
      contactPeople: contactPeople2 {
        id
        ...ContactPersonListData
      }
    }
  }
}
    ${ContactPersonListDataFragmentDoc}`;

/**
 * __useContactPeopleListQuery__
 *
 * To run a query within a React component, call `useContactPeopleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPeopleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPeopleListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useContactPeopleListQuery(baseOptions: Apollo.QueryHookOptions<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables> & ({ variables: Types.ContactPeopleListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables>(ContactPeopleListDocument, options);
      }
export function useContactPeopleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables>(ContactPeopleListDocument, options);
        }
export function useContactPeopleListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables>(ContactPeopleListDocument, options);
        }
export type ContactPeopleListQueryHookResult = ReturnType<typeof useContactPeopleListQuery>;
export type ContactPeopleListLazyQueryHookResult = ReturnType<typeof useContactPeopleListLazyQuery>;
export type ContactPeopleListSuspenseQueryHookResult = ReturnType<typeof useContactPeopleListSuspenseQuery>;
export type ContactPeopleListQueryResult = Apollo.QueryResult<Types.ContactPeopleListQuery, Types.ContactPeopleListQueryVariables>;
export const ContactPersonMoveDocument = gql`
    mutation ContactPersonMove($id: ID!, $direction: MoveDirection!, $page: Int!, $filter: String) {
  contactPersonMove(input: {id: $id, direction: $direction}) {
    pressroom {
      id
      contactPeopleList(page: $page, query: $filter, perPage: 12) {
        id
        totalPages
        currentPage
        contactPeople2 {
          id
          ...ContactPersonListData
        }
      }
    }
    error {
      message
    }
  }
}
    ${ContactPersonListDataFragmentDoc}`;
export type ContactPersonMoveMutationFn = Apollo.MutationFunction<Types.ContactPersonMoveMutation, Types.ContactPersonMoveMutationVariables>;

/**
 * __useContactPersonMoveMutation__
 *
 * To run a mutation, you first call `useContactPersonMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPersonMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPersonMoveMutation, { data, loading, error }] = useContactPersonMoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      direction: // value for 'direction'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContactPersonMoveMutation(baseOptions?: Apollo.MutationHookOptions<Types.ContactPersonMoveMutation, Types.ContactPersonMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ContactPersonMoveMutation, Types.ContactPersonMoveMutationVariables>(ContactPersonMoveDocument, options);
      }
export type ContactPersonMoveMutationHookResult = ReturnType<typeof useContactPersonMoveMutation>;
export type ContactPersonMoveMutationResult = Apollo.MutationResult<Types.ContactPersonMoveMutation>;
export type ContactPersonMoveMutationOptions = Apollo.BaseMutationOptions<Types.ContactPersonMoveMutation, Types.ContactPersonMoveMutationVariables>;
export const ContactPersonListUpdateDocument = gql`
    mutation ContactPersonListUpdate($pressroomId: ID!, $id: ID!, $publiclyVisible: Boolean, $showAsPressroomContact: Boolean) {
  contactPersonUpdate(
    input: {id: $id, pressroomId: $pressroomId, publiclyVisible: $publiclyVisible, showAsPressroomContact: $showAsPressroomContact}
  ) {
    contactPerson {
      id
      publiclyVisible
      showAsPressroomContact
    }
    pressroom {
      id
      contactPeopleList {
        id
        totalUnscheduledActiveCount
        totalUnscheduledActivePinnedCount
        contactPeople2 {
          id
        }
      }
    }
    error {
      message
    }
  }
}
    `;
export type ContactPersonListUpdateMutationFn = Apollo.MutationFunction<Types.ContactPersonListUpdateMutation, Types.ContactPersonListUpdateMutationVariables>;

/**
 * __useContactPersonListUpdateMutation__
 *
 * To run a mutation, you first call `useContactPersonListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPersonListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPersonListUpdateMutation, { data, loading, error }] = useContactPersonListUpdateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      publiclyVisible: // value for 'publiclyVisible'
 *      showAsPressroomContact: // value for 'showAsPressroomContact'
 *   },
 * });
 */
export function useContactPersonListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ContactPersonListUpdateMutation, Types.ContactPersonListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ContactPersonListUpdateMutation, Types.ContactPersonListUpdateMutationVariables>(ContactPersonListUpdateDocument, options);
      }
export type ContactPersonListUpdateMutationHookResult = ReturnType<typeof useContactPersonListUpdateMutation>;
export type ContactPersonListUpdateMutationResult = Apollo.MutationResult<Types.ContactPersonListUpdateMutation>;
export type ContactPersonListUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ContactPersonListUpdateMutation, Types.ContactPersonListUpdateMutationVariables>;
export const TotalActiveContactPeopleDocument = gql`
    query TotalActiveContactPeople($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    contactPeopleList {
      id
      totalUnscheduledActiveCount
      totalUnscheduledActivePinnedCount
    }
  }
}
    `;

/**
 * __useTotalActiveContactPeopleQuery__
 *
 * To run a query within a React component, call `useTotalActiveContactPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalActiveContactPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalActiveContactPeopleQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTotalActiveContactPeopleQuery(baseOptions: Apollo.QueryHookOptions<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables> & ({ variables: Types.TotalActiveContactPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables>(TotalActiveContactPeopleDocument, options);
      }
export function useTotalActiveContactPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables>(TotalActiveContactPeopleDocument, options);
        }
export function useTotalActiveContactPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables>(TotalActiveContactPeopleDocument, options);
        }
export type TotalActiveContactPeopleQueryHookResult = ReturnType<typeof useTotalActiveContactPeopleQuery>;
export type TotalActiveContactPeopleLazyQueryHookResult = ReturnType<typeof useTotalActiveContactPeopleLazyQuery>;
export type TotalActiveContactPeopleSuspenseQueryHookResult = ReturnType<typeof useTotalActiveContactPeopleSuspenseQuery>;
export type TotalActiveContactPeopleQueryResult = Apollo.QueryResult<Types.TotalActiveContactPeopleQuery, Types.TotalActiveContactPeopleQueryVariables>;
export const PressroomMetadataDocument = gql`
    query PressroomMetadata($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      newsroom: managed(feature: newsroom) {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __usePressroomMetadataQuery__
 *
 * To run a query within a React component, call `usePressroomMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressroomMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressroomMetadataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function usePressroomMetadataQuery(baseOptions: Apollo.QueryHookOptions<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables> & ({ variables: Types.PressroomMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables>(PressroomMetadataDocument, options);
      }
export function usePressroomMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables>(PressroomMetadataDocument, options);
        }
export function usePressroomMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables>(PressroomMetadataDocument, options);
        }
export type PressroomMetadataQueryHookResult = ReturnType<typeof usePressroomMetadataQuery>;
export type PressroomMetadataLazyQueryHookResult = ReturnType<typeof usePressroomMetadataLazyQuery>;
export type PressroomMetadataSuspenseQueryHookResult = ReturnType<typeof usePressroomMetadataSuspenseQuery>;
export type PressroomMetadataQueryResult = Apollo.QueryResult<Types.PressroomMetadataQuery, Types.PressroomMetadataQueryVariables>;
export const SaveContactPersonDocument = gql`
    mutation SaveContactPerson($id: ID, $pressroomId: ID!, $resourceImageId: ID, $name: String!, $phone: String!, $scheduledPublishAt: DateTime, $scheduledUnpublishAt: DateTime, $showAsPressroomContact: Boolean!, $publiclyVisible: Boolean!, $title: String!, $email: String!, $responsibility: String!, $links: [LinkInput!]) {
  contactPersonUpdate(
    input: {id: $id, pressroomId: $pressroomId, resourceImageId: $resourceImageId, name: $name, phone: $phone, scheduledPublishAt: $scheduledPublishAt, scheduledUnpublishAt: $scheduledUnpublishAt, showAsPressroomContact: $showAsPressroomContact, title: $title, email: $email, responsibility: $responsibility, publiclyVisible: $publiclyVisible, links: $links}
  ) {
    contactPerson {
      id
      name
      scheduledPublishAt
      scheduledUnpublishAt
      showAsPressroomContact
      publiclyVisible
      title
      email
      responsibility
      phone
      image {
        id
        url(transformation: CONTACT_PERSON)
      }
      links {
        url
        name
      }
    }
    pressroom {
      id
      contactPeopleList(page: 1, query: "", perPage: 12) {
        id
        totalPages
        totalUnscheduledActivePinnedCount
        contactPeople2 {
          id
        }
      }
    }
    error {
      message
      ... on ContactPersonUpdateValidationError {
        email
        name
        links {
          url
          name
        }
      }
    }
  }
}
    `;
export type SaveContactPersonMutationFn = Apollo.MutationFunction<Types.SaveContactPersonMutation, Types.SaveContactPersonMutationVariables>;

/**
 * __useSaveContactPersonMutation__
 *
 * To run a mutation, you first call `useSaveContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactPersonMutation, { data, loading, error }] = useSaveContactPersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      resourceImageId: // value for 'resourceImageId'
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *      scheduledPublishAt: // value for 'scheduledPublishAt'
 *      scheduledUnpublishAt: // value for 'scheduledUnpublishAt'
 *      showAsPressroomContact: // value for 'showAsPressroomContact'
 *      publiclyVisible: // value for 'publiclyVisible'
 *      title: // value for 'title'
 *      email: // value for 'email'
 *      responsibility: // value for 'responsibility'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useSaveContactPersonMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveContactPersonMutation, Types.SaveContactPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveContactPersonMutation, Types.SaveContactPersonMutationVariables>(SaveContactPersonDocument, options);
      }
export type SaveContactPersonMutationHookResult = ReturnType<typeof useSaveContactPersonMutation>;
export type SaveContactPersonMutationResult = Apollo.MutationResult<Types.SaveContactPersonMutation>;
export type SaveContactPersonMutationOptions = Apollo.BaseMutationOptions<Types.SaveContactPersonMutation, Types.SaveContactPersonMutationVariables>;
export const RemoveContactPersonImageDocument = gql`
    mutation RemoveContactPersonImage($id: ID!, $pressroomId: ID!) {
  contactPersonRemoveImage(input: {id: $id, pressroomId: $pressroomId}) {
    error {
      message
    }
    contactPerson {
      id
      image {
        id
      }
    }
  }
}
    `;
export type RemoveContactPersonImageMutationFn = Apollo.MutationFunction<Types.RemoveContactPersonImageMutation, Types.RemoveContactPersonImageMutationVariables>;

/**
 * __useRemoveContactPersonImageMutation__
 *
 * To run a mutation, you first call `useRemoveContactPersonImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactPersonImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactPersonImageMutation, { data, loading, error }] = useRemoveContactPersonImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useRemoveContactPersonImageMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveContactPersonImageMutation, Types.RemoveContactPersonImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveContactPersonImageMutation, Types.RemoveContactPersonImageMutationVariables>(RemoveContactPersonImageDocument, options);
      }
export type RemoveContactPersonImageMutationHookResult = ReturnType<typeof useRemoveContactPersonImageMutation>;
export type RemoveContactPersonImageMutationResult = Apollo.MutationResult<Types.RemoveContactPersonImageMutation>;
export type RemoveContactPersonImageMutationOptions = Apollo.BaseMutationOptions<Types.RemoveContactPersonImageMutation, Types.RemoveContactPersonImageMutationVariables>;
export const DeleteContactPersonDocument = gql`
    mutation DeleteContactPerson($id: ID!, $filter: String, $page: Int!) {
  contactPersonDelete(input: {id: $id}) {
    error {
      message
    }
    deletedId
    pressroom {
      id
      contactPeopleList(page: $page, query: $filter, perPage: 12) {
        id
        totalPages
        currentPage
        totalUnscheduledActiveCount
        contactPeople2 {
          id
        }
      }
    }
  }
}
    `;
export type DeleteContactPersonMutationFn = Apollo.MutationFunction<Types.DeleteContactPersonMutation, Types.DeleteContactPersonMutationVariables>;

/**
 * __useDeleteContactPersonMutation__
 *
 * To run a mutation, you first call `useDeleteContactPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactPersonMutation, { data, loading, error }] = useDeleteContactPersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDeleteContactPersonMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteContactPersonMutation, Types.DeleteContactPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteContactPersonMutation, Types.DeleteContactPersonMutationVariables>(DeleteContactPersonDocument, options);
      }
export type DeleteContactPersonMutationHookResult = ReturnType<typeof useDeleteContactPersonMutation>;
export type DeleteContactPersonMutationResult = Apollo.MutationResult<Types.DeleteContactPersonMutation>;
export type DeleteContactPersonMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContactPersonMutation, Types.DeleteContactPersonMutationVariables>;
export const ConnectPersonBulkDocument = gql`
    mutation ConnectPersonBulk($materialId: ID!, $materialType: MaterialType!, $contactPersonIds: [ID!]!) {
  contactPersonConnectBulk(
    input: {materialId: $materialId, materialType: $materialType, contactPersonIds: $contactPersonIds}
  ) {
    error {
      message
    }
    material {
      id
      ... on Pressrelease {
        contactPeople: contactPeople2 {
          id
          ...ContactPersonFragment
        }
      }
      ... on StoryMaterial {
        contactPeople: contactPeople2 {
          id
          ...ContactPersonFragment
        }
      }
      ... on Event {
        contactPeople: contactPeople2 {
          id
          ...ContactPersonFragment
        }
      }
      ... on Video {
        contactPeople: contactPeople2 {
          id
          ...ContactPersonFragment
        }
      }
      ... on Document {
        contactPeople: contactPeople2 {
          id
          ...ContactPersonFragment
        }
      }
    }
  }
}
    ${ContactPersonFragmentFragmentDoc}`;
export type ConnectPersonBulkMutationFn = Apollo.MutationFunction<Types.ConnectPersonBulkMutation, Types.ConnectPersonBulkMutationVariables>;

/**
 * __useConnectPersonBulkMutation__
 *
 * To run a mutation, you first call `useConnectPersonBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPersonBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPersonBulkMutation, { data, loading, error }] = useConnectPersonBulkMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      contactPersonIds: // value for 'contactPersonIds'
 *   },
 * });
 */
export function useConnectPersonBulkMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConnectPersonBulkMutation, Types.ConnectPersonBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConnectPersonBulkMutation, Types.ConnectPersonBulkMutationVariables>(ConnectPersonBulkDocument, options);
      }
export type ConnectPersonBulkMutationHookResult = ReturnType<typeof useConnectPersonBulkMutation>;
export type ConnectPersonBulkMutationResult = Apollo.MutationResult<Types.ConnectPersonBulkMutation>;
export type ConnectPersonBulkMutationOptions = Apollo.BaseMutationOptions<Types.ConnectPersonBulkMutation, Types.ConnectPersonBulkMutationVariables>;
export const GetChannelMessageDocument = gql`
    query GetChannelMessage($materialId: ID!, $type: MaterialType!, $channelId: ID!) {
  material(id: $materialId, type: $type) {
    id
    header
    summary
    channel(id: $channelId) {
      id
      ... on SocialChannel {
        customMessageForMaterial(id: $materialId, type: $type)
      }
    }
  }
}
    `;

/**
 * __useGetChannelMessageQuery__
 *
 * To run a query within a React component, call `useGetChannelMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelMessageQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelMessageQuery(baseOptions: Apollo.QueryHookOptions<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables> & ({ variables: Types.GetChannelMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables>(GetChannelMessageDocument, options);
      }
export function useGetChannelMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables>(GetChannelMessageDocument, options);
        }
export function useGetChannelMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables>(GetChannelMessageDocument, options);
        }
export type GetChannelMessageQueryHookResult = ReturnType<typeof useGetChannelMessageQuery>;
export type GetChannelMessageLazyQueryHookResult = ReturnType<typeof useGetChannelMessageLazyQuery>;
export type GetChannelMessageSuspenseQueryHookResult = ReturnType<typeof useGetChannelMessageSuspenseQuery>;
export type GetChannelMessageQueryResult = Apollo.QueryResult<Types.GetChannelMessageQuery, Types.GetChannelMessageQueryVariables>;
export const UpdateCustomChannelMessageOnMaterialDocument = gql`
    mutation UpdateCustomChannelMessageOnMaterial($materialId: ID!, $type: MaterialType!, $channelId: ID!, $message: String!) {
  materialChannelMessageUpdate(
    input: {materialId: $materialId, type: $type, channelId: $channelId, message: $message}
  ) {
    error {
      message
      __typename
    }
    material {
      id
      channel(id: $channelId) {
        id
        ... on SocialChannel {
          customMessageForMaterial(id: $materialId, type: $type)
        }
      }
    }
  }
}
    `;
export type UpdateCustomChannelMessageOnMaterialMutationFn = Apollo.MutationFunction<Types.UpdateCustomChannelMessageOnMaterialMutation, Types.UpdateCustomChannelMessageOnMaterialMutationVariables>;

/**
 * __useUpdateCustomChannelMessageOnMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateCustomChannelMessageOnMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomChannelMessageOnMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomChannelMessageOnMaterialMutation, { data, loading, error }] = useUpdateCustomChannelMessageOnMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      channelId: // value for 'channelId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateCustomChannelMessageOnMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCustomChannelMessageOnMaterialMutation, Types.UpdateCustomChannelMessageOnMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCustomChannelMessageOnMaterialMutation, Types.UpdateCustomChannelMessageOnMaterialMutationVariables>(UpdateCustomChannelMessageOnMaterialDocument, options);
      }
export type UpdateCustomChannelMessageOnMaterialMutationHookResult = ReturnType<typeof useUpdateCustomChannelMessageOnMaterialMutation>;
export type UpdateCustomChannelMessageOnMaterialMutationResult = Apollo.MutationResult<Types.UpdateCustomChannelMessageOnMaterialMutation>;
export type UpdateCustomChannelMessageOnMaterialMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomChannelMessageOnMaterialMutation, Types.UpdateCustomChannelMessageOnMaterialMutationVariables>;
export const GetDistributionChannelsDocument = gql`
    query GetDistributionChannels($pressroomId: ID!, $materialId: ID!, $type: MaterialType!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    channels {
      id
      ...DistributionChannels
    }
    channelsWithAcceptsDocuments {
      id
      ...DistributionChannels
    }
  }
  material(id: $materialId, type: $type) {
    id
    publishedAt2
    status
  }
}
    ${DistributionChannelsFragmentDoc}`;

/**
 * __useGetDistributionChannelsQuery__
 *
 * To run a query within a React component, call `useGetDistributionChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionChannelsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDistributionChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables> & ({ variables: Types.GetDistributionChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables>(GetDistributionChannelsDocument, options);
      }
export function useGetDistributionChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables>(GetDistributionChannelsDocument, options);
        }
export function useGetDistributionChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables>(GetDistributionChannelsDocument, options);
        }
export type GetDistributionChannelsQueryHookResult = ReturnType<typeof useGetDistributionChannelsQuery>;
export type GetDistributionChannelsLazyQueryHookResult = ReturnType<typeof useGetDistributionChannelsLazyQuery>;
export type GetDistributionChannelsSuspenseQueryHookResult = ReturnType<typeof useGetDistributionChannelsSuspenseQuery>;
export type GetDistributionChannelsQueryResult = Apollo.QueryResult<Types.GetDistributionChannelsQuery, Types.GetDistributionChannelsQueryVariables>;
export const AddChannelToMaterialDocument = gql`
    mutation AddChannelToMaterial($materialId: ID!, $type: MaterialType!, $channelIds: [ID!]!) {
  materialChannelsAdd(
    input: {materialId: $materialId, type: $type, channelIds: $channelIds}
  ) {
    error {
      message
    }
    material {
      id
      channels {
        id
        addedToMaterial(id: $materialId, type: $type)
      }
    }
  }
}
    `;
export type AddChannelToMaterialMutationFn = Apollo.MutationFunction<Types.AddChannelToMaterialMutation, Types.AddChannelToMaterialMutationVariables>;

/**
 * __useAddChannelToMaterialMutation__
 *
 * To run a mutation, you first call `useAddChannelToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChannelToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChannelToMaterialMutation, { data, loading, error }] = useAddChannelToMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function useAddChannelToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddChannelToMaterialMutation, Types.AddChannelToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddChannelToMaterialMutation, Types.AddChannelToMaterialMutationVariables>(AddChannelToMaterialDocument, options);
      }
export type AddChannelToMaterialMutationHookResult = ReturnType<typeof useAddChannelToMaterialMutation>;
export type AddChannelToMaterialMutationResult = Apollo.MutationResult<Types.AddChannelToMaterialMutation>;
export type AddChannelToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddChannelToMaterialMutation, Types.AddChannelToMaterialMutationVariables>;
export const RemoveChannelFromMaterialDocument = gql`
    mutation RemoveChannelFromMaterial($materialId: ID!, $type: MaterialType!, $channelIds: [ID!]!) {
  materialChannelsRemove(
    input: {materialId: $materialId, type: $type, channelIds: $channelIds}
  ) {
    error {
      message
    }
    pressroom {
      id
      channels {
        id
        addedToMaterial(id: $materialId, type: $type)
      }
    }
    material {
      id
      channels {
        id
      }
    }
  }
}
    `;
export type RemoveChannelFromMaterialMutationFn = Apollo.MutationFunction<Types.RemoveChannelFromMaterialMutation, Types.RemoveChannelFromMaterialMutationVariables>;

/**
 * __useRemoveChannelFromMaterialMutation__
 *
 * To run a mutation, you first call `useRemoveChannelFromMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChannelFromMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChannelFromMaterialMutation, { data, loading, error }] = useRemoveChannelFromMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function useRemoveChannelFromMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveChannelFromMaterialMutation, Types.RemoveChannelFromMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveChannelFromMaterialMutation, Types.RemoveChannelFromMaterialMutationVariables>(RemoveChannelFromMaterialDocument, options);
      }
export type RemoveChannelFromMaterialMutationHookResult = ReturnType<typeof useRemoveChannelFromMaterialMutation>;
export type RemoveChannelFromMaterialMutationResult = Apollo.MutationResult<Types.RemoveChannelFromMaterialMutation>;
export type RemoveChannelFromMaterialMutationOptions = Apollo.BaseMutationOptions<Types.RemoveChannelFromMaterialMutation, Types.RemoveChannelFromMaterialMutationVariables>;
export const UpdateChannelsFromMaterialDocument = gql`
    mutation UpdateChannelsFromMaterial($materialId: ID!, $type: MaterialType!, $channels: [ChannelIdMessageTuple!]!) {
  materialChannelsUpdate(
    input: {materialId: $materialId, type: $type, channels: $channels}
  ) {
    error {
      message
    }
    pressroom {
      id
      channels {
        id
        addedToMaterial(id: $materialId, type: $type)
        ... on SocialChannel {
          customMessageForMaterial(id: $materialId, type: $type)
        }
      }
    }
    material {
      id
      channels {
        id
      }
    }
  }
}
    `;
export type UpdateChannelsFromMaterialMutationFn = Apollo.MutationFunction<Types.UpdateChannelsFromMaterialMutation, Types.UpdateChannelsFromMaterialMutationVariables>;

/**
 * __useUpdateChannelsFromMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateChannelsFromMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelsFromMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelsFromMaterialMutation, { data, loading, error }] = useUpdateChannelsFromMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      channels: // value for 'channels'
 *   },
 * });
 */
export function useUpdateChannelsFromMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChannelsFromMaterialMutation, Types.UpdateChannelsFromMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChannelsFromMaterialMutation, Types.UpdateChannelsFromMaterialMutationVariables>(UpdateChannelsFromMaterialDocument, options);
      }
export type UpdateChannelsFromMaterialMutationHookResult = ReturnType<typeof useUpdateChannelsFromMaterialMutation>;
export type UpdateChannelsFromMaterialMutationResult = Apollo.MutationResult<Types.UpdateChannelsFromMaterialMutation>;
export type UpdateChannelsFromMaterialMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChannelsFromMaterialMutation, Types.UpdateChannelsFromMaterialMutationVariables>;
export const PublicationCreditDocument = gql`
    query publicationCredit($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    publicationLimitResetsAt
    publicationLimit
    publicationCount
  }
}
    `;

/**
 * __usePublicationCreditQuery__
 *
 * To run a query within a React component, call `usePublicationCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationCreditQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function usePublicationCreditQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables> & ({ variables: Types.PublicationCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables>(PublicationCreditDocument, options);
      }
export function usePublicationCreditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables>(PublicationCreditDocument, options);
        }
export function usePublicationCreditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables>(PublicationCreditDocument, options);
        }
export type PublicationCreditQueryHookResult = ReturnType<typeof usePublicationCreditQuery>;
export type PublicationCreditLazyQueryHookResult = ReturnType<typeof usePublicationCreditLazyQuery>;
export type PublicationCreditSuspenseQueryHookResult = ReturnType<typeof usePublicationCreditSuspenseQuery>;
export type PublicationCreditQueryResult = Apollo.QueryResult<Types.PublicationCreditQuery, Types.PublicationCreditQueryVariables>;
export const GetDistributionFooterDataDocument = gql`
    query GetDistributionFooterData($sourceId: ID!, $pressroomId: ID!, $id: ID!, $type: MaterialType!) {
  source(id: $sourceId) {
    id
    trusted
    shouldAcceptPublishPolicy
  }
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    contactPeopleList {
      id
      totalUnscheduledActiveCount
    }
  }
  material(id: $id, type: $type) {
    id
    status
    validToPublish2
    ... on Document {
      contactPeople: contactPeople2 {
        id
      }
    }
    ... on Pressrelease {
      boilerplate
      contactPeople: contactPeople2 {
        id
      }
    }
    ... on Event {
      contactPeople: contactPeople2 {
        id
      }
    }
    ... on StoryMaterial {
      contactPeople: contactPeople2 {
        id
      }
    }
    ... on Video {
      contactPeople: contactPeople2 {
        id
      }
    }
  }
}
    `;

/**
 * __useGetDistributionFooterDataQuery__
 *
 * To run a query within a React component, call `useGetDistributionFooterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionFooterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionFooterDataQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDistributionFooterDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables> & ({ variables: Types.GetDistributionFooterDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables>(GetDistributionFooterDataDocument, options);
      }
export function useGetDistributionFooterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables>(GetDistributionFooterDataDocument, options);
        }
export function useGetDistributionFooterDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables>(GetDistributionFooterDataDocument, options);
        }
export type GetDistributionFooterDataQueryHookResult = ReturnType<typeof useGetDistributionFooterDataQuery>;
export type GetDistributionFooterDataLazyQueryHookResult = ReturnType<typeof useGetDistributionFooterDataLazyQuery>;
export type GetDistributionFooterDataSuspenseQueryHookResult = ReturnType<typeof useGetDistributionFooterDataSuspenseQuery>;
export type GetDistributionFooterDataQueryResult = Apollo.QueryResult<Types.GetDistributionFooterDataQuery, Types.GetDistributionFooterDataQueryVariables>;
export const GetDistributionPageDataDocument = gql`
    query GetDistributionPageData($pressroomId: ID!, $id: ID!, $type: MaterialType!) {
  pressroom(id: $pressroomId) {
    id
    name
    newsroomUrl
    remainingPublicationCount
    siteCode
    live
    emailSettings {
      id
      outdated
    }
    features {
      id
      publish {
        id
        channels
        expiration
      }
      coPilotPublishSidebar: managed(feature: coPilotPublishSidebar) {
        id
        enabled
      }
      newsroom: managed(feature: newsroom) {
        id
        enabled
      }
      publishScheduling: managed(feature: publishScheduling) {
        id
        enabled
      }
    }
  }
  material(id: $id, type: $type) {
    id
    header
    publishedAt2
    scheduledFor
    status
    updatedAt
    expiresAt
    expiresAtNextExpirationJob
    validToPublish2
    disableAlertSubscriptionEmails
    ... on StoryMaterial {
      body
      feedback {
        positive
        comment
      }
    }
    image {
      id
      url(transformation: MATERIAL_HEADER_PREVIEW)
    }
    ... on Video {
      resourceVideo {
        id
      }
      thumbnailUrl
    }
  }
}
    `;

/**
 * __useGetDistributionPageDataQuery__
 *
 * To run a query within a React component, call `useGetDistributionPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionPageDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDistributionPageDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables> & ({ variables: Types.GetDistributionPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables>(GetDistributionPageDataDocument, options);
      }
export function useGetDistributionPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables>(GetDistributionPageDataDocument, options);
        }
export function useGetDistributionPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables>(GetDistributionPageDataDocument, options);
        }
export type GetDistributionPageDataQueryHookResult = ReturnType<typeof useGetDistributionPageDataQuery>;
export type GetDistributionPageDataLazyQueryHookResult = ReturnType<typeof useGetDistributionPageDataLazyQuery>;
export type GetDistributionPageDataSuspenseQueryHookResult = ReturnType<typeof useGetDistributionPageDataSuspenseQuery>;
export type GetDistributionPageDataQueryResult = Apollo.QueryResult<Types.GetDistributionPageDataQuery, Types.GetDistributionPageDataQueryVariables>;
export const PublishMaterialDocument = gql`
    mutation PublishMaterial($pressroomId: ID!, $input: MaterialPublishInput!) {
  materialPublish(input: $input) {
    material {
      id
      header
      publishedAt2
    }
    pressroom {
      id
    }
    user {
      id
      onboarding(pressroomId: $pressroomId) {
        id
        completed
      }
    }
    error {
      message
    }
  }
}
    `;
export type PublishMaterialMutationFn = Apollo.MutationFunction<Types.PublishMaterialMutation, Types.PublishMaterialMutationVariables>;

/**
 * __usePublishMaterialMutation__
 *
 * To run a mutation, you first call `usePublishMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMaterialMutation, { data, loading, error }] = usePublishMaterialMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublishMaterialMutation, Types.PublishMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublishMaterialMutation, Types.PublishMaterialMutationVariables>(PublishMaterialDocument, options);
      }
export type PublishMaterialMutationHookResult = ReturnType<typeof usePublishMaterialMutation>;
export type PublishMaterialMutationResult = Apollo.MutationResult<Types.PublishMaterialMutation>;
export type PublishMaterialMutationOptions = Apollo.BaseMutationOptions<Types.PublishMaterialMutation, Types.PublishMaterialMutationVariables>;
export const GetAffectedReachDataDocument = gql`
    query GetAffectedReachData($materialId: ID!, $materialType: MaterialType!) {
  material(id: $materialId, type: $materialType) {
    id
    disableAlertSubscriptionEmails
    id
    regions {
      id
    }
    subjects {
      id
    }
    backdatingThresholdDays
  }
}
    `;

/**
 * __useGetAffectedReachDataQuery__
 *
 * To run a query within a React component, call `useGetAffectedReachDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffectedReachDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffectedReachDataQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useGetAffectedReachDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables> & ({ variables: Types.GetAffectedReachDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables>(GetAffectedReachDataDocument, options);
      }
export function useGetAffectedReachDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables>(GetAffectedReachDataDocument, options);
        }
export function useGetAffectedReachDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables>(GetAffectedReachDataDocument, options);
        }
export type GetAffectedReachDataQueryHookResult = ReturnType<typeof useGetAffectedReachDataQuery>;
export type GetAffectedReachDataLazyQueryHookResult = ReturnType<typeof useGetAffectedReachDataLazyQuery>;
export type GetAffectedReachDataSuspenseQueryHookResult = ReturnType<typeof useGetAffectedReachDataSuspenseQuery>;
export type GetAffectedReachDataQueryResult = Apollo.QueryResult<Types.GetAffectedReachDataQuery, Types.GetAffectedReachDataQueryVariables>;
export const GetDistributionOutcomesDataDocument = gql`
    query GetDistributionOutcomesData($materialId: ID!, $materialType: MaterialType!) {
  material(id: $materialId, type: $materialType) {
    id
    disableAlertSubscriptionEmails
    channels {
      id
    }
    networkContactLists {
      id
    }
    individualNetworkContacts {
      id
    }
    pendingDistributionContacts {
      id
    }
    channels {
      id
    }
  }
}
    `;

/**
 * __useGetDistributionOutcomesDataQuery__
 *
 * To run a query within a React component, call `useGetDistributionOutcomesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionOutcomesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionOutcomesDataQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useGetDistributionOutcomesDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables> & ({ variables: Types.GetDistributionOutcomesDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables>(GetDistributionOutcomesDataDocument, options);
      }
export function useGetDistributionOutcomesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables>(GetDistributionOutcomesDataDocument, options);
        }
export function useGetDistributionOutcomesDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables>(GetDistributionOutcomesDataDocument, options);
        }
export type GetDistributionOutcomesDataQueryHookResult = ReturnType<typeof useGetDistributionOutcomesDataQuery>;
export type GetDistributionOutcomesDataLazyQueryHookResult = ReturnType<typeof useGetDistributionOutcomesDataLazyQuery>;
export type GetDistributionOutcomesDataSuspenseQueryHookResult = ReturnType<typeof useGetDistributionOutcomesDataSuspenseQuery>;
export type GetDistributionOutcomesDataQueryResult = Apollo.QueryResult<Types.GetDistributionOutcomesDataQuery, Types.GetDistributionOutcomesDataQueryVariables>;
export const EmailDistributionDataDocument = gql`
    query EmailDistributionData($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!, $search: String!, $sortList: NetworkContactListSort!, $sortContacts: NetworkContactSort!) {
  pressroom(id: $pressroomId) {
    id
    contactLimits {
      ...ContactLimits
    }
    features {
      id
      recommendedJournalistsNew
      audienceBuilder2 {
        enabled
        showUpsellPage
      }
    }
    siteLocale
    remainingPublicationCount
    networkContactListSearch(
      search: $search
      sort: $sortList
      page: 1
      first: 100
      withSystemManaged: true
    ) {
      totalCount
      totalPages
      nodes {
        id
        name
        contactsCount
      }
    }
    networkContactsSearch(search: $search, sort: $sortContacts, page: 1, first: 100) {
      totalCount
      totalPages
      nodes {
        id
        firstName
        lastName
        email
        unreachable
        unsubscribed
        follower
        optedOut
        importedViaRecommendedContacts
      }
    }
    emailSettings {
      id
      general {
        __typename
        ... on EasyCustomEmailSettings {
          pending
        }
        ... on AuthenticatedDomainEmailSettings {
          pending
        }
      }
    }
  }
  material(id: $materialId, type: $materialType) {
    id
    publishedAt2
    status
  }
}
    ${ContactLimitsFragmentDoc}`;

/**
 * __useEmailDistributionDataQuery__
 *
 * To run a query within a React component, call `useEmailDistributionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailDistributionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailDistributionDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      search: // value for 'search'
 *      sortList: // value for 'sortList'
 *      sortContacts: // value for 'sortContacts'
 *   },
 * });
 */
export function useEmailDistributionDataQuery(baseOptions: Apollo.QueryHookOptions<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables> & ({ variables: Types.EmailDistributionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables>(EmailDistributionDataDocument, options);
      }
export function useEmailDistributionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables>(EmailDistributionDataDocument, options);
        }
export function useEmailDistributionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables>(EmailDistributionDataDocument, options);
        }
export type EmailDistributionDataQueryHookResult = ReturnType<typeof useEmailDistributionDataQuery>;
export type EmailDistributionDataLazyQueryHookResult = ReturnType<typeof useEmailDistributionDataLazyQuery>;
export type EmailDistributionDataSuspenseQueryHookResult = ReturnType<typeof useEmailDistributionDataSuspenseQuery>;
export type EmailDistributionDataQueryResult = Apollo.QueryResult<Types.EmailDistributionDataQuery, Types.EmailDistributionDataQueryVariables>;
export const NetworkContactAndContactListDocument = gql`
    query NetworkContactAndContactList($materialId: ID!, $materialType: MaterialType!) {
  material(id: $materialId, type: $materialType) {
    id
    publishedAt2
    status
    disableAlertSubscriptionEmails
    networkContactLists {
      id
      name
      contactsCount
      systemManaged
    }
    individualNetworkContacts {
      id
      firstName
      lastName
      email
      unreachable
      unsubscribed
      follower
      optedOut
      importedViaRecommendedContacts
    }
    pendingDistributionContacts {
      id
      firstName
      lastName
      email
      name
      isRecommended
    }
  }
}
    `;

/**
 * __useNetworkContactAndContactListQuery__
 *
 * To run a query within a React component, call `useNetworkContactAndContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkContactAndContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkContactAndContactListQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useNetworkContactAndContactListQuery(baseOptions: Apollo.QueryHookOptions<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables> & ({ variables: Types.NetworkContactAndContactListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables>(NetworkContactAndContactListDocument, options);
      }
export function useNetworkContactAndContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables>(NetworkContactAndContactListDocument, options);
        }
export function useNetworkContactAndContactListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables>(NetworkContactAndContactListDocument, options);
        }
export type NetworkContactAndContactListQueryHookResult = ReturnType<typeof useNetworkContactAndContactListQuery>;
export type NetworkContactAndContactListLazyQueryHookResult = ReturnType<typeof useNetworkContactAndContactListLazyQuery>;
export type NetworkContactAndContactListSuspenseQueryHookResult = ReturnType<typeof useNetworkContactAndContactListSuspenseQuery>;
export type NetworkContactAndContactListQueryResult = Apollo.QueryResult<Types.NetworkContactAndContactListQuery, Types.NetworkContactAndContactListQueryVariables>;
export const AddContactListsToMaterialDocument = gql`
    mutation AddContactListsToMaterial($input: MaterialContactListsAddInput!) {
  materialContactListsAdd(input: $input) {
    material {
      id
      contactsCount
      networkContactLists {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type AddContactListsToMaterialMutationFn = Apollo.MutationFunction<Types.AddContactListsToMaterialMutation, Types.AddContactListsToMaterialMutationVariables>;

/**
 * __useAddContactListsToMaterialMutation__
 *
 * To run a mutation, you first call `useAddContactListsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactListsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactListsToMaterialMutation, { data, loading, error }] = useAddContactListsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContactListsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddContactListsToMaterialMutation, Types.AddContactListsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddContactListsToMaterialMutation, Types.AddContactListsToMaterialMutationVariables>(AddContactListsToMaterialDocument, options);
      }
export type AddContactListsToMaterialMutationHookResult = ReturnType<typeof useAddContactListsToMaterialMutation>;
export type AddContactListsToMaterialMutationResult = Apollo.MutationResult<Types.AddContactListsToMaterialMutation>;
export type AddContactListsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddContactListsToMaterialMutation, Types.AddContactListsToMaterialMutationVariables>;
export const RemoveContactListsToMaterialDocument = gql`
    mutation RemoveContactListsToMaterial($input: MaterialContactListsRemoveInput!) {
  materialContactListsRemove(input: $input) {
    material {
      id
      contactsCount
      networkContactLists {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type RemoveContactListsToMaterialMutationFn = Apollo.MutationFunction<Types.RemoveContactListsToMaterialMutation, Types.RemoveContactListsToMaterialMutationVariables>;

/**
 * __useRemoveContactListsToMaterialMutation__
 *
 * To run a mutation, you first call `useRemoveContactListsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactListsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactListsToMaterialMutation, { data, loading, error }] = useRemoveContactListsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveContactListsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveContactListsToMaterialMutation, Types.RemoveContactListsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveContactListsToMaterialMutation, Types.RemoveContactListsToMaterialMutationVariables>(RemoveContactListsToMaterialDocument, options);
      }
export type RemoveContactListsToMaterialMutationHookResult = ReturnType<typeof useRemoveContactListsToMaterialMutation>;
export type RemoveContactListsToMaterialMutationResult = Apollo.MutationResult<Types.RemoveContactListsToMaterialMutation>;
export type RemoveContactListsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.RemoveContactListsToMaterialMutation, Types.RemoveContactListsToMaterialMutationVariables>;
export const UpdateContactListsToMaterialDocument = gql`
    mutation UpdateContactListsToMaterial($input: MaterialContactListsUpdateInput!) {
  materialContactListsUpdate(input: $input) {
    material {
      id
      contactsCount
      networkContactLists {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type UpdateContactListsToMaterialMutationFn = Apollo.MutationFunction<Types.UpdateContactListsToMaterialMutation, Types.UpdateContactListsToMaterialMutationVariables>;

/**
 * __useUpdateContactListsToMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateContactListsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactListsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactListsToMaterialMutation, { data, loading, error }] = useUpdateContactListsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactListsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateContactListsToMaterialMutation, Types.UpdateContactListsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateContactListsToMaterialMutation, Types.UpdateContactListsToMaterialMutationVariables>(UpdateContactListsToMaterialDocument, options);
      }
export type UpdateContactListsToMaterialMutationHookResult = ReturnType<typeof useUpdateContactListsToMaterialMutation>;
export type UpdateContactListsToMaterialMutationResult = Apollo.MutationResult<Types.UpdateContactListsToMaterialMutation>;
export type UpdateContactListsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContactListsToMaterialMutation, Types.UpdateContactListsToMaterialMutationVariables>;
export const AddNetworkContactsToMaterialDocument = gql`
    mutation AddNetworkContactsToMaterial($input: MaterialNetworkContactAddInput!) {
  materialNetworkContactsAdd(input: $input) {
    material {
      id
      contactsCount
      individualNetworkContacts {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type AddNetworkContactsToMaterialMutationFn = Apollo.MutationFunction<Types.AddNetworkContactsToMaterialMutation, Types.AddNetworkContactsToMaterialMutationVariables>;

/**
 * __useAddNetworkContactsToMaterialMutation__
 *
 * To run a mutation, you first call `useAddNetworkContactsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNetworkContactsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNetworkContactsToMaterialMutation, { data, loading, error }] = useAddNetworkContactsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNetworkContactsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddNetworkContactsToMaterialMutation, Types.AddNetworkContactsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddNetworkContactsToMaterialMutation, Types.AddNetworkContactsToMaterialMutationVariables>(AddNetworkContactsToMaterialDocument, options);
      }
export type AddNetworkContactsToMaterialMutationHookResult = ReturnType<typeof useAddNetworkContactsToMaterialMutation>;
export type AddNetworkContactsToMaterialMutationResult = Apollo.MutationResult<Types.AddNetworkContactsToMaterialMutation>;
export type AddNetworkContactsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddNetworkContactsToMaterialMutation, Types.AddNetworkContactsToMaterialMutationVariables>;
export const RemoveNetworkContactsToMaterialDocument = gql`
    mutation RemoveNetworkContactsToMaterial($input: MaterialNetworkContactRemoveInput!) {
  materialNetworkContactsRemove(input: $input) {
    material {
      id
      contactsCount
      individualNetworkContacts {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type RemoveNetworkContactsToMaterialMutationFn = Apollo.MutationFunction<Types.RemoveNetworkContactsToMaterialMutation, Types.RemoveNetworkContactsToMaterialMutationVariables>;

/**
 * __useRemoveNetworkContactsToMaterialMutation__
 *
 * To run a mutation, you first call `useRemoveNetworkContactsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNetworkContactsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNetworkContactsToMaterialMutation, { data, loading, error }] = useRemoveNetworkContactsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveNetworkContactsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveNetworkContactsToMaterialMutation, Types.RemoveNetworkContactsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveNetworkContactsToMaterialMutation, Types.RemoveNetworkContactsToMaterialMutationVariables>(RemoveNetworkContactsToMaterialDocument, options);
      }
export type RemoveNetworkContactsToMaterialMutationHookResult = ReturnType<typeof useRemoveNetworkContactsToMaterialMutation>;
export type RemoveNetworkContactsToMaterialMutationResult = Apollo.MutationResult<Types.RemoveNetworkContactsToMaterialMutation>;
export type RemoveNetworkContactsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.RemoveNetworkContactsToMaterialMutation, Types.RemoveNetworkContactsToMaterialMutationVariables>;
export const UpdateNetworkContactsToMaterialDocument = gql`
    mutation UpdateNetworkContactsToMaterial($input: MaterialNetworkContactUpdateInput!) {
  materialNetworkContactsUpdate(input: $input) {
    material {
      id
      contactsCount
      individualNetworkContacts {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type UpdateNetworkContactsToMaterialMutationFn = Apollo.MutationFunction<Types.UpdateNetworkContactsToMaterialMutation, Types.UpdateNetworkContactsToMaterialMutationVariables>;

/**
 * __useUpdateNetworkContactsToMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateNetworkContactsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNetworkContactsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNetworkContactsToMaterialMutation, { data, loading, error }] = useUpdateNetworkContactsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNetworkContactsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNetworkContactsToMaterialMutation, Types.UpdateNetworkContactsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNetworkContactsToMaterialMutation, Types.UpdateNetworkContactsToMaterialMutationVariables>(UpdateNetworkContactsToMaterialDocument, options);
      }
export type UpdateNetworkContactsToMaterialMutationHookResult = ReturnType<typeof useUpdateNetworkContactsToMaterialMutation>;
export type UpdateNetworkContactsToMaterialMutationResult = Apollo.MutationResult<Types.UpdateNetworkContactsToMaterialMutation>;
export type UpdateNetworkContactsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNetworkContactsToMaterialMutation, Types.UpdateNetworkContactsToMaterialMutationVariables>;
export const AddPendingDistributionContactsToMaterialDocument = gql`
    mutation AddPendingDistributionContactsToMaterial($input: MaterialPendingDistributionContactAddInput!) {
  materialPendingDistributionContactsAdd(input: $input) {
    material {
      id
      contactsCount
      pendingDistributionContacts {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type AddPendingDistributionContactsToMaterialMutationFn = Apollo.MutationFunction<Types.AddPendingDistributionContactsToMaterialMutation, Types.AddPendingDistributionContactsToMaterialMutationVariables>;

/**
 * __useAddPendingDistributionContactsToMaterialMutation__
 *
 * To run a mutation, you first call `useAddPendingDistributionContactsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPendingDistributionContactsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPendingDistributionContactsToMaterialMutation, { data, loading, error }] = useAddPendingDistributionContactsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPendingDistributionContactsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddPendingDistributionContactsToMaterialMutation, Types.AddPendingDistributionContactsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddPendingDistributionContactsToMaterialMutation, Types.AddPendingDistributionContactsToMaterialMutationVariables>(AddPendingDistributionContactsToMaterialDocument, options);
      }
export type AddPendingDistributionContactsToMaterialMutationHookResult = ReturnType<typeof useAddPendingDistributionContactsToMaterialMutation>;
export type AddPendingDistributionContactsToMaterialMutationResult = Apollo.MutationResult<Types.AddPendingDistributionContactsToMaterialMutation>;
export type AddPendingDistributionContactsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddPendingDistributionContactsToMaterialMutation, Types.AddPendingDistributionContactsToMaterialMutationVariables>;
export const UpdatePendingDistributionContactsToMaterialDocument = gql`
    mutation UpdatePendingDistributionContactsToMaterial($input: MaterialPendingDistributionContactUpdateInput!) {
  materialPendingDistributionContactsUpdate(input: $input) {
    material {
      id
      contactsCount
      pendingDistributionContacts {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type UpdatePendingDistributionContactsToMaterialMutationFn = Apollo.MutationFunction<Types.UpdatePendingDistributionContactsToMaterialMutation, Types.UpdatePendingDistributionContactsToMaterialMutationVariables>;

/**
 * __useUpdatePendingDistributionContactsToMaterialMutation__
 *
 * To run a mutation, you first call `useUpdatePendingDistributionContactsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePendingDistributionContactsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePendingDistributionContactsToMaterialMutation, { data, loading, error }] = useUpdatePendingDistributionContactsToMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePendingDistributionContactsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePendingDistributionContactsToMaterialMutation, Types.UpdatePendingDistributionContactsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePendingDistributionContactsToMaterialMutation, Types.UpdatePendingDistributionContactsToMaterialMutationVariables>(UpdatePendingDistributionContactsToMaterialDocument, options);
      }
export type UpdatePendingDistributionContactsToMaterialMutationHookResult = ReturnType<typeof useUpdatePendingDistributionContactsToMaterialMutation>;
export type UpdatePendingDistributionContactsToMaterialMutationResult = Apollo.MutationResult<Types.UpdatePendingDistributionContactsToMaterialMutation>;
export type UpdatePendingDistributionContactsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePendingDistributionContactsToMaterialMutation, Types.UpdatePendingDistributionContactsToMaterialMutationVariables>;
export const RemovePendingDistributionContactsFromMaterialDocument = gql`
    mutation RemovePendingDistributionContactsFromMaterial($input: MaterialPendingDistributionContactRemoveInput!) {
  materialPendingDistributionContactsRemove(input: $input) {
    material {
      id
      contactsCount
      pendingDistributionContacts {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type RemovePendingDistributionContactsFromMaterialMutationFn = Apollo.MutationFunction<Types.RemovePendingDistributionContactsFromMaterialMutation, Types.RemovePendingDistributionContactsFromMaterialMutationVariables>;

/**
 * __useRemovePendingDistributionContactsFromMaterialMutation__
 *
 * To run a mutation, you first call `useRemovePendingDistributionContactsFromMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePendingDistributionContactsFromMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePendingDistributionContactsFromMaterialMutation, { data, loading, error }] = useRemovePendingDistributionContactsFromMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePendingDistributionContactsFromMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemovePendingDistributionContactsFromMaterialMutation, Types.RemovePendingDistributionContactsFromMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemovePendingDistributionContactsFromMaterialMutation, Types.RemovePendingDistributionContactsFromMaterialMutationVariables>(RemovePendingDistributionContactsFromMaterialDocument, options);
      }
export type RemovePendingDistributionContactsFromMaterialMutationHookResult = ReturnType<typeof useRemovePendingDistributionContactsFromMaterialMutation>;
export type RemovePendingDistributionContactsFromMaterialMutationResult = Apollo.MutationResult<Types.RemovePendingDistributionContactsFromMaterialMutation>;
export type RemovePendingDistributionContactsFromMaterialMutationOptions = Apollo.BaseMutationOptions<Types.RemovePendingDistributionContactsFromMaterialMutation, Types.RemovePendingDistributionContactsFromMaterialMutationVariables>;
export const MatchingJournalistsDocument = gql`
    query MatchingJournalists($materialId: ID!, $materialType: MaterialType!, $pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    mndReachMatchingJournalists(
      materialId: $materialId
      materialType: $materialType
    ) {
      id
      items {
        id
        name
        email
        ... on MndReachJournalist {
          imgUrl
          motivation
          mainOutlet {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMatchingJournalistsQuery__
 *
 * To run a query within a React component, call `useMatchingJournalistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchingJournalistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchingJournalistsQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useMatchingJournalistsQuery(baseOptions: Apollo.QueryHookOptions<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables> & ({ variables: Types.MatchingJournalistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables>(MatchingJournalistsDocument, options);
      }
export function useMatchingJournalistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables>(MatchingJournalistsDocument, options);
        }
export function useMatchingJournalistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables>(MatchingJournalistsDocument, options);
        }
export type MatchingJournalistsQueryHookResult = ReturnType<typeof useMatchingJournalistsQuery>;
export type MatchingJournalistsLazyQueryHookResult = ReturnType<typeof useMatchingJournalistsLazyQuery>;
export type MatchingJournalistsSuspenseQueryHookResult = ReturnType<typeof useMatchingJournalistsSuspenseQuery>;
export type MatchingJournalistsQueryResult = Apollo.QueryResult<Types.MatchingJournalistsQuery, Types.MatchingJournalistsQueryVariables>;
export const GetPreviewDocument = gql`
    query GetPreview($pressroomId: ID!, $id: ID!, $type: MaterialType!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    features {
      id
      publishScheduling: managed(feature: publishScheduling) {
        id
        enabled
      }
    }
  }
  material(id: $id, type: $type) {
    id
    ... on StoryMaterial {
      previewUrl
    }
    ... on Event {
      previewUrl
    }
  }
}
    `;

/**
 * __useGetPreviewQuery__
 *
 * To run a query within a React component, call `useGetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPreviewQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPreviewQuery, Types.GetPreviewQueryVariables> & ({ variables: Types.GetPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPreviewQuery, Types.GetPreviewQueryVariables>(GetPreviewDocument, options);
      }
export function useGetPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPreviewQuery, Types.GetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPreviewQuery, Types.GetPreviewQueryVariables>(GetPreviewDocument, options);
        }
export function useGetPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPreviewQuery, Types.GetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPreviewQuery, Types.GetPreviewQueryVariables>(GetPreviewDocument, options);
        }
export type GetPreviewQueryHookResult = ReturnType<typeof useGetPreviewQuery>;
export type GetPreviewLazyQueryHookResult = ReturnType<typeof useGetPreviewLazyQuery>;
export type GetPreviewSuspenseQueryHookResult = ReturnType<typeof useGetPreviewSuspenseQuery>;
export type GetPreviewQueryResult = Apollo.QueryResult<Types.GetPreviewQuery, Types.GetPreviewQueryVariables>;
export const PublishConfirmationDocument = gql`
    query PublishConfirmation($pressroomId: ID!, $materialId: ID!, $type: MaterialType!) {
  material(id: $materialId, type: $type) {
    id
    publishedAt2
    ... on StoryMaterial {
      scheduledFor
      visibility
      generatedByAiWriter
      generatedByAiWriterTemplate
      contactPeople: contactPeople2 {
        id
        ...ContactPersonListData
      }
    }
    ... on Document {
      contactPeople: contactPeople2 {
        id
        ...ContactPersonListData
      }
    }
    ... on Event {
      contactPeople: contactPeople2 {
        id
        ...ContactPersonListData
      }
    }
    ... on Video {
      contactPeople: contactPeople2 {
        id
        ...ContactPersonListData
      }
    }
    channels {
      id
      channelName
    }
    relatedMaterial(includeRecursive: true) {
      id
      status
      publishedAt: publishedAt2
      scheduledFor
      header
      thumbnail: image {
        id
        cloudinaryId
        url(transformation: THUMBNAIL_SMALL)
        altText
      }
      ... on Video {
        resourceVideo {
          id
        }
        thumbnailUrl
      }
      ... on Document {
        preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
      }
    }
  }
  pressroom(id: $pressroomId) {
    id
    live
    source {
      id
      trusted
    }
  }
}
    ${ContactPersonListDataFragmentDoc}`;

/**
 * __usePublishConfirmationQuery__
 *
 * To run a query within a React component, call `usePublishConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishConfirmationQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePublishConfirmationQuery(baseOptions: Apollo.QueryHookOptions<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables> & ({ variables: Types.PublishConfirmationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables>(PublishConfirmationDocument, options);
      }
export function usePublishConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables>(PublishConfirmationDocument, options);
        }
export function usePublishConfirmationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables>(PublishConfirmationDocument, options);
        }
export type PublishConfirmationQueryHookResult = ReturnType<typeof usePublishConfirmationQuery>;
export type PublishConfirmationLazyQueryHookResult = ReturnType<typeof usePublishConfirmationLazyQuery>;
export type PublishConfirmationSuspenseQueryHookResult = ReturnType<typeof usePublishConfirmationSuspenseQuery>;
export type PublishConfirmationQueryResult = Apollo.QueryResult<Types.PublishConfirmationQuery, Types.PublishConfirmationQueryVariables>;
export const GetMaterialTrackingDataDocument = gql`
    query GetMaterialTrackingData($materialId: ID!, $type: MaterialType!) {
  material(id: $materialId, type: $type) {
    id
    ... on Pressrelease {
      id
      publishedAt2
      scheduledFor
      visibility
      boilerplate
      summary
      tags
      disableAlertSubscriptionEmails
      contactPeople: contactPeople2 {
        id
      }
      image {
        id
      }
      regions {
        id
      }
      subjects {
        id
      }
      networkContactLists {
        id
      }
      channels {
        id
      }
      links {
        name
      }
      relatedStories: relatedMaterial(types: [Pressrelease, News, BlogPost, Event]) {
        id
      }
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
      }
      generatedByAiWriter
      generatedByAiWriterTemplate
    }
    individualNetworkContacts {
      id
      importedVia
      importedViaRecommendedContacts
    }
  }
}
    `;

/**
 * __useGetMaterialTrackingDataQuery__
 *
 * To run a query within a React component, call `useGetMaterialTrackingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialTrackingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialTrackingDataQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMaterialTrackingDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables> & ({ variables: Types.GetMaterialTrackingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables>(GetMaterialTrackingDataDocument, options);
      }
export function useGetMaterialTrackingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables>(GetMaterialTrackingDataDocument, options);
        }
export function useGetMaterialTrackingDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables>(GetMaterialTrackingDataDocument, options);
        }
export type GetMaterialTrackingDataQueryHookResult = ReturnType<typeof useGetMaterialTrackingDataQuery>;
export type GetMaterialTrackingDataLazyQueryHookResult = ReturnType<typeof useGetMaterialTrackingDataLazyQuery>;
export type GetMaterialTrackingDataSuspenseQueryHookResult = ReturnType<typeof useGetMaterialTrackingDataSuspenseQuery>;
export type GetMaterialTrackingDataQueryResult = Apollo.QueryResult<Types.GetMaterialTrackingDataQuery, Types.GetMaterialTrackingDataQueryVariables>;
export const GetShouldShowPublishingPolicyDocument = gql`
    query getShouldShowPublishingPolicy($sourceId: ID!) {
  source(id: $sourceId) {
    id
    shouldAcceptPublishPolicy
  }
}
    `;

/**
 * __useGetShouldShowPublishingPolicyQuery__
 *
 * To run a query within a React component, call `useGetShouldShowPublishingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShouldShowPublishingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShouldShowPublishingPolicyQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetShouldShowPublishingPolicyQuery(baseOptions: Apollo.QueryHookOptions<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables> & ({ variables: Types.GetShouldShowPublishingPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables>(GetShouldShowPublishingPolicyDocument, options);
      }
export function useGetShouldShowPublishingPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables>(GetShouldShowPublishingPolicyDocument, options);
        }
export function useGetShouldShowPublishingPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables>(GetShouldShowPublishingPolicyDocument, options);
        }
export type GetShouldShowPublishingPolicyQueryHookResult = ReturnType<typeof useGetShouldShowPublishingPolicyQuery>;
export type GetShouldShowPublishingPolicyLazyQueryHookResult = ReturnType<typeof useGetShouldShowPublishingPolicyLazyQuery>;
export type GetShouldShowPublishingPolicySuspenseQueryHookResult = ReturnType<typeof useGetShouldShowPublishingPolicySuspenseQuery>;
export type GetShouldShowPublishingPolicyQueryResult = Apollo.QueryResult<Types.GetShouldShowPublishingPolicyQuery, Types.GetShouldShowPublishingPolicyQueryVariables>;
export const GetLimitsDocument = gql`
    query GetLimits($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!, $site: String!) {
  pressroom(id: $pressroomId) {
    id
    siteCode
    features {
      id
      publish {
        id
        subjects {
          max
        }
        regions {
          max
        }
      }
    }
    newsroomUrl
  }
  material(id: $materialId, type: $materialType) {
    id
    publishedAt2
    status
    regions {
      id
      name
      fullName
    }
    subjects {
      id
      name
      fullName
      automated
    }
  }
  subjects(site: $site) {
    id
    name
    childrenIncludingParent {
      id
      name
      fullName
    }
  }
  regions(site: $site) {
    id
    name
    childrenIncludingParent {
      id
      name
      fullName
    }
  }
}
    `;

/**
 * __useGetLimitsQuery__
 *
 * To run a query within a React component, call `useGetLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      site: // value for 'site'
 *   },
 * });
 */
export function useGetLimitsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetLimitsQuery, Types.GetLimitsQueryVariables> & ({ variables: Types.GetLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLimitsQuery, Types.GetLimitsQueryVariables>(GetLimitsDocument, options);
      }
export function useGetLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLimitsQuery, Types.GetLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLimitsQuery, Types.GetLimitsQueryVariables>(GetLimitsDocument, options);
        }
export function useGetLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetLimitsQuery, Types.GetLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLimitsQuery, Types.GetLimitsQueryVariables>(GetLimitsDocument, options);
        }
export type GetLimitsQueryHookResult = ReturnType<typeof useGetLimitsQuery>;
export type GetLimitsLazyQueryHookResult = ReturnType<typeof useGetLimitsLazyQuery>;
export type GetLimitsSuspenseQueryHookResult = ReturnType<typeof useGetLimitsSuspenseQuery>;
export type GetLimitsQueryResult = Apollo.QueryResult<Types.GetLimitsQuery, Types.GetLimitsQueryVariables>;
export const AddSubjectsToMaterialDocument = gql`
    mutation addSubjectsToMaterial($Input: MaterialSubjectsAddInput!) {
  materialSubjectsAdd(input: $Input) {
    material {
      id
      subjects {
        id
      }
    }
    error {
      __typename
    }
  }
}
    `;
export type AddSubjectsToMaterialMutationFn = Apollo.MutationFunction<Types.AddSubjectsToMaterialMutation, Types.AddSubjectsToMaterialMutationVariables>;

/**
 * __useAddSubjectsToMaterialMutation__
 *
 * To run a mutation, you first call `useAddSubjectsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubjectsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubjectsToMaterialMutation, { data, loading, error }] = useAddSubjectsToMaterialMutation({
 *   variables: {
 *      Input: // value for 'Input'
 *   },
 * });
 */
export function useAddSubjectsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddSubjectsToMaterialMutation, Types.AddSubjectsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddSubjectsToMaterialMutation, Types.AddSubjectsToMaterialMutationVariables>(AddSubjectsToMaterialDocument, options);
      }
export type AddSubjectsToMaterialMutationHookResult = ReturnType<typeof useAddSubjectsToMaterialMutation>;
export type AddSubjectsToMaterialMutationResult = Apollo.MutationResult<Types.AddSubjectsToMaterialMutation>;
export type AddSubjectsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddSubjectsToMaterialMutation, Types.AddSubjectsToMaterialMutationVariables>;
export const RemoveSubjectsFromMaterialDocument = gql`
    mutation removeSubjectsFromMaterial($Input: MaterialSubjectsRemoveInput!) {
  materialSubjectsRemove(input: $Input) {
    material {
      id
      subjects {
        id
      }
    }
    error {
      __typename
    }
  }
}
    `;
export type RemoveSubjectsFromMaterialMutationFn = Apollo.MutationFunction<Types.RemoveSubjectsFromMaterialMutation, Types.RemoveSubjectsFromMaterialMutationVariables>;

/**
 * __useRemoveSubjectsFromMaterialMutation__
 *
 * To run a mutation, you first call `useRemoveSubjectsFromMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubjectsFromMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubjectsFromMaterialMutation, { data, loading, error }] = useRemoveSubjectsFromMaterialMutation({
 *   variables: {
 *      Input: // value for 'Input'
 *   },
 * });
 */
export function useRemoveSubjectsFromMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveSubjectsFromMaterialMutation, Types.RemoveSubjectsFromMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveSubjectsFromMaterialMutation, Types.RemoveSubjectsFromMaterialMutationVariables>(RemoveSubjectsFromMaterialDocument, options);
      }
export type RemoveSubjectsFromMaterialMutationHookResult = ReturnType<typeof useRemoveSubjectsFromMaterialMutation>;
export type RemoveSubjectsFromMaterialMutationResult = Apollo.MutationResult<Types.RemoveSubjectsFromMaterialMutation>;
export type RemoveSubjectsFromMaterialMutationOptions = Apollo.BaseMutationOptions<Types.RemoveSubjectsFromMaterialMutation, Types.RemoveSubjectsFromMaterialMutationVariables>;
export const SetMaterialSubjectsDocument = gql`
    mutation setMaterialSubjects($Input: MaterialSubjectsUpdateInput!) {
  materialSubjectsUpdate(input: $Input) {
    material {
      id
      subjects {
        id
      }
    }
    error {
      __typename
    }
  }
}
    `;
export type SetMaterialSubjectsMutationFn = Apollo.MutationFunction<Types.SetMaterialSubjectsMutation, Types.SetMaterialSubjectsMutationVariables>;

/**
 * __useSetMaterialSubjectsMutation__
 *
 * To run a mutation, you first call `useSetMaterialSubjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMaterialSubjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMaterialSubjectsMutation, { data, loading, error }] = useSetMaterialSubjectsMutation({
 *   variables: {
 *      Input: // value for 'Input'
 *   },
 * });
 */
export function useSetMaterialSubjectsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetMaterialSubjectsMutation, Types.SetMaterialSubjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetMaterialSubjectsMutation, Types.SetMaterialSubjectsMutationVariables>(SetMaterialSubjectsDocument, options);
      }
export type SetMaterialSubjectsMutationHookResult = ReturnType<typeof useSetMaterialSubjectsMutation>;
export type SetMaterialSubjectsMutationResult = Apollo.MutationResult<Types.SetMaterialSubjectsMutation>;
export type SetMaterialSubjectsMutationOptions = Apollo.BaseMutationOptions<Types.SetMaterialSubjectsMutation, Types.SetMaterialSubjectsMutationVariables>;
export const AddRegionsToMaterialDocument = gql`
    mutation addRegionsToMaterial($Input: MaterialRegionsAddInput!) {
  materialRegionsAdd(input: $Input) {
    material {
      id
      regions {
        id
      }
    }
    error {
      __typename
    }
  }
}
    `;
export type AddRegionsToMaterialMutationFn = Apollo.MutationFunction<Types.AddRegionsToMaterialMutation, Types.AddRegionsToMaterialMutationVariables>;

/**
 * __useAddRegionsToMaterialMutation__
 *
 * To run a mutation, you first call `useAddRegionsToMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRegionsToMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRegionsToMaterialMutation, { data, loading, error }] = useAddRegionsToMaterialMutation({
 *   variables: {
 *      Input: // value for 'Input'
 *   },
 * });
 */
export function useAddRegionsToMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRegionsToMaterialMutation, Types.AddRegionsToMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRegionsToMaterialMutation, Types.AddRegionsToMaterialMutationVariables>(AddRegionsToMaterialDocument, options);
      }
export type AddRegionsToMaterialMutationHookResult = ReturnType<typeof useAddRegionsToMaterialMutation>;
export type AddRegionsToMaterialMutationResult = Apollo.MutationResult<Types.AddRegionsToMaterialMutation>;
export type AddRegionsToMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddRegionsToMaterialMutation, Types.AddRegionsToMaterialMutationVariables>;
export const RemoveRegionsFromMaterialDocument = gql`
    mutation removeRegionsFromMaterial($Input: MaterialRegionsRemoveInput!) {
  materialRegionsRemove(input: $Input) {
    material {
      id
      regions {
        id
      }
    }
    error {
      __typename
    }
  }
}
    `;
export type RemoveRegionsFromMaterialMutationFn = Apollo.MutationFunction<Types.RemoveRegionsFromMaterialMutation, Types.RemoveRegionsFromMaterialMutationVariables>;

/**
 * __useRemoveRegionsFromMaterialMutation__
 *
 * To run a mutation, you first call `useRemoveRegionsFromMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRegionsFromMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRegionsFromMaterialMutation, { data, loading, error }] = useRemoveRegionsFromMaterialMutation({
 *   variables: {
 *      Input: // value for 'Input'
 *   },
 * });
 */
export function useRemoveRegionsFromMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveRegionsFromMaterialMutation, Types.RemoveRegionsFromMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveRegionsFromMaterialMutation, Types.RemoveRegionsFromMaterialMutationVariables>(RemoveRegionsFromMaterialDocument, options);
      }
export type RemoveRegionsFromMaterialMutationHookResult = ReturnType<typeof useRemoveRegionsFromMaterialMutation>;
export type RemoveRegionsFromMaterialMutationResult = Apollo.MutationResult<Types.RemoveRegionsFromMaterialMutation>;
export type RemoveRegionsFromMaterialMutationOptions = Apollo.BaseMutationOptions<Types.RemoveRegionsFromMaterialMutation, Types.RemoveRegionsFromMaterialMutationVariables>;
export const SetMaterialRegionsDocument = gql`
    mutation setMaterialRegions($Input: MaterialRegionsUpdateInput!) {
  materialRegionsUpdate(input: $Input) {
    material {
      id
      regions {
        id
      }
    }
    error {
      __typename
    }
  }
}
    `;
export type SetMaterialRegionsMutationFn = Apollo.MutationFunction<Types.SetMaterialRegionsMutation, Types.SetMaterialRegionsMutationVariables>;

/**
 * __useSetMaterialRegionsMutation__
 *
 * To run a mutation, you first call `useSetMaterialRegionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMaterialRegionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMaterialRegionsMutation, { data, loading, error }] = useSetMaterialRegionsMutation({
 *   variables: {
 *      Input: // value for 'Input'
 *   },
 * });
 */
export function useSetMaterialRegionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetMaterialRegionsMutation, Types.SetMaterialRegionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetMaterialRegionsMutation, Types.SetMaterialRegionsMutationVariables>(SetMaterialRegionsDocument, options);
      }
export type SetMaterialRegionsMutationHookResult = ReturnType<typeof useSetMaterialRegionsMutation>;
export type SetMaterialRegionsMutationResult = Apollo.MutationResult<Types.SetMaterialRegionsMutation>;
export type SetMaterialRegionsMutationOptions = Apollo.BaseMutationOptions<Types.SetMaterialRegionsMutation, Types.SetMaterialRegionsMutationVariables>;
export const SeenAutomatedTopicsBannerDocument = gql`
    mutation seenAutomatedTopicsBanner($pressroomId: ID!, $notice: Notice!) {
  noticeConfirm(input: {notice: $notice, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      automatedTopicsBanner
    }
  }
}
    `;
export type SeenAutomatedTopicsBannerMutationFn = Apollo.MutationFunction<Types.SeenAutomatedTopicsBannerMutation, Types.SeenAutomatedTopicsBannerMutationVariables>;

/**
 * __useSeenAutomatedTopicsBannerMutation__
 *
 * To run a mutation, you first call `useSeenAutomatedTopicsBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenAutomatedTopicsBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenAutomatedTopicsBannerMutation, { data, loading, error }] = useSeenAutomatedTopicsBannerMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      notice: // value for 'notice'
 *   },
 * });
 */
export function useSeenAutomatedTopicsBannerMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenAutomatedTopicsBannerMutation, Types.SeenAutomatedTopicsBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenAutomatedTopicsBannerMutation, Types.SeenAutomatedTopicsBannerMutationVariables>(SeenAutomatedTopicsBannerDocument, options);
      }
export type SeenAutomatedTopicsBannerMutationHookResult = ReturnType<typeof useSeenAutomatedTopicsBannerMutation>;
export type SeenAutomatedTopicsBannerMutationResult = Apollo.MutationResult<Types.SeenAutomatedTopicsBannerMutation>;
export type SeenAutomatedTopicsBannerMutationOptions = Apollo.BaseMutationOptions<Types.SeenAutomatedTopicsBannerMutation, Types.SeenAutomatedTopicsBannerMutationVariables>;
export const GetOpenEmailsWeekStatsDocument = gql`
    query GetOpenEmailsWeekStats($materialId: ID!, $materialType: MaterialType!) {
  material(id: $materialId, type: $materialType) {
    id
    ... on StoryMaterial {
      openEmailsWeekStats {
        day
        stats {
          time
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetOpenEmailsWeekStatsQuery__
 *
 * To run a query within a React component, call `useGetOpenEmailsWeekStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenEmailsWeekStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenEmailsWeekStatsQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useGetOpenEmailsWeekStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables> & ({ variables: Types.GetOpenEmailsWeekStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables>(GetOpenEmailsWeekStatsDocument, options);
      }
export function useGetOpenEmailsWeekStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables>(GetOpenEmailsWeekStatsDocument, options);
        }
export function useGetOpenEmailsWeekStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables>(GetOpenEmailsWeekStatsDocument, options);
        }
export type GetOpenEmailsWeekStatsQueryHookResult = ReturnType<typeof useGetOpenEmailsWeekStatsQuery>;
export type GetOpenEmailsWeekStatsLazyQueryHookResult = ReturnType<typeof useGetOpenEmailsWeekStatsLazyQuery>;
export type GetOpenEmailsWeekStatsSuspenseQueryHookResult = ReturnType<typeof useGetOpenEmailsWeekStatsSuspenseQuery>;
export type GetOpenEmailsWeekStatsQueryResult = Apollo.QueryResult<Types.GetOpenEmailsWeekStatsQuery, Types.GetOpenEmailsWeekStatsQueryVariables>;
export const GetDistributionAlertSubscriptionEmailsValueDocument = gql`
    query getDistributionAlertSubscriptionEmailsValue($materialId: ID!, $materialType: MaterialType!) {
  material(id: $materialId, type: $materialType) {
    id
    disableAlertSubscriptionEmails
    publishedAt2
    status
  }
}
    `;

/**
 * __useGetDistributionAlertSubscriptionEmailsValueQuery__
 *
 * To run a query within a React component, call `useGetDistributionAlertSubscriptionEmailsValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionAlertSubscriptionEmailsValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionAlertSubscriptionEmailsValueQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useGetDistributionAlertSubscriptionEmailsValueQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables> & ({ variables: Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables>(GetDistributionAlertSubscriptionEmailsValueDocument, options);
      }
export function useGetDistributionAlertSubscriptionEmailsValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables>(GetDistributionAlertSubscriptionEmailsValueDocument, options);
        }
export function useGetDistributionAlertSubscriptionEmailsValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables>(GetDistributionAlertSubscriptionEmailsValueDocument, options);
        }
export type GetDistributionAlertSubscriptionEmailsValueQueryHookResult = ReturnType<typeof useGetDistributionAlertSubscriptionEmailsValueQuery>;
export type GetDistributionAlertSubscriptionEmailsValueLazyQueryHookResult = ReturnType<typeof useGetDistributionAlertSubscriptionEmailsValueLazyQuery>;
export type GetDistributionAlertSubscriptionEmailsValueSuspenseQueryHookResult = ReturnType<typeof useGetDistributionAlertSubscriptionEmailsValueSuspenseQuery>;
export type GetDistributionAlertSubscriptionEmailsValueQueryResult = Apollo.QueryResult<Types.GetDistributionAlertSubscriptionEmailsValueQuery, Types.GetDistributionAlertSubscriptionEmailsValueQueryVariables>;
export const SetDistributionAlertSubscriptionEmailsValueDocument = gql`
    mutation setDistributionAlertSubscriptionEmailsValue($input: MaterialAlertSubscriptionEmailsUpdateInput!) {
  materialAlertSubscriptionEmailsUpdate(input: $input) {
    material {
      id
      disableAlertSubscriptionEmails
      status
    }
    error {
      __typename
    }
  }
}
    `;
export type SetDistributionAlertSubscriptionEmailsValueMutationFn = Apollo.MutationFunction<Types.SetDistributionAlertSubscriptionEmailsValueMutation, Types.SetDistributionAlertSubscriptionEmailsValueMutationVariables>;

/**
 * __useSetDistributionAlertSubscriptionEmailsValueMutation__
 *
 * To run a mutation, you first call `useSetDistributionAlertSubscriptionEmailsValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDistributionAlertSubscriptionEmailsValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDistributionAlertSubscriptionEmailsValueMutation, { data, loading, error }] = useSetDistributionAlertSubscriptionEmailsValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDistributionAlertSubscriptionEmailsValueMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetDistributionAlertSubscriptionEmailsValueMutation, Types.SetDistributionAlertSubscriptionEmailsValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetDistributionAlertSubscriptionEmailsValueMutation, Types.SetDistributionAlertSubscriptionEmailsValueMutationVariables>(SetDistributionAlertSubscriptionEmailsValueDocument, options);
      }
export type SetDistributionAlertSubscriptionEmailsValueMutationHookResult = ReturnType<typeof useSetDistributionAlertSubscriptionEmailsValueMutation>;
export type SetDistributionAlertSubscriptionEmailsValueMutationResult = Apollo.MutationResult<Types.SetDistributionAlertSubscriptionEmailsValueMutation>;
export type SetDistributionAlertSubscriptionEmailsValueMutationOptions = Apollo.BaseMutationOptions<Types.SetDistributionAlertSubscriptionEmailsValueMutation, Types.SetDistributionAlertSubscriptionEmailsValueMutationVariables>;
export const GetVisibilityDataDocument = gql`
    query GetVisibilityData($pressroomId: ID!, $materialId: ID!, $materialType: MaterialType!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
  }
  material(id: $materialId, type: $materialType) {
    id
    status
    ... on StoryMaterial {
      visibility
    }
  }
}
    `;

/**
 * __useGetVisibilityDataQuery__
 *
 * To run a query within a React component, call `useGetVisibilityDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibilityDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibilityDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useGetVisibilityDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables> & ({ variables: Types.GetVisibilityDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables>(GetVisibilityDataDocument, options);
      }
export function useGetVisibilityDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables>(GetVisibilityDataDocument, options);
        }
export function useGetVisibilityDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables>(GetVisibilityDataDocument, options);
        }
export type GetVisibilityDataQueryHookResult = ReturnType<typeof useGetVisibilityDataQuery>;
export type GetVisibilityDataLazyQueryHookResult = ReturnType<typeof useGetVisibilityDataLazyQuery>;
export type GetVisibilityDataSuspenseQueryHookResult = ReturnType<typeof useGetVisibilityDataSuspenseQuery>;
export type GetVisibilityDataQueryResult = Apollo.QueryResult<Types.GetVisibilityDataQuery, Types.GetVisibilityDataQueryVariables>;
export const UpdateMaterialVisibilityDocument = gql`
    mutation updateMaterialVisibility($input: MaterialVisibilityUpdateInput!) {
  materialVisibilityUpdate(input: $input) {
    material {
      id
      status
      ... on StoryMaterial {
        visibility
      }
    }
    error {
      message
      __typename
    }
  }
}
    `;
export type UpdateMaterialVisibilityMutationFn = Apollo.MutationFunction<Types.UpdateMaterialVisibilityMutation, Types.UpdateMaterialVisibilityMutationVariables>;

/**
 * __useUpdateMaterialVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialVisibilityMutation, { data, loading, error }] = useUpdateMaterialVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMaterialVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMaterialVisibilityMutation, Types.UpdateMaterialVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMaterialVisibilityMutation, Types.UpdateMaterialVisibilityMutationVariables>(UpdateMaterialVisibilityDocument, options);
      }
export type UpdateMaterialVisibilityMutationHookResult = ReturnType<typeof useUpdateMaterialVisibilityMutation>;
export type UpdateMaterialVisibilityMutationResult = Apollo.MutationResult<Types.UpdateMaterialVisibilityMutation>;
export type UpdateMaterialVisibilityMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMaterialVisibilityMutation, Types.UpdateMaterialVisibilityMutationVariables>;
export const UpdateMaterialPublicationTimeDocument = gql`
    mutation UpdateMaterialPublicationTime($input: MaterialPublicationTimeUpdateInput!) {
  materialPublicationTimeUpdate(input: $input) {
    material {
      id
      expiresAt
      publishedAt2
      scheduledFor
      status
    }
    error {
      message
    }
  }
}
    `;
export type UpdateMaterialPublicationTimeMutationFn = Apollo.MutationFunction<Types.UpdateMaterialPublicationTimeMutation, Types.UpdateMaterialPublicationTimeMutationVariables>;

/**
 * __useUpdateMaterialPublicationTimeMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialPublicationTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialPublicationTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialPublicationTimeMutation, { data, loading, error }] = useUpdateMaterialPublicationTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMaterialPublicationTimeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMaterialPublicationTimeMutation, Types.UpdateMaterialPublicationTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMaterialPublicationTimeMutation, Types.UpdateMaterialPublicationTimeMutationVariables>(UpdateMaterialPublicationTimeDocument, options);
      }
export type UpdateMaterialPublicationTimeMutationHookResult = ReturnType<typeof useUpdateMaterialPublicationTimeMutation>;
export type UpdateMaterialPublicationTimeMutationResult = Apollo.MutationResult<Types.UpdateMaterialPublicationTimeMutation>;
export type UpdateMaterialPublicationTimeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMaterialPublicationTimeMutation, Types.UpdateMaterialPublicationTimeMutationVariables>;
export const LoadSocialMediaSuggestionsDocument = gql`
    query LoadSocialMediaSuggestions($id: ID!, $type: MaterialType!, $skipLinkedin: Boolean!, $skipFacebook: Boolean!, $skipYoutube: Boolean!, $skipTwitter: Boolean!) {
  material(id: $id, type: $type) {
    id
    ... on StoryMaterial {
      linkedinSuggestion: socialMediaSuggestion(type: Linkedin) @skip(if: $skipLinkedin)
      facebookSuggestion: socialMediaSuggestion(type: Facebook) @skip(if: $skipFacebook)
      youtubeSuggestion: socialMediaSuggestion(type: YouTube) @skip(if: $skipYoutube)
      twitterSuggestion: socialMediaSuggestion(type: Twitter) @skip(if: $skipTwitter)
    }
  }
}
    `;

/**
 * __useLoadSocialMediaSuggestionsQuery__
 *
 * To run a query within a React component, call `useLoadSocialMediaSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadSocialMediaSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadSocialMediaSuggestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      skipLinkedin: // value for 'skipLinkedin'
 *      skipFacebook: // value for 'skipFacebook'
 *      skipYoutube: // value for 'skipYoutube'
 *      skipTwitter: // value for 'skipTwitter'
 *   },
 * });
 */
export function useLoadSocialMediaSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables> & ({ variables: Types.LoadSocialMediaSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables>(LoadSocialMediaSuggestionsDocument, options);
      }
export function useLoadSocialMediaSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables>(LoadSocialMediaSuggestionsDocument, options);
        }
export function useLoadSocialMediaSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables>(LoadSocialMediaSuggestionsDocument, options);
        }
export type LoadSocialMediaSuggestionsQueryHookResult = ReturnType<typeof useLoadSocialMediaSuggestionsQuery>;
export type LoadSocialMediaSuggestionsLazyQueryHookResult = ReturnType<typeof useLoadSocialMediaSuggestionsLazyQuery>;
export type LoadSocialMediaSuggestionsSuspenseQueryHookResult = ReturnType<typeof useLoadSocialMediaSuggestionsSuspenseQuery>;
export type LoadSocialMediaSuggestionsQueryResult = Apollo.QueryResult<Types.LoadSocialMediaSuggestionsQuery, Types.LoadSocialMediaSuggestionsQueryVariables>;
export const SaveBlogPostDocument = gql`
    mutation SaveBlogPost($id: ID, $pressroomId: ID!, $body: String, $header: String, $imageCaption: String, $imageAltText: String, $summary: String, $resourceImageId: ID, $generatedByAiWriter: Boolean, $generatedByAiWriterTemplate: GeneratedByAiWriterTemplate, $showAiDisclaimerText: Boolean) {
  blogPostUpdate(
    input: {id: $id, pressroomId: $pressroomId, body: $body, header: $header, imageCaption: $imageCaption, imageAltText: $imageAltText, summary: $summary, resourceImageId: $resourceImageId, generatedByAiWriter: $generatedByAiWriter, generatedByAiWriterTemplate: $generatedByAiWriterTemplate, showAiDisclaimerText: $showAiDisclaimerText}
  ) {
    blogPost {
      id
      status
      body
      showAiDisclaimerText
      generatedByAiWriter
      imageCaption
      imageAltText
      image {
        id
        cloudinaryId
        resourceImageId
        url(transformation: MATERIAL_HEADER_PREVIEW)
        croppedUrl: url
        coverImageGravity {
          x
          y
        }
      }
      connectedImages {
        id
        usageCount
      }
      summary
      header
      draft
      readability
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
    previousImages {
      id
      usageCount
    }
    error {
      message
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type SaveBlogPostMutationFn = Apollo.MutationFunction<Types.SaveBlogPostMutation, Types.SaveBlogPostMutationVariables>;

/**
 * __useSaveBlogPostMutation__
 *
 * To run a mutation, you first call `useSaveBlogPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBlogPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBlogPostMutation, { data, loading, error }] = useSaveBlogPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      body: // value for 'body'
 *      header: // value for 'header'
 *      imageCaption: // value for 'imageCaption'
 *      imageAltText: // value for 'imageAltText'
 *      summary: // value for 'summary'
 *      resourceImageId: // value for 'resourceImageId'
 *      generatedByAiWriter: // value for 'generatedByAiWriter'
 *      generatedByAiWriterTemplate: // value for 'generatedByAiWriterTemplate'
 *      showAiDisclaimerText: // value for 'showAiDisclaimerText'
 *   },
 * });
 */
export function useSaveBlogPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveBlogPostMutation, Types.SaveBlogPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveBlogPostMutation, Types.SaveBlogPostMutationVariables>(SaveBlogPostDocument, options);
      }
export type SaveBlogPostMutationHookResult = ReturnType<typeof useSaveBlogPostMutation>;
export type SaveBlogPostMutationResult = Apollo.MutationResult<Types.SaveBlogPostMutation>;
export type SaveBlogPostMutationOptions = Apollo.BaseMutationOptions<Types.SaveBlogPostMutation, Types.SaveBlogPostMutationVariables>;
export const MediaLicenseTypeChangedDocument = gql`
    query MediaLicenseTypeChanged($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      changedMediaLicenseType
    }
  }
}
    `;

/**
 * __useMediaLicenseTypeChangedQuery__
 *
 * To run a query within a React component, call `useMediaLicenseTypeChangedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaLicenseTypeChangedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaLicenseTypeChangedQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useMediaLicenseTypeChangedQuery(baseOptions: Apollo.QueryHookOptions<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables> & ({ variables: Types.MediaLicenseTypeChangedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables>(MediaLicenseTypeChangedDocument, options);
      }
export function useMediaLicenseTypeChangedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables>(MediaLicenseTypeChangedDocument, options);
        }
export function useMediaLicenseTypeChangedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables>(MediaLicenseTypeChangedDocument, options);
        }
export type MediaLicenseTypeChangedQueryHookResult = ReturnType<typeof useMediaLicenseTypeChangedQuery>;
export type MediaLicenseTypeChangedLazyQueryHookResult = ReturnType<typeof useMediaLicenseTypeChangedLazyQuery>;
export type MediaLicenseTypeChangedSuspenseQueryHookResult = ReturnType<typeof useMediaLicenseTypeChangedSuspenseQuery>;
export type MediaLicenseTypeChangedQueryResult = Apollo.QueryResult<Types.MediaLicenseTypeChangedQuery, Types.MediaLicenseTypeChangedQueryVariables>;
export const SeenMediaLicenseTypeBannerDocument = gql`
    mutation seenMediaLicenseTypeBanner($pressroomId: ID!, $notice: Notice!) {
  noticeConfirm(input: {notice: $notice, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      changedMediaLicenseType
    }
  }
}
    `;
export type SeenMediaLicenseTypeBannerMutationFn = Apollo.MutationFunction<Types.SeenMediaLicenseTypeBannerMutation, Types.SeenMediaLicenseTypeBannerMutationVariables>;

/**
 * __useSeenMediaLicenseTypeBannerMutation__
 *
 * To run a mutation, you first call `useSeenMediaLicenseTypeBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenMediaLicenseTypeBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenMediaLicenseTypeBannerMutation, { data, loading, error }] = useSeenMediaLicenseTypeBannerMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      notice: // value for 'notice'
 *   },
 * });
 */
export function useSeenMediaLicenseTypeBannerMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenMediaLicenseTypeBannerMutation, Types.SeenMediaLicenseTypeBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenMediaLicenseTypeBannerMutation, Types.SeenMediaLicenseTypeBannerMutationVariables>(SeenMediaLicenseTypeBannerDocument, options);
      }
export type SeenMediaLicenseTypeBannerMutationHookResult = ReturnType<typeof useSeenMediaLicenseTypeBannerMutation>;
export type SeenMediaLicenseTypeBannerMutationResult = Apollo.MutationResult<Types.SeenMediaLicenseTypeBannerMutation>;
export type SeenMediaLicenseTypeBannerMutationOptions = Apollo.BaseMutationOptions<Types.SeenMediaLicenseTypeBannerMutation, Types.SeenMediaLicenseTypeBannerMutationVariables>;
export const UpdateResourceImageDocument = gql`
    mutation UpdateResourceImage($resourceImageId: ID!, $x: Int!, $y: Int!, $pressroomId: ID!) {
  resourceImageUpdate(
    input: {id: $resourceImageId, coverImageGravityX: $x, coverImageGravityY: $y, pressroomId: $pressroomId}
  ) {
    image {
      id
    }
    error {
      message
      __typename
    }
  }
}
    `;
export type UpdateResourceImageMutationFn = Apollo.MutationFunction<Types.UpdateResourceImageMutation, Types.UpdateResourceImageMutationVariables>;

/**
 * __useUpdateResourceImageMutation__
 *
 * To run a mutation, you first call `useUpdateResourceImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceImageMutation, { data, loading, error }] = useUpdateResourceImageMutation({
 *   variables: {
 *      resourceImageId: // value for 'resourceImageId'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useUpdateResourceImageMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateResourceImageMutation, Types.UpdateResourceImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateResourceImageMutation, Types.UpdateResourceImageMutationVariables>(UpdateResourceImageDocument, options);
      }
export type UpdateResourceImageMutationHookResult = ReturnType<typeof useUpdateResourceImageMutation>;
export type UpdateResourceImageMutationResult = Apollo.MutationResult<Types.UpdateResourceImageMutation>;
export type UpdateResourceImageMutationOptions = Apollo.BaseMutationOptions<Types.UpdateResourceImageMutation, Types.UpdateResourceImageMutationVariables>;
export const SaveDocumentDocument = gql`
    mutation SaveDocument($id: ID, $pressroomId: ID!, $header: String, $licenseId: ID, $summary: String, $copyright: String) {
  documentUpdate(
    input: {id: $id, pressroomId: $pressroomId, header: $header, licenseId: $licenseId, summary: $summary, copyright: $copyright}
  ) {
    document {
      id
      status
      header
      summary
      copyright
      license {
        id
        name
      }
      resourceDocument {
        id
        name
      }
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
    error {
      message
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type SaveDocumentMutationFn = Apollo.MutationFunction<Types.SaveDocumentMutation, Types.SaveDocumentMutationVariables>;

/**
 * __useSaveDocumentMutation__
 *
 * To run a mutation, you first call `useSaveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentMutation, { data, loading, error }] = useSaveDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      header: // value for 'header'
 *      licenseId: // value for 'licenseId'
 *      summary: // value for 'summary'
 *      copyright: // value for 'copyright'
 *   },
 * });
 */
export function useSaveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveDocumentMutation, Types.SaveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveDocumentMutation, Types.SaveDocumentMutationVariables>(SaveDocumentDocument, options);
      }
export type SaveDocumentMutationHookResult = ReturnType<typeof useSaveDocumentMutation>;
export type SaveDocumentMutationResult = Apollo.MutationResult<Types.SaveDocumentMutation>;
export type SaveDocumentMutationOptions = Apollo.BaseMutationOptions<Types.SaveDocumentMutation, Types.SaveDocumentMutationVariables>;
export const RemoveResourceDocumentDocument = gql`
    mutation RemoveResourceDocument($id: ID!, $pressroomId: ID!) {
  documentRemoveResourceDocument(input: {id: $id, pressroomId: $pressroomId}) {
    document {
      id
      resourceDocument {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type RemoveResourceDocumentMutationFn = Apollo.MutationFunction<Types.RemoveResourceDocumentMutation, Types.RemoveResourceDocumentMutationVariables>;

/**
 * __useRemoveResourceDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveResourceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveResourceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeResourceDocumentMutation, { data, loading, error }] = useRemoveResourceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useRemoveResourceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveResourceDocumentMutation, Types.RemoveResourceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveResourceDocumentMutation, Types.RemoveResourceDocumentMutationVariables>(RemoveResourceDocumentDocument, options);
      }
export type RemoveResourceDocumentMutationHookResult = ReturnType<typeof useRemoveResourceDocumentMutation>;
export type RemoveResourceDocumentMutationResult = Apollo.MutationResult<Types.RemoveResourceDocumentMutation>;
export type RemoveResourceDocumentMutationOptions = Apollo.BaseMutationOptions<Types.RemoveResourceDocumentMutation, Types.RemoveResourceDocumentMutationVariables>;
export const SaveEventDocument = gql`
    mutation SaveEvent($id: ID, $pressroomId: ID!, $resourceImageId: ID, $imageCaption: String, $imageAltText: String, $startAt: DateTime, $endAt: DateTime, $allDay: Boolean, $header: String, $summary: String, $location: String, $signupUrl: String) {
  eventUpdate(
    input: {id: $id, pressroomId: $pressroomId, resourceImageId: $resourceImageId, imageCaption: $imageCaption, imageAltText: $imageAltText, startAt: $startAt, endAt: $endAt, allDay: $allDay, header: $header, summary: $summary, location: $location, signupUrl: $signupUrl}
  ) {
    event {
      id
      status
      draft
      image {
        id
        cloudinaryId
        resourceImageId
        url(transformation: MATERIAL_HEADER_PREVIEW)
        croppedUrl: url
        coverImageGravity {
          x
          y
        }
      }
      connectedImages {
        id
        usageCount
      }
      imageCaption
      imageAltText
      startAt
      endAt
      allDay
      header
      summary
      location
      signupUrl
      previewUrl
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
    previousImages {
      id
      usageCount
    }
    error {
      message
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type SaveEventMutationFn = Apollo.MutationFunction<Types.SaveEventMutation, Types.SaveEventMutationVariables>;

/**
 * __useSaveEventMutation__
 *
 * To run a mutation, you first call `useSaveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventMutation, { data, loading, error }] = useSaveEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      resourceImageId: // value for 'resourceImageId'
 *      imageCaption: // value for 'imageCaption'
 *      imageAltText: // value for 'imageAltText'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      allDay: // value for 'allDay'
 *      header: // value for 'header'
 *      summary: // value for 'summary'
 *      location: // value for 'location'
 *      signupUrl: // value for 'signupUrl'
 *   },
 * });
 */
export function useSaveEventMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveEventMutation, Types.SaveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveEventMutation, Types.SaveEventMutationVariables>(SaveEventDocument, options);
      }
export type SaveEventMutationHookResult = ReturnType<typeof useSaveEventMutation>;
export type SaveEventMutationResult = Apollo.MutationResult<Types.SaveEventMutation>;
export type SaveEventMutationOptions = Apollo.BaseMutationOptions<Types.SaveEventMutation, Types.SaveEventMutationVariables>;
export const LicensesDocument = gql`
    query Licenses {
  licenses {
    id
    name
  }
}
    `;

/**
 * __useLicensesQuery__
 *
 * To run a query within a React component, call `useLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicensesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicensesQuery(baseOptions?: Apollo.QueryHookOptions<Types.LicensesQuery, Types.LicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LicensesQuery, Types.LicensesQueryVariables>(LicensesDocument, options);
      }
export function useLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LicensesQuery, Types.LicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LicensesQuery, Types.LicensesQueryVariables>(LicensesDocument, options);
        }
export function useLicensesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LicensesQuery, Types.LicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LicensesQuery, Types.LicensesQueryVariables>(LicensesDocument, options);
        }
export type LicensesQueryHookResult = ReturnType<typeof useLicensesQuery>;
export type LicensesLazyQueryHookResult = ReturnType<typeof useLicensesLazyQuery>;
export type LicensesSuspenseQueryHookResult = ReturnType<typeof useLicensesSuspenseQuery>;
export type LicensesQueryResult = Apollo.QueryResult<Types.LicensesQuery, Types.LicensesQueryVariables>;
export const SaveNewsDocument = gql`
    mutation SaveNews($id: ID, $pressroomId: ID!, $body: String, $header: String, $imageCaption: String, $imageAltText: String, $summary: String, $resourceImageId: ID, $generatedByAiWriter: Boolean, $generatedByAiWriterTemplate: GeneratedByAiWriterTemplate, $showAiDisclaimerText: Boolean) {
  newsUpdate(
    input: {id: $id, pressroomId: $pressroomId, body: $body, header: $header, imageCaption: $imageCaption, imageAltText: $imageAltText, summary: $summary, resourceImageId: $resourceImageId, generatedByAiWriter: $generatedByAiWriter, generatedByAiWriterTemplate: $generatedByAiWriterTemplate, showAiDisclaimerText: $showAiDisclaimerText}
  ) {
    news {
      id
      status
      imageCaption
      imageAltText
      image {
        id
        cloudinaryId
        resourceImageId
        url(transformation: MATERIAL_HEADER_PREVIEW)
        croppedUrl: url
        coverImageGravity {
          x
          y
        }
      }
      body
      summary
      header
      draft
      readability
      showAiDisclaimerText
      generatedByAiWriter
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
      connectedImages {
        id
        usageCount
      }
      contactPeople: contactPeople2 {
        id
      }
    }
    previousImages {
      id
      usageCount
    }
    error {
      message
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type SaveNewsMutationFn = Apollo.MutationFunction<Types.SaveNewsMutation, Types.SaveNewsMutationVariables>;

/**
 * __useSaveNewsMutation__
 *
 * To run a mutation, you first call `useSaveNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewsMutation, { data, loading, error }] = useSaveNewsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      body: // value for 'body'
 *      header: // value for 'header'
 *      imageCaption: // value for 'imageCaption'
 *      imageAltText: // value for 'imageAltText'
 *      summary: // value for 'summary'
 *      resourceImageId: // value for 'resourceImageId'
 *      generatedByAiWriter: // value for 'generatedByAiWriter'
 *      generatedByAiWriterTemplate: // value for 'generatedByAiWriterTemplate'
 *      showAiDisclaimerText: // value for 'showAiDisclaimerText'
 *   },
 * });
 */
export function useSaveNewsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveNewsMutation, Types.SaveNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveNewsMutation, Types.SaveNewsMutationVariables>(SaveNewsDocument, options);
      }
export type SaveNewsMutationHookResult = ReturnType<typeof useSaveNewsMutation>;
export type SaveNewsMutationResult = Apollo.MutationResult<Types.SaveNewsMutation>;
export type SaveNewsMutationOptions = Apollo.BaseMutationOptions<Types.SaveNewsMutation, Types.SaveNewsMutationVariables>;
export const SavePressReleaseDocument = gql`
    mutation SavePressRelease($id: ID, $pressroomId: ID!, $body: String, $header: String, $imageCaption: String, $imageAltText: String, $summary: String, $boilerplate: String, $resourceImageId: ID, $generatedByAiWriter: Boolean, $generatedByAiWriterTemplate: GeneratedByAiWriterTemplate, $showAiDisclaimerText: Boolean) {
  pressReleaseUpdate(
    input: {id: $id, pressroomId: $pressroomId, body: $body, header: $header, imageCaption: $imageCaption, imageAltText: $imageAltText, summary: $summary, boilerplate: $boilerplate, resourceImageId: $resourceImageId, generatedByAiWriter: $generatedByAiWriter, generatedByAiWriterTemplate: $generatedByAiWriterTemplate, showAiDisclaimerText: $showAiDisclaimerText}
  ) {
    pressRelease {
      id
      status
      imageCaption
      imageAltText
      image {
        id
        cloudinaryId
        resourceImageId
        url(transformation: MATERIAL_HEADER_PREVIEW)
        croppedUrl: url
        coverImageGravity {
          x
          y
        }
      }
      body
      summary
      header
      boilerplate
      draft
      readability
      showAiDisclaimerText
      generatedByAiWriter
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
      connectedImages {
        id
        usageCount
      }
      contactPeople: contactPeople2 {
        id
      }
    }
    user {
      id
      onboarding(pressroomId: $pressroomId) {
        id
        completed
      }
    }
    previousImages {
      id
      usageCount
    }
    error {
      message
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type SavePressReleaseMutationFn = Apollo.MutationFunction<Types.SavePressReleaseMutation, Types.SavePressReleaseMutationVariables>;

/**
 * __useSavePressReleaseMutation__
 *
 * To run a mutation, you first call `useSavePressReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePressReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePressReleaseMutation, { data, loading, error }] = useSavePressReleaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      body: // value for 'body'
 *      header: // value for 'header'
 *      imageCaption: // value for 'imageCaption'
 *      imageAltText: // value for 'imageAltText'
 *      summary: // value for 'summary'
 *      boilerplate: // value for 'boilerplate'
 *      resourceImageId: // value for 'resourceImageId'
 *      generatedByAiWriter: // value for 'generatedByAiWriter'
 *      generatedByAiWriterTemplate: // value for 'generatedByAiWriterTemplate'
 *      showAiDisclaimerText: // value for 'showAiDisclaimerText'
 *   },
 * });
 */
export function useSavePressReleaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.SavePressReleaseMutation, Types.SavePressReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SavePressReleaseMutation, Types.SavePressReleaseMutationVariables>(SavePressReleaseDocument, options);
      }
export type SavePressReleaseMutationHookResult = ReturnType<typeof useSavePressReleaseMutation>;
export type SavePressReleaseMutationResult = Apollo.MutationResult<Types.SavePressReleaseMutation>;
export type SavePressReleaseMutationOptions = Apollo.BaseMutationOptions<Types.SavePressReleaseMutation, Types.SavePressReleaseMutationVariables>;
export const GetDefaultPressContactsDocument = gql`
    query GetDefaultPressContacts($id: ID!, $first: Int, $after: String) {
  pressroom(id: $id) {
    id
    pressContactList(first: $first, after: $after, published: true) {
      __typename
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        __typename
        id
        name
        imageUrl
        visibleSince
        showAsPressroomContact
        scheduledPublishAt
        scheduledUnpublishAt
      }
    }
  }
}
    `;

/**
 * __useGetDefaultPressContactsQuery__
 *
 * To run a query within a React component, call `useGetDefaultPressContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultPressContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultPressContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetDefaultPressContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables> & ({ variables: Types.GetDefaultPressContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables>(GetDefaultPressContactsDocument, options);
      }
export function useGetDefaultPressContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables>(GetDefaultPressContactsDocument, options);
        }
export function useGetDefaultPressContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables>(GetDefaultPressContactsDocument, options);
        }
export type GetDefaultPressContactsQueryHookResult = ReturnType<typeof useGetDefaultPressContactsQuery>;
export type GetDefaultPressContactsLazyQueryHookResult = ReturnType<typeof useGetDefaultPressContactsLazyQuery>;
export type GetDefaultPressContactsSuspenseQueryHookResult = ReturnType<typeof useGetDefaultPressContactsSuspenseQuery>;
export type GetDefaultPressContactsQueryResult = Apollo.QueryResult<Types.GetDefaultPressContactsQuery, Types.GetDefaultPressContactsQueryVariables>;
export const UpdateMaterialConnectionDocument = gql`
    mutation UpdateMaterialConnection($hostMaterialId: ID!, $hostMaterialType: MaterialType!, $connectedMaterials: [MaterialIdTuple!]!, $unscheduleRelatedMaterial: Boolean) {
  materialsConnectionUpdate(
    input: {hostMaterialId: $hostMaterialId, hostMaterialType: $hostMaterialType, connectedMaterials: $connectedMaterials, relatedMaterialTypes: [Image, Video, Document], unscheduleRelatedMaterial: $unscheduleRelatedMaterial}
  ) {
    error {
      message
    }
    material {
      id
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type UpdateMaterialConnectionMutationFn = Apollo.MutationFunction<Types.UpdateMaterialConnectionMutation, Types.UpdateMaterialConnectionMutationVariables>;

/**
 * __useUpdateMaterialConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialConnectionMutation, { data, loading, error }] = useUpdateMaterialConnectionMutation({
 *   variables: {
 *      hostMaterialId: // value for 'hostMaterialId'
 *      hostMaterialType: // value for 'hostMaterialType'
 *      connectedMaterials: // value for 'connectedMaterials'
 *      unscheduleRelatedMaterial: // value for 'unscheduleRelatedMaterial'
 *   },
 * });
 */
export function useUpdateMaterialConnectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMaterialConnectionMutation, Types.UpdateMaterialConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMaterialConnectionMutation, Types.UpdateMaterialConnectionMutationVariables>(UpdateMaterialConnectionDocument, options);
      }
export type UpdateMaterialConnectionMutationHookResult = ReturnType<typeof useUpdateMaterialConnectionMutation>;
export type UpdateMaterialConnectionMutationResult = Apollo.MutationResult<Types.UpdateMaterialConnectionMutation>;
export type UpdateMaterialConnectionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMaterialConnectionMutation, Types.UpdateMaterialConnectionMutationVariables>;
export const ConnectMediaDocument = gql`
    mutation ConnectMedia($hostMaterialId: ID!, $materialIdToConnect: ID!, $hostMaterialType: MaterialType!, $materialTypeToConnect: MaterialType!) {
  materialConnect(
    input: {hostMaterialId: $hostMaterialId, hostMaterialType: $hostMaterialType, materialIdToConnect: $materialIdToConnect, materialTypeToConnect: $materialTypeToConnect}
  ) {
    error {
      message
    }
    material {
      id
      relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type ConnectMediaMutationFn = Apollo.MutationFunction<Types.ConnectMediaMutation, Types.ConnectMediaMutationVariables>;

/**
 * __useConnectMediaMutation__
 *
 * To run a mutation, you first call `useConnectMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMediaMutation, { data, loading, error }] = useConnectMediaMutation({
 *   variables: {
 *      hostMaterialId: // value for 'hostMaterialId'
 *      materialIdToConnect: // value for 'materialIdToConnect'
 *      hostMaterialType: // value for 'hostMaterialType'
 *      materialTypeToConnect: // value for 'materialTypeToConnect'
 *   },
 * });
 */
export function useConnectMediaMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConnectMediaMutation, Types.ConnectMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConnectMediaMutation, Types.ConnectMediaMutationVariables>(ConnectMediaDocument, options);
      }
export type ConnectMediaMutationHookResult = ReturnType<typeof useConnectMediaMutation>;
export type ConnectMediaMutationResult = Apollo.MutationResult<Types.ConnectMediaMutation>;
export type ConnectMediaMutationOptions = Apollo.BaseMutationOptions<Types.ConnectMediaMutation, Types.ConnectMediaMutationVariables>;
export const DisconnectMediaDocument = gql`
    mutation DisconnectMedia($hostMaterialId: ID!, $connectedMaterialId: ID!, $hostMaterialType: MaterialType!, $connectedMaterialType: MaterialType!, $avoidRemovingHostResourceImage: Boolean) {
  materialDisconnect(
    input: {hostMaterialId: $hostMaterialId, hostMaterialType: $hostMaterialType, connectedMaterialId: $connectedMaterialId, connectedMaterialType: $connectedMaterialType, avoidRemovingHostResourceImage: $avoidRemovingHostResourceImage}
  ) {
    error {
      message
    }
    material {
      id
      relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
    previousImages {
      id
      usageCount
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type DisconnectMediaMutationFn = Apollo.MutationFunction<Types.DisconnectMediaMutation, Types.DisconnectMediaMutationVariables>;

/**
 * __useDisconnectMediaMutation__
 *
 * To run a mutation, you first call `useDisconnectMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMediaMutation, { data, loading, error }] = useDisconnectMediaMutation({
 *   variables: {
 *      hostMaterialId: // value for 'hostMaterialId'
 *      connectedMaterialId: // value for 'connectedMaterialId'
 *      hostMaterialType: // value for 'hostMaterialType'
 *      connectedMaterialType: // value for 'connectedMaterialType'
 *      avoidRemovingHostResourceImage: // value for 'avoidRemovingHostResourceImage'
 *   },
 * });
 */
export function useDisconnectMediaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisconnectMediaMutation, Types.DisconnectMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisconnectMediaMutation, Types.DisconnectMediaMutationVariables>(DisconnectMediaDocument, options);
      }
export type DisconnectMediaMutationHookResult = ReturnType<typeof useDisconnectMediaMutation>;
export type DisconnectMediaMutationResult = Apollo.MutationResult<Types.DisconnectMediaMutation>;
export type DisconnectMediaMutationOptions = Apollo.BaseMutationOptions<Types.DisconnectMediaMutation, Types.DisconnectMediaMutationVariables>;
export const ConnectStoryMaterialDocument = gql`
    mutation ConnectStoryMaterial($hostMaterialId: ID!, $materialIdToConnect: ID!, $hostMaterialType: MaterialType!, $materialTypeToConnect: MaterialType!) {
  materialConnect(
    input: {hostMaterialId: $hostMaterialId, hostMaterialType: $hostMaterialType, materialIdToConnect: $materialIdToConnect, materialTypeToConnect: $materialTypeToConnect}
  ) {
    error {
      message
    }
    material {
      id
      relatedMaterial(types: [Pressrelease, News, BlogPost, Event]) {
        id
        ...RelatedStory
        ...ModalStoryMaterial
      }
    }
  }
}
    ${RelatedStoryFragmentDoc}
${ModalStoryMaterialFragmentDoc}`;
export type ConnectStoryMaterialMutationFn = Apollo.MutationFunction<Types.ConnectStoryMaterialMutation, Types.ConnectStoryMaterialMutationVariables>;

/**
 * __useConnectStoryMaterialMutation__
 *
 * To run a mutation, you first call `useConnectStoryMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectStoryMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectStoryMaterialMutation, { data, loading, error }] = useConnectStoryMaterialMutation({
 *   variables: {
 *      hostMaterialId: // value for 'hostMaterialId'
 *      materialIdToConnect: // value for 'materialIdToConnect'
 *      hostMaterialType: // value for 'hostMaterialType'
 *      materialTypeToConnect: // value for 'materialTypeToConnect'
 *   },
 * });
 */
export function useConnectStoryMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConnectStoryMaterialMutation, Types.ConnectStoryMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConnectStoryMaterialMutation, Types.ConnectStoryMaterialMutationVariables>(ConnectStoryMaterialDocument, options);
      }
export type ConnectStoryMaterialMutationHookResult = ReturnType<typeof useConnectStoryMaterialMutation>;
export type ConnectStoryMaterialMutationResult = Apollo.MutationResult<Types.ConnectStoryMaterialMutation>;
export type ConnectStoryMaterialMutationOptions = Apollo.BaseMutationOptions<Types.ConnectStoryMaterialMutation, Types.ConnectStoryMaterialMutationVariables>;
export const DisconnectStoryMaterialDocument = gql`
    mutation DisconnectStoryMaterial($hostMaterialId: ID!, $connectedMaterialId: ID!, $hostMaterialType: MaterialType!, $connectedMaterialType: MaterialType!) {
  materialDisconnect(
    input: {hostMaterialId: $hostMaterialId, hostMaterialType: $hostMaterialType, connectedMaterialId: $connectedMaterialId, connectedMaterialType: $connectedMaterialType}
  ) {
    error {
      message
    }
    material {
      id
      relatedMaterial(types: [Pressrelease, News, BlogPost, Event]) {
        id
        ...RelatedStory
        ...ModalStoryMaterial
      }
    }
  }
}
    ${RelatedStoryFragmentDoc}
${ModalStoryMaterialFragmentDoc}`;
export type DisconnectStoryMaterialMutationFn = Apollo.MutationFunction<Types.DisconnectStoryMaterialMutation, Types.DisconnectStoryMaterialMutationVariables>;

/**
 * __useDisconnectStoryMaterialMutation__
 *
 * To run a mutation, you first call `useDisconnectStoryMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectStoryMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectStoryMaterialMutation, { data, loading, error }] = useDisconnectStoryMaterialMutation({
 *   variables: {
 *      hostMaterialId: // value for 'hostMaterialId'
 *      connectedMaterialId: // value for 'connectedMaterialId'
 *      hostMaterialType: // value for 'hostMaterialType'
 *      connectedMaterialType: // value for 'connectedMaterialType'
 *   },
 * });
 */
export function useDisconnectStoryMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisconnectStoryMaterialMutation, Types.DisconnectStoryMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisconnectStoryMaterialMutation, Types.DisconnectStoryMaterialMutationVariables>(DisconnectStoryMaterialDocument, options);
      }
export type DisconnectStoryMaterialMutationHookResult = ReturnType<typeof useDisconnectStoryMaterialMutation>;
export type DisconnectStoryMaterialMutationResult = Apollo.MutationResult<Types.DisconnectStoryMaterialMutation>;
export type DisconnectStoryMaterialMutationOptions = Apollo.BaseMutationOptions<Types.DisconnectStoryMaterialMutation, Types.DisconnectStoryMaterialMutationVariables>;
export const UpdateMaterialLinksDocument = gql`
    mutation UpdateMaterialLinks($input: MaterialLinksUpdateInput!) {
  materialLinksUpdate(input: $input) {
    error {
      message
      ... on MaterialLinksUpdateValidationError {
        links {
          name
          url
        }
      }
    }
    material {
      id
      links {
        url
        name
      }
    }
  }
}
    `;
export type UpdateMaterialLinksMutationFn = Apollo.MutationFunction<Types.UpdateMaterialLinksMutation, Types.UpdateMaterialLinksMutationVariables>;

/**
 * __useUpdateMaterialLinksMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialLinksMutation, { data, loading, error }] = useUpdateMaterialLinksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMaterialLinksMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMaterialLinksMutation, Types.UpdateMaterialLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMaterialLinksMutation, Types.UpdateMaterialLinksMutationVariables>(UpdateMaterialLinksDocument, options);
      }
export type UpdateMaterialLinksMutationHookResult = ReturnType<typeof useUpdateMaterialLinksMutation>;
export type UpdateMaterialLinksMutationResult = Apollo.MutationResult<Types.UpdateMaterialLinksMutation>;
export type UpdateMaterialLinksMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMaterialLinksMutation, Types.UpdateMaterialLinksMutationVariables>;
export const MaterialFeedbackDocument = gql`
    mutation MaterialFeedback($materialId: ID!, $materialType: MaterialType!, $positive: Boolean, $comment: String) {
  materialFeedback(
    input: {materialId: $materialId, type: $materialType, positive: $positive, comment: $comment}
  ) {
    error {
      message
    }
    material {
      id
      ... on StoryMaterial {
        feedback {
          positive
          comment
        }
      }
    }
  }
}
    `;
export type MaterialFeedbackMutationFn = Apollo.MutationFunction<Types.MaterialFeedbackMutation, Types.MaterialFeedbackMutationVariables>;

/**
 * __useMaterialFeedbackMutation__
 *
 * To run a mutation, you first call `useMaterialFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterialFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materialFeedbackMutation, { data, loading, error }] = useMaterialFeedbackMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      positive: // value for 'positive'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useMaterialFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.MaterialFeedbackMutation, Types.MaterialFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MaterialFeedbackMutation, Types.MaterialFeedbackMutationVariables>(MaterialFeedbackDocument, options);
      }
export type MaterialFeedbackMutationHookResult = ReturnType<typeof useMaterialFeedbackMutation>;
export type MaterialFeedbackMutationResult = Apollo.MutationResult<Types.MaterialFeedbackMutation>;
export type MaterialFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.MaterialFeedbackMutation, Types.MaterialFeedbackMutationVariables>;
export const LoadHeaderSuggestionsDocument = gql`
    query LoadHeaderSuggestions($id: ID!, $type: MaterialType!) {
  material(id: $id, type: $type) {
    id
    ... on StoryMaterial {
      headerSuggestions
    }
  }
}
    `;

/**
 * __useLoadHeaderSuggestionsQuery__
 *
 * To run a query within a React component, call `useLoadHeaderSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadHeaderSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadHeaderSuggestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLoadHeaderSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables> & ({ variables: Types.LoadHeaderSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables>(LoadHeaderSuggestionsDocument, options);
      }
export function useLoadHeaderSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables>(LoadHeaderSuggestionsDocument, options);
        }
export function useLoadHeaderSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables>(LoadHeaderSuggestionsDocument, options);
        }
export type LoadHeaderSuggestionsQueryHookResult = ReturnType<typeof useLoadHeaderSuggestionsQuery>;
export type LoadHeaderSuggestionsLazyQueryHookResult = ReturnType<typeof useLoadHeaderSuggestionsLazyQuery>;
export type LoadHeaderSuggestionsSuspenseQueryHookResult = ReturnType<typeof useLoadHeaderSuggestionsSuspenseQuery>;
export type LoadHeaderSuggestionsQueryResult = Apollo.QueryResult<Types.LoadHeaderSuggestionsQuery, Types.LoadHeaderSuggestionsQueryVariables>;
export const LoadSummarySuggestionsDocument = gql`
    query LoadSummarySuggestions($id: ID!, $type: MaterialType!) {
  material(id: $id, type: $type) {
    id
    ... on StoryMaterial {
      summarySuggestion
    }
  }
}
    `;

/**
 * __useLoadSummarySuggestionsQuery__
 *
 * To run a query within a React component, call `useLoadSummarySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadSummarySuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadSummarySuggestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLoadSummarySuggestionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables> & ({ variables: Types.LoadSummarySuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables>(LoadSummarySuggestionsDocument, options);
      }
export function useLoadSummarySuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables>(LoadSummarySuggestionsDocument, options);
        }
export function useLoadSummarySuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables>(LoadSummarySuggestionsDocument, options);
        }
export type LoadSummarySuggestionsQueryHookResult = ReturnType<typeof useLoadSummarySuggestionsQuery>;
export type LoadSummarySuggestionsLazyQueryHookResult = ReturnType<typeof useLoadSummarySuggestionsLazyQuery>;
export type LoadSummarySuggestionsSuspenseQueryHookResult = ReturnType<typeof useLoadSummarySuggestionsSuspenseQuery>;
export type LoadSummarySuggestionsQueryResult = Apollo.QueryResult<Types.LoadSummarySuggestionsQuery, Types.LoadSummarySuggestionsQueryVariables>;
export const GetPressroomTagsQueryDocument = gql`
    query GetPressroomTagsQuery($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    highlightedTags
    popularTags
  }
}
    `;

/**
 * __useGetPressroomTagsQueryQuery__
 *
 * To run a query within a React component, call `useGetPressroomTagsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressroomTagsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressroomTagsQueryQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetPressroomTagsQueryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables> & ({ variables: Types.GetPressroomTagsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables>(GetPressroomTagsQueryDocument, options);
      }
export function useGetPressroomTagsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables>(GetPressroomTagsQueryDocument, options);
        }
export function useGetPressroomTagsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables>(GetPressroomTagsQueryDocument, options);
        }
export type GetPressroomTagsQueryQueryHookResult = ReturnType<typeof useGetPressroomTagsQueryQuery>;
export type GetPressroomTagsQueryLazyQueryHookResult = ReturnType<typeof useGetPressroomTagsQueryLazyQuery>;
export type GetPressroomTagsQuerySuspenseQueryHookResult = ReturnType<typeof useGetPressroomTagsQuerySuspenseQuery>;
export type GetPressroomTagsQueryQueryResult = Apollo.QueryResult<Types.GetPressroomTagsQueryQuery, Types.GetPressroomTagsQueryQueryVariables>;
export const GetMaterialTagsQueryDocument = gql`
    query GetMaterialTagsQuery($materialId: ID!, $materialType: MaterialType!) {
  material(id: $materialId, type: $materialType) {
    id
    tags
  }
}
    `;

/**
 * __useGetMaterialTagsQueryQuery__
 *
 * To run a query within a React component, call `useGetMaterialTagsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialTagsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialTagsQueryQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *   },
 * });
 */
export function useGetMaterialTagsQueryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables> & ({ variables: Types.GetMaterialTagsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables>(GetMaterialTagsQueryDocument, options);
      }
export function useGetMaterialTagsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables>(GetMaterialTagsQueryDocument, options);
        }
export function useGetMaterialTagsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables>(GetMaterialTagsQueryDocument, options);
        }
export type GetMaterialTagsQueryQueryHookResult = ReturnType<typeof useGetMaterialTagsQueryQuery>;
export type GetMaterialTagsQueryLazyQueryHookResult = ReturnType<typeof useGetMaterialTagsQueryLazyQuery>;
export type GetMaterialTagsQuerySuspenseQueryHookResult = ReturnType<typeof useGetMaterialTagsQuerySuspenseQuery>;
export type GetMaterialTagsQueryQueryResult = Apollo.QueryResult<Types.GetMaterialTagsQueryQuery, Types.GetMaterialTagsQueryQueryVariables>;
export const GetSuggestedTagsQueryDocument = gql`
    query GetSuggestedTagsQuery($pressroomId: ID!, $query: String!) {
  pressroom(id: $pressroomId) {
    id
    tags: tags2(query: $query) {
      id
      hits {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSuggestedTagsQueryQuery__
 *
 * To run a query within a React component, call `useGetSuggestedTagsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedTagsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedTagsQueryQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetSuggestedTagsQueryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables> & ({ variables: Types.GetSuggestedTagsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables>(GetSuggestedTagsQueryDocument, options);
      }
export function useGetSuggestedTagsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables>(GetSuggestedTagsQueryDocument, options);
        }
export function useGetSuggestedTagsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables>(GetSuggestedTagsQueryDocument, options);
        }
export type GetSuggestedTagsQueryQueryHookResult = ReturnType<typeof useGetSuggestedTagsQueryQuery>;
export type GetSuggestedTagsQueryLazyQueryHookResult = ReturnType<typeof useGetSuggestedTagsQueryLazyQuery>;
export type GetSuggestedTagsQuerySuspenseQueryHookResult = ReturnType<typeof useGetSuggestedTagsQuerySuspenseQuery>;
export type GetSuggestedTagsQueryQueryResult = Apollo.QueryResult<Types.GetSuggestedTagsQueryQuery, Types.GetSuggestedTagsQueryQueryVariables>;
export const TagMaterialMutationDocument = gql`
    mutation TagMaterialMutation($materialId: ID!, $type: MaterialType!, $tag: String!) {
  materialTag(input: {materialId: $materialId, type: $type, tag: $tag}) {
    error {
      message
    }
    material {
      id
      tags
    }
  }
}
    `;
export type TagMaterialMutationMutationFn = Apollo.MutationFunction<Types.TagMaterialMutationMutation, Types.TagMaterialMutationMutationVariables>;

/**
 * __useTagMaterialMutationMutation__
 *
 * To run a mutation, you first call `useTagMaterialMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagMaterialMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagMaterialMutationMutation, { data, loading, error }] = useTagMaterialMutationMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useTagMaterialMutationMutation(baseOptions?: Apollo.MutationHookOptions<Types.TagMaterialMutationMutation, Types.TagMaterialMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TagMaterialMutationMutation, Types.TagMaterialMutationMutationVariables>(TagMaterialMutationDocument, options);
      }
export type TagMaterialMutationMutationHookResult = ReturnType<typeof useTagMaterialMutationMutation>;
export type TagMaterialMutationMutationResult = Apollo.MutationResult<Types.TagMaterialMutationMutation>;
export type TagMaterialMutationMutationOptions = Apollo.BaseMutationOptions<Types.TagMaterialMutationMutation, Types.TagMaterialMutationMutationVariables>;
export const UntagMaterialMutationDocument = gql`
    mutation UntagMaterialMutation($materialId: ID!, $type: MaterialType!, $tag: String!) {
  materialUntag(input: {materialId: $materialId, type: $type, tag: $tag}) {
    error {
      message
    }
    material {
      id
      tags
    }
  }
}
    `;
export type UntagMaterialMutationMutationFn = Apollo.MutationFunction<Types.UntagMaterialMutationMutation, Types.UntagMaterialMutationMutationVariables>;

/**
 * __useUntagMaterialMutationMutation__
 *
 * To run a mutation, you first call `useUntagMaterialMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntagMaterialMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untagMaterialMutationMutation, { data, loading, error }] = useUntagMaterialMutationMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      type: // value for 'type'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useUntagMaterialMutationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UntagMaterialMutationMutation, Types.UntagMaterialMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UntagMaterialMutationMutation, Types.UntagMaterialMutationMutationVariables>(UntagMaterialMutationDocument, options);
      }
export type UntagMaterialMutationMutationHookResult = ReturnType<typeof useUntagMaterialMutationMutation>;
export type UntagMaterialMutationMutationResult = Apollo.MutationResult<Types.UntagMaterialMutationMutation>;
export type UntagMaterialMutationMutationOptions = Apollo.BaseMutationOptions<Types.UntagMaterialMutationMutation, Types.UntagMaterialMutationMutationVariables>;
export const CreateVideoUploadSubtitlesLinkDocument = gql`
    mutation CreateVideoUploadSubtitlesLink($videoId: ID!) {
  videoCreateSubtitleUploadLink(input: {videoId: $videoId}) {
    error {
      message
    }
    uploadUrl
  }
}
    `;
export type CreateVideoUploadSubtitlesLinkMutationFn = Apollo.MutationFunction<Types.CreateVideoUploadSubtitlesLinkMutation, Types.CreateVideoUploadSubtitlesLinkMutationVariables>;

/**
 * __useCreateVideoUploadSubtitlesLinkMutation__
 *
 * To run a mutation, you first call `useCreateVideoUploadSubtitlesLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoUploadSubtitlesLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoUploadSubtitlesLinkMutation, { data, loading, error }] = useCreateVideoUploadSubtitlesLinkMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useCreateVideoUploadSubtitlesLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVideoUploadSubtitlesLinkMutation, Types.CreateVideoUploadSubtitlesLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVideoUploadSubtitlesLinkMutation, Types.CreateVideoUploadSubtitlesLinkMutationVariables>(CreateVideoUploadSubtitlesLinkDocument, options);
      }
export type CreateVideoUploadSubtitlesLinkMutationHookResult = ReturnType<typeof useCreateVideoUploadSubtitlesLinkMutation>;
export type CreateVideoUploadSubtitlesLinkMutationResult = Apollo.MutationResult<Types.CreateVideoUploadSubtitlesLinkMutation>;
export type CreateVideoUploadSubtitlesLinkMutationOptions = Apollo.BaseMutationOptions<Types.CreateVideoUploadSubtitlesLinkMutation, Types.CreateVideoUploadSubtitlesLinkMutationVariables>;
export const DeleteVideoSubtitlesDocument = gql`
    mutation DeleteVideoSubtitles($videoId: ID!) {
  videoDeleteSubtitles(input: {videoId: $videoId}) {
    error {
      message
    }
    video {
      id
      subtitles {
        id
      }
    }
  }
}
    `;
export type DeleteVideoSubtitlesMutationFn = Apollo.MutationFunction<Types.DeleteVideoSubtitlesMutation, Types.DeleteVideoSubtitlesMutationVariables>;

/**
 * __useDeleteVideoSubtitlesMutation__
 *
 * To run a mutation, you first call `useDeleteVideoSubtitlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoSubtitlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoSubtitlesMutation, { data, loading, error }] = useDeleteVideoSubtitlesMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useDeleteVideoSubtitlesMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVideoSubtitlesMutation, Types.DeleteVideoSubtitlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVideoSubtitlesMutation, Types.DeleteVideoSubtitlesMutationVariables>(DeleteVideoSubtitlesDocument, options);
      }
export type DeleteVideoSubtitlesMutationHookResult = ReturnType<typeof useDeleteVideoSubtitlesMutation>;
export type DeleteVideoSubtitlesMutationResult = Apollo.MutationResult<Types.DeleteVideoSubtitlesMutation>;
export type DeleteVideoSubtitlesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVideoSubtitlesMutation, Types.DeleteVideoSubtitlesMutationVariables>;
export const SaveVideoDocument = gql`
    mutation SaveVideo($id: ID, $pressroomId: ID!, $resourceVideoId: ID, $header: String, $licenseId: ID, $summary: String) {
  videoUpdate(
    input: {id: $id, pressroomId: $pressroomId, resourceVideoId: $resourceVideoId, header: $header, licenseId: $licenseId, summary: $summary}
  ) {
    video {
      id
      status
      draft
      header
      summary
      previewUrl
      thumbnailUrl
      resourceVideo {
        id
        processed
        cloudinaryId
      }
      license {
        id
        name
      }
      relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
        id
        ...RelatedMedia
        ...ModalMedia
      }
    }
    error {
      message
    }
  }
}
    ${RelatedMediaFragmentDoc}
${ModalMediaFragmentDoc}
${MediaPickerImageFragmentDoc}`;
export type SaveVideoMutationFn = Apollo.MutationFunction<Types.SaveVideoMutation, Types.SaveVideoMutationVariables>;

/**
 * __useSaveVideoMutation__
 *
 * To run a mutation, you first call `useSaveVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVideoMutation, { data, loading, error }] = useSaveVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pressroomId: // value for 'pressroomId'
 *      resourceVideoId: // value for 'resourceVideoId'
 *      header: // value for 'header'
 *      licenseId: // value for 'licenseId'
 *      summary: // value for 'summary'
 *   },
 * });
 */
export function useSaveVideoMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveVideoMutation, Types.SaveVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveVideoMutation, Types.SaveVideoMutationVariables>(SaveVideoDocument, options);
      }
export type SaveVideoMutationHookResult = ReturnType<typeof useSaveVideoMutation>;
export type SaveVideoMutationResult = Apollo.MutationResult<Types.SaveVideoMutation>;
export type SaveVideoMutationOptions = Apollo.BaseMutationOptions<Types.SaveVideoMutation, Types.SaveVideoMutationVariables>;
export const VideoQueryDocument = gql`
    query VideoQuery($id: ID!) {
  material(id: $id, type: Video) {
    id
    ... on Video {
      thumbnailUrl
      resourceVideo {
        id
        processed
        availableThumbnails
        cloudinaryId
      }
    }
  }
}
    `;

/**
 * __useVideoQueryQuery__
 *
 * To run a query within a React component, call `useVideoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoQueryQuery(baseOptions: Apollo.QueryHookOptions<Types.VideoQueryQuery, Types.VideoQueryQueryVariables> & ({ variables: Types.VideoQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VideoQueryQuery, Types.VideoQueryQueryVariables>(VideoQueryDocument, options);
      }
export function useVideoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VideoQueryQuery, Types.VideoQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VideoQueryQuery, Types.VideoQueryQueryVariables>(VideoQueryDocument, options);
        }
export function useVideoQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VideoQueryQuery, Types.VideoQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VideoQueryQuery, Types.VideoQueryQueryVariables>(VideoQueryDocument, options);
        }
export type VideoQueryQueryHookResult = ReturnType<typeof useVideoQueryQuery>;
export type VideoQueryLazyQueryHookResult = ReturnType<typeof useVideoQueryLazyQuery>;
export type VideoQuerySuspenseQueryHookResult = ReturnType<typeof useVideoQuerySuspenseQuery>;
export type VideoQueryQueryResult = Apollo.QueryResult<Types.VideoQueryQuery, Types.VideoQueryQueryVariables>;
export const VideoRemoveResourceDocument = gql`
    mutation VideoRemoveResource($pressroomId: ID!, $videoId: ID!) {
  videoRemoveResourceVideo(input: {pressroomId: $pressroomId, id: $videoId}) {
    error {
      message
    }
    video {
      id
      thumbnailUrl
      resourceVideo {
        id
      }
    }
  }
}
    `;
export type VideoRemoveResourceMutationFn = Apollo.MutationFunction<Types.VideoRemoveResourceMutation, Types.VideoRemoveResourceMutationVariables>;

/**
 * __useVideoRemoveResourceMutation__
 *
 * To run a mutation, you first call `useVideoRemoveResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoRemoveResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoRemoveResourceMutation, { data, loading, error }] = useVideoRemoveResourceMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useVideoRemoveResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.VideoRemoveResourceMutation, Types.VideoRemoveResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VideoRemoveResourceMutation, Types.VideoRemoveResourceMutationVariables>(VideoRemoveResourceDocument, options);
      }
export type VideoRemoveResourceMutationHookResult = ReturnType<typeof useVideoRemoveResourceMutation>;
export type VideoRemoveResourceMutationResult = Apollo.MutationResult<Types.VideoRemoveResourceMutation>;
export type VideoRemoveResourceMutationOptions = Apollo.BaseMutationOptions<Types.VideoRemoveResourceMutation, Types.VideoRemoveResourceMutationVariables>;
export const VideoUpdateThumbnailDocument = gql`
    mutation VideoUpdateThumbnail($videoId: ID!, $url: String, $resourceImageId: ID) {
  videoUpdateThumbnail(
    input: {videoId: $videoId, url: $url, resourceImageId: $resourceImageId}
  ) {
    video {
      id
      thumbnailUrl
      resourceVideo {
        id
      }
      connectedImages {
        id
        usageCount
      }
    }
    previousImage {
      id
      usageCount
    }
    error {
      message
    }
  }
}
    `;
export type VideoUpdateThumbnailMutationFn = Apollo.MutationFunction<Types.VideoUpdateThumbnailMutation, Types.VideoUpdateThumbnailMutationVariables>;

/**
 * __useVideoUpdateThumbnailMutation__
 *
 * To run a mutation, you first call `useVideoUpdateThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoUpdateThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoUpdateThumbnailMutation, { data, loading, error }] = useVideoUpdateThumbnailMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      url: // value for 'url'
 *      resourceImageId: // value for 'resourceImageId'
 *   },
 * });
 */
export function useVideoUpdateThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<Types.VideoUpdateThumbnailMutation, Types.VideoUpdateThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VideoUpdateThumbnailMutation, Types.VideoUpdateThumbnailMutationVariables>(VideoUpdateThumbnailDocument, options);
      }
export type VideoUpdateThumbnailMutationHookResult = ReturnType<typeof useVideoUpdateThumbnailMutation>;
export type VideoUpdateThumbnailMutationResult = Apollo.MutationResult<Types.VideoUpdateThumbnailMutation>;
export type VideoUpdateThumbnailMutationOptions = Apollo.BaseMutationOptions<Types.VideoUpdateThumbnailMutation, Types.VideoUpdateThumbnailMutationVariables>;
export const CreateVideoUploadLinkDocument = gql`
    mutation CreateVideoUploadLink($pressroomId: ID!) {
  videoCreateScreen9UploadLink(input: {pressroomId: $pressroomId}) {
    error {
      message
    }
    uploadLink {
      id
      screen9Tag
      url
    }
  }
}
    `;
export type CreateVideoUploadLinkMutationFn = Apollo.MutationFunction<Types.CreateVideoUploadLinkMutation, Types.CreateVideoUploadLinkMutationVariables>;

/**
 * __useCreateVideoUploadLinkMutation__
 *
 * To run a mutation, you first call `useCreateVideoUploadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoUploadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoUploadLinkMutation, { data, loading, error }] = useCreateVideoUploadLinkMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useCreateVideoUploadLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVideoUploadLinkMutation, Types.CreateVideoUploadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVideoUploadLinkMutation, Types.CreateVideoUploadLinkMutationVariables>(CreateVideoUploadLinkDocument, options);
      }
export type CreateVideoUploadLinkMutationHookResult = ReturnType<typeof useCreateVideoUploadLinkMutation>;
export type CreateVideoUploadLinkMutationResult = Apollo.MutationResult<Types.CreateVideoUploadLinkMutation>;
export type CreateVideoUploadLinkMutationOptions = Apollo.BaseMutationOptions<Types.CreateVideoUploadLinkMutation, Types.CreateVideoUploadLinkMutationVariables>;
export const SyncResourceVideoDocument = gql`
    mutation SyncResourceVideo($input: VideoSyncScreen9UploadInput!) {
  videoSyncScreen9Upload(input: $input) {
    error {
      message
    }
    video {
      id
      header
      license {
        id
      }
      thumbnailUrl
      resourceVideo {
        id
        processed
      }
    }
  }
}
    `;
export type SyncResourceVideoMutationFn = Apollo.MutationFunction<Types.SyncResourceVideoMutation, Types.SyncResourceVideoMutationVariables>;

/**
 * __useSyncResourceVideoMutation__
 *
 * To run a mutation, you first call `useSyncResourceVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncResourceVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncResourceVideoMutation, { data, loading, error }] = useSyncResourceVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncResourceVideoMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncResourceVideoMutation, Types.SyncResourceVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncResourceVideoMutation, Types.SyncResourceVideoMutationVariables>(SyncResourceVideoDocument, options);
      }
export type SyncResourceVideoMutationHookResult = ReturnType<typeof useSyncResourceVideoMutation>;
export type SyncResourceVideoMutationResult = Apollo.MutationResult<Types.SyncResourceVideoMutation>;
export type SyncResourceVideoMutationOptions = Apollo.BaseMutationOptions<Types.SyncResourceVideoMutation, Types.SyncResourceVideoMutationVariables>;
export const LoadMaterialDocument = gql`
    query LoadMaterial($id: ID!, $type: MaterialType!) {
  material(id: $id, type: $type) {
    id
    header
    summary
    updatedAt
    publishedAt2
    status
    scheduledFor
    image {
      id
      cloudinaryId
      resourceImageId
      url(transformation: MATERIAL_HEADER_PREVIEW)
      croppedUrl: url
      coverImageGravity {
        x
        y
      }
    }
    ... on Event {
      imageCaption
      imageAltText
      startAt
      endAt
      allDay
      location
      signupUrl
      draft
      previewUrl
      contactPeople: contactPeople2 {
        id
        ...ContactPersonFragment
      }
    }
    relatedStories: relatedMaterial(types: [Pressrelease, News, BlogPost, Event]) {
      id
      ...RelatedStory
    }
    relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
      id
      ...RelatedMedia
    }
    ... on Video {
      draft
      previewUrl
      thumbnailUrl
      license {
        id
        name
      }
      subtitles {
        id
        url
        filename
      }
      resourceVideo {
        id
        processed
        availableThumbnails
        cloudinaryId
      }
      contactPeople: contactPeople2 {
        id
        ...ContactPersonFragment
      }
    }
    ... on Document {
      license {
        id
        name
      }
      previewUrl
      copyright
      contactPeople: contactPeople2 {
        id
        ...ContactPersonFragment
      }
      resourceDocument {
        id
        name
      }
    }
    ... on Pressrelease {
      boilerplate
    }
    ... on StoryMaterial {
      body
      imageAltText
      imageCaption
      readability
      draft
      previewUrl
      showAiDisclaimerText
      generatedByAiWriter
      feedback {
        positive
        comment
      }
      links {
        url
        name
      }
      contactPeople: contactPeople2 {
        id
        ...ContactPersonFragment
      }
    }
  }
}
    ${ContactPersonFragmentFragmentDoc}
${RelatedStoryFragmentDoc}
${RelatedMediaFragmentDoc}`;

/**
 * __useLoadMaterialQuery__
 *
 * To run a query within a React component, call `useLoadMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMaterialQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLoadMaterialQuery(baseOptions: Apollo.QueryHookOptions<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables> & ({ variables: Types.LoadMaterialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables>(LoadMaterialDocument, options);
      }
export function useLoadMaterialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables>(LoadMaterialDocument, options);
        }
export function useLoadMaterialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables>(LoadMaterialDocument, options);
        }
export type LoadMaterialQueryHookResult = ReturnType<typeof useLoadMaterialQuery>;
export type LoadMaterialLazyQueryHookResult = ReturnType<typeof useLoadMaterialLazyQuery>;
export type LoadMaterialSuspenseQueryHookResult = ReturnType<typeof useLoadMaterialSuspenseQuery>;
export type LoadMaterialQueryResult = Apollo.QueryResult<Types.LoadMaterialQuery, Types.LoadMaterialQueryVariables>;
export const MaterialFormMetadataDocument = gql`
    query MaterialFormMetadata($pressroomId: ID!, $getBoilerplate: Boolean!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    features {
      id
      images
      publishRelatedMaterial: managed(feature: publishRelatedMaterial) {
        id
        enabled
      }
      coPilotPublishSidebar: managed(feature: coPilotPublishSidebar) {
        id
        enabled
      }
      newsroom: managed(feature: newsroom) {
        id
        enabled
      }
    }
    newsroomSettings @include(if: $getBoilerplate) {
      id
      boilerplates {
        id
        ...BoilerplateFragment
      }
    }
    source {
      id
      trusted
    }
  }
}
    ${BoilerplateFragmentFragmentDoc}`;

/**
 * __useMaterialFormMetadataQuery__
 *
 * To run a query within a React component, call `useMaterialFormMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialFormMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialFormMetadataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      getBoilerplate: // value for 'getBoilerplate'
 *   },
 * });
 */
export function useMaterialFormMetadataQuery(baseOptions: Apollo.QueryHookOptions<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables> & ({ variables: Types.MaterialFormMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables>(MaterialFormMetadataDocument, options);
      }
export function useMaterialFormMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables>(MaterialFormMetadataDocument, options);
        }
export function useMaterialFormMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables>(MaterialFormMetadataDocument, options);
        }
export type MaterialFormMetadataQueryHookResult = ReturnType<typeof useMaterialFormMetadataQuery>;
export type MaterialFormMetadataLazyQueryHookResult = ReturnType<typeof useMaterialFormMetadataLazyQuery>;
export type MaterialFormMetadataSuspenseQueryHookResult = ReturnType<typeof useMaterialFormMetadataSuspenseQuery>;
export type MaterialFormMetadataQueryResult = Apollo.QueryResult<Types.MaterialFormMetadataQuery, Types.MaterialFormMetadataQueryVariables>;
export const TotalActivePinnedContactPeopleDocument = gql`
    query TotalActivePinnedContactPeople($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    contactPeopleList {
      id
      totalUnscheduledActivePinnedCount
    }
  }
}
    `;

/**
 * __useTotalActivePinnedContactPeopleQuery__
 *
 * To run a query within a React component, call `useTotalActivePinnedContactPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalActivePinnedContactPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalActivePinnedContactPeopleQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTotalActivePinnedContactPeopleQuery(baseOptions: Apollo.QueryHookOptions<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables> & ({ variables: Types.TotalActivePinnedContactPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables>(TotalActivePinnedContactPeopleDocument, options);
      }
export function useTotalActivePinnedContactPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables>(TotalActivePinnedContactPeopleDocument, options);
        }
export function useTotalActivePinnedContactPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables>(TotalActivePinnedContactPeopleDocument, options);
        }
export type TotalActivePinnedContactPeopleQueryHookResult = ReturnType<typeof useTotalActivePinnedContactPeopleQuery>;
export type TotalActivePinnedContactPeopleLazyQueryHookResult = ReturnType<typeof useTotalActivePinnedContactPeopleLazyQuery>;
export type TotalActivePinnedContactPeopleSuspenseQueryHookResult = ReturnType<typeof useTotalActivePinnedContactPeopleSuspenseQuery>;
export type TotalActivePinnedContactPeopleQueryResult = Apollo.QueryResult<Types.TotalActivePinnedContactPeopleQuery, Types.TotalActivePinnedContactPeopleQueryVariables>;
export const ToneOfVoiceFromTextDocument = gql`
    query toneOfVoiceFromText($pressroomId: ID!, $text: String!) {
  pressroom(id: $pressroomId) {
    id
    toneOfVoiceFromText(text: $text) {
      id
      humor
      enthusiasm
      formality
      respectfulness
    }
  }
}
    `;

/**
 * __useToneOfVoiceFromTextQuery__
 *
 * To run a query within a React component, call `useToneOfVoiceFromTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useToneOfVoiceFromTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToneOfVoiceFromTextQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useToneOfVoiceFromTextQuery(baseOptions: Apollo.QueryHookOptions<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables> & ({ variables: Types.ToneOfVoiceFromTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables>(ToneOfVoiceFromTextDocument, options);
      }
export function useToneOfVoiceFromTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables>(ToneOfVoiceFromTextDocument, options);
        }
export function useToneOfVoiceFromTextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables>(ToneOfVoiceFromTextDocument, options);
        }
export type ToneOfVoiceFromTextQueryHookResult = ReturnType<typeof useToneOfVoiceFromTextQuery>;
export type ToneOfVoiceFromTextLazyQueryHookResult = ReturnType<typeof useToneOfVoiceFromTextLazyQuery>;
export type ToneOfVoiceFromTextSuspenseQueryHookResult = ReturnType<typeof useToneOfVoiceFromTextSuspenseQuery>;
export type ToneOfVoiceFromTextQueryResult = Apollo.QueryResult<Types.ToneOfVoiceFromTextQuery, Types.ToneOfVoiceFromTextQueryVariables>;
export const PressroomGenerateMaterialsDocument = gql`
    query pressroomGenerateMaterials($pressroomId: ID!, $sourceId: ID!) {
  source(id: $sourceId) {
    id
  }
  pressroom(id: $pressroomId) {
    id
    name
  }
}
    `;

/**
 * __usePressroomGenerateMaterialsQuery__
 *
 * To run a query within a React component, call `usePressroomGenerateMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressroomGenerateMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressroomGenerateMaterialsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function usePressroomGenerateMaterialsQuery(baseOptions: Apollo.QueryHookOptions<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables> & ({ variables: Types.PressroomGenerateMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables>(PressroomGenerateMaterialsDocument, options);
      }
export function usePressroomGenerateMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables>(PressroomGenerateMaterialsDocument, options);
        }
export function usePressroomGenerateMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables>(PressroomGenerateMaterialsDocument, options);
        }
export type PressroomGenerateMaterialsQueryHookResult = ReturnType<typeof usePressroomGenerateMaterialsQuery>;
export type PressroomGenerateMaterialsLazyQueryHookResult = ReturnType<typeof usePressroomGenerateMaterialsLazyQuery>;
export type PressroomGenerateMaterialsSuspenseQueryHookResult = ReturnType<typeof usePressroomGenerateMaterialsSuspenseQuery>;
export type PressroomGenerateMaterialsQueryResult = Apollo.QueryResult<Types.PressroomGenerateMaterialsQuery, Types.PressroomGenerateMaterialsQueryVariables>;
export const ImageBankEditDocument = gql`
    query ImageBankEdit($pressroomId: ID!, $imageIds: [ID!]!) {
  licenses {
    id
    name
  }
  pressroom(id: $pressroomId) {
    id
    images(ids: $imageIds, first: 20) {
      nodes {
        ...ImageEdit
        id
      }
    }
    features {
      id
      newsroom: managed(feature: newsroom) {
        id
        enabled
      }
    }
  }
}
    ${ImageEditFragmentDoc}`;

/**
 * __useImageBankEditQuery__
 *
 * To run a query within a React component, call `useImageBankEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageBankEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageBankEditQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useImageBankEditQuery(baseOptions: Apollo.QueryHookOptions<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables> & ({ variables: Types.ImageBankEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables>(ImageBankEditDocument, options);
      }
export function useImageBankEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables>(ImageBankEditDocument, options);
        }
export function useImageBankEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables>(ImageBankEditDocument, options);
        }
export type ImageBankEditQueryHookResult = ReturnType<typeof useImageBankEditQuery>;
export type ImageBankEditLazyQueryHookResult = ReturnType<typeof useImageBankEditLazyQuery>;
export type ImageBankEditSuspenseQueryHookResult = ReturnType<typeof useImageBankEditSuspenseQuery>;
export type ImageBankEditQueryResult = Apollo.QueryResult<Types.ImageBankEditQuery, Types.ImageBankEditQueryVariables>;
export const ImageBankUpdateDocument = gql`
    mutation ImageBankUpdate($input: ImagesUpdateInput!) {
  imagesUpdate(input: $input) {
    error {
      message
      ... on ImagesUpdateValidationError {
        header
        tags
        scheduledFor
      }
    }
    images {
      id
      publishedAt: publishedAt2
      header
      status
      summary
      scheduledFor
      photographer
      copyright
      altText
      license {
        id
      }
      altText
      tags
      image {
        id
        cropping {
          x
          y
          height
          width
        }
        croppedUrl: url
        mediaBankUrl: url(transformation: IMAGE_BANK_THUMBNAIL)
        dimensions
        originalDimensions {
          x
          y
        }
        size
      }
    }
  }
}
    `;
export type ImageBankUpdateMutationFn = Apollo.MutationFunction<Types.ImageBankUpdateMutation, Types.ImageBankUpdateMutationVariables>;

/**
 * __useImageBankUpdateMutation__
 *
 * To run a mutation, you first call `useImageBankUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageBankUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageBankUpdateMutation, { data, loading, error }] = useImageBankUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImageBankUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImageBankUpdateMutation, Types.ImageBankUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImageBankUpdateMutation, Types.ImageBankUpdateMutationVariables>(ImageBankUpdateDocument, options);
      }
export type ImageBankUpdateMutationHookResult = ReturnType<typeof useImageBankUpdateMutation>;
export type ImageBankUpdateMutationResult = Apollo.MutationResult<Types.ImageBankUpdateMutation>;
export type ImageBankUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ImageBankUpdateMutation, Types.ImageBankUpdateMutationVariables>;
export const UsageModalDocument = gql`
    query UsageModal($pressroomId: ID!, $imageId: [ID!], $offset: Int, $limit: Int) {
  pressroom(id: $pressroomId) {
    id
    source {
      id
      trusted
    }
    images(ids: $imageId) {
      nodes {
        id
        usages(offset: $offset, limit: $limit) {
          id
          ...ImageUsage
        }
      }
    }
  }
}
    ${ImageUsageFragmentDoc}`;

/**
 * __useUsageModalQuery__
 *
 * To run a query within a React component, call `useUsageModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageModalQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      imageId: // value for 'imageId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUsageModalQuery(baseOptions: Apollo.QueryHookOptions<Types.UsageModalQuery, Types.UsageModalQueryVariables> & ({ variables: Types.UsageModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UsageModalQuery, Types.UsageModalQueryVariables>(UsageModalDocument, options);
      }
export function useUsageModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UsageModalQuery, Types.UsageModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UsageModalQuery, Types.UsageModalQueryVariables>(UsageModalDocument, options);
        }
export function useUsageModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UsageModalQuery, Types.UsageModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UsageModalQuery, Types.UsageModalQueryVariables>(UsageModalDocument, options);
        }
export type UsageModalQueryHookResult = ReturnType<typeof useUsageModalQuery>;
export type UsageModalLazyQueryHookResult = ReturnType<typeof useUsageModalLazyQuery>;
export type UsageModalSuspenseQueryHookResult = ReturnType<typeof useUsageModalSuspenseQuery>;
export type UsageModalQueryResult = Apollo.QueryResult<Types.UsageModalQuery, Types.UsageModalQueryVariables>;
export const ImageBankPaginationDocument = gql`
    query ImageBankPagination($pressroomId: ID!, $after: String, $status: ImageStatusFilter, $filter: String, $count: Int, $sortBy: ImageSort) {
  pressroom(id: $pressroomId) {
    id
    images(
      first: $count
      after: $after
      status2: $status
      query: $filter
      sortBy: $sortBy
    ) {
      nodes {
        id
        header
        status
        usageCount
        updatedAt
        createdAt
        image {
          id
          url(transformation: IMAGE_BANK_THUMBNAIL)
          downloadUrl
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useImageBankPaginationQuery__
 *
 * To run a query within a React component, call `useImageBankPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageBankPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageBankPaginationQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      filter: // value for 'filter'
 *      count: // value for 'count'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useImageBankPaginationQuery(baseOptions: Apollo.QueryHookOptions<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables> & ({ variables: Types.ImageBankPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables>(ImageBankPaginationDocument, options);
      }
export function useImageBankPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables>(ImageBankPaginationDocument, options);
        }
export function useImageBankPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables>(ImageBankPaginationDocument, options);
        }
export type ImageBankPaginationQueryHookResult = ReturnType<typeof useImageBankPaginationQuery>;
export type ImageBankPaginationLazyQueryHookResult = ReturnType<typeof useImageBankPaginationLazyQuery>;
export type ImageBankPaginationSuspenseQueryHookResult = ReturnType<typeof useImageBankPaginationSuspenseQuery>;
export type ImageBankPaginationQueryResult = Apollo.QueryResult<Types.ImageBankPaginationQuery, Types.ImageBankPaginationQueryVariables>;
export const ImageBankMetadataDocument = gql`
    query ImageBankMetadata($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      images
    }
    source {
      id
      hasImages(ignorePressroomId: $pressroomId)
      pressrooms {
        id
      }
    }
  }
}
    `;

/**
 * __useImageBankMetadataQuery__
 *
 * To run a query within a React component, call `useImageBankMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageBankMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageBankMetadataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useImageBankMetadataQuery(baseOptions: Apollo.QueryHookOptions<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables> & ({ variables: Types.ImageBankMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables>(ImageBankMetadataDocument, options);
      }
export function useImageBankMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables>(ImageBankMetadataDocument, options);
        }
export function useImageBankMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables>(ImageBankMetadataDocument, options);
        }
export type ImageBankMetadataQueryHookResult = ReturnType<typeof useImageBankMetadataQuery>;
export type ImageBankMetadataLazyQueryHookResult = ReturnType<typeof useImageBankMetadataLazyQuery>;
export type ImageBankMetadataSuspenseQueryHookResult = ReturnType<typeof useImageBankMetadataSuspenseQuery>;
export type ImageBankMetadataQueryResult = Apollo.QueryResult<Types.ImageBankMetadataQuery, Types.ImageBankMetadataQueryVariables>;
export const ImagesBulkDownloadDocument = gql`
    mutation ImagesBulkDownload($input: ResourceImagesBulkDownloadInput!) {
  resourceImagesBulkDownload(input: $input) {
    downloadUrl
    error {
      message
    }
  }
}
    `;
export type ImagesBulkDownloadMutationFn = Apollo.MutationFunction<Types.ImagesBulkDownloadMutation, Types.ImagesBulkDownloadMutationVariables>;

/**
 * __useImagesBulkDownloadMutation__
 *
 * To run a mutation, you first call `useImagesBulkDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImagesBulkDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imagesBulkDownloadMutation, { data, loading, error }] = useImagesBulkDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImagesBulkDownloadMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImagesBulkDownloadMutation, Types.ImagesBulkDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImagesBulkDownloadMutation, Types.ImagesBulkDownloadMutationVariables>(ImagesBulkDownloadDocument, options);
      }
export type ImagesBulkDownloadMutationHookResult = ReturnType<typeof useImagesBulkDownloadMutation>;
export type ImagesBulkDownloadMutationResult = Apollo.MutationResult<Types.ImagesBulkDownloadMutation>;
export type ImagesBulkDownloadMutationOptions = Apollo.BaseMutationOptions<Types.ImagesBulkDownloadMutation, Types.ImagesBulkDownloadMutationVariables>;
export const ImageBulkDeleteDocument = gql`
    mutation ImageBulkDelete($input: ImagesDeleteInput!) {
  imagesDelete(input: $input) {
    deletedIds
    error {
      message
    }
  }
}
    `;
export type ImageBulkDeleteMutationFn = Apollo.MutationFunction<Types.ImageBulkDeleteMutation, Types.ImageBulkDeleteMutationVariables>;

/**
 * __useImageBulkDeleteMutation__
 *
 * To run a mutation, you first call `useImageBulkDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageBulkDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageBulkDeleteMutation, { data, loading, error }] = useImageBulkDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImageBulkDeleteMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImageBulkDeleteMutation, Types.ImageBulkDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImageBulkDeleteMutation, Types.ImageBulkDeleteMutationVariables>(ImageBulkDeleteDocument, options);
      }
export type ImageBulkDeleteMutationHookResult = ReturnType<typeof useImageBulkDeleteMutation>;
export type ImageBulkDeleteMutationResult = Apollo.MutationResult<Types.ImageBulkDeleteMutation>;
export type ImageBulkDeleteMutationOptions = Apollo.BaseMutationOptions<Types.ImageBulkDeleteMutation, Types.ImageBulkDeleteMutationVariables>;
export const DuplicateMaterialDocument = gql`
    mutation DuplicateMaterial($input: MaterialDuplicateInput!) {
  materialDuplicate(input: $input) {
    material {
      id
    }
    error {
      message
      __typename
    }
  }
}
    `;
export type DuplicateMaterialMutationFn = Apollo.MutationFunction<Types.DuplicateMaterialMutation, Types.DuplicateMaterialMutationVariables>;

/**
 * __useDuplicateMaterialMutation__
 *
 * To run a mutation, you first call `useDuplicateMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMaterialMutation, { data, loading, error }] = useDuplicateMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateMaterialMutation, Types.DuplicateMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateMaterialMutation, Types.DuplicateMaterialMutationVariables>(DuplicateMaterialDocument, options);
      }
export type DuplicateMaterialMutationHookResult = ReturnType<typeof useDuplicateMaterialMutation>;
export type DuplicateMaterialMutationResult = Apollo.MutationResult<Types.DuplicateMaterialMutation>;
export type DuplicateMaterialMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateMaterialMutation, Types.DuplicateMaterialMutationVariables>;
export const SetMaterialVisibilityDocument = gql`
    mutation SetMaterialVisibility($input: MaterialVisibilityUpdateInput!) {
  materialVisibilityUpdate(input: $input) {
    material {
      id
      ... on StoryMaterial {
        visibility
      }
    }
    error {
      message
      __typename
    }
  }
}
    `;
export type SetMaterialVisibilityMutationFn = Apollo.MutationFunction<Types.SetMaterialVisibilityMutation, Types.SetMaterialVisibilityMutationVariables>;

/**
 * __useSetMaterialVisibilityMutation__
 *
 * To run a mutation, you first call `useSetMaterialVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMaterialVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMaterialVisibilityMutation, { data, loading, error }] = useSetMaterialVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMaterialVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetMaterialVisibilityMutation, Types.SetMaterialVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetMaterialVisibilityMutation, Types.SetMaterialVisibilityMutationVariables>(SetMaterialVisibilityDocument, options);
      }
export type SetMaterialVisibilityMutationHookResult = ReturnType<typeof useSetMaterialVisibilityMutation>;
export type SetMaterialVisibilityMutationResult = Apollo.MutationResult<Types.SetMaterialVisibilityMutation>;
export type SetMaterialVisibilityMutationOptions = Apollo.BaseMutationOptions<Types.SetMaterialVisibilityMutation, Types.SetMaterialVisibilityMutationVariables>;
export const ArchiveMaterialDocument = gql`
    mutation ArchiveMaterial($input: MaterialArchiveInput!) {
  materialArchive(input: $input) {
    material {
      id
    }
    error {
      message
    }
  }
}
    `;
export type ArchiveMaterialMutationFn = Apollo.MutationFunction<Types.ArchiveMaterialMutation, Types.ArchiveMaterialMutationVariables>;

/**
 * __useArchiveMaterialMutation__
 *
 * To run a mutation, you first call `useArchiveMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMaterialMutation, { data, loading, error }] = useArchiveMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.ArchiveMaterialMutation, Types.ArchiveMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ArchiveMaterialMutation, Types.ArchiveMaterialMutationVariables>(ArchiveMaterialDocument, options);
      }
export type ArchiveMaterialMutationHookResult = ReturnType<typeof useArchiveMaterialMutation>;
export type ArchiveMaterialMutationResult = Apollo.MutationResult<Types.ArchiveMaterialMutation>;
export type ArchiveMaterialMutationOptions = Apollo.BaseMutationOptions<Types.ArchiveMaterialMutation, Types.ArchiveMaterialMutationVariables>;
export const CloneMaterialDocument = gql`
    mutation CloneMaterial($materialId: ID!, $materialType: MaterialType!, $targetPressroomIds: [ID!]!) {
  materialClone(
    input: {materialId: $materialId, materialType: $materialType, targetPressroomIds: $targetPressroomIds}
  ) {
    material {
      id
    }
    error {
      message
    }
  }
}
    `;
export type CloneMaterialMutationFn = Apollo.MutationFunction<Types.CloneMaterialMutation, Types.CloneMaterialMutationVariables>;

/**
 * __useCloneMaterialMutation__
 *
 * To run a mutation, you first call `useCloneMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneMaterialMutation, { data, loading, error }] = useCloneMaterialMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      materialType: // value for 'materialType'
 *      targetPressroomIds: // value for 'targetPressroomIds'
 *   },
 * });
 */
export function useCloneMaterialMutation(baseOptions?: Apollo.MutationHookOptions<Types.CloneMaterialMutation, Types.CloneMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CloneMaterialMutation, Types.CloneMaterialMutationVariables>(CloneMaterialDocument, options);
      }
export type CloneMaterialMutationHookResult = ReturnType<typeof useCloneMaterialMutation>;
export type CloneMaterialMutationResult = Apollo.MutationResult<Types.CloneMaterialMutation>;
export type CloneMaterialMutationOptions = Apollo.BaseMutationOptions<Types.CloneMaterialMutation, Types.CloneMaterialMutationVariables>;
export const CloneModalDocument = gql`
    query CloneModal($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    source {
      id
      pressrooms {
        id
        name
        siteCode
      }
    }
  }
}
    `;

/**
 * __useCloneModalQuery__
 *
 * To run a query within a React component, call `useCloneModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloneModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloneModalQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useCloneModalQuery(baseOptions: Apollo.QueryHookOptions<Types.CloneModalQuery, Types.CloneModalQueryVariables> & ({ variables: Types.CloneModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CloneModalQuery, Types.CloneModalQueryVariables>(CloneModalDocument, options);
      }
export function useCloneModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CloneModalQuery, Types.CloneModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CloneModalQuery, Types.CloneModalQueryVariables>(CloneModalDocument, options);
        }
export function useCloneModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CloneModalQuery, Types.CloneModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CloneModalQuery, Types.CloneModalQueryVariables>(CloneModalDocument, options);
        }
export type CloneModalQueryHookResult = ReturnType<typeof useCloneModalQuery>;
export type CloneModalLazyQueryHookResult = ReturnType<typeof useCloneModalLazyQuery>;
export type CloneModalSuspenseQueryHookResult = ReturnType<typeof useCloneModalSuspenseQuery>;
export type CloneModalQueryResult = Apollo.QueryResult<Types.CloneModalQuery, Types.CloneModalQueryVariables>;
export const ImportFromOtherNewsroomDocument = gql`
    mutation ImportFromOtherNewsroom($input: ImagesImportFromOtherNewsroomInput!) {
  imagesImportFromOtherNewsroom(input: $input) {
    error {
      message
    }
    skippedDuplicates
    images {
      id
      image {
        id
      }
    }
  }
}
    `;
export type ImportFromOtherNewsroomMutationFn = Apollo.MutationFunction<Types.ImportFromOtherNewsroomMutation, Types.ImportFromOtherNewsroomMutationVariables>;

/**
 * __useImportFromOtherNewsroomMutation__
 *
 * To run a mutation, you first call `useImportFromOtherNewsroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFromOtherNewsroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFromOtherNewsroomMutation, { data, loading, error }] = useImportFromOtherNewsroomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportFromOtherNewsroomMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportFromOtherNewsroomMutation, Types.ImportFromOtherNewsroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportFromOtherNewsroomMutation, Types.ImportFromOtherNewsroomMutationVariables>(ImportFromOtherNewsroomDocument, options);
      }
export type ImportFromOtherNewsroomMutationHookResult = ReturnType<typeof useImportFromOtherNewsroomMutation>;
export type ImportFromOtherNewsroomMutationResult = Apollo.MutationResult<Types.ImportFromOtherNewsroomMutation>;
export type ImportFromOtherNewsroomMutationOptions = Apollo.BaseMutationOptions<Types.ImportFromOtherNewsroomMutation, Types.ImportFromOtherNewsroomMutationVariables>;
export const DeleteMaterialByIdDocument = gql`
    mutation deleteMaterialById($typename: MaterialType!, $id: ID!, $unscheduleRelatedMaterial: Boolean) {
  deleteMaterial(
    input: {id: $id, typename: $typename, unscheduleRelatedMaterial: $unscheduleRelatedMaterial}
  ) {
    errors
    material {
      id
    }
    pressroom {
      id
    }
    previousImages {
      id
      usageCount
    }
  }
}
    `;
export type DeleteMaterialByIdMutationFn = Apollo.MutationFunction<Types.DeleteMaterialByIdMutation, Types.DeleteMaterialByIdMutationVariables>;

/**
 * __useDeleteMaterialByIdMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaterialByIdMutation, { data, loading, error }] = useDeleteMaterialByIdMutation({
 *   variables: {
 *      typename: // value for 'typename'
 *      id: // value for 'id'
 *      unscheduleRelatedMaterial: // value for 'unscheduleRelatedMaterial'
 *   },
 * });
 */
export function useDeleteMaterialByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMaterialByIdMutation, Types.DeleteMaterialByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMaterialByIdMutation, Types.DeleteMaterialByIdMutationVariables>(DeleteMaterialByIdDocument, options);
      }
export type DeleteMaterialByIdMutationHookResult = ReturnType<typeof useDeleteMaterialByIdMutation>;
export type DeleteMaterialByIdMutationResult = Apollo.MutationResult<Types.DeleteMaterialByIdMutation>;
export type DeleteMaterialByIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMaterialByIdMutation, Types.DeleteMaterialByIdMutationVariables>;
export const GetPressroomFeaturesDocument = gql`
    query getPressroomFeatures($pressroomId: ID!, $sourceId: ID!) {
  source(id: $sourceId) {
    id
    trial
  }
  pressroom(id: $pressroomId) {
    id
    live
    features {
      id
      copilotFeatures
      coPilotAiWriter: managed(feature: coPilotAiWriter) {
        id
        enabled
      }
    }
    newsroomSettings {
      id
      homepageUrl
    }
  }
}
    `;

/**
 * __useGetPressroomFeaturesQuery__
 *
 * To run a query within a React component, call `useGetPressroomFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressroomFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressroomFeaturesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetPressroomFeaturesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables> & ({ variables: Types.GetPressroomFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables>(GetPressroomFeaturesDocument, options);
      }
export function useGetPressroomFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables>(GetPressroomFeaturesDocument, options);
        }
export function useGetPressroomFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables>(GetPressroomFeaturesDocument, options);
        }
export type GetPressroomFeaturesQueryHookResult = ReturnType<typeof useGetPressroomFeaturesQuery>;
export type GetPressroomFeaturesLazyQueryHookResult = ReturnType<typeof useGetPressroomFeaturesLazyQuery>;
export type GetPressroomFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetPressroomFeaturesSuspenseQuery>;
export type GetPressroomFeaturesQueryResult = Apollo.QueryResult<Types.GetPressroomFeaturesQuery, Types.GetPressroomFeaturesQueryVariables>;
export const GetRemainingPublicationsCountDocument = gql`
    query getRemainingPublicationsCount($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    remainingPublicationCount
    name
  }
}
    `;

/**
 * __useGetRemainingPublicationsCountQuery__
 *
 * To run a query within a React component, call `useGetRemainingPublicationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemainingPublicationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemainingPublicationsCountQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetRemainingPublicationsCountQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables> & ({ variables: Types.GetRemainingPublicationsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables>(GetRemainingPublicationsCountDocument, options);
      }
export function useGetRemainingPublicationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables>(GetRemainingPublicationsCountDocument, options);
        }
export function useGetRemainingPublicationsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables>(GetRemainingPublicationsCountDocument, options);
        }
export type GetRemainingPublicationsCountQueryHookResult = ReturnType<typeof useGetRemainingPublicationsCountQuery>;
export type GetRemainingPublicationsCountLazyQueryHookResult = ReturnType<typeof useGetRemainingPublicationsCountLazyQuery>;
export type GetRemainingPublicationsCountSuspenseQueryHookResult = ReturnType<typeof useGetRemainingPublicationsCountSuspenseQuery>;
export type GetRemainingPublicationsCountQueryResult = Apollo.QueryResult<Types.GetRemainingPublicationsCountQuery, Types.GetRemainingPublicationsCountQueryVariables>;
export const GetMaterialListDocument = gql`
    query getMaterialList($pressroomId: ID!, $types: [MaterialType!]!, $page: Int = 1, $query: String, $status: MaterialStatusFilter, $perPage: Int!, $sort: MaterialListSort, $after: String) {
  pressroom(id: $pressroomId) {
    id
    newsroomUrl
    features {
      id
      prImpact: managed(feature: prImpact) {
        id
        enabled
      }
      prImpactLimited: managed(feature: prImpactLimited) {
        id
        enabled
      }
      analyzeMaterial: managed(feature: analyzeMaterial) {
        id
        enabled
      }
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      analyzeLight: managed(feature: analyzeLight) {
        id
        enabled
      }
      duplicateMaterial: managed(feature: duplicateMaterial) {
        id
        enabled
      }
      publishScheduling: managed(feature: publishScheduling) {
        id
        enabled
      }
      pitch
      cloneStoryMaterial
      publish {
        id
        expiration
      }
    }
    materialList2(
      types: $types
      page: $page
      query: $query
      status: $status
      first: $perPage
      sort: $sort
      after: $after
    ) {
      totalPages
      totalCount
      currentPage
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        __typename
        type: __typename
        header
        id
        publicUrl
        publishedAt2
        scheduledFor
        status
        expiresAt
        quotationsCount
        image {
          id
          url(transformation: THUMBNAIL_SMALL)
          altText
        }
        ... on Video {
          thumbnailUrl
          resourceVideo {
            id
            downloadUrl(forceDownload: true)
          }
          contactPeople: contactPeople2 {
            id
            ...ContactPersonFragment
          }
        }
        ... on Event {
          contactPeople: contactPeople2 {
            id
            ...ContactPersonFragment
          }
        }
        ... on Document {
          preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
          resourceDocument {
            id
            downloadUrl(forceDownload: true)
          }
          contactPeople: contactPeople2 {
            id
            ...ContactPersonFragment
          }
        }
        ... on StoryMaterial {
          visibility
          previewUrl
          generatedByAiWriter
          publishedBy {
            user {
              id
              name
              isMynewsdeskAdmin
            }
            deleted
            removedFromSource
          }
          contactPeople: contactPeople2 {
            id
            ...ContactPersonFragment
          }
        }
        ... on Pressrelease {
          sendExclusive {
            id
            ...SendExclusive
          }
          contactPeople: contactPeople2 {
            id
            ...ContactPersonFragment
          }
        }
        relatedMaterial(types: [Pressrelease, News, BlogPost, Event]) {
          id
          ...RelatedStory
        }
        relatedMedia: relatedMaterial(types: [Image, Video, Document]) {
          id
          ...RelatedMedia
        }
      }
    }
  }
}
    ${ContactPersonFragmentFragmentDoc}
${SendExclusiveFragmentDoc}
${RelatedStoryFragmentDoc}
${RelatedMediaFragmentDoc}`;

/**
 * __useGetMaterialListQuery__
 *
 * To run a query within a React component, call `useGetMaterialListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      types: // value for 'types'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMaterialListQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables> & ({ variables: Types.GetMaterialListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables>(GetMaterialListDocument, options);
      }
export function useGetMaterialListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables>(GetMaterialListDocument, options);
        }
export function useGetMaterialListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables>(GetMaterialListDocument, options);
        }
export type GetMaterialListQueryHookResult = ReturnType<typeof useGetMaterialListQuery>;
export type GetMaterialListLazyQueryHookResult = ReturnType<typeof useGetMaterialListLazyQuery>;
export type GetMaterialListSuspenseQueryHookResult = ReturnType<typeof useGetMaterialListSuspenseQuery>;
export type GetMaterialListQueryResult = Apollo.QueryResult<Types.GetMaterialListQuery, Types.GetMaterialListQueryVariables>;
export const Report2AddReachHighlightsDocument = gql`
    mutation Report2AddReachHighlights($reportSectionId: ID!, $articleIds: [ID!]!, $removedArticleIds: [ID!]!) {
  reportAddMonitorCoverage(
    input: {reportSectionId: $reportSectionId, articleIds: $articleIds, removedArticleIds: $removedArticleIds}
  ) {
    error {
      message
    }
    removedArticleIds
    removedQuotationIds
    report: report2 {
      id
      sections2 {
        id
        ... on ReportVisibilitySection {
          id
          subSections {
            id
            ... on ReportVisibilityHighlights {
              ...Report2VisibilityHighlights
            }
          }
        }
      }
    }
  }
}
    ${Report2VisibilityHighlightsFragmentDoc}
${ReportQuotation2FragmentDoc}`;
export type Report2AddReachHighlightsMutationFn = Apollo.MutationFunction<Types.Report2AddReachHighlightsMutation, Types.Report2AddReachHighlightsMutationVariables>;

/**
 * __useReport2AddReachHighlightsMutation__
 *
 * To run a mutation, you first call `useReport2AddReachHighlightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReport2AddReachHighlightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [report2AddReachHighlightsMutation, { data, loading, error }] = useReport2AddReachHighlightsMutation({
 *   variables: {
 *      reportSectionId: // value for 'reportSectionId'
 *      articleIds: // value for 'articleIds'
 *      removedArticleIds: // value for 'removedArticleIds'
 *   },
 * });
 */
export function useReport2AddReachHighlightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.Report2AddReachHighlightsMutation, Types.Report2AddReachHighlightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Report2AddReachHighlightsMutation, Types.Report2AddReachHighlightsMutationVariables>(Report2AddReachHighlightsDocument, options);
      }
export type Report2AddReachHighlightsMutationHookResult = ReturnType<typeof useReport2AddReachHighlightsMutation>;
export type Report2AddReachHighlightsMutationResult = Apollo.MutationResult<Types.Report2AddReachHighlightsMutation>;
export type Report2AddReachHighlightsMutationOptions = Apollo.BaseMutationOptions<Types.Report2AddReachHighlightsMutation, Types.Report2AddReachHighlightsMutationVariables>;
export const Report2HitsByIdsDocument = gql`
    query Report2HitsByIds($reportId: ID!, $pressroomId: ID!, $sectionId: ID!, $language: UserLocale) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      managed(feature: monitorSentiment) {
        id
        enabled
      }
    }
  }
  report2(id: $reportId) {
    id
    ... on BrandReport {
      highlighedHitsPool {
        id
        inCoverageReportSection(sectionId: $sectionId)
        ...HitDataWithDuplicates
      }
    }
  }
}
    ${HitDataWithDuplicatesFragmentDoc}
${HitDataFragmentDoc}`;

/**
 * __useReport2HitsByIdsQuery__
 *
 * To run a query within a React component, call `useReport2HitsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReport2HitsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReport2HitsByIdsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      pressroomId: // value for 'pressroomId'
 *      sectionId: // value for 'sectionId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useReport2HitsByIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables> & ({ variables: Types.Report2HitsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables>(Report2HitsByIdsDocument, options);
      }
export function useReport2HitsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables>(Report2HitsByIdsDocument, options);
        }
export function useReport2HitsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables>(Report2HitsByIdsDocument, options);
        }
export type Report2HitsByIdsQueryHookResult = ReturnType<typeof useReport2HitsByIdsQuery>;
export type Report2HitsByIdsLazyQueryHookResult = ReturnType<typeof useReport2HitsByIdsLazyQuery>;
export type Report2HitsByIdsSuspenseQueryHookResult = ReturnType<typeof useReport2HitsByIdsSuspenseQuery>;
export type Report2HitsByIdsQueryResult = Apollo.QueryResult<Types.Report2HitsByIdsQuery, Types.Report2HitsByIdsQueryVariables>;
export const Report2RequestPdfSlideshowDocument = gql`
    mutation Report2RequestPdfSlideshow($reportId: ID!, $version: String) {
  reportRequestPdfSlideshow(input: {reportId: $reportId, version: $version}) {
    error {
      message
    }
    pdfSlideshow {
      id
      state
      url
    }
  }
}
    `;
export type Report2RequestPdfSlideshowMutationFn = Apollo.MutationFunction<Types.Report2RequestPdfSlideshowMutation, Types.Report2RequestPdfSlideshowMutationVariables>;

/**
 * __useReport2RequestPdfSlideshowMutation__
 *
 * To run a mutation, you first call `useReport2RequestPdfSlideshowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReport2RequestPdfSlideshowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [report2RequestPdfSlideshowMutation, { data, loading, error }] = useReport2RequestPdfSlideshowMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useReport2RequestPdfSlideshowMutation(baseOptions?: Apollo.MutationHookOptions<Types.Report2RequestPdfSlideshowMutation, Types.Report2RequestPdfSlideshowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Report2RequestPdfSlideshowMutation, Types.Report2RequestPdfSlideshowMutationVariables>(Report2RequestPdfSlideshowDocument, options);
      }
export type Report2RequestPdfSlideshowMutationHookResult = ReturnType<typeof useReport2RequestPdfSlideshowMutation>;
export type Report2RequestPdfSlideshowMutationResult = Apollo.MutationResult<Types.Report2RequestPdfSlideshowMutation>;
export type Report2RequestPdfSlideshowMutationOptions = Apollo.BaseMutationOptions<Types.Report2RequestPdfSlideshowMutation, Types.Report2RequestPdfSlideshowMutationVariables>;
export const ReportPdfPollingDocument = gql`
    query ReportPdfPolling($reportId: ID!, $pdfRequestIds: [ID!]!) {
  report: report2(id: $reportId) {
    id
    pdfSlideshows(ids: $pdfRequestIds) {
      id
      state
      url
    }
  }
}
    `;

/**
 * __useReportPdfPollingQuery__
 *
 * To run a query within a React component, call `useReportPdfPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPdfPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPdfPollingQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      pdfRequestIds: // value for 'pdfRequestIds'
 *   },
 * });
 */
export function useReportPdfPollingQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables> & ({ variables: Types.ReportPdfPollingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables>(ReportPdfPollingDocument, options);
      }
export function useReportPdfPollingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables>(ReportPdfPollingDocument, options);
        }
export function useReportPdfPollingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables>(ReportPdfPollingDocument, options);
        }
export type ReportPdfPollingQueryHookResult = ReturnType<typeof useReportPdfPollingQuery>;
export type ReportPdfPollingLazyQueryHookResult = ReturnType<typeof useReportPdfPollingLazyQuery>;
export type ReportPdfPollingSuspenseQueryHookResult = ReturnType<typeof useReportPdfPollingSuspenseQuery>;
export type ReportPdfPollingQueryResult = Apollo.QueryResult<Types.ReportPdfPollingQuery, Types.ReportPdfPollingQueryVariables>;
export const CreateBrandReportSourceGroupFilterDocument = gql`
    query CreateBrandReportSourceGroupFilter($pressroomId: ID!, $languages: [MonitorProfileLanguage!]!, $countries: [MonitorProfileCountry!]!, $name: String!, $mediaTypes: [MonitorMediaFilterType!]!) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      sourceGroups2(
        countries: $countries
        languages: $languages
        name: $name
        mediaTypes: $mediaTypes
      ) {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCreateBrandReportSourceGroupFilterQuery__
 *
 * To run a query within a React component, call `useCreateBrandReportSourceGroupFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandReportSourceGroupFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateBrandReportSourceGroupFilterQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      languages: // value for 'languages'
 *      countries: // value for 'countries'
 *      name: // value for 'name'
 *      mediaTypes: // value for 'mediaTypes'
 *   },
 * });
 */
export function useCreateBrandReportSourceGroupFilterQuery(baseOptions: Apollo.QueryHookOptions<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables> & ({ variables: Types.CreateBrandReportSourceGroupFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables>(CreateBrandReportSourceGroupFilterDocument, options);
      }
export function useCreateBrandReportSourceGroupFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables>(CreateBrandReportSourceGroupFilterDocument, options);
        }
export function useCreateBrandReportSourceGroupFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables>(CreateBrandReportSourceGroupFilterDocument, options);
        }
export type CreateBrandReportSourceGroupFilterQueryHookResult = ReturnType<typeof useCreateBrandReportSourceGroupFilterQuery>;
export type CreateBrandReportSourceGroupFilterLazyQueryHookResult = ReturnType<typeof useCreateBrandReportSourceGroupFilterLazyQuery>;
export type CreateBrandReportSourceGroupFilterSuspenseQueryHookResult = ReturnType<typeof useCreateBrandReportSourceGroupFilterSuspenseQuery>;
export type CreateBrandReportSourceGroupFilterQueryResult = Apollo.QueryResult<Types.CreateBrandReportSourceGroupFilterQuery, Types.CreateBrandReportSourceGroupFilterQueryVariables>;
export const AnalyzeSimpleSearchProfilesDocument = gql`
    mutation AnalyzeSimpleSearchProfiles($pressroomId: ID!, $simpleSearchProfileIds: [ID!]!, $sourceSelection: SimpleSearchProfileSourceSelection!) {
  monitorSimpleSearchProfilesAnalyze(
    input: {pressroomId: $pressroomId, simpleSearchProfileIds: $simpleSearchProfileIds, sourceSelection: $sourceSelection}
  ) {
    simpleSearchProfiles {
      id
      ...SimpleSearchProfileWithPreliminaryResults
    }
    error {
      __typename
    }
  }
}
    ${SimpleSearchProfileWithPreliminaryResultsFragmentDoc}
${SimpleSearchProfileFragmentDoc}
${PreliminaryResultsFragmentDoc}`;
export type AnalyzeSimpleSearchProfilesMutationFn = Apollo.MutationFunction<Types.AnalyzeSimpleSearchProfilesMutation, Types.AnalyzeSimpleSearchProfilesMutationVariables>;

/**
 * __useAnalyzeSimpleSearchProfilesMutation__
 *
 * To run a mutation, you first call `useAnalyzeSimpleSearchProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeSimpleSearchProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeSimpleSearchProfilesMutation, { data, loading, error }] = useAnalyzeSimpleSearchProfilesMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      simpleSearchProfileIds: // value for 'simpleSearchProfileIds'
 *      sourceSelection: // value for 'sourceSelection'
 *   },
 * });
 */
export function useAnalyzeSimpleSearchProfilesMutation(baseOptions?: Apollo.MutationHookOptions<Types.AnalyzeSimpleSearchProfilesMutation, Types.AnalyzeSimpleSearchProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AnalyzeSimpleSearchProfilesMutation, Types.AnalyzeSimpleSearchProfilesMutationVariables>(AnalyzeSimpleSearchProfilesDocument, options);
      }
export type AnalyzeSimpleSearchProfilesMutationHookResult = ReturnType<typeof useAnalyzeSimpleSearchProfilesMutation>;
export type AnalyzeSimpleSearchProfilesMutationResult = Apollo.MutationResult<Types.AnalyzeSimpleSearchProfilesMutation>;
export type AnalyzeSimpleSearchProfilesMutationOptions = Apollo.BaseMutationOptions<Types.AnalyzeSimpleSearchProfilesMutation, Types.AnalyzeSimpleSearchProfilesMutationVariables>;
export const CreateCoverageReportDocument = gql`
    mutation CreateCoverageReport($input: NewCoverageReportInput!) {
  reportCreate(input: {data: {newCoverageReportInput: $input}}) {
    error {
      message
      ... on ReportCreateValidationError {
        title
        description
        coverImage
      }
    }
    report: report2 {
      id
      connectedImages {
        id
        usageCount
      }
    }
    pressroom {
      id
      pendingNotices {
        id
        coverageReportNotices {
          createReportEmptyState
        }
      }
      report: reports2 {
        id
      }
    }
  }
}
    `;
export type CreateCoverageReportMutationFn = Apollo.MutationFunction<Types.CreateCoverageReportMutation, Types.CreateCoverageReportMutationVariables>;

/**
 * __useCreateCoverageReportMutation__
 *
 * To run a mutation, you first call `useCreateCoverageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverageReportMutation, { data, loading, error }] = useCreateCoverageReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoverageReportMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCoverageReportMutation, Types.CreateCoverageReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCoverageReportMutation, Types.CreateCoverageReportMutationVariables>(CreateCoverageReportDocument, options);
      }
export type CreateCoverageReportMutationHookResult = ReturnType<typeof useCreateCoverageReportMutation>;
export type CreateCoverageReportMutationResult = Apollo.MutationResult<Types.CreateCoverageReportMutation>;
export type CreateCoverageReportMutationOptions = Apollo.BaseMutationOptions<Types.CreateCoverageReportMutation, Types.CreateCoverageReportMutationVariables>;
export const ReportCoverImageDocument = gql`
    query ReportCoverImage($id: ID!) {
  material(id: $id, type: Image) {
    id
    ... on Image {
      image {
        id
        url(transformation: LIMIT_1000)
      }
    }
  }
}
    `;

/**
 * __useReportCoverImageQuery__
 *
 * To run a query within a React component, call `useReportCoverImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCoverImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCoverImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCoverImageQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables> & ({ variables: Types.ReportCoverImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables>(ReportCoverImageDocument, options);
      }
export function useReportCoverImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables>(ReportCoverImageDocument, options);
        }
export function useReportCoverImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables>(ReportCoverImageDocument, options);
        }
export type ReportCoverImageQueryHookResult = ReturnType<typeof useReportCoverImageQuery>;
export type ReportCoverImageLazyQueryHookResult = ReturnType<typeof useReportCoverImageLazyQuery>;
export type ReportCoverImageSuspenseQueryHookResult = ReturnType<typeof useReportCoverImageSuspenseQuery>;
export type ReportCoverImageQueryResult = Apollo.QueryResult<Types.ReportCoverImageQuery, Types.ReportCoverImageQueryVariables>;
export const SeenReportOnboardingDocument = gql`
    mutation SeenReportOnboarding($pressroomId: ID!) {
  noticeConfirm(
    input: {pressroomId: $pressroomId, notice: coverageReportOnboarding}
  ) {
    pendingNotices {
      id
      coverageReportNotices {
        onboarding
      }
    }
  }
}
    `;
export type SeenReportOnboardingMutationFn = Apollo.MutationFunction<Types.SeenReportOnboardingMutation, Types.SeenReportOnboardingMutationVariables>;

/**
 * __useSeenReportOnboardingMutation__
 *
 * To run a mutation, you first call `useSeenReportOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenReportOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenReportOnboardingMutation, { data, loading, error }] = useSeenReportOnboardingMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSeenReportOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenReportOnboardingMutation, Types.SeenReportOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenReportOnboardingMutation, Types.SeenReportOnboardingMutationVariables>(SeenReportOnboardingDocument, options);
      }
export type SeenReportOnboardingMutationHookResult = ReturnType<typeof useSeenReportOnboardingMutation>;
export type SeenReportOnboardingMutationResult = Apollo.MutationResult<Types.SeenReportOnboardingMutation>;
export type SeenReportOnboardingMutationOptions = Apollo.BaseMutationOptions<Types.SeenReportOnboardingMutation, Types.SeenReportOnboardingMutationVariables>;
export const ReportUpdateDocument = gql`
    mutation ReportUpdate($id: ID!, $title: String!, $description: String, $brandColor: String, $coverImageId: ID, $logotypeId: ID, $metricsDescription: String, $metricsTitle: String, $locale: UserLocale, $visibleMetrics: [ReportMetric!], $featuredDescription: String, $featuredTitle: String, $logotypeWidth: Int, $textLogotype: String, $textLogotypeColor: String, $textLogotypeFontSize: Int, $textLogotypeLetterSpacing: Int, $typeOfLogo: ReportLogo) {
  reportUpdate(
    input: {reportId: $id, title: $title, description: $description, brandColor: $brandColor, coverImageId: $coverImageId, logotypeId: $logotypeId, metricsDescription: $metricsDescription, logotypeWidth: $logotypeWidth, textLogotype: $textLogotype, textLogotypeColor: $textLogotypeColor, textLogotypeFontSize: $textLogotypeFontSize, textLogotypeLetterSpacing: $textLogotypeLetterSpacing, locale: $locale, visibleMetrics: $visibleMetrics, metricsTitle: $metricsTitle, featuredDescription: $featuredDescription, featuredTitle: $featuredTitle, typeOfLogo: $typeOfLogo}
  ) {
    error {
      message
      ... on ReportUpdateValidationError {
        title
        description
        coverImage
        logotypeId
        metricsDescription
        featuredDescription
        featuredTitle
        logotypeWidth
        textLogotype
        textLogotypeFontSize
        textLogotypeLetterSpacing
      }
    }
    report: report2 {
      id
      connectedImages {
        id
        usageCount
      }
      ...ReportMeta
    }
    previousImages {
      id
      usageCount
    }
  }
}
    ${ReportMetaFragmentDoc}`;
export type ReportUpdateMutationFn = Apollo.MutationFunction<Types.ReportUpdateMutation, Types.ReportUpdateMutationVariables>;

/**
 * __useReportUpdateMutation__
 *
 * To run a mutation, you first call `useReportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUpdateMutation, { data, loading, error }] = useReportUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      brandColor: // value for 'brandColor'
 *      coverImageId: // value for 'coverImageId'
 *      logotypeId: // value for 'logotypeId'
 *      metricsDescription: // value for 'metricsDescription'
 *      metricsTitle: // value for 'metricsTitle'
 *      locale: // value for 'locale'
 *      visibleMetrics: // value for 'visibleMetrics'
 *      featuredDescription: // value for 'featuredDescription'
 *      featuredTitle: // value for 'featuredTitle'
 *      logotypeWidth: // value for 'logotypeWidth'
 *      textLogotype: // value for 'textLogotype'
 *      textLogotypeColor: // value for 'textLogotypeColor'
 *      textLogotypeFontSize: // value for 'textLogotypeFontSize'
 *      textLogotypeLetterSpacing: // value for 'textLogotypeLetterSpacing'
 *      typeOfLogo: // value for 'typeOfLogo'
 *   },
 * });
 */
export function useReportUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportUpdateMutation, Types.ReportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportUpdateMutation, Types.ReportUpdateMutationVariables>(ReportUpdateDocument, options);
      }
export type ReportUpdateMutationHookResult = ReturnType<typeof useReportUpdateMutation>;
export type ReportUpdateMutationResult = Apollo.MutationResult<Types.ReportUpdateMutation>;
export type ReportUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ReportUpdateMutation, Types.ReportUpdateMutationVariables>;
export const ReportSectionUpdateDocument = gql`
    mutation ReportSectionUpdate($id: ID!, $title: String, $description: String, $design: ReportSectionDesign) {
  reportUpdateSection(
    input: {reportSectionId: $id, title: $title, description: $description, design: $design}
  ) {
    error {
      message
      ... on ReportUpdateSectionValidationError {
        title
        description
      }
    }
    section2 {
      id
      title
      description
    }
  }
}
    `;
export type ReportSectionUpdateMutationFn = Apollo.MutationFunction<Types.ReportSectionUpdateMutation, Types.ReportSectionUpdateMutationVariables>;

/**
 * __useReportSectionUpdateMutation__
 *
 * To run a mutation, you first call `useReportSectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSectionUpdateMutation, { data, loading, error }] = useReportSectionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      design: // value for 'design'
 *   },
 * });
 */
export function useReportSectionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportSectionUpdateMutation, Types.ReportSectionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportSectionUpdateMutation, Types.ReportSectionUpdateMutationVariables>(ReportSectionUpdateDocument, options);
      }
export type ReportSectionUpdateMutationHookResult = ReturnType<typeof useReportSectionUpdateMutation>;
export type ReportSectionUpdateMutationResult = Apollo.MutationResult<Types.ReportSectionUpdateMutation>;
export type ReportSectionUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ReportSectionUpdateMutation, Types.ReportSectionUpdateMutationVariables>;
export const ReportPollingDocument = gql`
    query ReportPolling($reportId: ID!, $openSectionId: ID!, $useOpenSection: Boolean!, $closedFetchCount: Int!, $openFetchCount: Int!, $openSectionLastCursor: String, $pdfRequestIds: [ID!]!) {
  report: report2(id: $reportId) {
    id
    importJobs {
      id
      totalCount
      finishedCount
      state
      section {
        id
        title
      }
    }
    pdfSlideshows(ids: $pdfRequestIds) {
      id
      state
      url
    }
    allSections: sections2 @skip(if: $useOpenSection) {
      id
      ... on ReportQuotationGridSection {
        quotations(first: $closedFetchCount, skipHidden: false) {
          ...ReportCoveragePollingConnectionData
        }
      }
      ... on ReportQuotationFullWidthSection {
        quotations(first: $closedFetchCount, skipHidden: false) {
          ...ReportCoveragePollingConnectionData
        }
      }
      ... on ReportMetricsSection {
        ...ReportMetricsSection
      }
    }
    openSection: sections2(ids: [$openSectionId]) @include(if: $useOpenSection) {
      id
      ... on ReportQuotationGridSection {
        quotations(
          first: $openFetchCount
          after: $openSectionLastCursor
          skipHidden: false
        ) {
          ...ReportCoveragePollingConnectionData
        }
      }
      ... on ReportQuotationFullWidthSection {
        quotations(
          first: $openFetchCount
          after: $openSectionLastCursor
          skipHidden: false
        ) {
          ...ReportCoveragePollingConnectionData
        }
      }
      ... on ReportMetricsSection {
        ...ReportMetricsSection
      }
    }
    closedSections: sections2(excludeIds: [$openSectionId]) @include(if: $useOpenSection) {
      id
      ... on ReportQuotationGridSection {
        quotations(first: $closedFetchCount, skipHidden: false) {
          ...ReportCoveragePollingConnectionData
        }
      }
      ... on ReportQuotationFullWidthSection {
        quotations(first: $closedFetchCount, skipHidden: false) {
          ...ReportCoveragePollingConnectionData
        }
      }
      ... on ReportMetricsSection {
        ...ReportMetricsSection
      }
    }
  }
}
    ${ReportCoveragePollingConnectionDataFragmentDoc}
${ReportQuotationFragmentDoc}
${ReportMetricsSectionFragmentDoc}`;

/**
 * __useReportPollingQuery__
 *
 * To run a query within a React component, call `useReportPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPollingQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      openSectionId: // value for 'openSectionId'
 *      useOpenSection: // value for 'useOpenSection'
 *      closedFetchCount: // value for 'closedFetchCount'
 *      openFetchCount: // value for 'openFetchCount'
 *      openSectionLastCursor: // value for 'openSectionLastCursor'
 *      pdfRequestIds: // value for 'pdfRequestIds'
 *   },
 * });
 */
export function useReportPollingQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportPollingQuery, Types.ReportPollingQueryVariables> & ({ variables: Types.ReportPollingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportPollingQuery, Types.ReportPollingQueryVariables>(ReportPollingDocument, options);
      }
export function useReportPollingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportPollingQuery, Types.ReportPollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportPollingQuery, Types.ReportPollingQueryVariables>(ReportPollingDocument, options);
        }
export function useReportPollingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportPollingQuery, Types.ReportPollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportPollingQuery, Types.ReportPollingQueryVariables>(ReportPollingDocument, options);
        }
export type ReportPollingQueryHookResult = ReturnType<typeof useReportPollingQuery>;
export type ReportPollingLazyQueryHookResult = ReturnType<typeof useReportPollingLazyQuery>;
export type ReportPollingSuspenseQueryHookResult = ReturnType<typeof useReportPollingSuspenseQuery>;
export type ReportPollingQueryResult = Apollo.QueryResult<Types.ReportPollingQuery, Types.ReportPollingQueryVariables>;
export const CoverageMaterialsDocument = gql`
    query CoverageMaterials($pressroomId: ID!, $page: Int, $sectionId: ID!) {
  pressroom(id: $pressroomId) {
    id
    materialList2(
      first: 10
      page: $page
      types: [Pressrelease, BlogPost, News]
      status: published
      sort: descending_published_at
    ) {
      currentPage
      totalPages
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        id
        header
        publishedAt: publishedAt2
        quotationsCount
        status
        ... on StoryMaterial {
          availableForCoverageReportSection(sectionId: $sectionId)
          inCoverageReportSection(sectionId: $sectionId)
        }
        image {
          id
          url(transformation: THUMBNAIL_SMALL)
          altText
        }
      }
    }
  }
}
    `;

/**
 * __useCoverageMaterialsQuery__
 *
 * To run a query within a React component, call `useCoverageMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverageMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverageMaterialsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      page: // value for 'page'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCoverageMaterialsQuery(baseOptions: Apollo.QueryHookOptions<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables> & ({ variables: Types.CoverageMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables>(CoverageMaterialsDocument, options);
      }
export function useCoverageMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables>(CoverageMaterialsDocument, options);
        }
export function useCoverageMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables>(CoverageMaterialsDocument, options);
        }
export type CoverageMaterialsQueryHookResult = ReturnType<typeof useCoverageMaterialsQuery>;
export type CoverageMaterialsLazyQueryHookResult = ReturnType<typeof useCoverageMaterialsLazyQuery>;
export type CoverageMaterialsSuspenseQueryHookResult = ReturnType<typeof useCoverageMaterialsSuspenseQuery>;
export type CoverageMaterialsQueryResult = Apollo.QueryResult<Types.CoverageMaterialsQuery, Types.CoverageMaterialsQueryVariables>;
export const ReportUpdateCoverageDocument = gql`
    mutation ReportUpdateCoverage($addedMaterials: [MaterialIdTuple!], $removedMaterials: [MaterialIdTuple!], $reportId: ID!, $reportSectionId: ID!, $first: Int, $after: String) {
  reportUpdateCoverage(
    input: {reportId: $reportId, reportSectionId: $reportSectionId, addedMaterials: $addedMaterials, removedMaterials: $removedMaterials}
  ) {
    error {
      message
    }
    materials {
      id
      availableForCoverageReportSection(sectionId: $reportSectionId)
      inCoverageReportSection(sectionId: $reportSectionId)
    }
    deletedQuotations
    report: report2 {
      id
      updatedMetrics: sections2 {
        id
        ...ReportMetricsSection
      }
      sections2(ids: [$reportSectionId]) {
        id
        ... on ReportQuotationGridSection {
          quotations(first: $first, after: $after, skipHidden: false) {
            totalCount
            edges {
              cursor
              node {
                id
                ...ReportQuotation
              }
            }
          }
        }
        ... on ReportQuotationFullWidthSection {
          quotations(first: $first, after: $after, skipHidden: false) {
            totalCount
            edges {
              cursor
              node {
                id
                ...ReportQuotation
              }
            }
          }
        }
      }
    }
  }
}
    ${ReportMetricsSectionFragmentDoc}
${ReportQuotationFragmentDoc}`;
export type ReportUpdateCoverageMutationFn = Apollo.MutationFunction<Types.ReportUpdateCoverageMutation, Types.ReportUpdateCoverageMutationVariables>;

/**
 * __useReportUpdateCoverageMutation__
 *
 * To run a mutation, you first call `useReportUpdateCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUpdateCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUpdateCoverageMutation, { data, loading, error }] = useReportUpdateCoverageMutation({
 *   variables: {
 *      addedMaterials: // value for 'addedMaterials'
 *      removedMaterials: // value for 'removedMaterials'
 *      reportId: // value for 'reportId'
 *      reportSectionId: // value for 'reportSectionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportUpdateCoverageMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportUpdateCoverageMutation, Types.ReportUpdateCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportUpdateCoverageMutation, Types.ReportUpdateCoverageMutationVariables>(ReportUpdateCoverageDocument, options);
      }
export type ReportUpdateCoverageMutationHookResult = ReturnType<typeof useReportUpdateCoverageMutation>;
export type ReportUpdateCoverageMutationResult = Apollo.MutationResult<Types.ReportUpdateCoverageMutation>;
export type ReportUpdateCoverageMutationOptions = Apollo.BaseMutationOptions<Types.ReportUpdateCoverageMutation, Types.ReportUpdateCoverageMutationVariables>;
export const ReportAddExternalDocument = gql`
    mutation ReportAddExternal($reportId: ID!, $urls: [String!]!, $reportSectionId: ID!, $first: Int, $after: String) {
  reportAddExternalCoverage(
    input: {reportId: $reportId, urls: $urls, reportSectionId: $reportSectionId}
  ) {
    error {
      message
    }
    report: report2 {
      id
      updatedMetrics: sections2 {
        id
        ...ReportMetricsSection
      }
      importJobs {
        id
        totalCount
        finishedCount
        state
        section {
          id
          title
        }
      }
      sections2(ids: [$reportSectionId]) {
        id
        ... on ReportQuotationGridSection {
          quotations(first: $first, after: $after, skipHidden: false) {
            totalCount
            edges {
              cursor
              node {
                id
                ...ReportQuotation
              }
            }
          }
        }
        ... on ReportQuotationFullWidthSection {
          quotations(first: $first, after: $after, skipHidden: false) {
            totalCount
            edges {
              cursor
              node {
                id
                ...ReportQuotation
              }
            }
          }
        }
      }
    }
  }
}
    ${ReportMetricsSectionFragmentDoc}
${ReportQuotationFragmentDoc}`;
export type ReportAddExternalMutationFn = Apollo.MutationFunction<Types.ReportAddExternalMutation, Types.ReportAddExternalMutationVariables>;

/**
 * __useReportAddExternalMutation__
 *
 * To run a mutation, you first call `useReportAddExternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAddExternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAddExternalMutation, { data, loading, error }] = useReportAddExternalMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      urls: // value for 'urls'
 *      reportSectionId: // value for 'reportSectionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportAddExternalMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportAddExternalMutation, Types.ReportAddExternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportAddExternalMutation, Types.ReportAddExternalMutationVariables>(ReportAddExternalDocument, options);
      }
export type ReportAddExternalMutationHookResult = ReturnType<typeof useReportAddExternalMutation>;
export type ReportAddExternalMutationResult = Apollo.MutationResult<Types.ReportAddExternalMutation>;
export type ReportAddExternalMutationOptions = Apollo.BaseMutationOptions<Types.ReportAddExternalMutation, Types.ReportAddExternalMutationVariables>;
export const ReportSocialPreviewDocument = gql`
    query ReportSocialPreview($url: String!) {
  preview: socialMediaPreview(url: $url) {
    description
    image
    title
    publishedAt
    source
    icon
    url
    reach
    engagement
    sentiment
  }
}
    `;

/**
 * __useReportSocialPreviewQuery__
 *
 * To run a query within a React component, call `useReportSocialPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSocialPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSocialPreviewQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useReportSocialPreviewQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables> & ({ variables: Types.ReportSocialPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables>(ReportSocialPreviewDocument, options);
      }
export function useReportSocialPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables>(ReportSocialPreviewDocument, options);
        }
export function useReportSocialPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables>(ReportSocialPreviewDocument, options);
        }
export type ReportSocialPreviewQueryHookResult = ReturnType<typeof useReportSocialPreviewQuery>;
export type ReportSocialPreviewLazyQueryHookResult = ReturnType<typeof useReportSocialPreviewLazyQuery>;
export type ReportSocialPreviewSuspenseQueryHookResult = ReturnType<typeof useReportSocialPreviewSuspenseQuery>;
export type ReportSocialPreviewQueryResult = Apollo.QueryResult<Types.ReportSocialPreviewQuery, Types.ReportSocialPreviewQueryVariables>;
export const ReportAddMonitorDocument = gql`
    mutation ReportAddMonitor($reportSectionId: ID!, $articleIds: [ID!]!, $removedArticleIds: [ID!]!) {
  reportAddMonitorCoverage(
    input: {reportSectionId: $reportSectionId, articleIds: $articleIds, removedArticleIds: $removedArticleIds}
  ) {
    error {
      message
    }
    removedArticleIds
    removedQuotationIds
    report: report2 {
      id
      updatedMetrics: sections2 {
        id
        ...ReportMetricsSection
      }
      importJobs {
        id
        totalCount
        finishedCount
        state
        section {
          id
          title
        }
      }
    }
  }
}
    ${ReportMetricsSectionFragmentDoc}`;
export type ReportAddMonitorMutationFn = Apollo.MutationFunction<Types.ReportAddMonitorMutation, Types.ReportAddMonitorMutationVariables>;

/**
 * __useReportAddMonitorMutation__
 *
 * To run a mutation, you first call `useReportAddMonitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAddMonitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAddMonitorMutation, { data, loading, error }] = useReportAddMonitorMutation({
 *   variables: {
 *      reportSectionId: // value for 'reportSectionId'
 *      articleIds: // value for 'articleIds'
 *      removedArticleIds: // value for 'removedArticleIds'
 *   },
 * });
 */
export function useReportAddMonitorMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportAddMonitorMutation, Types.ReportAddMonitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportAddMonitorMutation, Types.ReportAddMonitorMutationVariables>(ReportAddMonitorDocument, options);
      }
export type ReportAddMonitorMutationHookResult = ReturnType<typeof useReportAddMonitorMutation>;
export type ReportAddMonitorMutationResult = Apollo.MutationResult<Types.ReportAddMonitorMutation>;
export type ReportAddMonitorMutationOptions = Apollo.BaseMutationOptions<Types.ReportAddMonitorMutation, Types.ReportAddMonitorMutationVariables>;
export const ReportMonitorHitListDocument = gql`
    query ReportMonitorHitList($pressroomId: ID!, $profiles: [ID!], $sources: [MonitorMediaFilterType!], $timespan: MonitorTimespan, $timeRange: MonitorTimeRange, $after: String, $groupIdentical: Boolean, $locations: [LocationFilterInput!], $freeTextSearch: String, $sectionId: ID!, $feature: Feature!, $orderBy: MonitorOrderBy, $language: UserLocale) {
  pressroom(id: $pressroomId) {
    id
    monitor {
      id
      hitList(
        searchParams: {profiles: $profiles, sources: $sources, timespan: $timespan, timeRange: $timeRange}
        locations: $locations
        after: $after
        groupIdentical: $groupIdentical
        freetextSearch: $freeTextSearch
        orderBy: $orderBy
      ) {
        totalCount
        endCursor
        hits {
          id
          inCoverageReportSection(sectionId: $sectionId)
          duplicates {
            id
            inCoverageReportSection(sectionId: $sectionId)
          }
          ...HitDataWithDuplicates
        }
        error {
          __typename
        }
      }
    }
    features {
      id
      managed(feature: $feature) {
        id
        enabled
      }
    }
  }
}
    ${HitDataWithDuplicatesFragmentDoc}
${HitDataFragmentDoc}`;

/**
 * __useReportMonitorHitListQuery__
 *
 * To run a query within a React component, call `useReportMonitorHitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportMonitorHitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportMonitorHitListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      profiles: // value for 'profiles'
 *      sources: // value for 'sources'
 *      timespan: // value for 'timespan'
 *      timeRange: // value for 'timeRange'
 *      after: // value for 'after'
 *      groupIdentical: // value for 'groupIdentical'
 *      locations: // value for 'locations'
 *      freeTextSearch: // value for 'freeTextSearch'
 *      sectionId: // value for 'sectionId'
 *      feature: // value for 'feature'
 *      orderBy: // value for 'orderBy'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useReportMonitorHitListQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables> & ({ variables: Types.ReportMonitorHitListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables>(ReportMonitorHitListDocument, options);
      }
export function useReportMonitorHitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables>(ReportMonitorHitListDocument, options);
        }
export function useReportMonitorHitListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables>(ReportMonitorHitListDocument, options);
        }
export type ReportMonitorHitListQueryHookResult = ReturnType<typeof useReportMonitorHitListQuery>;
export type ReportMonitorHitListLazyQueryHookResult = ReturnType<typeof useReportMonitorHitListLazyQuery>;
export type ReportMonitorHitListSuspenseQueryHookResult = ReturnType<typeof useReportMonitorHitListSuspenseQuery>;
export type ReportMonitorHitListQueryResult = Apollo.QueryResult<Types.ReportMonitorHitListQuery, Types.ReportMonitorHitListQueryVariables>;
export const ReportHubspotCallbackDocument = gql`
    mutation ReportHubspotCallback($type: HubspotCallbacks!) {
  hubspotCallbackRequest(input: {type: $type}) {
    error {
      message
    }
  }
}
    `;
export type ReportHubspotCallbackMutationFn = Apollo.MutationFunction<Types.ReportHubspotCallbackMutation, Types.ReportHubspotCallbackMutationVariables>;

/**
 * __useReportHubspotCallbackMutation__
 *
 * To run a mutation, you first call `useReportHubspotCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportHubspotCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportHubspotCallbackMutation, { data, loading, error }] = useReportHubspotCallbackMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useReportHubspotCallbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportHubspotCallbackMutation, Types.ReportHubspotCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportHubspotCallbackMutation, Types.ReportHubspotCallbackMutationVariables>(ReportHubspotCallbackDocument, options);
      }
export type ReportHubspotCallbackMutationHookResult = ReturnType<typeof useReportHubspotCallbackMutation>;
export type ReportHubspotCallbackMutationResult = Apollo.MutationResult<Types.ReportHubspotCallbackMutation>;
export type ReportHubspotCallbackMutationOptions = Apollo.BaseMutationOptions<Types.ReportHubspotCallbackMutation, Types.ReportHubspotCallbackMutationVariables>;
export const ReportRemoveCoverageDocument = gql`
    mutation ReportRemoveCoverage($reportId: ID!, $quotationId: ID!, $sectionId: ID!) {
  reportRemoveCoverage(input: {reportId: $reportId, quotationId: $quotationId}) {
    error {
      message
    }
    report: report2 {
      id
      metrics: sections2 {
        id
        ... on ReportMetricsSection {
          ...ReportMetricsSection
        }
      }
      sections2(ids: [$sectionId]) {
        id
        ... on ReportQuotationGridSection {
          q1: quotations(skipHidden: false, first: 3) {
            totalCount
            edges {
              cursor
              node {
                id
                ...ReportQuotation
              }
            }
          }
          q2: quotations(skipHidden: true, first: 3) {
            totalCount
            edges {
              cursor
              node {
                id
                ...ReportQuotation
              }
            }
          }
        }
        ... on ReportQuotationFullWidthSection {
          q1: quotations(skipHidden: false) {
            totalCount
          }
          q2: quotations(skipHidden: true) {
            totalCount
          }
        }
      }
    }
    material {
      id
      availableForCoverageReportSection(sectionId: $sectionId)
      inCoverageReportSection(sectionId: $sectionId)
    }
    monitorHit {
      id
      inCoverageReportSection(sectionId: $sectionId)
    }
    deletedId
  }
}
    ${ReportMetricsSectionFragmentDoc}
${ReportQuotationFragmentDoc}`;
export type ReportRemoveCoverageMutationFn = Apollo.MutationFunction<Types.ReportRemoveCoverageMutation, Types.ReportRemoveCoverageMutationVariables>;

/**
 * __useReportRemoveCoverageMutation__
 *
 * To run a mutation, you first call `useReportRemoveCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRemoveCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRemoveCoverageMutation, { data, loading, error }] = useReportRemoveCoverageMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      quotationId: // value for 'quotationId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useReportRemoveCoverageMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportRemoveCoverageMutation, Types.ReportRemoveCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportRemoveCoverageMutation, Types.ReportRemoveCoverageMutationVariables>(ReportRemoveCoverageDocument, options);
      }
export type ReportRemoveCoverageMutationHookResult = ReturnType<typeof useReportRemoveCoverageMutation>;
export type ReportRemoveCoverageMutationResult = Apollo.MutationResult<Types.ReportRemoveCoverageMutation>;
export type ReportRemoveCoverageMutationOptions = Apollo.BaseMutationOptions<Types.ReportRemoveCoverageMutation, Types.ReportRemoveCoverageMutationVariables>;
export const ReportSetCoverageFeaturedDocument = gql`
    mutation ReportSetCoverageFeatured($reportId: ID!, $quotationId: ID!, $featured: Boolean!) {
  reportSetCoverageFeatured(
    input: {reportId: $reportId, quotationId: $quotationId, featured: $featured}
  ) {
    error {
      message
    }
    report: report2 {
      id
    }
    section {
      id
      quotationsList {
        id
        featured
      }
    }
    quotation {
      id
      featured
    }
  }
}
    `;
export type ReportSetCoverageFeaturedMutationFn = Apollo.MutationFunction<Types.ReportSetCoverageFeaturedMutation, Types.ReportSetCoverageFeaturedMutationVariables>;

/**
 * __useReportSetCoverageFeaturedMutation__
 *
 * To run a mutation, you first call `useReportSetCoverageFeaturedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSetCoverageFeaturedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSetCoverageFeaturedMutation, { data, loading, error }] = useReportSetCoverageFeaturedMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      quotationId: // value for 'quotationId'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useReportSetCoverageFeaturedMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportSetCoverageFeaturedMutation, Types.ReportSetCoverageFeaturedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportSetCoverageFeaturedMutation, Types.ReportSetCoverageFeaturedMutationVariables>(ReportSetCoverageFeaturedDocument, options);
      }
export type ReportSetCoverageFeaturedMutationHookResult = ReturnType<typeof useReportSetCoverageFeaturedMutation>;
export type ReportSetCoverageFeaturedMutationResult = Apollo.MutationResult<Types.ReportSetCoverageFeaturedMutation>;
export type ReportSetCoverageFeaturedMutationOptions = Apollo.BaseMutationOptions<Types.ReportSetCoverageFeaturedMutation, Types.ReportSetCoverageFeaturedMutationVariables>;
export const ReportSetCoverageSentimentDocument = gql`
    mutation ReportSetCoverageSentiment($reportId: ID!, $quotationId: ID!, $sentiment: Sentiment!) {
  reportSetCoverageSentiment(
    input: {reportId: $reportId, quotationId: $quotationId, sentiment: $sentiment}
  ) {
    error {
      message
    }
    section {
      id
      sentiment {
        hidden
        positive
        neutral
        negative
        average
      }
    }
    quotation {
      id
      sentiment
    }
  }
}
    `;
export type ReportSetCoverageSentimentMutationFn = Apollo.MutationFunction<Types.ReportSetCoverageSentimentMutation, Types.ReportSetCoverageSentimentMutationVariables>;

/**
 * __useReportSetCoverageSentimentMutation__
 *
 * To run a mutation, you first call `useReportSetCoverageSentimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSetCoverageSentimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSetCoverageSentimentMutation, { data, loading, error }] = useReportSetCoverageSentimentMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      quotationId: // value for 'quotationId'
 *      sentiment: // value for 'sentiment'
 *   },
 * });
 */
export function useReportSetCoverageSentimentMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportSetCoverageSentimentMutation, Types.ReportSetCoverageSentimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportSetCoverageSentimentMutation, Types.ReportSetCoverageSentimentMutationVariables>(ReportSetCoverageSentimentDocument, options);
      }
export type ReportSetCoverageSentimentMutationHookResult = ReturnType<typeof useReportSetCoverageSentimentMutation>;
export type ReportSetCoverageSentimentMutationResult = Apollo.MutationResult<Types.ReportSetCoverageSentimentMutation>;
export type ReportSetCoverageSentimentMutationOptions = Apollo.BaseMutationOptions<Types.ReportSetCoverageSentimentMutation, Types.ReportSetCoverageSentimentMutationVariables>;
export const ReportSetCoverageHiddenDocument = gql`
    mutation ReportSetCoverageHidden($reportId: ID!, $quotationId: ID!, $hidden: Boolean!) {
  reportSetCoverageHidden(
    input: {reportId: $reportId, quotationId: $quotationId, hidden: $hidden}
  ) {
    error {
      message
    }
    quotation {
      id
      hidden
    }
  }
}
    `;
export type ReportSetCoverageHiddenMutationFn = Apollo.MutationFunction<Types.ReportSetCoverageHiddenMutation, Types.ReportSetCoverageHiddenMutationVariables>;

/**
 * __useReportSetCoverageHiddenMutation__
 *
 * To run a mutation, you first call `useReportSetCoverageHiddenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSetCoverageHiddenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSetCoverageHiddenMutation, { data, loading, error }] = useReportSetCoverageHiddenMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      quotationId: // value for 'quotationId'
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useReportSetCoverageHiddenMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportSetCoverageHiddenMutation, Types.ReportSetCoverageHiddenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportSetCoverageHiddenMutation, Types.ReportSetCoverageHiddenMutationVariables>(ReportSetCoverageHiddenDocument, options);
      }
export type ReportSetCoverageHiddenMutationHookResult = ReturnType<typeof useReportSetCoverageHiddenMutation>;
export type ReportSetCoverageHiddenMutationResult = Apollo.MutationResult<Types.ReportSetCoverageHiddenMutation>;
export type ReportSetCoverageHiddenMutationOptions = Apollo.BaseMutationOptions<Types.ReportSetCoverageHiddenMutation, Types.ReportSetCoverageHiddenMutationVariables>;
export const ReportSortCoverageDocument = gql`
    mutation ReportSortCoverage($reportId: ID!, $direction: MoveDirection, $quotationId: ID!) {
  reportSortCoverage(
    input: {reportId: $reportId, direction: $direction, quotationId: $quotationId}
  ) {
    error {
      message
    }
    updatedQuotations {
      id
      sortIndex
    }
  }
}
    `;
export type ReportSortCoverageMutationFn = Apollo.MutationFunction<Types.ReportSortCoverageMutation, Types.ReportSortCoverageMutationVariables>;

/**
 * __useReportSortCoverageMutation__
 *
 * To run a mutation, you first call `useReportSortCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSortCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSortCoverageMutation, { data, loading, error }] = useReportSortCoverageMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      direction: // value for 'direction'
 *      quotationId: // value for 'quotationId'
 *   },
 * });
 */
export function useReportSortCoverageMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportSortCoverageMutation, Types.ReportSortCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportSortCoverageMutation, Types.ReportSortCoverageMutationVariables>(ReportSortCoverageDocument, options);
      }
export type ReportSortCoverageMutationHookResult = ReturnType<typeof useReportSortCoverageMutation>;
export type ReportSortCoverageMutationResult = Apollo.MutationResult<Types.ReportSortCoverageMutation>;
export type ReportSortCoverageMutationOptions = Apollo.BaseMutationOptions<Types.ReportSortCoverageMutation, Types.ReportSortCoverageMutationVariables>;
export const ReportPopulateFeaturedDocument = gql`
    mutation ReportPopulateFeatured($reportId: ID!) {
  reportPopulateFeatured(input: {reportId: $reportId}) {
    error {
      message
    }
    section {
      id
      quotationsList {
        id
        featured
      }
    }
  }
}
    `;
export type ReportPopulateFeaturedMutationFn = Apollo.MutationFunction<Types.ReportPopulateFeaturedMutation, Types.ReportPopulateFeaturedMutationVariables>;

/**
 * __useReportPopulateFeaturedMutation__
 *
 * To run a mutation, you first call `useReportPopulateFeaturedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPopulateFeaturedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPopulateFeaturedMutation, { data, loading, error }] = useReportPopulateFeaturedMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportPopulateFeaturedMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportPopulateFeaturedMutation, Types.ReportPopulateFeaturedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportPopulateFeaturedMutation, Types.ReportPopulateFeaturedMutationVariables>(ReportPopulateFeaturedDocument, options);
      }
export type ReportPopulateFeaturedMutationHookResult = ReturnType<typeof useReportPopulateFeaturedMutation>;
export type ReportPopulateFeaturedMutationResult = Apollo.MutationResult<Types.ReportPopulateFeaturedMutation>;
export type ReportPopulateFeaturedMutationOptions = Apollo.BaseMutationOptions<Types.ReportPopulateFeaturedMutation, Types.ReportPopulateFeaturedMutationVariables>;
export const ReportAddSectionDocument = gql`
    mutation ReportAddSection($id: ID!, $anchorSection: ID, $placement: RelativePlacement) {
  reportAddSection(
    input: {reportId: $id, anchorSection: $anchorSection, placement: $placement}
  ) {
    error {
      message
    }
    report: report2 {
      id
      sections2 {
        id
        title
        description
      }
    }
    section {
      id
    }
  }
}
    `;
export type ReportAddSectionMutationFn = Apollo.MutationFunction<Types.ReportAddSectionMutation, Types.ReportAddSectionMutationVariables>;

/**
 * __useReportAddSectionMutation__
 *
 * To run a mutation, you first call `useReportAddSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAddSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAddSectionMutation, { data, loading, error }] = useReportAddSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      anchorSection: // value for 'anchorSection'
 *      placement: // value for 'placement'
 *   },
 * });
 */
export function useReportAddSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportAddSectionMutation, Types.ReportAddSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportAddSectionMutation, Types.ReportAddSectionMutationVariables>(ReportAddSectionDocument, options);
      }
export type ReportAddSectionMutationHookResult = ReturnType<typeof useReportAddSectionMutation>;
export type ReportAddSectionMutationResult = Apollo.MutationResult<Types.ReportAddSectionMutation>;
export type ReportAddSectionMutationOptions = Apollo.BaseMutationOptions<Types.ReportAddSectionMutation, Types.ReportAddSectionMutationVariables>;
export const ReportMoveSectionDocument = gql`
    mutation ReportMoveSection($id: ID!, $direction: MoveDirection!) {
  reportSortSection(input: {reportSectionId: $id, direction: $direction}) {
    error {
      message
    }
    report: report2 {
      id
      sections2 {
        id
      }
    }
  }
}
    `;
export type ReportMoveSectionMutationFn = Apollo.MutationFunction<Types.ReportMoveSectionMutation, Types.ReportMoveSectionMutationVariables>;

/**
 * __useReportMoveSectionMutation__
 *
 * To run a mutation, you first call `useReportMoveSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportMoveSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportMoveSectionMutation, { data, loading, error }] = useReportMoveSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useReportMoveSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportMoveSectionMutation, Types.ReportMoveSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportMoveSectionMutation, Types.ReportMoveSectionMutationVariables>(ReportMoveSectionDocument, options);
      }
export type ReportMoveSectionMutationHookResult = ReturnType<typeof useReportMoveSectionMutation>;
export type ReportMoveSectionMutationResult = Apollo.MutationResult<Types.ReportMoveSectionMutation>;
export type ReportMoveSectionMutationOptions = Apollo.BaseMutationOptions<Types.ReportMoveSectionMutation, Types.ReportMoveSectionMutationVariables>;
export const ReportRemoveSectionDocument = gql`
    mutation ReportRemoveSection($id: ID!) {
  reportRemoveSection(input: {reportSectionId: $id}) {
    error {
      message
    }
    report: report2 {
      id
      sections2 {
        id
        ...ReportMetricsSection
      }
    }
  }
}
    ${ReportMetricsSectionFragmentDoc}`;
export type ReportRemoveSectionMutationFn = Apollo.MutationFunction<Types.ReportRemoveSectionMutation, Types.ReportRemoveSectionMutationVariables>;

/**
 * __useReportRemoveSectionMutation__
 *
 * To run a mutation, you first call `useReportRemoveSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRemoveSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRemoveSectionMutation, { data, loading, error }] = useReportRemoveSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportRemoveSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportRemoveSectionMutation, Types.ReportRemoveSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportRemoveSectionMutation, Types.ReportRemoveSectionMutationVariables>(ReportRemoveSectionDocument, options);
      }
export type ReportRemoveSectionMutationHookResult = ReturnType<typeof useReportRemoveSectionMutation>;
export type ReportRemoveSectionMutationResult = Apollo.MutationResult<Types.ReportRemoveSectionMutation>;
export type ReportRemoveSectionMutationOptions = Apollo.BaseMutationOptions<Types.ReportRemoveSectionMutation, Types.ReportRemoveSectionMutationVariables>;
export const ReportsGenerateSectionDescriptionPromptDataDocument = gql`
    mutation ReportsGenerateSectionDescriptionPromptData($sectionId: ID!) {
  reportsGenerateSectionDescriptionPromptData(input: {sectionId: $sectionId}) {
    error {
      message
    }
    gzippedArticlesForPrompt
    language
  }
}
    `;
export type ReportsGenerateSectionDescriptionPromptDataMutationFn = Apollo.MutationFunction<Types.ReportsGenerateSectionDescriptionPromptDataMutation, Types.ReportsGenerateSectionDescriptionPromptDataMutationVariables>;

/**
 * __useReportsGenerateSectionDescriptionPromptDataMutation__
 *
 * To run a mutation, you first call `useReportsGenerateSectionDescriptionPromptDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportsGenerateSectionDescriptionPromptDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportsGenerateSectionDescriptionPromptDataMutation, { data, loading, error }] = useReportsGenerateSectionDescriptionPromptDataMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useReportsGenerateSectionDescriptionPromptDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportsGenerateSectionDescriptionPromptDataMutation, Types.ReportsGenerateSectionDescriptionPromptDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportsGenerateSectionDescriptionPromptDataMutation, Types.ReportsGenerateSectionDescriptionPromptDataMutationVariables>(ReportsGenerateSectionDescriptionPromptDataDocument, options);
      }
export type ReportsGenerateSectionDescriptionPromptDataMutationHookResult = ReturnType<typeof useReportsGenerateSectionDescriptionPromptDataMutation>;
export type ReportsGenerateSectionDescriptionPromptDataMutationResult = Apollo.MutationResult<Types.ReportsGenerateSectionDescriptionPromptDataMutation>;
export type ReportsGenerateSectionDescriptionPromptDataMutationOptions = Apollo.BaseMutationOptions<Types.ReportsGenerateSectionDescriptionPromptDataMutation, Types.ReportsGenerateSectionDescriptionPromptDataMutationVariables>;
export const ReportUpdatePrValueSettingsDocument = gql`
    mutation ReportUpdatePrValueSettings($reportId: ID!, $currency: ReportPrValueCurrency!, $cpc: Float, $cpm: Float, $twitterCpm: Float, $facebookCpm: Float, $instagramCpm: Float, $default: Boolean, $pricingModel: ReportPrValuePricingModel) {
  reportUpdatePrValueSettings(
    input: {reportId: $reportId, cpc: $cpc, cpm: $cpm, twitterCpm: $twitterCpm, facebookCpm: $facebookCpm, instagramCpm: $instagramCpm, currency: $currency, default: $default, pricingModel: $pricingModel}
  ) {
    error {
      message
    }
    report: report2 {
      id
      sections2 {
        id
        ... on ReportMetricsSection {
          ...ReportMetricsSection
        }
      }
      prValueSetting {
        cpc
        cpm
        twitterCpm
        facebookCpm
        instagramCpm
        currency
        differentFromDefault
        pricingModel
      }
    }
  }
}
    ${ReportMetricsSectionFragmentDoc}`;
export type ReportUpdatePrValueSettingsMutationFn = Apollo.MutationFunction<Types.ReportUpdatePrValueSettingsMutation, Types.ReportUpdatePrValueSettingsMutationVariables>;

/**
 * __useReportUpdatePrValueSettingsMutation__
 *
 * To run a mutation, you first call `useReportUpdatePrValueSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUpdatePrValueSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUpdatePrValueSettingsMutation, { data, loading, error }] = useReportUpdatePrValueSettingsMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      currency: // value for 'currency'
 *      cpc: // value for 'cpc'
 *      cpm: // value for 'cpm'
 *      twitterCpm: // value for 'twitterCpm'
 *      facebookCpm: // value for 'facebookCpm'
 *      instagramCpm: // value for 'instagramCpm'
 *      default: // value for 'default'
 *      pricingModel: // value for 'pricingModel'
 *   },
 * });
 */
export function useReportUpdatePrValueSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportUpdatePrValueSettingsMutation, Types.ReportUpdatePrValueSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportUpdatePrValueSettingsMutation, Types.ReportUpdatePrValueSettingsMutationVariables>(ReportUpdatePrValueSettingsDocument, options);
      }
export type ReportUpdatePrValueSettingsMutationHookResult = ReturnType<typeof useReportUpdatePrValueSettingsMutation>;
export type ReportUpdatePrValueSettingsMutationResult = Apollo.MutationResult<Types.ReportUpdatePrValueSettingsMutation>;
export type ReportUpdatePrValueSettingsMutationOptions = Apollo.BaseMutationOptions<Types.ReportUpdatePrValueSettingsMutation, Types.ReportUpdatePrValueSettingsMutationVariables>;
export const ReportRequestPdfSlideshowDocument = gql`
    mutation ReportRequestPdfSlideshow($reportId: ID!) {
  reportRequestPdfSlideshow(input: {reportId: $reportId}) {
    error {
      message
    }
    pdfSlideshow {
      id
      state
      url
    }
  }
}
    `;
export type ReportRequestPdfSlideshowMutationFn = Apollo.MutationFunction<Types.ReportRequestPdfSlideshowMutation, Types.ReportRequestPdfSlideshowMutationVariables>;

/**
 * __useReportRequestPdfSlideshowMutation__
 *
 * To run a mutation, you first call `useReportRequestPdfSlideshowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRequestPdfSlideshowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRequestPdfSlideshowMutation, { data, loading, error }] = useReportRequestPdfSlideshowMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportRequestPdfSlideshowMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportRequestPdfSlideshowMutation, Types.ReportRequestPdfSlideshowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportRequestPdfSlideshowMutation, Types.ReportRequestPdfSlideshowMutationVariables>(ReportRequestPdfSlideshowDocument, options);
      }
export type ReportRequestPdfSlideshowMutationHookResult = ReturnType<typeof useReportRequestPdfSlideshowMutation>;
export type ReportRequestPdfSlideshowMutationResult = Apollo.MutationResult<Types.ReportRequestPdfSlideshowMutation>;
export type ReportRequestPdfSlideshowMutationOptions = Apollo.BaseMutationOptions<Types.ReportRequestPdfSlideshowMutation, Types.ReportRequestPdfSlideshowMutationVariables>;
export const ReportSlideshowDocument = gql`
    query ReportSlideshow($id: ID!, $first: Int!, $skipHidden: Boolean = true) {
  report: report2(id: $id) {
    id
    ...Report
  }
}
    ${ReportFragmentDoc}
${ReportMetaFragmentDoc}
${ReportCoveragesFragmentDoc}
${ReportMetricsSectionFragmentDoc}
${ReportFeaturedSectionFragmentDoc}
${ReportQuotationGridSectionFragmentDoc}
${ReportQuotationFragmentDoc}
${ReportQuotationFullWidthSectionFragmentDoc}`;

/**
 * __useReportSlideshowQuery__
 *
 * To run a query within a React component, call `useReportSlideshowQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSlideshowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSlideshowQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      skipHidden: // value for 'skipHidden'
 *   },
 * });
 */
export function useReportSlideshowQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables> & ({ variables: Types.ReportSlideshowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables>(ReportSlideshowDocument, options);
      }
export function useReportSlideshowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables>(ReportSlideshowDocument, options);
        }
export function useReportSlideshowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables>(ReportSlideshowDocument, options);
        }
export type ReportSlideshowQueryHookResult = ReturnType<typeof useReportSlideshowQuery>;
export type ReportSlideshowLazyQueryHookResult = ReturnType<typeof useReportSlideshowLazyQuery>;
export type ReportSlideshowSuspenseQueryHookResult = ReturnType<typeof useReportSlideshowSuspenseQuery>;
export type ReportSlideshowQueryResult = Apollo.QueryResult<Types.ReportSlideshowQuery, Types.ReportSlideshowQueryVariables>;
export const ReportDocument = gql`
    query Report($id: ID!, $first: Int = 5, $skipHidden: Boolean = false, $includePrValueSetting: Boolean = true) {
  report: report2(id: $id) {
    id
    ...Report
    ...BrandReport
  }
  me {
    id
    ...Me
  }
}
    ${ReportFragmentDoc}
${ReportMetaFragmentDoc}
${ReportCoveragesFragmentDoc}
${ReportMetricsSectionFragmentDoc}
${ReportFeaturedSectionFragmentDoc}
${ReportQuotationGridSectionFragmentDoc}
${ReportQuotationFragmentDoc}
${ReportQuotationFullWidthSectionFragmentDoc}
${BrandReportFragmentDoc}
${Report2PrValueSettingFragmentDoc}
${BrandReportStaticDataFragmentDoc}
${Report2SectionFragmentDoc}
${Report2MenuSectionFragmentDoc}
${Report2SummarySectionFragmentDoc}
${Report2SummaryCoverFragmentDoc}
${Report2SummaryKeyMetricsFragmentDoc}
${Report2SectionInsightsFragmentDoc}
${Report2VisibilitySectionFragmentDoc}
${Report2VisibilityOverviewFragmentDoc}
${Report2VisibilityMentionsOverTimeFragmentDoc}
${Report2VisibilityReachOverTimeFragmentDoc}
${Report2VisibilityHighlightsFragmentDoc}
${ReportQuotation2FragmentDoc}
${Report2VisibilityBenchmarkSectionFragmentDoc}
${Report2VisibilityBenchmarkShareOfVoiceFragmentDoc}
${Report2VisibilityBenchmarkShareOfVoiceOverTimeFragmentDoc}
${Report2PerceptionSectionFragmentDoc}
${Report2PerceptionSentimentOverviewFragmentDoc}
${Report2PerceptionSentimentOverTimeFragmentDoc}
${Report2PerceptionBenchmarkSectionFragmentDoc}
${Report2PerceptionBenchmarkSentimentOverviewFragmentDoc}
${MeFragmentDoc}`;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      skipHidden: // value for 'skipHidden'
 *      includePrValueSetting: // value for 'includePrValueSetting'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportQuery, Types.ReportQueryVariables> & ({ variables: Types.ReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportQuery, Types.ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportQuery, Types.ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportQuery, Types.ReportQueryVariables>(ReportDocument, options);
        }
export function useReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportQuery, Types.ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportQuery, Types.ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportSuspenseQueryHookResult = ReturnType<typeof useReportSuspenseQuery>;
export type ReportQueryResult = Apollo.QueryResult<Types.ReportQuery, Types.ReportQueryVariables>;
export const ReportPreviewDocument = gql`
    query ReportPreview($id: ID!, $first: Int = 5, $skipHidden: Boolean = true, $pressroomId: ID!) {
  report: report2(id: $id) {
    id
    ...Report
  }
  pressroom(id: $pressroomId) {
    id
    source {
      id
      features {
        id
        coverageReports {
          enabled
          newTrialAvailable
        }
      }
    }
  }
  me {
    id
    ...Me
  }
}
    ${ReportFragmentDoc}
${ReportMetaFragmentDoc}
${ReportCoveragesFragmentDoc}
${ReportMetricsSectionFragmentDoc}
${ReportFeaturedSectionFragmentDoc}
${ReportQuotationGridSectionFragmentDoc}
${ReportQuotationFragmentDoc}
${ReportQuotationFullWidthSectionFragmentDoc}
${MeFragmentDoc}`;

/**
 * __useReportPreviewQuery__
 *
 * To run a query within a React component, call `useReportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      skipHidden: // value for 'skipHidden'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useReportPreviewQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables> & ({ variables: Types.ReportPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables>(ReportPreviewDocument, options);
      }
export function useReportPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables>(ReportPreviewDocument, options);
        }
export function useReportPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables>(ReportPreviewDocument, options);
        }
export type ReportPreviewQueryHookResult = ReturnType<typeof useReportPreviewQuery>;
export type ReportPreviewLazyQueryHookResult = ReturnType<typeof useReportPreviewLazyQuery>;
export type ReportPreviewSuspenseQueryHookResult = ReturnType<typeof useReportPreviewSuspenseQuery>;
export type ReportPreviewQueryResult = Apollo.QueryResult<Types.ReportPreviewQuery, Types.ReportPreviewQueryVariables>;
export const ReportEditMetadataDocument = gql`
    query ReportEditMetadata($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    name
    pendingNotices {
      id
      coverageReportNotices {
        onboarding
      }
    }
    source {
      id
      features {
        id
        brandReports: managed(feature: brandReports) {
          id
          enabled
          trial {
            daysLeft
          }
          previousTrial
        }
        coverageReports: managed(feature: coverageReports) {
          id
          enabled
          trial {
            daysLeft
          }
          previousTrial
        }
      }
    }
    features {
      id
      analyze: managed(feature: analyze) {
        id
        enabled
      }
      monitor: managed(feature: monitor) {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useReportEditMetadataQuery__
 *
 * To run a query within a React component, call `useReportEditMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportEditMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportEditMetadataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useReportEditMetadataQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables> & ({ variables: Types.ReportEditMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables>(ReportEditMetadataDocument, options);
      }
export function useReportEditMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables>(ReportEditMetadataDocument, options);
        }
export function useReportEditMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables>(ReportEditMetadataDocument, options);
        }
export type ReportEditMetadataQueryHookResult = ReturnType<typeof useReportEditMetadataQuery>;
export type ReportEditMetadataLazyQueryHookResult = ReturnType<typeof useReportEditMetadataLazyQuery>;
export type ReportEditMetadataSuspenseQueryHookResult = ReturnType<typeof useReportEditMetadataSuspenseQuery>;
export type ReportEditMetadataQueryResult = Apollo.QueryResult<Types.ReportEditMetadataQuery, Types.ReportEditMetadataQueryVariables>;
export const ReportCancelImportJobDocument = gql`
    mutation ReportCancelImportJob($jobId: ID!) {
  reportCancelImportJob(input: {jobId: $jobId}) {
    error {
      message
    }
    cancelledJobId
    report: report2 {
      id
      sections2 {
        id
        ...ReportMetricsSection
      }
      importJobs {
        id
        state
      }
    }
  }
}
    ${ReportMetricsSectionFragmentDoc}`;
export type ReportCancelImportJobMutationFn = Apollo.MutationFunction<Types.ReportCancelImportJobMutation, Types.ReportCancelImportJobMutationVariables>;

/**
 * __useReportCancelImportJobMutation__
 *
 * To run a mutation, you first call `useReportCancelImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCancelImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCancelImportJobMutation, { data, loading, error }] = useReportCancelImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useReportCancelImportJobMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportCancelImportJobMutation, Types.ReportCancelImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportCancelImportJobMutation, Types.ReportCancelImportJobMutationVariables>(ReportCancelImportJobDocument, options);
      }
export type ReportCancelImportJobMutationHookResult = ReturnType<typeof useReportCancelImportJobMutation>;
export type ReportCancelImportJobMutationResult = Apollo.MutationResult<Types.ReportCancelImportJobMutation>;
export type ReportCancelImportJobMutationOptions = Apollo.BaseMutationOptions<Types.ReportCancelImportJobMutation, Types.ReportCancelImportJobMutationVariables>;
export const RecentlyEditedReportsDocument = gql`
    query RecentlyEditedReports($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    reports: reports2(limit: 3, sortBy: DESCENDING_UPDATED_AT) {
      id
      description
      title
      coverImage {
        id
        url(transformation: LIMIT_1000)
      }
      fallbackCoverSrc
    }
  }
}
    `;

/**
 * __useRecentlyEditedReportsQuery__
 *
 * To run a query within a React component, call `useRecentlyEditedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyEditedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyEditedReportsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useRecentlyEditedReportsQuery(baseOptions: Apollo.QueryHookOptions<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables> & ({ variables: Types.RecentlyEditedReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables>(RecentlyEditedReportsDocument, options);
      }
export function useRecentlyEditedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables>(RecentlyEditedReportsDocument, options);
        }
export function useRecentlyEditedReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables>(RecentlyEditedReportsDocument, options);
        }
export type RecentlyEditedReportsQueryHookResult = ReturnType<typeof useRecentlyEditedReportsQuery>;
export type RecentlyEditedReportsLazyQueryHookResult = ReturnType<typeof useRecentlyEditedReportsLazyQuery>;
export type RecentlyEditedReportsSuspenseQueryHookResult = ReturnType<typeof useRecentlyEditedReportsSuspenseQuery>;
export type RecentlyEditedReportsQueryResult = Apollo.QueryResult<Types.RecentlyEditedReportsQuery, Types.RecentlyEditedReportsQueryVariables>;
export const CreateBrandReportData2Document = gql`
    query CreateBrandReportData2($pressroomId: ID!, $includeSimpleProfile: Boolean!, $simpleSearchProfileId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      brandReportTrialData: managed(feature: brandReports) {
        id
        enabled
        trial {
          __typename
        }
      }
    }
    siteLocale
    monitor {
      id
      sources {
        id
        name
      }
      defaultExcludedSourceGroups {
        id
        name
      }
      groups {
        isRoot
        id
        name
        profiles {
          id
          name
          languages
          countries
          selectedMediaTypes {
            id
            name
          }
          simpleSearchProfile {
            id
            brandName
            competitors {
              id
              searchProfileId
              brandName
            }
          }
        }
      }
      allLanguages: languages {
        id
        value
        label
      }
      allCountries: countries {
        id
        value
        label
      }
      simpleSearchProfile(id: $simpleSearchProfileId) @include(if: $includeSimpleProfile) {
        id
        ...SimpleSearchProfile
        competitors {
          id
          ...SimpleSearchProfile
        }
      }
    }
  }
}
    ${SimpleSearchProfileFragmentDoc}`;

/**
 * __useCreateBrandReportData2Query__
 *
 * To run a query within a React component, call `useCreateBrandReportData2Query` and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandReportData2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateBrandReportData2Query({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      includeSimpleProfile: // value for 'includeSimpleProfile'
 *      simpleSearchProfileId: // value for 'simpleSearchProfileId'
 *   },
 * });
 */
export function useCreateBrandReportData2Query(baseOptions: Apollo.QueryHookOptions<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables> & ({ variables: Types.CreateBrandReportData2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables>(CreateBrandReportData2Document, options);
      }
export function useCreateBrandReportData2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables>(CreateBrandReportData2Document, options);
        }
export function useCreateBrandReportData2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables>(CreateBrandReportData2Document, options);
        }
export type CreateBrandReportData2QueryHookResult = ReturnType<typeof useCreateBrandReportData2Query>;
export type CreateBrandReportData2LazyQueryHookResult = ReturnType<typeof useCreateBrandReportData2LazyQuery>;
export type CreateBrandReportData2SuspenseQueryHookResult = ReturnType<typeof useCreateBrandReportData2SuspenseQuery>;
export type CreateBrandReportData2QueryResult = Apollo.QueryResult<Types.CreateBrandReportData2Query, Types.CreateBrandReportData2QueryVariables>;
export const CreateBrandReport2Document = gql`
    mutation CreateBrandReport2($input: NewBrandReportInput!) {
  reportCreate(input: {data: {newBrandReportInput: $input}}) {
    error {
      message
      ... on ReportCreateValidationError {
        title
        searchProfileIds
        brand
      }
    }
    pressroom {
      id
      reports: reports2 {
        id
      }
    }
    report: report2 {
      id
      ... on BrandReport {
        state2
      }
    }
  }
}
    `;
export type CreateBrandReport2MutationFn = Apollo.MutationFunction<Types.CreateBrandReport2Mutation, Types.CreateBrandReport2MutationVariables>;

/**
 * __useCreateBrandReport2Mutation__
 *
 * To run a mutation, you first call `useCreateBrandReport2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandReport2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandReport2Mutation, { data, loading, error }] = useCreateBrandReport2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandReport2Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBrandReport2Mutation, Types.CreateBrandReport2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBrandReport2Mutation, Types.CreateBrandReport2MutationVariables>(CreateBrandReport2Document, options);
      }
export type CreateBrandReport2MutationHookResult = ReturnType<typeof useCreateBrandReport2Mutation>;
export type CreateBrandReport2MutationResult = Apollo.MutationResult<Types.CreateBrandReport2Mutation>;
export type CreateBrandReport2MutationOptions = Apollo.BaseMutationOptions<Types.CreateBrandReport2Mutation, Types.CreateBrandReport2MutationVariables>;
export const ReportTrialDataDocument = gql`
    query ReportTrialData($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    source {
      id
      features {
        id
        brandReports: managed(feature: brandReports) {
          id
          enabled
          trial {
            daysLeft
          }
          previousTrial
        }
      }
    }
  }
}
    `;

/**
 * __useReportTrialDataQuery__
 *
 * To run a query within a React component, call `useReportTrialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTrialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTrialDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useReportTrialDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables> & ({ variables: Types.ReportTrialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables>(ReportTrialDataDocument, options);
      }
export function useReportTrialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables>(ReportTrialDataDocument, options);
        }
export function useReportTrialDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables>(ReportTrialDataDocument, options);
        }
export type ReportTrialDataQueryHookResult = ReturnType<typeof useReportTrialDataQuery>;
export type ReportTrialDataLazyQueryHookResult = ReturnType<typeof useReportTrialDataLazyQuery>;
export type ReportTrialDataSuspenseQueryHookResult = ReturnType<typeof useReportTrialDataSuspenseQuery>;
export type ReportTrialDataQueryResult = Apollo.QueryResult<Types.ReportTrialDataQuery, Types.ReportTrialDataQueryVariables>;
export const ReportsAccessDocument = gql`
    query ReportsAccess($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    source {
      id
      features {
        id
        brandReport: managed(feature: brandReports) {
          id
          enabled
          trial {
            daysLeft
          }
          previousTrial
        }
        coverageReport: managed(feature: coverageReports) {
          id
          enabled
          trial {
            __typename
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReportsAccessQuery__
 *
 * To run a query within a React component, call `useReportsAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsAccessQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useReportsAccessQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables> & ({ variables: Types.ReportsAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables>(ReportsAccessDocument, options);
      }
export function useReportsAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables>(ReportsAccessDocument, options);
        }
export function useReportsAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables>(ReportsAccessDocument, options);
        }
export type ReportsAccessQueryHookResult = ReturnType<typeof useReportsAccessQuery>;
export type ReportsAccessLazyQueryHookResult = ReturnType<typeof useReportsAccessLazyQuery>;
export type ReportsAccessSuspenseQueryHookResult = ReturnType<typeof useReportsAccessSuspenseQuery>;
export type ReportsAccessQueryResult = Apollo.QueryResult<Types.ReportsAccessQuery, Types.ReportsAccessQueryVariables>;
export const ReportRemoveDocument = gql`
    mutation ReportRemove($reportId: ID!) {
  reportRemove(input: {reportId: $reportId}) {
    error {
      message
    }
    previousImages {
      id
      usageCount
    }
    deletedId
  }
}
    `;
export type ReportRemoveMutationFn = Apollo.MutationFunction<Types.ReportRemoveMutation, Types.ReportRemoveMutationVariables>;

/**
 * __useReportRemoveMutation__
 *
 * To run a mutation, you first call `useReportRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRemoveMutation, { data, loading, error }] = useReportRemoveMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportRemoveMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportRemoveMutation, Types.ReportRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportRemoveMutation, Types.ReportRemoveMutationVariables>(ReportRemoveDocument, options);
      }
export type ReportRemoveMutationHookResult = ReturnType<typeof useReportRemoveMutation>;
export type ReportRemoveMutationResult = Apollo.MutationResult<Types.ReportRemoveMutation>;
export type ReportRemoveMutationOptions = Apollo.BaseMutationOptions<Types.ReportRemoveMutation, Types.ReportRemoveMutationVariables>;
export const ReportsListDocument = gql`
    query ReportsList($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      coverageReportNotices {
        createReportEmptyState
      }
    }
    source {
      id
      features {
        id
        brandReport: managed(feature: brandReports) {
          id
          enabled
          trial {
            daysLeft
          }
          previousTrial
        }
        coverageReport: managed(feature: coverageReports) {
          id
          enabled
        }
        coverageReports {
          daysLeftOfTrial
          enabled
          newTrialAvailable
        }
      }
    }
    autogeneratedQ1Report {
      id
    }
    recentlyEdited: reports2(limit: 3, sortBy: DESCENDING_UPDATED_AT) {
      id
      description
      title
      version
      coverImage {
        id
        url(transformation: LIMIT_1000)
      }
      fallbackCoverSrc
      ... on BrandReport {
        state2
      }
      createdBy
      createdAt
    }
    reports: reports2 {
      id
      description
      title
      version
      coverImage {
        id
        url(transformation: LIMIT_1000)
      }
      fallbackCoverSrc
      ... on BrandReport {
        state2
      }
      createdBy
      createdAt
    }
  }
}
    `;

/**
 * __useReportsListQuery__
 *
 * To run a query within a React component, call `useReportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsListQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useReportsListQuery(baseOptions: Apollo.QueryHookOptions<Types.ReportsListQuery, Types.ReportsListQueryVariables> & ({ variables: Types.ReportsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReportsListQuery, Types.ReportsListQueryVariables>(ReportsListDocument, options);
      }
export function useReportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReportsListQuery, Types.ReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReportsListQuery, Types.ReportsListQueryVariables>(ReportsListDocument, options);
        }
export function useReportsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReportsListQuery, Types.ReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReportsListQuery, Types.ReportsListQueryVariables>(ReportsListDocument, options);
        }
export type ReportsListQueryHookResult = ReturnType<typeof useReportsListQuery>;
export type ReportsListLazyQueryHookResult = ReturnType<typeof useReportsListLazyQuery>;
export type ReportsListSuspenseQueryHookResult = ReturnType<typeof useReportsListSuspenseQuery>;
export type ReportsListQueryResult = Apollo.QueryResult<Types.ReportsListQuery, Types.ReportsListQueryVariables>;
export const SendExlusiveMaterialsDocument = gql`
    query SendExlusiveMaterials($idTuples: [MaterialIdTuple!]!, $pressroomId: ID!) {
  materials(idTuples: $idTuples) {
    id
    header
    status
    publishedAt: publishedAt2
    scheduledFor
    image {
      id
      url(transformation: IMAGE_BANK_THUMBNAIL)
    }
    ... on Document {
      preview: thumbnail(transformation: IMAGE_BANK_THUMBNAIL)
    }
    ... on Video {
      thumbnailUrl
    }
  }
  pressroom(id: $pressroomId) {
    id
    source {
      id
      trusted
    }
  }
}
    `;

/**
 * __useSendExlusiveMaterialsQuery__
 *
 * To run a query within a React component, call `useSendExlusiveMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendExlusiveMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendExlusiveMaterialsQuery({
 *   variables: {
 *      idTuples: // value for 'idTuples'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSendExlusiveMaterialsQuery(baseOptions: Apollo.QueryHookOptions<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables> & ({ variables: Types.SendExlusiveMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables>(SendExlusiveMaterialsDocument, options);
      }
export function useSendExlusiveMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables>(SendExlusiveMaterialsDocument, options);
        }
export function useSendExlusiveMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables>(SendExlusiveMaterialsDocument, options);
        }
export type SendExlusiveMaterialsQueryHookResult = ReturnType<typeof useSendExlusiveMaterialsQuery>;
export type SendExlusiveMaterialsLazyQueryHookResult = ReturnType<typeof useSendExlusiveMaterialsLazyQuery>;
export type SendExlusiveMaterialsSuspenseQueryHookResult = ReturnType<typeof useSendExlusiveMaterialsSuspenseQuery>;
export type SendExlusiveMaterialsQueryResult = Apollo.QueryResult<Types.SendExlusiveMaterialsQuery, Types.SendExlusiveMaterialsQueryVariables>;
export const SendExclusiveRecipientsDocument = gql`
    query SendExclusiveRecipients($pressroomId: ID!, $contactIds: [ID!]!, $contactListIds: [ID!]!, $filter: NetworkContactFilter, $filterSearch: String, $filterListId: [ID!]!, $skipListWithFilter: Boolean!, $skipAllWithFilter: Boolean!) {
  pressroom(id: $pressroomId) {
    id
    networkContactLists(ids: $contactListIds) {
      id
      name
      contactsCount
    }
    listWithFilter: networkContactLists(ids: $filterListId) @skip(if: $skipListWithFilter) {
      id
      name
      networkContacts(search: $filterSearch, filter: $filter) {
        totalCount
      }
    }
    allWithFilter: networkContactsSearch(search: $filterSearch, filter: $filter) @skip(if: $skipAllWithFilter) {
      totalCount
    }
    networkContacts: networkContacts2(ids: $contactIds) {
      id
      firstName
      lastName
      email
      unreachable
      unsubscribed
      follower
      optedOut
    }
  }
}
    `;

/**
 * __useSendExclusiveRecipientsQuery__
 *
 * To run a query within a React component, call `useSendExclusiveRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendExclusiveRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendExclusiveRecipientsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      contactIds: // value for 'contactIds'
 *      contactListIds: // value for 'contactListIds'
 *      filter: // value for 'filter'
 *      filterSearch: // value for 'filterSearch'
 *      filterListId: // value for 'filterListId'
 *      skipListWithFilter: // value for 'skipListWithFilter'
 *      skipAllWithFilter: // value for 'skipAllWithFilter'
 *   },
 * });
 */
export function useSendExclusiveRecipientsQuery(baseOptions: Apollo.QueryHookOptions<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables> & ({ variables: Types.SendExclusiveRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables>(SendExclusiveRecipientsDocument, options);
      }
export function useSendExclusiveRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables>(SendExclusiveRecipientsDocument, options);
        }
export function useSendExclusiveRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables>(SendExclusiveRecipientsDocument, options);
        }
export type SendExclusiveRecipientsQueryHookResult = ReturnType<typeof useSendExclusiveRecipientsQuery>;
export type SendExclusiveRecipientsLazyQueryHookResult = ReturnType<typeof useSendExclusiveRecipientsLazyQuery>;
export type SendExclusiveRecipientsSuspenseQueryHookResult = ReturnType<typeof useSendExclusiveRecipientsSuspenseQuery>;
export type SendExclusiveRecipientsQueryResult = Apollo.QueryResult<Types.SendExclusiveRecipientsQuery, Types.SendExclusiveRecipientsQueryVariables>;
export const SendExclusiveDocument = gql`
    mutation SendExclusive($input: SendExclusiveInput!) {
  sendExclusive(input: $input) {
    error {
      message
      ... on SendExclusiveValidationError {
        attachedItems
        body
        receivers
        subject
      }
    }
  }
}
    `;
export type SendExclusiveMutationFn = Apollo.MutationFunction<Types.SendExclusiveMutation, Types.SendExclusiveMutationVariables>;

/**
 * __useSendExclusiveMutation__
 *
 * To run a mutation, you first call `useSendExclusiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendExclusiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendExclusiveMutation, { data, loading, error }] = useSendExclusiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendExclusiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendExclusiveMutation, Types.SendExclusiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendExclusiveMutation, Types.SendExclusiveMutationVariables>(SendExclusiveDocument, options);
      }
export type SendExclusiveMutationHookResult = ReturnType<typeof useSendExclusiveMutation>;
export type SendExclusiveMutationResult = Apollo.MutationResult<Types.SendExclusiveMutation>;
export type SendExclusiveMutationOptions = Apollo.BaseMutationOptions<Types.SendExclusiveMutation, Types.SendExclusiveMutationVariables>;
export const SaveScheduledSendExclusiveDocument = gql`
    mutation SaveScheduledSendExclusive($input: SaveScheduledSendExclusiveInput!) {
  saveScheduledSendExclusive(input: $input) {
    materials {
      id
      ... on Pressrelease {
        sendExclusive {
          id
          ...SendExclusive
        }
      }
    }
    error {
      message
      ... on SendExclusiveValidationError {
        attachedItems
        body
        receivers
        subject
      }
    }
  }
}
    ${SendExclusiveFragmentDoc}`;
export type SaveScheduledSendExclusiveMutationFn = Apollo.MutationFunction<Types.SaveScheduledSendExclusiveMutation, Types.SaveScheduledSendExclusiveMutationVariables>;

/**
 * __useSaveScheduledSendExclusiveMutation__
 *
 * To run a mutation, you first call `useSaveScheduledSendExclusiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduledSendExclusiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduledSendExclusiveMutation, { data, loading, error }] = useSaveScheduledSendExclusiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduledSendExclusiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveScheduledSendExclusiveMutation, Types.SaveScheduledSendExclusiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveScheduledSendExclusiveMutation, Types.SaveScheduledSendExclusiveMutationVariables>(SaveScheduledSendExclusiveDocument, options);
      }
export type SaveScheduledSendExclusiveMutationHookResult = ReturnType<typeof useSaveScheduledSendExclusiveMutation>;
export type SaveScheduledSendExclusiveMutationResult = Apollo.MutationResult<Types.SaveScheduledSendExclusiveMutation>;
export type SaveScheduledSendExclusiveMutationOptions = Apollo.BaseMutationOptions<Types.SaveScheduledSendExclusiveMutation, Types.SaveScheduledSendExclusiveMutationVariables>;
export const DeleteScheduledSendExclusiveDocument = gql`
    mutation DeleteScheduledSendExclusive($sendExclusiveId: ID!) {
  deleteScheduledSendExclusive(input: {sendExclusiveId: $sendExclusiveId}) {
    materials {
      id
      ... on Pressrelease {
        sendExclusive {
          id
        }
      }
    }
    error
  }
}
    `;
export type DeleteScheduledSendExclusiveMutationFn = Apollo.MutationFunction<Types.DeleteScheduledSendExclusiveMutation, Types.DeleteScheduledSendExclusiveMutationVariables>;

/**
 * __useDeleteScheduledSendExclusiveMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledSendExclusiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledSendExclusiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledSendExclusiveMutation, { data, loading, error }] = useDeleteScheduledSendExclusiveMutation({
 *   variables: {
 *      sendExclusiveId: // value for 'sendExclusiveId'
 *   },
 * });
 */
export function useDeleteScheduledSendExclusiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteScheduledSendExclusiveMutation, Types.DeleteScheduledSendExclusiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteScheduledSendExclusiveMutation, Types.DeleteScheduledSendExclusiveMutationVariables>(DeleteScheduledSendExclusiveDocument, options);
      }
export type DeleteScheduledSendExclusiveMutationHookResult = ReturnType<typeof useDeleteScheduledSendExclusiveMutation>;
export type DeleteScheduledSendExclusiveMutationResult = Apollo.MutationResult<Types.DeleteScheduledSendExclusiveMutation>;
export type DeleteScheduledSendExclusiveMutationOptions = Apollo.BaseMutationOptions<Types.DeleteScheduledSendExclusiveMutation, Types.DeleteScheduledSendExclusiveMutationVariables>;
export const GetPreviewEmailDocument = gql`
    query GetPreviewEmail($pressroomId: ID!) {
  me {
    id
    user {
      id
      name
      email
    }
  }
  pressroom(id: $pressroomId) {
    id
    name
    replyToEmail
    fromEmail
  }
}
    `;

/**
 * __useGetPreviewEmailQuery__
 *
 * To run a query within a React component, call `useGetPreviewEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewEmailQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetPreviewEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables> & ({ variables: Types.GetPreviewEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables>(GetPreviewEmailDocument, options);
      }
export function useGetPreviewEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables>(GetPreviewEmailDocument, options);
        }
export function useGetPreviewEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables>(GetPreviewEmailDocument, options);
        }
export type GetPreviewEmailQueryHookResult = ReturnType<typeof useGetPreviewEmailQuery>;
export type GetPreviewEmailLazyQueryHookResult = ReturnType<typeof useGetPreviewEmailLazyQuery>;
export type GetPreviewEmailSuspenseQueryHookResult = ReturnType<typeof useGetPreviewEmailSuspenseQuery>;
export type GetPreviewEmailQueryResult = Apollo.QueryResult<Types.GetPreviewEmailQuery, Types.GetPreviewEmailQueryVariables>;
export const SendExclusiveSearchDocument = gql`
    query SendExclusiveSearch($pressroomId: ID!, $search: String!, $sortList: NetworkContactListSort!, $sortContacts: NetworkContactSort!, $page: Int!, $perPage: Int!) {
  pressroom(id: $pressroomId) {
    id
    networkContactListSearch(
      search: $search
      sort: $sortList
      page: $page
      first: $perPage
      withSystemManaged: true
    ) {
      totalCount
      totalPages
      nodes {
        id
        name
        contactsCount
      }
    }
    networkContactsSearch(
      search: $search
      sort: $sortContacts
      page: $page
      first: $perPage
    ) {
      totalCount
      totalPages
      nodes {
        id
        firstName
        lastName
        email
        unreachable
        unsubscribed
        follower
        optedOut
      }
    }
  }
}
    `;

/**
 * __useSendExclusiveSearchQuery__
 *
 * To run a query within a React component, call `useSendExclusiveSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendExclusiveSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendExclusiveSearchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      search: // value for 'search'
 *      sortList: // value for 'sortList'
 *      sortContacts: // value for 'sortContacts'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useSendExclusiveSearchQuery(baseOptions: Apollo.QueryHookOptions<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables> & ({ variables: Types.SendExclusiveSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables>(SendExclusiveSearchDocument, options);
      }
export function useSendExclusiveSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables>(SendExclusiveSearchDocument, options);
        }
export function useSendExclusiveSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables>(SendExclusiveSearchDocument, options);
        }
export type SendExclusiveSearchQueryHookResult = ReturnType<typeof useSendExclusiveSearchQuery>;
export type SendExclusiveSearchLazyQueryHookResult = ReturnType<typeof useSendExclusiveSearchLazyQuery>;
export type SendExclusiveSearchSuspenseQueryHookResult = ReturnType<typeof useSendExclusiveSearchSuspenseQuery>;
export type SendExclusiveSearchQueryResult = Apollo.QueryResult<Types.SendExclusiveSearchQuery, Types.SendExclusiveSearchQueryVariables>;
export const GetSenderDocument = gql`
    query GetSender($pressroomId: ID!) {
  me {
    id
    user {
      id
      name
      email
    }
  }
  pressroom(id: $pressroomId) {
    id
    name
    replyToEmail
  }
}
    `;

/**
 * __useGetSenderQuery__
 *
 * To run a query within a React component, call `useGetSenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSenderQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetSenderQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSenderQuery, Types.GetSenderQueryVariables> & ({ variables: Types.GetSenderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSenderQuery, Types.GetSenderQueryVariables>(GetSenderDocument, options);
      }
export function useGetSenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSenderQuery, Types.GetSenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSenderQuery, Types.GetSenderQueryVariables>(GetSenderDocument, options);
        }
export function useGetSenderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSenderQuery, Types.GetSenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSenderQuery, Types.GetSenderQueryVariables>(GetSenderDocument, options);
        }
export type GetSenderQueryHookResult = ReturnType<typeof useGetSenderQuery>;
export type GetSenderLazyQueryHookResult = ReturnType<typeof useGetSenderLazyQuery>;
export type GetSenderSuspenseQueryHookResult = ReturnType<typeof useGetSenderSuspenseQuery>;
export type GetSenderQueryResult = Apollo.QueryResult<Types.GetSenderQuery, Types.GetSenderQueryVariables>;
export const SettingsDocument = gql`
    query Settings($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      hostedNewsroom: managed(feature: hostedNewsroom) {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.SettingsQuery, Types.SettingsQueryVariables> & ({ variables: Types.SettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SettingsQuery, Types.SettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SettingsQuery, Types.SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SettingsQuery, Types.SettingsQueryVariables>(SettingsDocument, options);
        }
export function useSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SettingsQuery, Types.SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SettingsQuery, Types.SettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsSuspenseQueryHookResult = ReturnType<typeof useSettingsSuspenseQuery>;
export type SettingsQueryResult = Apollo.QueryResult<Types.SettingsQuery, Types.SettingsQueryVariables>;
export const ChooseFacebookPageDocument = gql`
    mutation chooseFacebookPage($input: NewsroomFeedFacebookChoosePageInput!) {
  newsroomFeedFacebookChoosePage(input: $input) {
    pressroom {
      id
      newsroomFeeds {
        id
        inputNeeded {
          reason
          ... on FacebookNewsroomFeedChoosePage {
            pages {
              id
              name
              token
            }
          }
        }
        lastError
        source
        status
      }
    }
    error {
      message
    }
  }
}
    `;
export type ChooseFacebookPageMutationFn = Apollo.MutationFunction<Types.ChooseFacebookPageMutation, Types.ChooseFacebookPageMutationVariables>;

/**
 * __useChooseFacebookPageMutation__
 *
 * To run a mutation, you first call `useChooseFacebookPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseFacebookPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseFacebookPageMutation, { data, loading, error }] = useChooseFacebookPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseFacebookPageMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChooseFacebookPageMutation, Types.ChooseFacebookPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChooseFacebookPageMutation, Types.ChooseFacebookPageMutationVariables>(ChooseFacebookPageDocument, options);
      }
export type ChooseFacebookPageMutationHookResult = ReturnType<typeof useChooseFacebookPageMutation>;
export type ChooseFacebookPageMutationResult = Apollo.MutationResult<Types.ChooseFacebookPageMutation>;
export type ChooseFacebookPageMutationOptions = Apollo.BaseMutationOptions<Types.ChooseFacebookPageMutation, Types.ChooseFacebookPageMutationVariables>;
export const AddRssFeedDocument = gql`
    mutation addRssFeed($input: NewsroomFeedRssCreateInput!) {
  newsroomFeedRssCreate(input: $input) {
    pressroom {
      id
      newsroomFeeds {
        id
      }
    }
    error {
      message
      ... on NewsroomFeedRssCreateValidationError {
        feedUrl
      }
    }
  }
}
    `;
export type AddRssFeedMutationFn = Apollo.MutationFunction<Types.AddRssFeedMutation, Types.AddRssFeedMutationVariables>;

/**
 * __useAddRssFeedMutation__
 *
 * To run a mutation, you first call `useAddRssFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRssFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRssFeedMutation, { data, loading, error }] = useAddRssFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRssFeedMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRssFeedMutation, Types.AddRssFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRssFeedMutation, Types.AddRssFeedMutationVariables>(AddRssFeedDocument, options);
      }
export type AddRssFeedMutationHookResult = ReturnType<typeof useAddRssFeedMutation>;
export type AddRssFeedMutationResult = Apollo.MutationResult<Types.AddRssFeedMutation>;
export type AddRssFeedMutationOptions = Apollo.BaseMutationOptions<Types.AddRssFeedMutation, Types.AddRssFeedMutationVariables>;
export const DeleteSocialFeedDocument = gql`
    mutation deleteSocialFeed($input: NewsroomFeedDeleteInput!) {
  newsroomFeedDelete(input: $input) {
    pressroom {
      id
      newsroomFeeds {
        id
      }
    }
    error {
      message
    }
  }
}
    `;
export type DeleteSocialFeedMutationFn = Apollo.MutationFunction<Types.DeleteSocialFeedMutation, Types.DeleteSocialFeedMutationVariables>;

/**
 * __useDeleteSocialFeedMutation__
 *
 * To run a mutation, you first call `useDeleteSocialFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialFeedMutation, { data, loading, error }] = useDeleteSocialFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSocialFeedMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSocialFeedMutation, Types.DeleteSocialFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSocialFeedMutation, Types.DeleteSocialFeedMutationVariables>(DeleteSocialFeedDocument, options);
      }
export type DeleteSocialFeedMutationHookResult = ReturnType<typeof useDeleteSocialFeedMutation>;
export type DeleteSocialFeedMutationResult = Apollo.MutationResult<Types.DeleteSocialFeedMutation>;
export type DeleteSocialFeedMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSocialFeedMutation, Types.DeleteSocialFeedMutationVariables>;
export const GetSocialFeedsDocument = gql`
    query getSocialFeeds($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    newsroomFeedCountLimit
    createNewsroomFeed {
      facebookUrl
      instagramUrl
    }
    newsroomUrl
    newsroomFeeds {
      id
      inputNeeded {
        reason
        ... on FacebookNewsroomFeedChoosePage {
          pages {
            id
            name
            token
          }
        }
        ... on FacebookNewsroomFeedReauthenticate {
          facebookUrl
          reason
        }
        ... on InstagramNewsroomFeedReauthenticate {
          instagramUrl
          reason
        }
      }
      lastError
      startedFailingAt
      source
      status
    }
  }
}
    `;

/**
 * __useGetSocialFeedsQuery__
 *
 * To run a query within a React component, call `useGetSocialFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialFeedsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetSocialFeedsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables> & ({ variables: Types.GetSocialFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables>(GetSocialFeedsDocument, options);
      }
export function useGetSocialFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables>(GetSocialFeedsDocument, options);
        }
export function useGetSocialFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables>(GetSocialFeedsDocument, options);
        }
export type GetSocialFeedsQueryHookResult = ReturnType<typeof useGetSocialFeedsQuery>;
export type GetSocialFeedsLazyQueryHookResult = ReturnType<typeof useGetSocialFeedsLazyQuery>;
export type GetSocialFeedsSuspenseQueryHookResult = ReturnType<typeof useGetSocialFeedsSuspenseQuery>;
export type GetSocialFeedsQueryResult = Apollo.QueryResult<Types.GetSocialFeedsQuery, Types.GetSocialFeedsQueryVariables>;
export const PollNewsroomFeedStatusDocument = gql`
    query pollNewsroomFeedStatus($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    newsroomFeeds {
      id
      status
    }
  }
}
    `;

/**
 * __usePollNewsroomFeedStatusQuery__
 *
 * To run a query within a React component, call `usePollNewsroomFeedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollNewsroomFeedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollNewsroomFeedStatusQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function usePollNewsroomFeedStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables> & ({ variables: Types.PollNewsroomFeedStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables>(PollNewsroomFeedStatusDocument, options);
      }
export function usePollNewsroomFeedStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables>(PollNewsroomFeedStatusDocument, options);
        }
export function usePollNewsroomFeedStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables>(PollNewsroomFeedStatusDocument, options);
        }
export type PollNewsroomFeedStatusQueryHookResult = ReturnType<typeof usePollNewsroomFeedStatusQuery>;
export type PollNewsroomFeedStatusLazyQueryHookResult = ReturnType<typeof usePollNewsroomFeedStatusLazyQuery>;
export type PollNewsroomFeedStatusSuspenseQueryHookResult = ReturnType<typeof usePollNewsroomFeedStatusSuspenseQuery>;
export type PollNewsroomFeedStatusQueryResult = Apollo.QueryResult<Types.PollNewsroomFeedStatusQuery, Types.PollNewsroomFeedStatusQueryVariables>;
export const AddYoutubeFeedDocument = gql`
    mutation addYoutubeFeed($input: NewsroomFeedYoutubeCreateInput!) {
  newsroomFeedYoutubeCreate(input: $input) {
    pressroom {
      id
      newsroomFeeds {
        id
      }
    }
    error {
      message
      ... on NewsroomFeedYoutubeCreateValidationError {
        username
      }
    }
  }
}
    `;
export type AddYoutubeFeedMutationFn = Apollo.MutationFunction<Types.AddYoutubeFeedMutation, Types.AddYoutubeFeedMutationVariables>;

/**
 * __useAddYoutubeFeedMutation__
 *
 * To run a mutation, you first call `useAddYoutubeFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddYoutubeFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addYoutubeFeedMutation, { data, loading, error }] = useAddYoutubeFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddYoutubeFeedMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddYoutubeFeedMutation, Types.AddYoutubeFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddYoutubeFeedMutation, Types.AddYoutubeFeedMutationVariables>(AddYoutubeFeedDocument, options);
      }
export type AddYoutubeFeedMutationHookResult = ReturnType<typeof useAddYoutubeFeedMutation>;
export type AddYoutubeFeedMutationResult = Apollo.MutationResult<Types.AddYoutubeFeedMutation>;
export type AddYoutubeFeedMutationOptions = Apollo.BaseMutationOptions<Types.AddYoutubeFeedMutation, Types.AddYoutubeFeedMutationVariables>;
export const BetaFeaturesDocument = gql`
    query BetaFeatures($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      ...BetaFeatures
    }
  }
}
    ${BetaFeaturesFragmentDoc}`;

/**
 * __useBetaFeaturesQuery__
 *
 * To run a query within a React component, call `useBetaFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBetaFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBetaFeaturesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useBetaFeaturesQuery(baseOptions: Apollo.QueryHookOptions<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables> & ({ variables: Types.BetaFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables>(BetaFeaturesDocument, options);
      }
export function useBetaFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables>(BetaFeaturesDocument, options);
        }
export function useBetaFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables>(BetaFeaturesDocument, options);
        }
export type BetaFeaturesQueryHookResult = ReturnType<typeof useBetaFeaturesQuery>;
export type BetaFeaturesLazyQueryHookResult = ReturnType<typeof useBetaFeaturesLazyQuery>;
export type BetaFeaturesSuspenseQueryHookResult = ReturnType<typeof useBetaFeaturesSuspenseQuery>;
export type BetaFeaturesQueryResult = Apollo.QueryResult<Types.BetaFeaturesQuery, Types.BetaFeaturesQueryVariables>;
export const UpdateFooterHtmlDocument = gql`
    mutation UpdateFooterHtml($input: HostedNewsroomSettingsUpdateInput!) {
  hostedNewsroomSettingsUpdate(input: $input) {
    error {
      __typename
    }
    hostedNewsroomSettings {
      id
      hostedNewsroomStyle {
        footerHtml
      }
    }
  }
}
    `;
export type UpdateFooterHtmlMutationFn = Apollo.MutationFunction<Types.UpdateFooterHtmlMutation, Types.UpdateFooterHtmlMutationVariables>;

/**
 * __useUpdateFooterHtmlMutation__
 *
 * To run a mutation, you first call `useUpdateFooterHtmlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFooterHtmlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFooterHtmlMutation, { data, loading, error }] = useUpdateFooterHtmlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFooterHtmlMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFooterHtmlMutation, Types.UpdateFooterHtmlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFooterHtmlMutation, Types.UpdateFooterHtmlMutationVariables>(UpdateFooterHtmlDocument, options);
      }
export type UpdateFooterHtmlMutationHookResult = ReturnType<typeof useUpdateFooterHtmlMutation>;
export type UpdateFooterHtmlMutationResult = Apollo.MutationResult<Types.UpdateFooterHtmlMutation>;
export type UpdateFooterHtmlMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFooterHtmlMutation, Types.UpdateFooterHtmlMutationVariables>;
export const UpdateFooterCssDocument = gql`
    mutation UpdateFooterCss($input: HostedNewsroomSettingsUpdateInput!) {
  hostedNewsroomSettingsUpdate(input: $input) {
    error {
      __typename
    }
    hostedNewsroomSettings {
      id
      hostedNewsroomStyle {
        footerCss
      }
    }
  }
}
    `;
export type UpdateFooterCssMutationFn = Apollo.MutationFunction<Types.UpdateFooterCssMutation, Types.UpdateFooterCssMutationVariables>;

/**
 * __useUpdateFooterCssMutation__
 *
 * To run a mutation, you first call `useUpdateFooterCssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFooterCssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFooterCssMutation, { data, loading, error }] = useUpdateFooterCssMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFooterCssMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFooterCssMutation, Types.UpdateFooterCssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFooterCssMutation, Types.UpdateFooterCssMutationVariables>(UpdateFooterCssDocument, options);
      }
export type UpdateFooterCssMutationHookResult = ReturnType<typeof useUpdateFooterCssMutation>;
export type UpdateFooterCssMutationResult = Apollo.MutationResult<Types.UpdateFooterCssMutation>;
export type UpdateFooterCssMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFooterCssMutation, Types.UpdateFooterCssMutationVariables>;
export const UpdateHeaderHtmlDocument = gql`
    mutation UpdateHeaderHtml($input: HostedNewsroomSettingsUpdateInput!) {
  hostedNewsroomSettingsUpdate(input: $input) {
    error {
      __typename
      ... on HostedNewsroomSettingsUpdateValidationError {
        headerHtml {
          message
          scrubbedHtml
        }
      }
    }
    hostedNewsroomSettings {
      id
      hostedNewsroomStyle {
        headerHtml
      }
    }
  }
}
    `;
export type UpdateHeaderHtmlMutationFn = Apollo.MutationFunction<Types.UpdateHeaderHtmlMutation, Types.UpdateHeaderHtmlMutationVariables>;

/**
 * __useUpdateHeaderHtmlMutation__
 *
 * To run a mutation, you first call `useUpdateHeaderHtmlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeaderHtmlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeaderHtmlMutation, { data, loading, error }] = useUpdateHeaderHtmlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHeaderHtmlMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateHeaderHtmlMutation, Types.UpdateHeaderHtmlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateHeaderHtmlMutation, Types.UpdateHeaderHtmlMutationVariables>(UpdateHeaderHtmlDocument, options);
      }
export type UpdateHeaderHtmlMutationHookResult = ReturnType<typeof useUpdateHeaderHtmlMutation>;
export type UpdateHeaderHtmlMutationResult = Apollo.MutationResult<Types.UpdateHeaderHtmlMutation>;
export type UpdateHeaderHtmlMutationOptions = Apollo.BaseMutationOptions<Types.UpdateHeaderHtmlMutation, Types.UpdateHeaderHtmlMutationVariables>;
export const UpdateHeaderCssDocument = gql`
    mutation UpdateHeaderCss($input: HostedNewsroomSettingsUpdateInput!) {
  hostedNewsroomSettingsUpdate(input: $input) {
    error {
      __typename
    }
    hostedNewsroomSettings {
      id
      hostedNewsroomStyle {
        headerCss
      }
    }
  }
}
    `;
export type UpdateHeaderCssMutationFn = Apollo.MutationFunction<Types.UpdateHeaderCssMutation, Types.UpdateHeaderCssMutationVariables>;

/**
 * __useUpdateHeaderCssMutation__
 *
 * To run a mutation, you first call `useUpdateHeaderCssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeaderCssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeaderCssMutation, { data, loading, error }] = useUpdateHeaderCssMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHeaderCssMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateHeaderCssMutation, Types.UpdateHeaderCssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateHeaderCssMutation, Types.UpdateHeaderCssMutationVariables>(UpdateHeaderCssDocument, options);
      }
export type UpdateHeaderCssMutationHookResult = ReturnType<typeof useUpdateHeaderCssMutation>;
export type UpdateHeaderCssMutationResult = Apollo.MutationResult<Types.UpdateHeaderCssMutation>;
export type UpdateHeaderCssMutationOptions = Apollo.BaseMutationOptions<Types.UpdateHeaderCssMutation, Types.UpdateHeaderCssMutationVariables>;
export const GetAvailableFontsDocument = gql`
    query GetAvailableFonts($pressroomId: ID!, $first: Int, $after: String, $query: String) {
  pressroom(id: $pressroomId) {
    id
    hostedNewsroomSettings {
      id
      hostedNewsroomStyle {
        headlineFont {
          id
          ...FontFragment
        }
        paragraphFont {
          id
          ...FontFragment
        }
        miscellaneousFont {
          id
          ...FontFragment
        }
        availableFonts(first: $first, after: $after, query: $query) {
          nodes {
            id
            family
            weights {
              id
              name
              value
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
}
    ${FontFragmentFragmentDoc}`;

/**
 * __useGetAvailableFontsQuery__
 *
 * To run a query within a React component, call `useGetAvailableFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableFontsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAvailableFontsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables> & ({ variables: Types.GetAvailableFontsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables>(GetAvailableFontsDocument, options);
      }
export function useGetAvailableFontsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables>(GetAvailableFontsDocument, options);
        }
export function useGetAvailableFontsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables>(GetAvailableFontsDocument, options);
        }
export type GetAvailableFontsQueryHookResult = ReturnType<typeof useGetAvailableFontsQuery>;
export type GetAvailableFontsLazyQueryHookResult = ReturnType<typeof useGetAvailableFontsLazyQuery>;
export type GetAvailableFontsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableFontsSuspenseQuery>;
export type GetAvailableFontsQueryResult = Apollo.QueryResult<Types.GetAvailableFontsQuery, Types.GetAvailableFontsQueryVariables>;
export const UpdateDefaultBoilerplateDocument = gql`
    mutation updateDefaultBoilerplate($pressroomId: ID!, $boilerplateId: ID!, $default: Boolean) {
  newsroomBoilerplateUpdate(
    input: {pressroomId: $pressroomId, id: $boilerplateId, default: $default}
  ) {
    error {
      message
    }
    pressroom {
      id
      ...CRUDBoilerplateFragment
    }
  }
}
    ${CrudBoilerplateFragmentFragmentDoc}
${BoilerplateFragmentFragmentDoc}`;
export type UpdateDefaultBoilerplateMutationFn = Apollo.MutationFunction<Types.UpdateDefaultBoilerplateMutation, Types.UpdateDefaultBoilerplateMutationVariables>;

/**
 * __useUpdateDefaultBoilerplateMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultBoilerplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultBoilerplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultBoilerplateMutation, { data, loading, error }] = useUpdateDefaultBoilerplateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      boilerplateId: // value for 'boilerplateId'
 *      default: // value for 'default'
 *   },
 * });
 */
export function useUpdateDefaultBoilerplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDefaultBoilerplateMutation, Types.UpdateDefaultBoilerplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDefaultBoilerplateMutation, Types.UpdateDefaultBoilerplateMutationVariables>(UpdateDefaultBoilerplateDocument, options);
      }
export type UpdateDefaultBoilerplateMutationHookResult = ReturnType<typeof useUpdateDefaultBoilerplateMutation>;
export type UpdateDefaultBoilerplateMutationResult = Apollo.MutationResult<Types.UpdateDefaultBoilerplateMutation>;
export type UpdateDefaultBoilerplateMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDefaultBoilerplateMutation, Types.UpdateDefaultBoilerplateMutationVariables>;
export const EditBoilerplateDocument = gql`
    mutation editBoilerplate($pressroomId: ID!, $boilerplateId: ID!, $name: String, $content: String) {
  newsroomBoilerplateUpdate(
    input: {pressroomId: $pressroomId, id: $boilerplateId, name: $name, content: $content}
  ) {
    error {
      message
    }
    pressroom {
      id
      ...CRUDBoilerplateFragment
    }
  }
}
    ${CrudBoilerplateFragmentFragmentDoc}
${BoilerplateFragmentFragmentDoc}`;
export type EditBoilerplateMutationFn = Apollo.MutationFunction<Types.EditBoilerplateMutation, Types.EditBoilerplateMutationVariables>;

/**
 * __useEditBoilerplateMutation__
 *
 * To run a mutation, you first call `useEditBoilerplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBoilerplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBoilerplateMutation, { data, loading, error }] = useEditBoilerplateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      boilerplateId: // value for 'boilerplateId'
 *      name: // value for 'name'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useEditBoilerplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.EditBoilerplateMutation, Types.EditBoilerplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EditBoilerplateMutation, Types.EditBoilerplateMutationVariables>(EditBoilerplateDocument, options);
      }
export type EditBoilerplateMutationHookResult = ReturnType<typeof useEditBoilerplateMutation>;
export type EditBoilerplateMutationResult = Apollo.MutationResult<Types.EditBoilerplateMutation>;
export type EditBoilerplateMutationOptions = Apollo.BaseMutationOptions<Types.EditBoilerplateMutation, Types.EditBoilerplateMutationVariables>;
export const CreateBoilerplateDocument = gql`
    mutation createBoilerplate($pressroomId: ID!, $name: String!, $content: String!, $default: Boolean) {
  newsroomBoilerplateCreate(
    input: {pressroomId: $pressroomId, name: $name, content: $content, default: $default}
  ) {
    error {
      ... on NewsroomBoilerplateCreateValidationError {
        name
      }
    }
    pressroom {
      id
      ...CRUDBoilerplateFragment
    }
  }
}
    ${CrudBoilerplateFragmentFragmentDoc}
${BoilerplateFragmentFragmentDoc}`;
export type CreateBoilerplateMutationFn = Apollo.MutationFunction<Types.CreateBoilerplateMutation, Types.CreateBoilerplateMutationVariables>;

/**
 * __useCreateBoilerplateMutation__
 *
 * To run a mutation, you first call `useCreateBoilerplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoilerplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoilerplateMutation, { data, loading, error }] = useCreateBoilerplateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      name: // value for 'name'
 *      content: // value for 'content'
 *      default: // value for 'default'
 *   },
 * });
 */
export function useCreateBoilerplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBoilerplateMutation, Types.CreateBoilerplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBoilerplateMutation, Types.CreateBoilerplateMutationVariables>(CreateBoilerplateDocument, options);
      }
export type CreateBoilerplateMutationHookResult = ReturnType<typeof useCreateBoilerplateMutation>;
export type CreateBoilerplateMutationResult = Apollo.MutationResult<Types.CreateBoilerplateMutation>;
export type CreateBoilerplateMutationOptions = Apollo.BaseMutationOptions<Types.CreateBoilerplateMutation, Types.CreateBoilerplateMutationVariables>;
export const DeleteBoilerplateDocument = gql`
    mutation deleteBoilerplate($pressroomId: ID!, $boilerplateId: ID!) {
  newsroomBoilerplateDelete(
    input: {pressroomId: $pressroomId, id: $boilerplateId}
  ) {
    error {
      message
    }
    pressroom {
      id
      ...CRUDBoilerplateFragment
    }
  }
}
    ${CrudBoilerplateFragmentFragmentDoc}
${BoilerplateFragmentFragmentDoc}`;
export type DeleteBoilerplateMutationFn = Apollo.MutationFunction<Types.DeleteBoilerplateMutation, Types.DeleteBoilerplateMutationVariables>;

/**
 * __useDeleteBoilerplateMutation__
 *
 * To run a mutation, you first call `useDeleteBoilerplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoilerplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoilerplateMutation, { data, loading, error }] = useDeleteBoilerplateMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      boilerplateId: // value for 'boilerplateId'
 *   },
 * });
 */
export function useDeleteBoilerplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteBoilerplateMutation, Types.DeleteBoilerplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteBoilerplateMutation, Types.DeleteBoilerplateMutationVariables>(DeleteBoilerplateDocument, options);
      }
export type DeleteBoilerplateMutationHookResult = ReturnType<typeof useDeleteBoilerplateMutation>;
export type DeleteBoilerplateMutationResult = Apollo.MutationResult<Types.DeleteBoilerplateMutation>;
export type DeleteBoilerplateMutationOptions = Apollo.BaseMutationOptions<Types.DeleteBoilerplateMutation, Types.DeleteBoilerplateMutationVariables>;
export const GetNewsroomLanguagesListDocument = gql`
    query getNewsroomLanguagesList {
  newsroomLanguages {
    id
    locale
    name
  }
}
    `;

/**
 * __useGetNewsroomLanguagesListQuery__
 *
 * To run a query within a React component, call `useGetNewsroomLanguagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsroomLanguagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsroomLanguagesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsroomLanguagesListQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>(GetNewsroomLanguagesListDocument, options);
      }
export function useGetNewsroomLanguagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>(GetNewsroomLanguagesListDocument, options);
        }
export function useGetNewsroomLanguagesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>(GetNewsroomLanguagesListDocument, options);
        }
export type GetNewsroomLanguagesListQueryHookResult = ReturnType<typeof useGetNewsroomLanguagesListQuery>;
export type GetNewsroomLanguagesListLazyQueryHookResult = ReturnType<typeof useGetNewsroomLanguagesListLazyQuery>;
export type GetNewsroomLanguagesListSuspenseQueryHookResult = ReturnType<typeof useGetNewsroomLanguagesListSuspenseQuery>;
export type GetNewsroomLanguagesListQueryResult = Apollo.QueryResult<Types.GetNewsroomLanguagesListQuery, Types.GetNewsroomLanguagesListQueryVariables>;
export const GetSettingsDataDocument = gql`
    query GetSettingsData($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    siteCode
    siteLocale
    newsroomSettings {
      id
      ...NewsroomSettingsFragment
    }
    features {
      id
      googleAnalytics: managed(feature: googleAnalytics) {
        id
        enabled
      }
      publish {
        id
        subjects {
          max
        }
        regions {
          max
        }
      }
    }
    featureToggles {
      id
      noindexMaterials
    }
  }
  licenses {
    id
    name
    description
  }
}
    ${NewsroomSettingsFragmentFragmentDoc}
${BoilerplateFragmentFragmentDoc}
${NewsroomStyleFragmentFragmentDoc}`;

/**
 * __useGetSettingsDataQuery__
 *
 * To run a query within a React component, call `useGetSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetSettingsDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables> & ({ variables: Types.GetSettingsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables>(GetSettingsDataDocument, options);
      }
export function useGetSettingsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables>(GetSettingsDataDocument, options);
        }
export function useGetSettingsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables>(GetSettingsDataDocument, options);
        }
export type GetSettingsDataQueryHookResult = ReturnType<typeof useGetSettingsDataQuery>;
export type GetSettingsDataLazyQueryHookResult = ReturnType<typeof useGetSettingsDataLazyQuery>;
export type GetSettingsDataSuspenseQueryHookResult = ReturnType<typeof useGetSettingsDataSuspenseQuery>;
export type GetSettingsDataQueryResult = Apollo.QueryResult<Types.GetSettingsDataQuery, Types.GetSettingsDataQueryVariables>;
export const GetSubjectsAndRegionsDocument = gql`
    query GetSubjectsAndRegions($site: String!) {
  subjects(site: $site) {
    id
    name
    childrenIncludingParent {
      id
      name
      fullName
    }
  }
  regions(site: $site) {
    id
    name
    childrenIncludingParent {
      id
      name
      fullName
    }
  }
}
    `;

/**
 * __useGetSubjectsAndRegionsQuery__
 *
 * To run a query within a React component, call `useGetSubjectsAndRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectsAndRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectsAndRegionsQuery({
 *   variables: {
 *      site: // value for 'site'
 *   },
 * });
 */
export function useGetSubjectsAndRegionsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables> & ({ variables: Types.GetSubjectsAndRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables>(GetSubjectsAndRegionsDocument, options);
      }
export function useGetSubjectsAndRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables>(GetSubjectsAndRegionsDocument, options);
        }
export function useGetSubjectsAndRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables>(GetSubjectsAndRegionsDocument, options);
        }
export type GetSubjectsAndRegionsQueryHookResult = ReturnType<typeof useGetSubjectsAndRegionsQuery>;
export type GetSubjectsAndRegionsLazyQueryHookResult = ReturnType<typeof useGetSubjectsAndRegionsLazyQuery>;
export type GetSubjectsAndRegionsSuspenseQueryHookResult = ReturnType<typeof useGetSubjectsAndRegionsSuspenseQuery>;
export type GetSubjectsAndRegionsQueryResult = Apollo.QueryResult<Types.GetSubjectsAndRegionsQuery, Types.GetSubjectsAndRegionsQueryVariables>;
export const UpdateNewsroomSettingsDocument = gql`
    mutation updateNewsroomSettings($newsroomId: ID!, $companyName: String, $tagline: String, $companyDescription: String, $shortcut: String, $locale: NewsroomLocale, $street: String, $postalCode: String, $city: String, $country: String, $gaProfileId: String, $licenseId: ID, $logotype: ResourceImageInput, $favicon: ResourceImageInput, $deleteFavicon: Boolean, $deleteLogotype: Boolean, $primaryBrandColor: String, $secondaryBrandColor: String, $mediaLayout: MediaLayout, $links: [NewsroomLinkInput!], $subjectIds: [ID!], $regionIds: [ID!], $noindexMaterials: Boolean, $downloadMaterialsEnabled: Boolean, $shareFacebookEnabled: Boolean, $shareLinkedinEnabled: Boolean, $shareXEnabled: Boolean) {
  newsroomSettingsUpdate(
    input: {newsroomId: $newsroomId, companyName: $companyName, tagline: $tagline, companyDescription: $companyDescription, shortcut: $shortcut, locale: $locale, street: $street, postalCode: $postalCode, city: $city, country: $country, gaProfileId: $gaProfileId, licenseId: $licenseId, primaryBrandColor: $primaryBrandColor, secondaryBrandColor: $secondaryBrandColor, mediaLayout: $mediaLayout, logotype: $logotype, favicon: $favicon, deleteFavicon: $deleteFavicon, deleteLogotype: $deleteLogotype, links: $links, subjectIds: $subjectIds, regionIds: $regionIds, noindexMaterials: $noindexMaterials, downloadMaterialsEnabled: $downloadMaterialsEnabled, shareFacebookEnabled: $shareFacebookEnabled, shareLinkedinEnabled: $shareLinkedinEnabled, shareXEnabled: $shareXEnabled}
  ) {
    error {
      ... on NewsroomSettingsUpdateValidationError {
        city
        companyDescription
        companyName
        country
        gaProfileId
        licenseId
        links {
          id
          linkText
          url
        }
        logotype {
          fileFormat
          name
        }
        favicon {
          fileFormat
          name
        }
        postalCode
        shortcut
        street
        tagline
      }
    }
    newsroomSettings {
      id
      ...NewsroomSettingsFragment
    }
  }
}
    ${NewsroomSettingsFragmentFragmentDoc}
${BoilerplateFragmentFragmentDoc}
${NewsroomStyleFragmentFragmentDoc}`;
export type UpdateNewsroomSettingsMutationFn = Apollo.MutationFunction<Types.UpdateNewsroomSettingsMutation, Types.UpdateNewsroomSettingsMutationVariables>;

/**
 * __useUpdateNewsroomSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNewsroomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsroomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsroomSettingsMutation, { data, loading, error }] = useUpdateNewsroomSettingsMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      companyName: // value for 'companyName'
 *      tagline: // value for 'tagline'
 *      companyDescription: // value for 'companyDescription'
 *      shortcut: // value for 'shortcut'
 *      locale: // value for 'locale'
 *      street: // value for 'street'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      gaProfileId: // value for 'gaProfileId'
 *      licenseId: // value for 'licenseId'
 *      logotype: // value for 'logotype'
 *      favicon: // value for 'favicon'
 *      deleteFavicon: // value for 'deleteFavicon'
 *      deleteLogotype: // value for 'deleteLogotype'
 *      primaryBrandColor: // value for 'primaryBrandColor'
 *      secondaryBrandColor: // value for 'secondaryBrandColor'
 *      mediaLayout: // value for 'mediaLayout'
 *      links: // value for 'links'
 *      subjectIds: // value for 'subjectIds'
 *      regionIds: // value for 'regionIds'
 *      noindexMaterials: // value for 'noindexMaterials'
 *      downloadMaterialsEnabled: // value for 'downloadMaterialsEnabled'
 *      shareFacebookEnabled: // value for 'shareFacebookEnabled'
 *      shareLinkedinEnabled: // value for 'shareLinkedinEnabled'
 *      shareXEnabled: // value for 'shareXEnabled'
 *   },
 * });
 */
export function useUpdateNewsroomSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNewsroomSettingsMutation, Types.UpdateNewsroomSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNewsroomSettingsMutation, Types.UpdateNewsroomSettingsMutationVariables>(UpdateNewsroomSettingsDocument, options);
      }
export type UpdateNewsroomSettingsMutationHookResult = ReturnType<typeof useUpdateNewsroomSettingsMutation>;
export type UpdateNewsroomSettingsMutationResult = Apollo.MutationResult<Types.UpdateNewsroomSettingsMutation>;
export type UpdateNewsroomSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNewsroomSettingsMutation, Types.UpdateNewsroomSettingsMutationVariables>;
export const UpdatePreviewNewsroomStylesDocument = gql`
    mutation updatePreviewNewsroomStyles($newsroomId: ID!, $primaryBrandColor: String, $secondaryBrandColor: String, $mediaLayout: MediaLayout, $logotype: ResourceImageInput, $favicon: ResourceImageInput, $deleteFavicon: Boolean, $deleteLogotype: Boolean) {
  newsroomStylePreviewUpdate(
    input: {newsroomId: $newsroomId, primaryBrandColor: $primaryBrandColor, secondaryBrandColor: $secondaryBrandColor, mediaLayout: $mediaLayout, logotype: $logotype, favicon: $favicon, deleteFavicon: $deleteFavicon, deleteLogotype: $deleteLogotype}
  ) {
    newsroomStyle {
      ...NewsroomStyleFragment
    }
    pressroom {
      id
      newsroomUrl
    }
  }
}
    ${NewsroomStyleFragmentFragmentDoc}`;
export type UpdatePreviewNewsroomStylesMutationFn = Apollo.MutationFunction<Types.UpdatePreviewNewsroomStylesMutation, Types.UpdatePreviewNewsroomStylesMutationVariables>;

/**
 * __useUpdatePreviewNewsroomStylesMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewNewsroomStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewNewsroomStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewNewsroomStylesMutation, { data, loading, error }] = useUpdatePreviewNewsroomStylesMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      primaryBrandColor: // value for 'primaryBrandColor'
 *      secondaryBrandColor: // value for 'secondaryBrandColor'
 *      mediaLayout: // value for 'mediaLayout'
 *      logotype: // value for 'logotype'
 *      favicon: // value for 'favicon'
 *      deleteFavicon: // value for 'deleteFavicon'
 *      deleteLogotype: // value for 'deleteLogotype'
 *   },
 * });
 */
export function useUpdatePreviewNewsroomStylesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePreviewNewsroomStylesMutation, Types.UpdatePreviewNewsroomStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePreviewNewsroomStylesMutation, Types.UpdatePreviewNewsroomStylesMutationVariables>(UpdatePreviewNewsroomStylesDocument, options);
      }
export type UpdatePreviewNewsroomStylesMutationHookResult = ReturnType<typeof useUpdatePreviewNewsroomStylesMutation>;
export type UpdatePreviewNewsroomStylesMutationResult = Apollo.MutationResult<Types.UpdatePreviewNewsroomStylesMutation>;
export type UpdatePreviewNewsroomStylesMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePreviewNewsroomStylesMutation, Types.UpdatePreviewNewsroomStylesMutationVariables>;
export const UpdateHostedNewsroomDataDocument = gql`
    mutation updateHostedNewsroomData($newsroomId: ID!, $newsroomLayout: NewsroomLayout, $iframeUrl: String, $cname: String, $cookieSettings: CookieSettings, $subdomain: String, $cnameCookieTermsUrl: String, $useHostedNewsroomUrlForRedirects: Boolean, $headlineFontFamily: String, $headlineFontStyle: String, $paragraphFontFamily: String, $paragraphPreambleFontStyle: String, $paragraphBodyFontStyle: String, $miscellaneousFontFamily: String, $miscellaneousFontStyle: String, $backgroundColor: String, $customFooter: Boolean, $footerCss: String, $footerHtml: String, $customHeader: Boolean, $headerCss: String, $headerHtml: String, $includeLogotype: Boolean, $includeFooter: Boolean, $useCustomTitles: Boolean, $latestNewsTitle: String, $newsArchiveTitle: String, $mediaLibraryTitle: String, $eventsTitle: String, $contactTitle: String) {
  hostedNewsroomSettingsUpdate(
    input: {newsroomId: $newsroomId, newsroomLayout: $newsroomLayout, cookieSettings: $cookieSettings, iframeUrl: $iframeUrl, cname: $cname, subdomain: $subdomain, cnameCookieTermsUrl: $cnameCookieTermsUrl, useHostedNewsroomUrlForRedirects: $useHostedNewsroomUrlForRedirects, headlineFontFamily: $headlineFontFamily, headlineFontStyle: $headlineFontStyle, paragraphFontFamily: $paragraphFontFamily, paragraphPreambleFontStyle: $paragraphPreambleFontStyle, paragraphBodyFontStyle: $paragraphBodyFontStyle, miscellaneousFontFamily: $miscellaneousFontFamily, miscellaneousFontStyle: $miscellaneousFontStyle, backgroundColor: $backgroundColor, customFooter: $customFooter, footerCss: $footerCss, footerHtml: $footerHtml, customHeader: $customHeader, headerCss: $headerCss, headerHtml: $headerHtml, includeLogotype: $includeLogotype, includeFooter: $includeFooter, useCustomTitles: $useCustomTitles, latestNewsTitle: $latestNewsTitle, newsArchiveTitle: $newsArchiveTitle, mediaLibraryTitle: $mediaLibraryTitle, eventsTitle: $eventsTitle, contactTitle: $contactTitle}
  ) {
    error {
      ... on HostedNewsroomSettingsUpdateValidationError {
        cname
        cnameCookieTermsUrl
        iframeUrl
        latestNewsTitle
        newsArchiveTitle
        mediaLibraryTitle
        eventsTitle
        contactTitle
        headerHtml {
          message
          scrubbedHtml
        }
        footerHtml {
          message
          scrubbedHtml
        }
        headerCssV2 {
          message
          scrubbedCss
        }
        footerCssV2 {
          message
          scrubbedCss
        }
      }
    }
    hostedNewsroomSettings {
      id
      newsroomLayout
      iframeUrl
      cname
      subdomain
      cnameCookieTermsUrl
      useHostedNewsroomUrlForRedirects
      customTitles {
        ...CustomTitlesCard
      }
      hostedNewsroomStyle {
        ...StyleFragment
      }
    }
  }
}
    ${CustomTitlesCardFragmentDoc}
${StyleFragmentFragmentDoc}
${FontFamilyFragmentFragmentDoc}`;
export type UpdateHostedNewsroomDataMutationFn = Apollo.MutationFunction<Types.UpdateHostedNewsroomDataMutation, Types.UpdateHostedNewsroomDataMutationVariables>;

/**
 * __useUpdateHostedNewsroomDataMutation__
 *
 * To run a mutation, you first call `useUpdateHostedNewsroomDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHostedNewsroomDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHostedNewsroomDataMutation, { data, loading, error }] = useUpdateHostedNewsroomDataMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      newsroomLayout: // value for 'newsroomLayout'
 *      iframeUrl: // value for 'iframeUrl'
 *      cname: // value for 'cname'
 *      cookieSettings: // value for 'cookieSettings'
 *      subdomain: // value for 'subdomain'
 *      cnameCookieTermsUrl: // value for 'cnameCookieTermsUrl'
 *      useHostedNewsroomUrlForRedirects: // value for 'useHostedNewsroomUrlForRedirects'
 *      headlineFontFamily: // value for 'headlineFontFamily'
 *      headlineFontStyle: // value for 'headlineFontStyle'
 *      paragraphFontFamily: // value for 'paragraphFontFamily'
 *      paragraphPreambleFontStyle: // value for 'paragraphPreambleFontStyle'
 *      paragraphBodyFontStyle: // value for 'paragraphBodyFontStyle'
 *      miscellaneousFontFamily: // value for 'miscellaneousFontFamily'
 *      miscellaneousFontStyle: // value for 'miscellaneousFontStyle'
 *      backgroundColor: // value for 'backgroundColor'
 *      customFooter: // value for 'customFooter'
 *      footerCss: // value for 'footerCss'
 *      footerHtml: // value for 'footerHtml'
 *      customHeader: // value for 'customHeader'
 *      headerCss: // value for 'headerCss'
 *      headerHtml: // value for 'headerHtml'
 *      includeLogotype: // value for 'includeLogotype'
 *      includeFooter: // value for 'includeFooter'
 *      useCustomTitles: // value for 'useCustomTitles'
 *      latestNewsTitle: // value for 'latestNewsTitle'
 *      newsArchiveTitle: // value for 'newsArchiveTitle'
 *      mediaLibraryTitle: // value for 'mediaLibraryTitle'
 *      eventsTitle: // value for 'eventsTitle'
 *      contactTitle: // value for 'contactTitle'
 *   },
 * });
 */
export function useUpdateHostedNewsroomDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateHostedNewsroomDataMutation, Types.UpdateHostedNewsroomDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateHostedNewsroomDataMutation, Types.UpdateHostedNewsroomDataMutationVariables>(UpdateHostedNewsroomDataDocument, options);
      }
export type UpdateHostedNewsroomDataMutationHookResult = ReturnType<typeof useUpdateHostedNewsroomDataMutation>;
export type UpdateHostedNewsroomDataMutationResult = Apollo.MutationResult<Types.UpdateHostedNewsroomDataMutation>;
export type UpdateHostedNewsroomDataMutationOptions = Apollo.BaseMutationOptions<Types.UpdateHostedNewsroomDataMutation, Types.UpdateHostedNewsroomDataMutationVariables>;
export const UpdatePreviewHostedNewsroomStylesDocument = gql`
    mutation updatePreviewHostedNewsroomStyles($newsroomId: ID!, $headlineFontFamily: String, $headlineFontStyle: String, $paragraphFontFamily: String, $paragraphPreambleFontStyle: String, $paragraphBodyFontStyle: String, $miscellaneousFontFamily: String, $miscellaneousFontStyle: String, $backgroundColor: String, $customFooter: Boolean!, $footerCss: String, $footerHtml: String, $customHeader: Boolean!, $headerCss: String, $headerHtml: String, $includeLogotype: Boolean!, $includeFooter: Boolean!) {
  hostedNewsroomStylePreviewUpdate(
    input: {newsroomId: $newsroomId, headlineFontFamily: $headlineFontFamily, headlineFontStyle: $headlineFontStyle, paragraphFontFamily: $paragraphFontFamily, paragraphPreambleFontStyle: $paragraphPreambleFontStyle, paragraphBodyFontStyle: $paragraphBodyFontStyle, miscellaneousFontFamily: $miscellaneousFontFamily, miscellaneousFontStyle: $miscellaneousFontStyle, backgroundColor: $backgroundColor, customFooter: $customFooter, footerCss: $footerCss, footerHtml: $footerHtml, customHeader: $customHeader, headerCss: $headerCss, headerHtml: $headerHtml, includeLogotype: $includeLogotype, includeFooter: $includeFooter}
  ) {
    error {
      ... on HostedNewsroomStylePreviewUpdateValidationError {
        headerHtml {
          message
          scrubbedHtml
        }
        footerHtml {
          message
          scrubbedHtml
        }
        headerCssV2 {
          message
          scrubbedCss
        }
        footerCssV2 {
          message
          scrubbedCss
        }
      }
    }
    hostedNewsroomStyle {
      ...StyleFragment
    }
  }
}
    ${StyleFragmentFragmentDoc}
${FontFamilyFragmentFragmentDoc}`;
export type UpdatePreviewHostedNewsroomStylesMutationFn = Apollo.MutationFunction<Types.UpdatePreviewHostedNewsroomStylesMutation, Types.UpdatePreviewHostedNewsroomStylesMutationVariables>;

/**
 * __useUpdatePreviewHostedNewsroomStylesMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewHostedNewsroomStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewHostedNewsroomStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewHostedNewsroomStylesMutation, { data, loading, error }] = useUpdatePreviewHostedNewsroomStylesMutation({
 *   variables: {
 *      newsroomId: // value for 'newsroomId'
 *      headlineFontFamily: // value for 'headlineFontFamily'
 *      headlineFontStyle: // value for 'headlineFontStyle'
 *      paragraphFontFamily: // value for 'paragraphFontFamily'
 *      paragraphPreambleFontStyle: // value for 'paragraphPreambleFontStyle'
 *      paragraphBodyFontStyle: // value for 'paragraphBodyFontStyle'
 *      miscellaneousFontFamily: // value for 'miscellaneousFontFamily'
 *      miscellaneousFontStyle: // value for 'miscellaneousFontStyle'
 *      backgroundColor: // value for 'backgroundColor'
 *      customFooter: // value for 'customFooter'
 *      footerCss: // value for 'footerCss'
 *      footerHtml: // value for 'footerHtml'
 *      customHeader: // value for 'customHeader'
 *      headerCss: // value for 'headerCss'
 *      headerHtml: // value for 'headerHtml'
 *      includeLogotype: // value for 'includeLogotype'
 *      includeFooter: // value for 'includeFooter'
 *   },
 * });
 */
export function useUpdatePreviewHostedNewsroomStylesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePreviewHostedNewsroomStylesMutation, Types.UpdatePreviewHostedNewsroomStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePreviewHostedNewsroomStylesMutation, Types.UpdatePreviewHostedNewsroomStylesMutationVariables>(UpdatePreviewHostedNewsroomStylesDocument, options);
      }
export type UpdatePreviewHostedNewsroomStylesMutationHookResult = ReturnType<typeof useUpdatePreviewHostedNewsroomStylesMutation>;
export type UpdatePreviewHostedNewsroomStylesMutationResult = Apollo.MutationResult<Types.UpdatePreviewHostedNewsroomStylesMutation>;
export type UpdatePreviewHostedNewsroomStylesMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePreviewHostedNewsroomStylesMutation, Types.UpdatePreviewHostedNewsroomStylesMutationVariables>;
export const GetHostedNewsroomDataDocument = gql`
    query getHostedNewsroomData($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    hostedNewsroomSettings {
      id
      newsroomLayout
      useHostedNewsroomUrlForRedirects
      iframeUrl
      cname
      subdomain
      cnameCookieTermsUrl
      cookieSettings
      cnameIsLegacy
      cnameDnsSetup
      cnameDnsValue
      customTitles {
        ...CustomTitlesCard
      }
      hostedNewsroomStyle {
        ...StyleFragment
      }
    }
  }
}
    ${CustomTitlesCardFragmentDoc}
${StyleFragmentFragmentDoc}
${FontFamilyFragmentFragmentDoc}`;

/**
 * __useGetHostedNewsroomDataQuery__
 *
 * To run a query within a React component, call `useGetHostedNewsroomDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedNewsroomDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedNewsroomDataQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useGetHostedNewsroomDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables> & ({ variables: Types.GetHostedNewsroomDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables>(GetHostedNewsroomDataDocument, options);
      }
export function useGetHostedNewsroomDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables>(GetHostedNewsroomDataDocument, options);
        }
export function useGetHostedNewsroomDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables>(GetHostedNewsroomDataDocument, options);
        }
export type GetHostedNewsroomDataQueryHookResult = ReturnType<typeof useGetHostedNewsroomDataQuery>;
export type GetHostedNewsroomDataLazyQueryHookResult = ReturnType<typeof useGetHostedNewsroomDataLazyQuery>;
export type GetHostedNewsroomDataSuspenseQueryHookResult = ReturnType<typeof useGetHostedNewsroomDataSuspenseQuery>;
export type GetHostedNewsroomDataQueryResult = Apollo.QueryResult<Types.GetHostedNewsroomDataQuery, Types.GetHostedNewsroomDataQueryVariables>;
export const StoryWidgetDocument = gql`
    query StoryWidget($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      storyWidget: managed(feature: storyWidget) {
        id
        enabled
      }
    }
    storyWidget {
      id
      heading
      layout
      style
      availableStyles
      openInNewTab
      types
      css
      iframeUrl
      width
      height
      tags {
        id
        ...StoryWidgetTag
      }
    }
  }
}
    ${StoryWidgetTagFragmentDoc}`;

/**
 * __useStoryWidgetQuery__
 *
 * To run a query within a React component, call `useStoryWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryWidgetQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useStoryWidgetQuery(baseOptions: Apollo.QueryHookOptions<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables> & ({ variables: Types.StoryWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables>(StoryWidgetDocument, options);
      }
export function useStoryWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables>(StoryWidgetDocument, options);
        }
export function useStoryWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables>(StoryWidgetDocument, options);
        }
export type StoryWidgetQueryHookResult = ReturnType<typeof useStoryWidgetQuery>;
export type StoryWidgetLazyQueryHookResult = ReturnType<typeof useStoryWidgetLazyQuery>;
export type StoryWidgetSuspenseQueryHookResult = ReturnType<typeof useStoryWidgetSuspenseQuery>;
export type StoryWidgetQueryResult = Apollo.QueryResult<Types.StoryWidgetQuery, Types.StoryWidgetQueryVariables>;
export const StoryWidgetTagsDocument = gql`
    query StoryWidgetTags($pressroomId: ID!, $query: String) {
  pressroom(id: $pressroomId) {
    id
    tags2(query: $query) {
      id
      hits {
        id
        ...StoryWidgetTag
      }
    }
  }
}
    ${StoryWidgetTagFragmentDoc}`;

/**
 * __useStoryWidgetTagsQuery__
 *
 * To run a query within a React component, call `useStoryWidgetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryWidgetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryWidgetTagsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useStoryWidgetTagsQuery(baseOptions: Apollo.QueryHookOptions<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables> & ({ variables: Types.StoryWidgetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables>(StoryWidgetTagsDocument, options);
      }
export function useStoryWidgetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables>(StoryWidgetTagsDocument, options);
        }
export function useStoryWidgetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables>(StoryWidgetTagsDocument, options);
        }
export type StoryWidgetTagsQueryHookResult = ReturnType<typeof useStoryWidgetTagsQuery>;
export type StoryWidgetTagsLazyQueryHookResult = ReturnType<typeof useStoryWidgetTagsLazyQuery>;
export type StoryWidgetTagsSuspenseQueryHookResult = ReturnType<typeof useStoryWidgetTagsSuspenseQuery>;
export type StoryWidgetTagsQueryResult = Apollo.QueryResult<Types.StoryWidgetTagsQuery, Types.StoryWidgetTagsQueryVariables>;
export const UpdateStoryWidgetDocument = gql`
    mutation updateStoryWidget($css: String, $layout: StoryWidgetLayout, $style: StoryWidgetStyle, $openInNewTab: Boolean, $tagIds: [ID!], $types: [MaterialType!], $pressroomId: ID!) {
  storyWidgetUpdate(
    input: {css: $css, layout: $layout, style: $style, openInNewTab: $openInNewTab, tagIds: $tagIds, types: $types, pressroomId: $pressroomId}
  ) {
    pressroom {
      id
      storyWidget {
        id
        ...StoryWidget
      }
    }
    error {
      message
      ... on StoryWidgetUpdateValidationError {
        tagIds
        types
        css {
          scrubbedCss
        }
      }
    }
  }
}
    ${StoryWidgetFragmentDoc}
${StoryWidgetTagFragmentDoc}`;
export type UpdateStoryWidgetMutationFn = Apollo.MutationFunction<Types.UpdateStoryWidgetMutation, Types.UpdateStoryWidgetMutationVariables>;

/**
 * __useUpdateStoryWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateStoryWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoryWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoryWidgetMutation, { data, loading, error }] = useUpdateStoryWidgetMutation({
 *   variables: {
 *      css: // value for 'css'
 *      layout: // value for 'layout'
 *      style: // value for 'style'
 *      openInNewTab: // value for 'openInNewTab'
 *      tagIds: // value for 'tagIds'
 *      types: // value for 'types'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useUpdateStoryWidgetMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateStoryWidgetMutation, Types.UpdateStoryWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateStoryWidgetMutation, Types.UpdateStoryWidgetMutationVariables>(UpdateStoryWidgetDocument, options);
      }
export type UpdateStoryWidgetMutationHookResult = ReturnType<typeof useUpdateStoryWidgetMutation>;
export type UpdateStoryWidgetMutationResult = Apollo.MutationResult<Types.UpdateStoryWidgetMutation>;
export type UpdateStoryWidgetMutationOptions = Apollo.BaseMutationOptions<Types.UpdateStoryWidgetMutation, Types.UpdateStoryWidgetMutationVariables>;
export const TagDocument = gql`
    query Tag($pressroomId: ID!, $id: ID!) {
  pressroom(id: $pressroomId) {
    id
    tag(id: $id) {
      id
      ...TagManagementTag
      materials {
        id
        ...TagManagementMaterial
      }
    }
  }
}
    ${TagManagementTagFragmentDoc}
${TagManagementMaterialFragmentDoc}`;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(baseOptions: Apollo.QueryHookOptions<Types.TagQuery, Types.TagQueryVariables> & ({ variables: Types.TagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagQuery, Types.TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagQuery, Types.TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagQuery, Types.TagQueryVariables>(TagDocument, options);
        }
export function useTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TagQuery, Types.TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TagQuery, Types.TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagSuspenseQueryHookResult = ReturnType<typeof useTagSuspenseQuery>;
export type TagQueryResult = Apollo.QueryResult<Types.TagQuery, Types.TagQueryVariables>;
export const TagIdsDocument = gql`
    query tagIds($pressroomId: ID!, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder) {
  pressroom(id: $pressroomId) {
    id
    tags2(perPage: $perPage, page: $page, query: $query, sortOrder: $sortOrder) {
      id
      totalCount
      hits {
        id
      }
    }
  }
}
    `;

/**
 * __useTagIdsQuery__
 *
 * To run a query within a React component, call `useTagIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagIdsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useTagIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.TagIdsQuery, Types.TagIdsQueryVariables> & ({ variables: Types.TagIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagIdsQuery, Types.TagIdsQueryVariables>(TagIdsDocument, options);
      }
export function useTagIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagIdsQuery, Types.TagIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagIdsQuery, Types.TagIdsQueryVariables>(TagIdsDocument, options);
        }
export function useTagIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TagIdsQuery, Types.TagIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TagIdsQuery, Types.TagIdsQueryVariables>(TagIdsDocument, options);
        }
export type TagIdsQueryHookResult = ReturnType<typeof useTagIdsQuery>;
export type TagIdsLazyQueryHookResult = ReturnType<typeof useTagIdsLazyQuery>;
export type TagIdsSuspenseQueryHookResult = ReturnType<typeof useTagIdsSuspenseQuery>;
export type TagIdsQueryResult = Apollo.QueryResult<Types.TagIdsQuery, Types.TagIdsQueryVariables>;
export const TagsDocument = gql`
    query Tags($pressroomId: ID!, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder) {
  pressroom(id: $pressroomId) {
    id
    ...TagManagementPressroom
  }
}
    ${TagManagementPressroomFragmentDoc}
${TagManagementTagFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useTagsQuery(baseOptions: Apollo.QueryHookOptions<Types.TagsQuery, Types.TagsQueryVariables> & ({ variables: Types.TagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagsQuery, Types.TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagsQuery, Types.TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagsQuery, Types.TagsQueryVariables>(TagsDocument, options);
        }
export function useTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TagsQuery, Types.TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TagsQuery, Types.TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<Types.TagsQuery, Types.TagsQueryVariables>;
export const TagNamesDocument = gql`
    query TagNames($pressroomId: ID!, $ids: [ID!]) {
  pressroom(id: $pressroomId) {
    id
    tags2(ids: $ids) {
      id
      hits {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTagNamesQuery__
 *
 * To run a query within a React component, call `useTagNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagNamesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTagNamesQuery(baseOptions: Apollo.QueryHookOptions<Types.TagNamesQuery, Types.TagNamesQueryVariables> & ({ variables: Types.TagNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagNamesQuery, Types.TagNamesQueryVariables>(TagNamesDocument, options);
      }
export function useTagNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagNamesQuery, Types.TagNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagNamesQuery, Types.TagNamesQueryVariables>(TagNamesDocument, options);
        }
export function useTagNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TagNamesQuery, Types.TagNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TagNamesQuery, Types.TagNamesQueryVariables>(TagNamesDocument, options);
        }
export type TagNamesQueryHookResult = ReturnType<typeof useTagNamesQuery>;
export type TagNamesLazyQueryHookResult = ReturnType<typeof useTagNamesLazyQuery>;
export type TagNamesSuspenseQueryHookResult = ReturnType<typeof useTagNamesSuspenseQuery>;
export type TagNamesQueryResult = Apollo.QueryResult<Types.TagNamesQuery, Types.TagNamesQueryVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($id: ID!, $name: String, $highlighted: Boolean, $imageId: ID, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder, $pressroomId: ID!) {
  tagUpdate(
    input: {id: $id, name: $name, highlighted: $highlighted, imageId: $imageId, pressroomId: $pressroomId}
  ) {
    error {
      message
      ... on TagUpdateValidationError {
        name
      }
    }
    newImage {
      id
      usageCount
    }
    previousImage {
      id
      usageCount
    }
    pressroom {
      id
      ...TagManagementPressroom
    }
  }
}
    ${TagManagementPressroomFragmentDoc}
${TagManagementTagFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      highlighted: // value for 'highlighted'
 *      imageId: // value for 'imageId'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<Types.UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>;
export const UntagDocument = gql`
    mutation untag($id: ID!, $materials: [TaggedMaterial!]!, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder, $pressroomId: ID!) {
  tagUntagMaterials(
    input: {id: $id, materials: $materials, pressroomId: $pressroomId}
  ) {
    pressroom {
      id
      ...TagManagementPressroom
    }
    error {
      message
    }
  }
}
    ${TagManagementPressroomFragmentDoc}
${TagManagementTagFragmentDoc}`;
export type UntagMutationFn = Apollo.MutationFunction<Types.UntagMutation, Types.UntagMutationVariables>;

/**
 * __useUntagMutation__
 *
 * To run a mutation, you first call `useUntagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untagMutation, { data, loading, error }] = useUntagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      materials: // value for 'materials'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useUntagMutation(baseOptions?: Apollo.MutationHookOptions<Types.UntagMutation, Types.UntagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UntagMutation, Types.UntagMutationVariables>(UntagDocument, options);
      }
export type UntagMutationHookResult = ReturnType<typeof useUntagMutation>;
export type UntagMutationResult = Apollo.MutationResult<Types.UntagMutation>;
export type UntagMutationOptions = Apollo.BaseMutationOptions<Types.UntagMutation, Types.UntagMutationVariables>;
export const TagCombineDocument = gql`
    mutation tagCombine($ids: [ID!]!, $name: String!, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder, $pressroomId: ID!) {
  tagCombine(input: {ids: $ids, name: $name, pressroomId: $pressroomId}) {
    pressroom {
      id
      ...TagManagementPressroom
    }
    error {
      ... on TagCombineValidationError {
        name
      }
      message
    }
  }
}
    ${TagManagementPressroomFragmentDoc}
${TagManagementTagFragmentDoc}`;
export type TagCombineMutationFn = Apollo.MutationFunction<Types.TagCombineMutation, Types.TagCombineMutationVariables>;

/**
 * __useTagCombineMutation__
 *
 * To run a mutation, you first call `useTagCombineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCombineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCombineMutation, { data, loading, error }] = useTagCombineMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTagCombineMutation(baseOptions?: Apollo.MutationHookOptions<Types.TagCombineMutation, Types.TagCombineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TagCombineMutation, Types.TagCombineMutationVariables>(TagCombineDocument, options);
      }
export type TagCombineMutationHookResult = ReturnType<typeof useTagCombineMutation>;
export type TagCombineMutationResult = Apollo.MutationResult<Types.TagCombineMutation>;
export type TagCombineMutationOptions = Apollo.BaseMutationOptions<Types.TagCombineMutation, Types.TagCombineMutationVariables>;
export const TagDeleteDocument = gql`
    mutation tagDelete($ids: [ID!]!, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder, $pressroomId: ID!) {
  tagDelete(input: {ids: $ids, pressroomId: $pressroomId}) {
    pressroom {
      id
      ...TagManagementPressroom
    }
    previousImages {
      id
      usageCount
    }
    error {
      message
    }
  }
}
    ${TagManagementPressroomFragmentDoc}
${TagManagementTagFragmentDoc}`;
export type TagDeleteMutationFn = Apollo.MutationFunction<Types.TagDeleteMutation, Types.TagDeleteMutationVariables>;

/**
 * __useTagDeleteMutation__
 *
 * To run a mutation, you first call `useTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDeleteMutation, { data, loading, error }] = useTagDeleteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<Types.TagDeleteMutation, Types.TagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TagDeleteMutation, Types.TagDeleteMutationVariables>(TagDeleteDocument, options);
      }
export type TagDeleteMutationHookResult = ReturnType<typeof useTagDeleteMutation>;
export type TagDeleteMutationResult = Apollo.MutationResult<Types.TagDeleteMutation>;
export type TagDeleteMutationOptions = Apollo.BaseMutationOptions<Types.TagDeleteMutation, Types.TagDeleteMutationVariables>;
export const TagMoveHighlightedDocument = gql`
    mutation tagMoveHighlighted($id: ID!, $relativeTo: ID!, $above: Boolean, $perPage: Int, $page: Int, $query: String, $sortOrder: TagSortOrder, $pressroomId: ID!) {
  tagMoveHighlighted(
    input: {id: $id, relativeTo: $relativeTo, above: $above, pressroomId: $pressroomId}
  ) {
    pressroom {
      id
      ...TagManagementPressroom
    }
    error {
      message
    }
  }
}
    ${TagManagementPressroomFragmentDoc}
${TagManagementTagFragmentDoc}`;
export type TagMoveHighlightedMutationFn = Apollo.MutationFunction<Types.TagMoveHighlightedMutation, Types.TagMoveHighlightedMutationVariables>;

/**
 * __useTagMoveHighlightedMutation__
 *
 * To run a mutation, you first call `useTagMoveHighlightedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagMoveHighlightedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagMoveHighlightedMutation, { data, loading, error }] = useTagMoveHighlightedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      relativeTo: // value for 'relativeTo'
 *      above: // value for 'above'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      sortOrder: // value for 'sortOrder'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTagMoveHighlightedMutation(baseOptions?: Apollo.MutationHookOptions<Types.TagMoveHighlightedMutation, Types.TagMoveHighlightedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TagMoveHighlightedMutation, Types.TagMoveHighlightedMutationVariables>(TagMoveHighlightedDocument, options);
      }
export type TagMoveHighlightedMutationHookResult = ReturnType<typeof useTagMoveHighlightedMutation>;
export type TagMoveHighlightedMutationResult = Apollo.MutationResult<Types.TagMoveHighlightedMutation>;
export type TagMoveHighlightedMutationOptions = Apollo.BaseMutationOptions<Types.TagMoveHighlightedMutation, Types.TagMoveHighlightedMutationVariables>;
export const TrialDemoBookingNoticeDocument = gql`
    query TrialDemoBookingNotice($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      trialDemo
      planUpsell
    }
  }
}
    `;

/**
 * __useTrialDemoBookingNoticeQuery__
 *
 * To run a query within a React component, call `useTrialDemoBookingNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialDemoBookingNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialDemoBookingNoticeQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTrialDemoBookingNoticeQuery(baseOptions: Apollo.QueryHookOptions<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables> & ({ variables: Types.TrialDemoBookingNoticeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables>(TrialDemoBookingNoticeDocument, options);
      }
export function useTrialDemoBookingNoticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables>(TrialDemoBookingNoticeDocument, options);
        }
export function useTrialDemoBookingNoticeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables>(TrialDemoBookingNoticeDocument, options);
        }
export type TrialDemoBookingNoticeQueryHookResult = ReturnType<typeof useTrialDemoBookingNoticeQuery>;
export type TrialDemoBookingNoticeLazyQueryHookResult = ReturnType<typeof useTrialDemoBookingNoticeLazyQuery>;
export type TrialDemoBookingNoticeSuspenseQueryHookResult = ReturnType<typeof useTrialDemoBookingNoticeSuspenseQuery>;
export type TrialDemoBookingNoticeQueryResult = Apollo.QueryResult<Types.TrialDemoBookingNoticeQuery, Types.TrialDemoBookingNoticeQueryVariables>;
export const BookTrialDemoNoticeDocument = gql`
    mutation bookTrialDemoNotice($pressroomId: ID!) {
  noticeConfirm(input: {notice: trialDemo, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      trialDemo
    }
  }
}
    `;
export type BookTrialDemoNoticeMutationFn = Apollo.MutationFunction<Types.BookTrialDemoNoticeMutation, Types.BookTrialDemoNoticeMutationVariables>;

/**
 * __useBookTrialDemoNoticeMutation__
 *
 * To run a mutation, you first call `useBookTrialDemoNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookTrialDemoNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookTrialDemoNoticeMutation, { data, loading, error }] = useBookTrialDemoNoticeMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useBookTrialDemoNoticeMutation(baseOptions?: Apollo.MutationHookOptions<Types.BookTrialDemoNoticeMutation, Types.BookTrialDemoNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BookTrialDemoNoticeMutation, Types.BookTrialDemoNoticeMutationVariables>(BookTrialDemoNoticeDocument, options);
      }
export type BookTrialDemoNoticeMutationHookResult = ReturnType<typeof useBookTrialDemoNoticeMutation>;
export type BookTrialDemoNoticeMutationResult = Apollo.MutationResult<Types.BookTrialDemoNoticeMutation>;
export type BookTrialDemoNoticeMutationOptions = Apollo.BaseMutationOptions<Types.BookTrialDemoNoticeMutation, Types.BookTrialDemoNoticeMutationVariables>;
export const RequestTrialDemoDocument = gql`
    mutation RequestTrialDemo($pressroomId: ID!, $hubspotType: [HubspotDemos!], $phone: String) {
  requestDemo(
    input: {pressroomId: $pressroomId, scope: {hubspotDemos: $hubspotType}, phone: $phone}
  ) {
    error {
      message
      ... on RequestDemoValidationError {
        phone
      }
    }
  }
}
    `;
export type RequestTrialDemoMutationFn = Apollo.MutationFunction<Types.RequestTrialDemoMutation, Types.RequestTrialDemoMutationVariables>;

/**
 * __useRequestTrialDemoMutation__
 *
 * To run a mutation, you first call `useRequestTrialDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTrialDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTrialDemoMutation, { data, loading, error }] = useRequestTrialDemoMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      hubspotType: // value for 'hubspotType'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useRequestTrialDemoMutation(baseOptions?: Apollo.MutationHookOptions<Types.RequestTrialDemoMutation, Types.RequestTrialDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RequestTrialDemoMutation, Types.RequestTrialDemoMutationVariables>(RequestTrialDemoDocument, options);
      }
export type RequestTrialDemoMutationHookResult = ReturnType<typeof useRequestTrialDemoMutation>;
export type RequestTrialDemoMutationResult = Apollo.MutationResult<Types.RequestTrialDemoMutation>;
export type RequestTrialDemoMutationOptions = Apollo.BaseMutationOptions<Types.RequestTrialDemoMutation, Types.RequestTrialDemoMutationVariables>;
export const SetNoticeDocument = gql`
    mutation SetNotice($pressroomId: ID!, $notice: Notice!) {
  noticeConfirm(input: {notice: $notice, pressroomId: $pressroomId}) {
    pendingNotices {
      id
      ...BookingModalNotices
    }
  }
}
    ${BookingModalNoticesFragmentDoc}`;
export type SetNoticeMutationFn = Apollo.MutationFunction<Types.SetNoticeMutation, Types.SetNoticeMutationVariables>;

/**
 * __useSetNoticeMutation__
 *
 * To run a mutation, you first call `useSetNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNoticeMutation, { data, loading, error }] = useSetNoticeMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      notice: // value for 'notice'
 *   },
 * });
 */
export function useSetNoticeMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetNoticeMutation, Types.SetNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetNoticeMutation, Types.SetNoticeMutationVariables>(SetNoticeDocument, options);
      }
export type SetNoticeMutationHookResult = ReturnType<typeof useSetNoticeMutation>;
export type SetNoticeMutationResult = Apollo.MutationResult<Types.SetNoticeMutation>;
export type SetNoticeMutationOptions = Apollo.BaseMutationOptions<Types.SetNoticeMutation, Types.SetNoticeMutationVariables>;
export const TrialUserDetailsDocument = gql`
    query TrialUserDetails($sourceId: ID!, $pressroomId: ID!) {
  me {
    id
    user {
      id
      email
      phone
    }
  }
  pressroom(id: $pressroomId) {
    id
    pendingNotices {
      id
      trialDemo
    }
  }
  source(id: $sourceId) {
    id
    currentPlan
    trialDaysLeft
  }
}
    `;

/**
 * __useTrialUserDetailsQuery__
 *
 * To run a query within a React component, call `useTrialUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialUserDetailsQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useTrialUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables> & ({ variables: Types.TrialUserDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables>(TrialUserDetailsDocument, options);
      }
export function useTrialUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables>(TrialUserDetailsDocument, options);
        }
export function useTrialUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables>(TrialUserDetailsDocument, options);
        }
export type TrialUserDetailsQueryHookResult = ReturnType<typeof useTrialUserDetailsQuery>;
export type TrialUserDetailsLazyQueryHookResult = ReturnType<typeof useTrialUserDetailsLazyQuery>;
export type TrialUserDetailsSuspenseQueryHookResult = ReturnType<typeof useTrialUserDetailsSuspenseQuery>;
export type TrialUserDetailsQueryResult = Apollo.QueryResult<Types.TrialUserDetailsQuery, Types.TrialUserDetailsQueryVariables>;
export const PreviewPressreleasesDocument = gql`
    query PreviewPressreleases($pressroomId: ID!) {
  me {
    id
    user {
      id
      name
      email
      phone
    }
  }
  pressroom(id: $pressroomId) {
    id
    siteLocale
    siteCode
    newsroomSettings {
      id
      companyName
      newsroomStyle {
        primaryBrandColor
        secondaryBrandColor
        logotype {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __usePreviewPressreleasesQuery__
 *
 * To run a query within a React component, call `usePreviewPressreleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewPressreleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewPressreleasesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function usePreviewPressreleasesQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables> & ({ variables: Types.PreviewPressreleasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables>(PreviewPressreleasesDocument, options);
      }
export function usePreviewPressreleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables>(PreviewPressreleasesDocument, options);
        }
export function usePreviewPressreleasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables>(PreviewPressreleasesDocument, options);
        }
export type PreviewPressreleasesQueryHookResult = ReturnType<typeof usePreviewPressreleasesQuery>;
export type PreviewPressreleasesLazyQueryHookResult = ReturnType<typeof usePreviewPressreleasesLazyQuery>;
export type PreviewPressreleasesSuspenseQueryHookResult = ReturnType<typeof usePreviewPressreleasesSuspenseQuery>;
export type PreviewPressreleasesQueryResult = Apollo.QueryResult<Types.PreviewPressreleasesQuery, Types.PreviewPressreleasesQueryVariables>;
export const RequestDemoDocument = gql`
    mutation RequestDemo($pressroomId: ID!, $hubspotDemos: [HubspotDemos!]) {
  requestDemo(
    input: {pressroomId: $pressroomId, scope: {hubspotDemos: $hubspotDemos}}
  ) {
    error {
      message
    }
  }
}
    `;
export type RequestDemoMutationFn = Apollo.MutationFunction<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>;

/**
 * __useRequestDemoMutation__
 *
 * To run a mutation, you first call `useRequestDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDemoMutation, { data, loading, error }] = useRequestDemoMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      hubspotDemos: // value for 'hubspotDemos'
 *   },
 * });
 */
export function useRequestDemoMutation(baseOptions?: Apollo.MutationHookOptions<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>(RequestDemoDocument, options);
      }
export type RequestDemoMutationHookResult = ReturnType<typeof useRequestDemoMutation>;
export type RequestDemoMutationResult = Apollo.MutationResult<Types.RequestDemoMutation>;
export type RequestDemoMutationOptions = Apollo.BaseMutationOptions<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>;
export const UnlockerFeatureDocument = gql`
    query unlockerFeature($pressroomId: ID!, $feature: Feature!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      managed(feature: $feature) {
        id
        ...featureInfo
      }
    }
  }
}
    ${FeatureInfoFragmentDoc}`;

/**
 * __useUnlockerFeatureQuery__
 *
 * To run a query within a React component, call `useUnlockerFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnlockerFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnlockerFeatureQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useUnlockerFeatureQuery(baseOptions: Apollo.QueryHookOptions<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables> & ({ variables: Types.UnlockerFeatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables>(UnlockerFeatureDocument, options);
      }
export function useUnlockerFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables>(UnlockerFeatureDocument, options);
        }
export function useUnlockerFeatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables>(UnlockerFeatureDocument, options);
        }
export type UnlockerFeatureQueryHookResult = ReturnType<typeof useUnlockerFeatureQuery>;
export type UnlockerFeatureLazyQueryHookResult = ReturnType<typeof useUnlockerFeatureLazyQuery>;
export type UnlockerFeatureSuspenseQueryHookResult = ReturnType<typeof useUnlockerFeatureSuspenseQuery>;
export type UnlockerFeatureQueryResult = Apollo.QueryResult<Types.UnlockerFeatureQuery, Types.UnlockerFeatureQueryVariables>;
export const RequestTrialDocument = gql`
    mutation requestTrial($pressroomId: ID!, $features: [Feature!]!) {
  featureRequestTrial2(input: {pressroomId: $pressroomId, features: $features}) {
    error {
      message
    }
    pressroom {
      id
      source {
        id
        features {
          id
          manageds(features: $features) {
            id
            ...featureInfo
          }
        }
      }
      features {
        id
        manageds(features: $features) {
          id
          ...featureInfo
        }
      }
    }
  }
}
    ${FeatureInfoFragmentDoc}`;
export type RequestTrialMutationFn = Apollo.MutationFunction<Types.RequestTrialMutation, Types.RequestTrialMutationVariables>;

/**
 * __useRequestTrialMutation__
 *
 * To run a mutation, you first call `useRequestTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTrialMutation, { data, loading, error }] = useRequestTrialMutation({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      features: // value for 'features'
 *   },
 * });
 */
export function useRequestTrialMutation(baseOptions?: Apollo.MutationHookOptions<Types.RequestTrialMutation, Types.RequestTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RequestTrialMutation, Types.RequestTrialMutationVariables>(RequestTrialDocument, options);
      }
export type RequestTrialMutationHookResult = ReturnType<typeof useRequestTrialMutation>;
export type RequestTrialMutationResult = Apollo.MutationResult<Types.RequestTrialMutation>;
export type RequestTrialMutationOptions = Apollo.BaseMutationOptions<Types.RequestTrialMutation, Types.RequestTrialMutationVariables>;
export const UnlockerPageSwitchDocument = gql`
    query UnlockerPageSwitch($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    id
    features {
      id
      prImpact: managed(feature: prImpact) {
        id
        enabled
      }
      prImpactLimited: managed(feature: prImpactLimited) {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useUnlockerPageSwitchQuery__
 *
 * To run a query within a React component, call `useUnlockerPageSwitchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnlockerPageSwitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnlockerPageSwitchQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useUnlockerPageSwitchQuery(baseOptions: Apollo.QueryHookOptions<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables> & ({ variables: Types.UnlockerPageSwitchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables>(UnlockerPageSwitchDocument, options);
      }
export function useUnlockerPageSwitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables>(UnlockerPageSwitchDocument, options);
        }
export function useUnlockerPageSwitchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables>(UnlockerPageSwitchDocument, options);
        }
export type UnlockerPageSwitchQueryHookResult = ReturnType<typeof useUnlockerPageSwitchQuery>;
export type UnlockerPageSwitchLazyQueryHookResult = ReturnType<typeof useUnlockerPageSwitchLazyQuery>;
export type UnlockerPageSwitchSuspenseQueryHookResult = ReturnType<typeof useUnlockerPageSwitchSuspenseQuery>;
export type UnlockerPageSwitchQueryResult = Apollo.QueryResult<Types.UnlockerPageSwitchQuery, Types.UnlockerPageSwitchQueryVariables>;
export const CheckPasswordDocument = gql`
    mutation CheckPassword($password: String!) {
  passwordCheck(input: {password: $password}) {
    match
    error {
      message
    }
  }
}
    `;
export type CheckPasswordMutationFn = Apollo.MutationFunction<Types.CheckPasswordMutation, Types.CheckPasswordMutationVariables>;

/**
 * __useCheckPasswordMutation__
 *
 * To run a mutation, you first call `useCheckPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPasswordMutation, { data, loading, error }] = useCheckPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCheckPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.CheckPasswordMutation, Types.CheckPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CheckPasswordMutation, Types.CheckPasswordMutationVariables>(CheckPasswordDocument, options);
      }
export type CheckPasswordMutationHookResult = ReturnType<typeof useCheckPasswordMutation>;
export type CheckPasswordMutationResult = Apollo.MutationResult<Types.CheckPasswordMutation>;
export type CheckPasswordMutationOptions = Apollo.BaseMutationOptions<Types.CheckPasswordMutation, Types.CheckPasswordMutationVariables>;
export const TwoFactorDataDocument = gql`
    query TwoFactorData($password: String!) {
  me {
    id
    twoFactorOtpSetupUri(password: $password)
    twoFactorOtpSecret(password: $password)
  }
}
    `;

/**
 * __useTwoFactorDataQuery__
 *
 * To run a query within a React component, call `useTwoFactorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwoFactorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwoFactorDataQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useTwoFactorDataQuery(baseOptions: Apollo.QueryHookOptions<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables> & ({ variables: Types.TwoFactorDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables>(TwoFactorDataDocument, options);
      }
export function useTwoFactorDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables>(TwoFactorDataDocument, options);
        }
export function useTwoFactorDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables>(TwoFactorDataDocument, options);
        }
export type TwoFactorDataQueryHookResult = ReturnType<typeof useTwoFactorDataQuery>;
export type TwoFactorDataLazyQueryHookResult = ReturnType<typeof useTwoFactorDataLazyQuery>;
export type TwoFactorDataSuspenseQueryHookResult = ReturnType<typeof useTwoFactorDataSuspenseQuery>;
export type TwoFactorDataQueryResult = Apollo.QueryResult<Types.TwoFactorDataQuery, Types.TwoFactorDataQueryVariables>;
export const EnableTwoFactorDocument = gql`
    mutation EnableTwoFactor($password: String!, $otp: String!) {
  twoFactorEnable(input: {password: $password, otp: $otp}) {
    me {
      id
      user {
        id
        enabled2fa
        enforce2fa
      }
    }
    codes
    error {
      message
      ... on TwoFactorEnableValidationError {
        otp
        password
      }
    }
  }
}
    `;
export type EnableTwoFactorMutationFn = Apollo.MutationFunction<Types.EnableTwoFactorMutation, Types.EnableTwoFactorMutationVariables>;

/**
 * __useEnableTwoFactorMutation__
 *
 * To run a mutation, you first call `useEnableTwoFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTwoFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTwoFactorMutation, { data, loading, error }] = useEnableTwoFactorMutation({
 *   variables: {
 *      password: // value for 'password'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useEnableTwoFactorMutation(baseOptions?: Apollo.MutationHookOptions<Types.EnableTwoFactorMutation, Types.EnableTwoFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EnableTwoFactorMutation, Types.EnableTwoFactorMutationVariables>(EnableTwoFactorDocument, options);
      }
export type EnableTwoFactorMutationHookResult = ReturnType<typeof useEnableTwoFactorMutation>;
export type EnableTwoFactorMutationResult = Apollo.MutationResult<Types.EnableTwoFactorMutation>;
export type EnableTwoFactorMutationOptions = Apollo.BaseMutationOptions<Types.EnableTwoFactorMutation, Types.EnableTwoFactorMutationVariables>;
export const ForgotPasswordDataDocument = gql`
    query ForgotPasswordData {
  me {
    id
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useForgotPasswordDataQuery__
 *
 * To run a query within a React component, call `useForgotPasswordDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForgotPasswordDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useForgotPasswordDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>(ForgotPasswordDataDocument, options);
      }
export function useForgotPasswordDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>(ForgotPasswordDataDocument, options);
        }
export function useForgotPasswordDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>(ForgotPasswordDataDocument, options);
        }
export type ForgotPasswordDataQueryHookResult = ReturnType<typeof useForgotPasswordDataQuery>;
export type ForgotPasswordDataLazyQueryHookResult = ReturnType<typeof useForgotPasswordDataLazyQuery>;
export type ForgotPasswordDataSuspenseQueryHookResult = ReturnType<typeof useForgotPasswordDataSuspenseQuery>;
export type ForgotPasswordDataQueryResult = Apollo.QueryResult<Types.ForgotPasswordDataQuery, Types.ForgotPasswordDataQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword {
  passwordForgot(input: {}) {
    error {
      message
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<Types.ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>;
export const ResetRecoveryCodesDocument = gql`
    mutation ResetRecoveryCodes($password: String!) {
  twoFactorRenewRecoveryCodes(input: {password: $password}) {
    codes
    error {
      message
      ... on TwoFactorRenewRecoveryCodesValidationError {
        password
      }
    }
  }
}
    `;
export type ResetRecoveryCodesMutationFn = Apollo.MutationFunction<Types.ResetRecoveryCodesMutation, Types.ResetRecoveryCodesMutationVariables>;

/**
 * __useResetRecoveryCodesMutation__
 *
 * To run a mutation, you first call `useResetRecoveryCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRecoveryCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRecoveryCodesMutation, { data, loading, error }] = useResetRecoveryCodesMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetRecoveryCodesMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResetRecoveryCodesMutation, Types.ResetRecoveryCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResetRecoveryCodesMutation, Types.ResetRecoveryCodesMutationVariables>(ResetRecoveryCodesDocument, options);
      }
export type ResetRecoveryCodesMutationHookResult = ReturnType<typeof useResetRecoveryCodesMutation>;
export type ResetRecoveryCodesMutationResult = Apollo.MutationResult<Types.ResetRecoveryCodesMutation>;
export type ResetRecoveryCodesMutationOptions = Apollo.BaseMutationOptions<Types.ResetRecoveryCodesMutation, Types.ResetRecoveryCodesMutationVariables>;
export const RemoveSelfDocument = gql`
    mutation RemoveSelf($password: String!) {
  userRemoveSelf(input: {password: $password}) {
    error {
      message
      ... on UserRemoveSelfValidationError {
        password
      }
    }
    nameOfRemovedUser
  }
}
    `;
export type RemoveSelfMutationFn = Apollo.MutationFunction<Types.RemoveSelfMutation, Types.RemoveSelfMutationVariables>;

/**
 * __useRemoveSelfMutation__
 *
 * To run a mutation, you first call `useRemoveSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSelfMutation, { data, loading, error }] = useRemoveSelfMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRemoveSelfMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveSelfMutation, Types.RemoveSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveSelfMutation, Types.RemoveSelfMutationVariables>(RemoveSelfDocument, options);
      }
export type RemoveSelfMutationHookResult = ReturnType<typeof useRemoveSelfMutation>;
export type RemoveSelfMutationResult = Apollo.MutationResult<Types.RemoveSelfMutation>;
export type RemoveSelfMutationOptions = Apollo.BaseMutationOptions<Types.RemoveSelfMutation, Types.RemoveSelfMutationVariables>;
export const ToggleFollowerNotificationsDocument = gql`
    mutation ToggleFollowerNotifications($input: SourceToggleFollowerNotificationsInput!) {
  sourceToggleFollowerNotifications(input: $input) {
    error {
      message
    }
    sources {
      id
      currentUserGetsFollowerNotifications
    }
  }
}
    `;
export type ToggleFollowerNotificationsMutationFn = Apollo.MutationFunction<Types.ToggleFollowerNotificationsMutation, Types.ToggleFollowerNotificationsMutationVariables>;

/**
 * __useToggleFollowerNotificationsMutation__
 *
 * To run a mutation, you first call `useToggleFollowerNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFollowerNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFollowerNotificationsMutation, { data, loading, error }] = useToggleFollowerNotificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleFollowerNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ToggleFollowerNotificationsMutation, Types.ToggleFollowerNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ToggleFollowerNotificationsMutation, Types.ToggleFollowerNotificationsMutationVariables>(ToggleFollowerNotificationsDocument, options);
      }
export type ToggleFollowerNotificationsMutationHookResult = ReturnType<typeof useToggleFollowerNotificationsMutation>;
export type ToggleFollowerNotificationsMutationResult = Apollo.MutationResult<Types.ToggleFollowerNotificationsMutation>;
export type ToggleFollowerNotificationsMutationOptions = Apollo.BaseMutationOptions<Types.ToggleFollowerNotificationsMutation, Types.ToggleFollowerNotificationsMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($newPassword: String!, $oldPassword: String!) {
  passwordChange(input: {newPassword: $newPassword, oldPassword: $oldPassword}) {
    error {
      message
      ... on PasswordChangeValidationError {
        newPassword
        oldPassword
      }
    }
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<Types.ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;
export const Disable2FaDocument = gql`
    mutation Disable2FA($password: String!) {
  twoFactorDisable(input: {password: $password}) {
    error {
      message
      ... on TwoFactorDisableValidationError {
        password
      }
    }
    me {
      id
      user {
        id
        enabled2fa
        enforce2fa
      }
    }
  }
}
    `;
export type Disable2FaMutationFn = Apollo.MutationFunction<Types.Disable2FaMutation, Types.Disable2FaMutationVariables>;

/**
 * __useDisable2FaMutation__
 *
 * To run a mutation, you first call `useDisable2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisable2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disable2FaMutation, { data, loading, error }] = useDisable2FaMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDisable2FaMutation(baseOptions?: Apollo.MutationHookOptions<Types.Disable2FaMutation, Types.Disable2FaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Disable2FaMutation, Types.Disable2FaMutationVariables>(Disable2FaDocument, options);
      }
export type Disable2FaMutationHookResult = ReturnType<typeof useDisable2FaMutation>;
export type Disable2FaMutationResult = Apollo.MutationResult<Types.Disable2FaMutation>;
export type Disable2FaMutationOptions = Apollo.BaseMutationOptions<Types.Disable2FaMutation, Types.Disable2FaMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: ID!, $password: String, $fields: UserUpdateFields!) {
  userUpdate(input: {userId: $userId, userFields: $fields, password: $password}) {
    error {
      message
      ... on UserUpdateValidationError {
        name
        title
        username
        email
        password
        phone
      }
    }
    user {
      id
      name
      title
      username
      email
      phone
      timeZone: timeZone2
      locale: locale2
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      password: // value for 'password'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const UserSettingsDataDocument = gql`
    query UserSettingsData {
  me {
    id
    recoveryCodesCount
    user {
      id
      ...UserSettingsDetails
      ...NotificationsData
    }
  }
  timeZones {
    value: value2
    text
  }
}
    ${UserSettingsDetailsFragmentDoc}
${NotificationsDataFragmentDoc}`;

/**
 * __useUserSettingsDataQuery__
 *
 * To run a query within a React component, call `useUserSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSettingsDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>(UserSettingsDataDocument, options);
      }
export function useUserSettingsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>(UserSettingsDataDocument, options);
        }
export function useUserSettingsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>(UserSettingsDataDocument, options);
        }
export type UserSettingsDataQueryHookResult = ReturnType<typeof useUserSettingsDataQuery>;
export type UserSettingsDataLazyQueryHookResult = ReturnType<typeof useUserSettingsDataLazyQuery>;
export type UserSettingsDataSuspenseQueryHookResult = ReturnType<typeof useUserSettingsDataSuspenseQuery>;
export type UserSettingsDataQueryResult = Apollo.QueryResult<Types.UserSettingsDataQuery, Types.UserSettingsDataQueryVariables>;
export const FetchMoreTopReferrersDocument = gql`
    query FetchMoreTopReferrers($pressroomId: ID!, $time: DateTimeRangeInput, $after: String) {
  newsroomReport(pressroomId: $pressroomId) {
    id
    topReferrers(time: $time, first: 99999, after: $after) {
      nodes {
        name
        views
        icon
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    `;

/**
 * __useFetchMoreTopReferrersQuery__
 *
 * To run a query within a React component, call `useFetchMoreTopReferrersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMoreTopReferrersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMoreTopReferrersQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      time: // value for 'time'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchMoreTopReferrersQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables> & ({ variables: Types.FetchMoreTopReferrersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables>(FetchMoreTopReferrersDocument, options);
      }
export function useFetchMoreTopReferrersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables>(FetchMoreTopReferrersDocument, options);
        }
export function useFetchMoreTopReferrersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables>(FetchMoreTopReferrersDocument, options);
        }
export type FetchMoreTopReferrersQueryHookResult = ReturnType<typeof useFetchMoreTopReferrersQuery>;
export type FetchMoreTopReferrersLazyQueryHookResult = ReturnType<typeof useFetchMoreTopReferrersLazyQuery>;
export type FetchMoreTopReferrersSuspenseQueryHookResult = ReturnType<typeof useFetchMoreTopReferrersSuspenseQuery>;
export type FetchMoreTopReferrersQueryResult = Apollo.QueryResult<Types.FetchMoreTopReferrersQuery, Types.FetchMoreTopReferrersQueryVariables>;
export const FetchMoreTopStoriesDocument = gql`
    query FetchMoreTopStories($pressroomId: ID!, $time: DateTimeRangeInput, $limit: Int, $after: String) {
  newsroomReport(pressroomId: $pressroomId) {
    id
    topStories(time: $time, limit: $limit, first: 10, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      nodes {
        material {
          header
          id
          publishedAt2
        }
        views
      }
    }
  }
}
    `;

/**
 * __useFetchMoreTopStoriesQuery__
 *
 * To run a query within a React component, call `useFetchMoreTopStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMoreTopStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMoreTopStoriesQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *      time: // value for 'time'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchMoreTopStoriesQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables> & ({ variables: Types.FetchMoreTopStoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables>(FetchMoreTopStoriesDocument, options);
      }
export function useFetchMoreTopStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables>(FetchMoreTopStoriesDocument, options);
        }
export function useFetchMoreTopStoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables>(FetchMoreTopStoriesDocument, options);
        }
export type FetchMoreTopStoriesQueryHookResult = ReturnType<typeof useFetchMoreTopStoriesQuery>;
export type FetchMoreTopStoriesLazyQueryHookResult = ReturnType<typeof useFetchMoreTopStoriesLazyQuery>;
export type FetchMoreTopStoriesSuspenseQueryHookResult = ReturnType<typeof useFetchMoreTopStoriesSuspenseQuery>;
export type FetchMoreTopStoriesQueryResult = Apollo.QueryResult<Types.FetchMoreTopStoriesQuery, Types.FetchMoreTopStoriesQueryVariables>;
export const DisplayReportSectionDocument = gql`
    query DisplayReportSection($reportId: ID!, $sectionId: ID!, $first: Int, $after: String, $skipHidden: Boolean!) {
  report: report2(id: $reportId) {
    id
    sections: sections2(ids: [$sectionId]) {
      id
      ... on ReportQuotationGridSection {
        ...DisplayReportQuotationGridSection
      }
      ... on ReportQuotationFullWidthSection {
        ...DisplayReportQuotationFullWidthSection
      }
    }
  }
}
    ${DisplayReportQuotationGridSectionFragmentDoc}
${ReportCoverageInterfaceConnectionFragmentDoc}
${DisplayReportQuotationFullWidthSectionFragmentDoc}`;

/**
 * __useDisplayReportSectionQuery__
 *
 * To run a query within a React component, call `useDisplayReportSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayReportSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayReportSectionQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      sectionId: // value for 'sectionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      skipHidden: // value for 'skipHidden'
 *   },
 * });
 */
export function useDisplayReportSectionQuery(baseOptions: Apollo.QueryHookOptions<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables> & ({ variables: Types.DisplayReportSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables>(DisplayReportSectionDocument, options);
      }
export function useDisplayReportSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables>(DisplayReportSectionDocument, options);
        }
export function useDisplayReportSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables>(DisplayReportSectionDocument, options);
        }
export type DisplayReportSectionQueryHookResult = ReturnType<typeof useDisplayReportSectionQuery>;
export type DisplayReportSectionLazyQueryHookResult = ReturnType<typeof useDisplayReportSectionLazyQuery>;
export type DisplayReportSectionSuspenseQueryHookResult = ReturnType<typeof useDisplayReportSectionSuspenseQuery>;
export type DisplayReportSectionQueryResult = Apollo.QueryResult<Types.DisplayReportSectionQuery, Types.DisplayReportSectionQueryVariables>;
export const AdminPanelLinkDocument = gql`
    query AdminPanelLink($pressroomId: ID!) {
  pressroom(id: $pressroomId) {
    source {
      id
    }
  }
}
    `;

/**
 * __useAdminPanelLinkQuery__
 *
 * To run a query within a React component, call `useAdminPanelLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPanelLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPanelLinkQuery({
 *   variables: {
 *      pressroomId: // value for 'pressroomId'
 *   },
 * });
 */
export function useAdminPanelLinkQuery(baseOptions: Apollo.QueryHookOptions<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables> & ({ variables: Types.AdminPanelLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables>(AdminPanelLinkDocument, options);
      }
export function useAdminPanelLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables>(AdminPanelLinkDocument, options);
        }
export function useAdminPanelLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables>(AdminPanelLinkDocument, options);
        }
export type AdminPanelLinkQueryHookResult = ReturnType<typeof useAdminPanelLinkQuery>;
export type AdminPanelLinkLazyQueryHookResult = ReturnType<typeof useAdminPanelLinkLazyQuery>;
export type AdminPanelLinkSuspenseQueryHookResult = ReturnType<typeof useAdminPanelLinkSuspenseQuery>;
export type AdminPanelLinkQueryResult = Apollo.QueryResult<Types.AdminPanelLinkQuery, Types.AdminPanelLinkQueryVariables>;
export const HitsByIdsDocument = gql`
    query HitsByIds($reportId: ID!, $from: DateTime!, $to: DateTime!, $searchProfileIds: [ID!], $language: UserLocale) {
  report2(id: $reportId) {
    id
    ... on BrandReport {
      hits: hits2(
        timeRange: {from: $from, to: $to}
        orderBy: REACH
        searchProfileIds: $searchProfileIds
      ) {
        ...HitData
      }
    }
  }
}
    ${HitDataFragmentDoc}`;

/**
 * __useHitsByIdsQuery__
 *
 * To run a query within a React component, call `useHitsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHitsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHitsByIdsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      searchProfileIds: // value for 'searchProfileIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useHitsByIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables> & ({ variables: Types.HitsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables>(HitsByIdsDocument, options);
      }
export function useHitsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables>(HitsByIdsDocument, options);
        }
export function useHitsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables>(HitsByIdsDocument, options);
        }
export type HitsByIdsQueryHookResult = ReturnType<typeof useHitsByIdsQuery>;
export type HitsByIdsLazyQueryHookResult = ReturnType<typeof useHitsByIdsLazyQuery>;
export type HitsByIdsSuspenseQueryHookResult = ReturnType<typeof useHitsByIdsSuspenseQuery>;
export type HitsByIdsQueryResult = Apollo.QueryResult<Types.HitsByIdsQuery, Types.HitsByIdsQueryVariables>;
export const SentimentHitsDocument = gql`
    query SentimentHits($reportId: ID!, $from: DateTime!, $to: DateTime!, $sentiment: Sentiment, $searchProfileIds: [ID!]) {
  report2(id: $reportId) {
    id
    ... on BrandReport {
      sentimentAnalysisHits(
        timeRange: {from: $from, to: $to}
        sentiment: $sentiment
        searchProfileIds: $searchProfileIds
      ) {
        id
        sentiment
        sentimentExplanation
        sourceName
        publishedAt
        title
        hitLine
        link
        thumbnailUrl
        reach
        sourceVerification
        audioUrl
        audioHitlines {
          id
          startPos
          endPos
          hitline
        }
      }
    }
  }
}
    `;

/**
 * __useSentimentHitsQuery__
 *
 * To run a query within a React component, call `useSentimentHitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentimentHitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentimentHitsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sentiment: // value for 'sentiment'
 *      searchProfileIds: // value for 'searchProfileIds'
 *   },
 * });
 */
export function useSentimentHitsQuery(baseOptions: Apollo.QueryHookOptions<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables> & ({ variables: Types.SentimentHitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables>(SentimentHitsDocument, options);
      }
export function useSentimentHitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables>(SentimentHitsDocument, options);
        }
export function useSentimentHitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables>(SentimentHitsDocument, options);
        }
export type SentimentHitsQueryHookResult = ReturnType<typeof useSentimentHitsQuery>;
export type SentimentHitsLazyQueryHookResult = ReturnType<typeof useSentimentHitsLazyQuery>;
export type SentimentHitsSuspenseQueryHookResult = ReturnType<typeof useSentimentHitsSuspenseQuery>;
export type SentimentHitsQueryResult = Apollo.QueryResult<Types.SentimentHitsQuery, Types.SentimentHitsQueryVariables>;
export const ReportUpdateInsightDocument = gql`
    mutation ReportUpdateInsight($reportInsightId: ID!, $insight: String, $title: String) {
  reportUpdateInsight(
    input: {reportInsightId: $reportInsightId, insight: $insight, title: $title}
  ) {
    insight {
      id
      title
      insight
      insightType
    }
    error {
      message
    }
  }
}
    `;
export type ReportUpdateInsightMutationFn = Apollo.MutationFunction<Types.ReportUpdateInsightMutation, Types.ReportUpdateInsightMutationVariables>;

/**
 * __useReportUpdateInsightMutation__
 *
 * To run a mutation, you first call `useReportUpdateInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUpdateInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUpdateInsightMutation, { data, loading, error }] = useReportUpdateInsightMutation({
 *   variables: {
 *      reportInsightId: // value for 'reportInsightId'
 *      insight: // value for 'insight'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useReportUpdateInsightMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReportUpdateInsightMutation, Types.ReportUpdateInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReportUpdateInsightMutation, Types.ReportUpdateInsightMutationVariables>(ReportUpdateInsightDocument, options);
      }
export type ReportUpdateInsightMutationHookResult = ReturnType<typeof useReportUpdateInsightMutation>;
export type ReportUpdateInsightMutationResult = Apollo.MutationResult<Types.ReportUpdateInsightMutation>;
export type ReportUpdateInsightMutationOptions = Apollo.BaseMutationOptions<Types.ReportUpdateInsightMutation, Types.ReportUpdateInsightMutationVariables>;
export const PollingVisibilityHighlightsDocument = gql`
    query PollingVisibilityHighlights($reportId: ID!) {
  report2(id: $reportId) {
    id
    sections2 {
      id
      ... on ReportVisibilitySection {
        id
        subSections {
          id
          ... on ReportVisibilityHighlights {
            ...Report2VisibilityHighlights
          }
        }
      }
    }
  }
}
    ${Report2VisibilityHighlightsFragmentDoc}
${ReportQuotation2FragmentDoc}`;

/**
 * __usePollingVisibilityHighlightsQuery__
 *
 * To run a query within a React component, call `usePollingVisibilityHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollingVisibilityHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollingVisibilityHighlightsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function usePollingVisibilityHighlightsQuery(baseOptions: Apollo.QueryHookOptions<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables> & ({ variables: Types.PollingVisibilityHighlightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables>(PollingVisibilityHighlightsDocument, options);
      }
export function usePollingVisibilityHighlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables>(PollingVisibilityHighlightsDocument, options);
        }
export function usePollingVisibilityHighlightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables>(PollingVisibilityHighlightsDocument, options);
        }
export type PollingVisibilityHighlightsQueryHookResult = ReturnType<typeof usePollingVisibilityHighlightsQuery>;
export type PollingVisibilityHighlightsLazyQueryHookResult = ReturnType<typeof usePollingVisibilityHighlightsLazyQuery>;
export type PollingVisibilityHighlightsSuspenseQueryHookResult = ReturnType<typeof usePollingVisibilityHighlightsSuspenseQuery>;
export type PollingVisibilityHighlightsQueryResult = Apollo.QueryResult<Types.PollingVisibilityHighlightsQuery, Types.PollingVisibilityHighlightsQueryVariables>;
export const Report2UpdateDocument = gql`
    mutation Report2Update($id: ID!, $title: String, $description: String, $brandColor: String, $logotypeId: ID, $coverImageId: ID) {
  reportUpdate(
    input: {reportId: $id, title: $title, description: $description, brandColor: $brandColor, logotypeId: $logotypeId, coverImageId: $coverImageId}
  ) {
    error {
      ... on ReportUpdateValidationError {
        title
        logotypeId
      }
    }
    report: report2 {
      ... on ReportInterface {
        id
        title
        brandColor
        description
        coverImage {
          id
          url(transformation: LIMIT_1000)
        }
        logotype {
          id
          url(transformation: LIMIT_1000)
        }
      }
    }
  }
}
    `;
export type Report2UpdateMutationFn = Apollo.MutationFunction<Types.Report2UpdateMutation, Types.Report2UpdateMutationVariables>;

/**
 * __useReport2UpdateMutation__
 *
 * To run a mutation, you first call `useReport2UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReport2UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [report2UpdateMutation, { data, loading, error }] = useReport2UpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      brandColor: // value for 'brandColor'
 *      logotypeId: // value for 'logotypeId'
 *      coverImageId: // value for 'coverImageId'
 *   },
 * });
 */
export function useReport2UpdateMutation(baseOptions?: Apollo.MutationHookOptions<Types.Report2UpdateMutation, Types.Report2UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Report2UpdateMutation, Types.Report2UpdateMutationVariables>(Report2UpdateDocument, options);
      }
export type Report2UpdateMutationHookResult = ReturnType<typeof useReport2UpdateMutation>;
export type Report2UpdateMutationResult = Apollo.MutationResult<Types.Report2UpdateMutation>;
export type Report2UpdateMutationOptions = Apollo.BaseMutationOptions<Types.Report2UpdateMutation, Types.Report2UpdateMutationVariables>;
export const Report2UpdatePrValueSettingsDocument = gql`
    mutation Report2UpdatePrValueSettings($reportId: ID!, $currency: ReportPrValueCurrency!, $cpc: Float, $cpm: Float, $twitterCpm: Float, $facebookCpm: Float, $instagramCpm: Float, $default: Boolean, $pricingModel: ReportPrValuePricingModel) {
  reportUpdatePrValueSettings(
    input: {reportId: $reportId, cpc: $cpc, cpm: $cpm, twitterCpm: $twitterCpm, facebookCpm: $facebookCpm, instagramCpm: $instagramCpm, currency: $currency, default: $default, pricingModel: $pricingModel}
  ) {
    error {
      message
    }
    report: report2 {
      id
      prValueSetting {
        ...Report2PrValueSetting
      }
      sections2 {
        ... on ReportSummarySection {
          subSections {
            ...Report2SummaryKeyMetrics
          }
        }
      }
    }
  }
}
    ${Report2PrValueSettingFragmentDoc}
${Report2SummaryKeyMetricsFragmentDoc}
${Report2SectionFragmentDoc}`;
export type Report2UpdatePrValueSettingsMutationFn = Apollo.MutationFunction<Types.Report2UpdatePrValueSettingsMutation, Types.Report2UpdatePrValueSettingsMutationVariables>;

/**
 * __useReport2UpdatePrValueSettingsMutation__
 *
 * To run a mutation, you first call `useReport2UpdatePrValueSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReport2UpdatePrValueSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [report2UpdatePrValueSettingsMutation, { data, loading, error }] = useReport2UpdatePrValueSettingsMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      currency: // value for 'currency'
 *      cpc: // value for 'cpc'
 *      cpm: // value for 'cpm'
 *      twitterCpm: // value for 'twitterCpm'
 *      facebookCpm: // value for 'facebookCpm'
 *      instagramCpm: // value for 'instagramCpm'
 *      default: // value for 'default'
 *      pricingModel: // value for 'pricingModel'
 *   },
 * });
 */
export function useReport2UpdatePrValueSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.Report2UpdatePrValueSettingsMutation, Types.Report2UpdatePrValueSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.Report2UpdatePrValueSettingsMutation, Types.Report2UpdatePrValueSettingsMutationVariables>(Report2UpdatePrValueSettingsDocument, options);
      }
export type Report2UpdatePrValueSettingsMutationHookResult = ReturnType<typeof useReport2UpdatePrValueSettingsMutation>;
export type Report2UpdatePrValueSettingsMutationResult = Apollo.MutationResult<Types.Report2UpdatePrValueSettingsMutation>;
export type Report2UpdatePrValueSettingsMutationOptions = Apollo.BaseMutationOptions<Types.Report2UpdatePrValueSettingsMutation, Types.Report2UpdatePrValueSettingsMutationVariables>;